
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("deBE2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $98ffc5207cce799c$export$2e2bcd8739ae039);
/**
 * Package @atlassian/invite-people lives in Atlassian Frontend repo
 * https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/people-and-teams/invite-people/
 * */ 
var $5uXOq = parcelRequire("5uXOq");

var $gAbOP = parcelRequire("gAbOP");

var $k1GKH = parcelRequire("k1GKH");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $dAfqg = parcelRequire("dAfqg");

var $d3xqi = parcelRequire("d3xqi");

var $2fX5x = parcelRequire("2fX5x");

var $eIokK = parcelRequire("eIokK");
const $98ffc5207cce799c$var$Content = ({ isOpen: isOpen, onClose: onClose, inviteFlow: inviteFlow, continueUrl: continueUrl, disableNoInviteError: disableNoInviteError, displayModal: displayModal })=>{
    const { cloudId: cloudId, appEditions: { software: software } } = (0, $9OXo1.useTenantContext)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { addFlag: addFlag } = (0, $eIokK.useInvitePeopleFlags)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const subProduct = (0, $eIokK.jiraProjectTypeToSubProduct)(project?.projectType);
    const source = (0, $d3xqi.getSourceByInviteFlow)(inviteFlow);
    const experimentalFeatures = {
        inviteFromAssignModal: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        'variation'
    };
    let continueUrlProp = continueUrl;
    if (continueUrl === undefined || continueUrl === null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const issueKey = (0, $eIokK.stripUrlToIssueKey)(window.location.href) || null;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        continueUrlProp = issueKey ? `${window.location.origin}/browse/${issueKey}` : undefined;
    }
    const commonProps = {
        showFlag: addFlag,
        enableThirdParty: true,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        subProduct: subProduct,
        source: source,
        continueUrl: continueUrlProp,
        experimentalFeatures: experimentalFeatures,
        disableNoInviteError: disableNoInviteError,
        experimental_applicationEdition: software,
        orgId: orgId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2fX5x.AnalyticsProvider), null, displayModal && isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1GKH.InvitePeopleModal), {
        onCloseHandler: onClose,
        ...commonProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAbOP.default), {
        isOpen: isOpen,
        onCloseHandler: onClose,
        ...commonProps
    }));
};
var $98ffc5207cce799c$export$2e2bcd8739ae039 = $98ffc5207cce799c$var$Content;

});
parcelRegister("gAbOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e9bdbe98ae8546b$export$2e2bcd8739ae039);
/* InvitePeopleDrawer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $b0J2Z = parcelRequire("b0J2Z");
var $ak8Tx = parcelRequire("ak8Tx");
var $dpz5x = parcelRequire("dpz5x");
var $141xu = parcelRequire("141xu");

var $kweMg = parcelRequire("kweMg");

var $5sRpy = parcelRequire("5sRpy");

var $4tULk = parcelRequire("4tULk");

var $cKaFn = parcelRequire("cKaFn");

var $6zLS8 = parcelRequire("6zLS8");

var $9efUE = parcelRequire("9efUE");
const $1e9bdbe98ae8546b$var$styles = {
    wrapper: "_1e0c116y _ae4v1h6o _1bah1h6o _1wpz1h6o _1bsb1osq",
    leftContentWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug _4t3i1osq _c71lufrr _p12f1qho _1wpz1h6o _2hwx1epz _19pk1jfw",
    rightContentWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c116y _p12f1qho _1wpz1y6m _19pk1epz",
    inviteWrapper: "_2rkoiti9 _1ul91a2h _16qszucj _vchhusvi"
};
const $1e9bdbe98ae8546b$var$InvitePeopleDrawer = ({ isOpen: isOpen, onCloseHandler: onCloseHandler, ...invitePeopleProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b0J2Z.Drawer), {
        onClose: onCloseHandler,
        isOpen: isOpen,
        testId: (0, $6zLS8.TestId).InvitePeopleDrawer,
        width: "full",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $141xu.DrawerSidebar), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ak8Tx.DrawerCloseButton), {
                    // TODO: Drawer support for new icons - https://product-fabric.atlassian.net/browse/DSP-19527
                    icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kweMg))), {
                            label: "close",
                            color: "currentColor",
                            spacing: "spacious"
                        })
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dpz5x.DrawerContent), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9efUE.default), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                        testId: (0, $6zLS8.TestId).InvitePeopleDrawerContent,
                        xcss: $1e9bdbe98ae8546b$var$styles.wrapper,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                                testId: (0, $6zLS8.TestId).InvitePeopleDrawerImage,
                                xcss: $1e9bdbe98ae8546b$var$styles.leftContentWrapper,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                                    alt: "drawer-illustration",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4tULk)))
                                })
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                                xcss: $1e9bdbe98ae8546b$var$styles.rightContentWrapper,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                                    backgroundColor: "elevation.surface.raised",
                                    xcss: $1e9bdbe98ae8546b$var$styles.inviteWrapper,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cKaFn.InvitePeopleWithAnalytics), {
                                        onSendHandler: onCloseHandler,
                                        onCancelHandler: onCloseHandler,
                                        ...invitePeopleProps,
                                        viewAs: "drawer"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $1e9bdbe98ae8546b$export$2e2bcd8739ae039 = $1e9bdbe98ae8546b$var$InvitePeopleDrawer;

});
parcelRegister("4tULk", function(module, exports) {
module.exports = new URL("DrawerIllustration.5c9452ed.svg", import.meta.url).toString();

});

parcelRegister("cKaFn", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleWithAnalytics", () => $845d34fd2dc2ad56$export$9dbc3ab01ac4df16);
/* InvitePeople.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $asiGE = parcelRequire("asiGE");

var $5sLH0 = parcelRequire("5sLH0");

var $b4PzF = parcelRequire("b4PzF");

var $luvXZ = parcelRequire("luvXZ");
var $f6U3Q = parcelRequire("f6U3Q");

var $hatDq = parcelRequire("hatDq");

var $Zeu50 = parcelRequire("Zeu50");

var $a5Jah = parcelRequire("a5Jah");

var $84G45 = parcelRequire("84G45");
var $6HEbe = parcelRequire("6HEbe");

var $5Iax1 = parcelRequire("5Iax1");

var $4gxY5 = parcelRequire("4gxY5");

var $kx8ta = parcelRequire("kx8ta");

var $dCNWF = parcelRequire("dCNWF");

var $i7Upr = parcelRequire("i7Upr");
var $daXvt = parcelRequire("daXvt");

var $cfWle = parcelRequire("cfWle");

var $1CnPD = parcelRequire("1CnPD");

var $clxo5 = parcelRequire("clxo5");

var $a3CEJ = parcelRequire("a3CEJ");

var $5mSkC = parcelRequire("5mSkC");

var $fkAmK = parcelRequire("fkAmK");

var $hofb1 = parcelRequire("hofb1");

var $kPhww = parcelRequire("kPhww");

var $lWbFO = parcelRequire("lWbFO");

var $94SGH = parcelRequire("94SGH");

var $a0kJp = parcelRequire("a0kJp");

var $io72P = parcelRequire("io72P");

var $444qv = parcelRequire("444qv");

var $86tbn = parcelRequire("86tbn");

var $h23hB = parcelRequire("h23hB");


var $78lfI = parcelRequire("78lfI");

var $14Qmx = parcelRequire("14Qmx");

var $cQ8dn = parcelRequire("cQ8dn");

var $h0W5W = parcelRequire("h0W5W");
const $845d34fd2dc2ad56$var$styles = {
    spinnerWrapper: "_1mouxncg _195gxncg _1tke1lit _18m91wug"
};
const $845d34fd2dc2ad56$var$InvitePeopleContainer = ({ _hasError: _hasError, alignButtons: alignButtons = 'right', cancelButtonLabel: cancelButtonLabel, continueUrl: continueUrl, onInviteCompletedHandler: onInviteCompletedHandler, experimental_formTitleByline: experimental_formTitleByline, experimental_onReopenHandler: experimental_onReopenHandler, formDescription: formDescription, formTitle: formTitle, hideFormHeader: hideFormHeader, hideCancelButton: hideCancelButton, isInitialLoad: isInitialLoad, maxNumberOfInputs: maxNumberOfInputs = (0, $Zeu50.INVITE_API_MAX_USERS), onCancelHandler: onCancelHandler, onSendHandler: onSendHandler, onSubmit: onSubmit, sendButtonLabel: sendButtonLabel, setIsInitialLoad: setIsInitialLoad, showFlag: showFlag, titleId: titleId, experimental_submitButtonRef: experimental_submitButtonRef, forceLoading: forceLoading, experimental_onCloseTurnOnInviteLinkModal: experimental_onCloseTurnOnInviteLinkModal, experimental_onInviteeListChangeHandler: experimental_onInviteeListChangeHandler })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $5Iax1.InvitePeopleAnalytics));
    const invitePeopleData = (0, $78lfI.useInvitePeopleData)();
    const { emails: emails, users: users, userPickerOptions: userPickerOptions, setUserPickerOptions: setUserPickerOptions } = (0, $1CnPD.useInviteeListStateContext)();
    const { disableNoInviteError: disableNoInviteError, isLoading: invitePeopleLoading, source: source, userRole: userRole } = (0, $daXvt.useInvitePeopleContext)();
    const { availableProductOptions: availableProductOptions, isFetchProductsLoading: isFetchProductsLoading, hasPermissionToInviteOrRequestAccess: hasPermissionToInviteOrRequestAccess, selectedProducts: selectedProducts, setSelectedProducts: setSelectedProducts } = (0, $4gxY5.useProducts)();
    const [isSendingInvitation, setIsSendingInvitation] = (0, $5uXOq.useState)(false);
    const { isOk: thirdPartyOk, isLoading: isThirdPartyLoading, abortThirdPartyRequests: abortThirdPartyRequests } = (0, $dCNWF.useThirdPartyState)();
    const itpt = (0, $86tbn.useInviteThirdPartyTeams)();
    const maxInputs = itpt.isEnabled ? (0, $c2b60d1cbe5ffbe3$export$a0c5ea4233e1cf17) : maxNumberOfInputs;
    const { isEnrolled: isDriveMultiProductInvitesExperimentEnrolled, getEligibleUsersAndProducts: getEligibleUsersAndProducts, cohort: driveMultiProductInvitesExperimentCohort } = (0, $h23hB.useCoreInvitesDriveMultiProductInvitesContext)();
    const { isLoading: isInfiSpotlightLoading } = (0, $cQ8dn.useInfiSpotlight)();
    const { viralSettingsDESEligibleStates: viralSettingsDESEligibleStates, showOpenInvite: showOpenInvite, openInviteEnabled: enableOpenInvite, uniqueEmailDomains: uniqueEmailDomains, setUniqueEmailDomains: setUniqueEmailDomains, isViralSettingsEnabled: isViralSettingsEnabled } = (0, $hofb1.useViralSettingsContext)();
    const [shouldShowSecondarySection, setShouldShowSecondarySection] = (0, $5uXOq.useState)(false);
    const [shouldDisplayInviteSuccessContent, setShouldDisplayInviteSuccessContent] = (0, $5uXOq.useState)(false);
    const [successfulInviteText, setSuccessfulInviteText] = (0, $5uXOq.useState)();
    const [multiInviteEligibleProducts, setMultiInviteEligibleProducts] = (0, $5uXOq.useState)();
    const [multiInviteInvitedProducts, setMultiInviteInvitedProducts] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $lWbFO.invitePeopleRendered).addMetadata({
            source: source,
            thirdPartyEnabled: thirdPartyOk,
            isInitialLoad: isInitialLoad
        });
        if (setIsInitialLoad && isInitialLoad) setIsInitialLoad(false);
    // calling this effect shouldn't depend on changes to `isInitialLoad`
    // eslint-disable-next-line
    }, [
        source,
        thirdPartyOk
    ]);
    (0, $5uXOq.useEffect)(()=>abortThirdPartyRequests, [
        abortThirdPartyRequests
    ]);
    const onInviteeListChangeCallback = (0, $5uXOq.useCallback)(()=>{
        if ((0, $84G45.qualifiesForViralSettings)(userRole)) setUniqueEmailDomains((0, $kx8ta.getUniqueEmailDomains)(emails));
        if (users && users.length > 0) setShouldShowSecondarySection(true);
        // Execute the callback passed by the consumer passing the emails as an argument
        experimental_onInviteeListChangeHandler?.(emails);
    }, [
        userRole,
        setUniqueEmailDomains,
        emails,
        users,
        experimental_onInviteeListChangeHandler
    ]);
    const { processDirectAccessSettings: processDirectAccessSettings } = (0, $94SGH.default)({
        viralSettingsDESEligibleStates: viralSettingsDESEligibleStates,
        selectedProducts: selectedProducts,
        isViralSettingsEnabled: isViralSettingsEnabled
    });
    const { processOpenInviteSettings: processOpenInviteSettings } = (0, $a0kJp.default)({
        showOpenInvite: showOpenInvite,
        enableOpenInvite: enableOpenInvite,
        selectedProducts: selectedProducts,
        isViralSettingsEnabled: isViralSettingsEnabled
    });
    const { inviteUsers: inviteUsers } = (0, $io72P.default)({
        continueUrl: continueUrl,
        onInviteCompletedHandler: onInviteCompletedHandler,
        onReopenHandler: experimental_onReopenHandler
    });
    const getViralSettingsFlags = (0, $a3CEJ.useViralSettingsFlags)();
    const [viralSettingsFlags, setViralSettingsFlags] = (0, $5uXOq.useState)([]);
    const onSubmitCallback = (0, $5uXOq.useCallback)(async (products, isSuccessModal, getRecaptchaToken)=>{
        const inviteSuccessContentOnSubmit = async ()=>{
            const response = await inviteUsers(getRecaptchaToken, true);
            if (response.flags && showFlag) {
                [
                    ...response.flags,
                    ...viralSettingsFlags
                ].forEach(showFlag);
                onSendHandler?.();
            }
        };
        const invitePeopleOnSubmit = async ()=>{
            const openInviteSettingsPromise = processOpenInviteSettings();
            const directAccessSettingsPromise = processDirectAccessSettings();
            const inviteUsersPromise = inviteUsers(getRecaptchaToken, false);
            const response = await Promise.allSettled([
                openInviteSettingsPromise,
                directAccessSettingsPromise,
                inviteUsersPromise
            ]);
            const [openInviteResponse, directAccessSettingsResponse, inviteUsersResponse] = response;
            let showInviteSuccessContent = false;
            if (isDriveMultiProductInvitesExperimentEnrolled && inviteUsersResponse.status === 'fulfilled' && inviteUsersResponse.value.responseStatus === (0, $hatDq.InviteProcessingResponseStatus).SUCCESS && !('failure' in inviteUsersResponse.value.response)) try {
                const { users: users, products: eligibleProducts } = await getEligibleUsersAndProducts(inviteUsersResponse.value.response.invited, products);
                if (eligibleProducts.length && users.length && driveMultiProductInvitesExperimentCohort === 'variation') {
                    setMultiInviteEligibleProducts(eligibleProducts);
                    setMultiInviteInvitedProducts(selectedProducts);
                    setUserPickerOptions(users);
                    setSelectedProducts([]);
                    showInviteSuccessContent = true;
                    setShouldDisplayInviteSuccessContent(showInviteSuccessContent);
                    const successFlag = inviteUsersResponse.value.flags.find((flag)=>flag.appearance === 'success');
                    successFlag && setSuccessfulInviteText({
                        title: successFlag.title,
                        description: successFlag.description
                    });
                }
            } catch (e) {
                analytics.fetchingEligibleUsersFailed(products);
            }
            let flags = [];
            if (openInviteResponse.status === 'fulfilled' && directAccessSettingsResponse.status === 'fulfilled') {
                flags.push(...getViralSettingsFlags((0, $kx8ta.resolveInviteProcessingResponseStatus)(openInviteResponse.value.responseStatus), (0, $kx8ta.resolveInviteProcessingResponseStatus)(directAccessSettingsResponse.value.responseStatus)));
                setViralSettingsFlags([
                    ...flags
                ]);
            }
            if (inviteUsersResponse.status === 'fulfilled' && inviteUsersResponse.value.flags) flags.push(...inviteUsersResponse.value.flags);
            if (!showInviteSuccessContent) {
                showFlag && flags.forEach(showFlag);
                onSendHandler?.();
            }
            return {
                openInviteResponse: openInviteResponse,
                directAccessSettingsResponse: directAccessSettingsResponse,
                inviteUsersResponse: inviteUsersResponse
            };
        };
        try {
            setIsSendingInvitation(true);
            const internalOnSubmit = isSuccessModal ? inviteSuccessContentOnSubmit : invitePeopleOnSubmit;
            if (onSubmit && !isSuccessModal) await onSubmit({
                defaultOnSubmit: invitePeopleOnSubmit,
                invitePeopleData: invitePeopleData,
                getRecaptchaToken: getRecaptchaToken
            });
            else await internalOnSubmit();
        } finally{
            setIsSendingInvitation(false);
        }
    }, [
        getViralSettingsFlags,
        viralSettingsFlags,
        invitePeopleData,
        inviteUsers,
        onSendHandler,
        onSubmit,
        processDirectAccessSettings,
        processOpenInviteSettings,
        showFlag,
        isDriveMultiProductInvitesExperimentEnrolled,
        getEligibleUsersAndProducts,
        analytics,
        driveMultiProductInvitesExperimentCohort,
        selectedProducts,
        setUserPickerOptions,
        setSuccessfulInviteText,
        setSelectedProducts
    ]);
    const isFormLoading = isThirdPartyLoading || invitePeopleLoading || isFetchProductsLoading || itpt.isLoading || isInfiSpotlightLoading;
    (0, $5uXOq.useEffect)(()=>{
        if (isFormLoading) (0, $kPhww.startMeasure)('inviteFormLoad');
        else (0, $kPhww.stopMeasure)('inviteFormLoad', (duration, _)=>{
            analytics.inviteFormLoaded(duration, hasPermissionToInviteOrRequestAccess);
        });
    }, [
        analytics,
        hasPermissionToInviteOrRequestAccess,
        isFormLoading
    ]);
    const onCancelButtonClick = (0, $5uXOq.useCallback)(async (isSuccessModal)=>{
        abortThirdPartyRequests();
        if (onCancelHandler) onCancelHandler();
        if (isSuccessModal) showFlag && viralSettingsFlags.forEach(showFlag);
    }, [
        abortThirdPartyRequests,
        onCancelHandler,
        showFlag,
        viralSettingsFlags
    ]);
    const shouldDisplayNoInvitePermissionMessage = !disableNoInviteError && !hasPermissionToInviteOrRequestAccess;
    const showInviteSuccessContent = successfulInviteText && multiInviteEligibleProducts && multiInviteInvitedProducts && shouldDisplayInviteSuccessContent;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fkAmK.default), {
        errorCallback: ()=>{
            (0, $lWbFO.invitePeopleRendered).failure();
        },
        children: [
            isFormLoading || forceLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                alignBlock: "center",
                alignInline: "center",
                testId: "testId-invite-people-spinner",
                xcss: $845d34fd2dc2ad56$var$styles.spinnerWrapper,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {})
            }) : shouldDisplayNoInvitePermissionMessage ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $14Qmx.default), {
                onAcknowledgeButtonClick: onCancelButtonClick
            }) : showInviteSuccessContent ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h0W5W.InviteSuccessContent), {
                successfulInviteText: successfulInviteText,
                availableProducts: multiInviteEligibleProducts,
                invitees: userPickerOptions,
                invitedProducts: multiInviteInvitedProducts,
                onInviteButtonClick: onSubmitCallback,
                onCancelButtonClick: onCancelButtonClick,
                isSendingInvitation: isSendingInvitation
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a5Jah.default), {
                alignButtons: alignButtons,
                cancelButtonLabel: cancelButtonLabel,
                hideCancelButton: hideCancelButton,
                formTitle: formTitle,
                hideFormHeader: hideFormHeader,
                formDescription: formDescription,
                maxNumberOfInputs: maxInputs,
                isSendingInvitation: isSendingInvitation,
                onInviteButtonClick: onSubmitCallback,
                onCancelButtonClick: onCancelButtonClick,
                sendButtonLabel: sendButtonLabel,
                productOptions: availableProductOptions,
                onInviteeListChange: onInviteeListChangeCallback,
                showFlag: showFlag,
                uniqueEmailDomains: uniqueEmailDomains,
                selectedProducts: selectedProducts,
                showSecondarySection: shouldShowSecondarySection,
                titleId: titleId,
                experimental_formTitleByline: experimental_formTitleByline,
                experimental_submitButtonRef: experimental_submitButtonRef,
                experimental_onCloseTurnOnInviteLinkModal: experimental_onCloseTurnOnInviteLinkModal
            }),
            _hasError && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kx8ta.Buggy), {}),
            !isFormLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $luvXZ.ExperienceSuccess), {
                experience: (0, $lWbFO.invitePeopleRendered)
            })
        ]
    });
};
const $845d34fd2dc2ad56$var$InvitePeople = (0, $444qv.withExperimentalFeatures)((props)=>{
    const { allowEmail: allowEmail, enableThirdParty: enableThirdParty, inviteeProvider: inviteeProvider, onCancelHandler: onCancelHandler, orgId: orgId, plugins: plugins, productOptions: productOptions, resourceAri: resourceAri, showFlag: showFlag, displayInfiSpotlight: displayInfiSpotlight, source: source, subProduct: subProduct, userRole: userRole, viewAs: viewAs, disableViralSettings: disableViralSettings = false, disableNoInviteError: disableNoInviteError = false, onInviteeListFocus: onInviteeListFocus, initialInvitees: initialInvitees, experimental_userPickerByline: experimental_userPickerByline, experimental_inviteLink: experimental_inviteLink, experimental_turnOnInviteLinkModalDismissed: experimental_turnOnInviteLinkModalDismissed } = props;
    (0, $f6U3Q.useUFOComponentExperience)((0, $lWbFO.invitePeopleRendered));
    // Disable all third party invites when we are in FedRAMP environment
    let enableThirdPartyProp = (0, $b4PzF.isFedRamp)() ? false : enableThirdParty;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i7Upr.InvitePeopleContext), {
        inviteeProvider: inviteeProvider,
        orgId: orgId,
        plugins: plugins,
        resourceAri: resourceAri,
        source: source,
        subProduct: subProduct,
        userRole: userRole,
        viewAs: viewAs,
        disableNoInviteError: disableNoInviteError,
        experimental_inviteLink: experimental_inviteLink,
        experimental_turnOnInviteLinkModalDismissed: experimental_turnOnInviteLinkModalDismissed,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5mSkC.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dCNWF.ThirdPartyContext), {
                enableThirdParty: enableThirdPartyProp,
                showFlag: showFlag,
                onCancelButtonClick: onCancelHandler,
                displayInfiSpotlight: displayInfiSpotlight,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cfWle.CoreInvitesJiraProjectContext), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4gxY5.ProductContext), {
                        resourceAri: resourceAri,
                        productOptions: productOptions,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1CnPD.InviteeListContext), {
                            allowEmail: allowEmail,
                            initialInvitees: initialInvitees,
                            experimental_userPickerByline: experimental_userPickerByline,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h23hB.CoreInvitesDriveMultiProductInvitesContext), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hofb1.ViralSettingsContext), {
                                    disableViralSettings: disableViralSettings,
                                    onInviteeListFocus: onInviteeListFocus,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($845d34fd2dc2ad56$var$InvitePeopleContainer, {
                                        ...props
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
});
const $845d34fd2dc2ad56$var$analyticsContextData = {
    source: (0, $hatDq.AnalyticsSource).ADD_PEOPLE,
    componentName: 'addPeople'
};
const $845d34fd2dc2ad56$export$9dbc3ab01ac4df16 = (0, $asiGE.default)($845d34fd2dc2ad56$var$analyticsContextData)($845d34fd2dc2ad56$var$InvitePeople);
var $845d34fd2dc2ad56$export$2e2bcd8739ae039 = $845d34fd2dc2ad56$var$InvitePeople;

});
parcelRegister("f6U3Q", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $83c8f3be827dc0a6$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $83c8f3be827dc0a6$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $83c8f3be827dc0a6$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $83c8f3be827dc0a6$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("hatDq", function(module, exports) {

$parcel$export(module.exports, "InviteProcessingResponseStatus", () => $5e67ea0dba098f88$export$84ac6743b4a854ba);
$parcel$export(module.exports, "isUserWithEmail", () => $5e67ea0dba098f88$export$d920ab469024b0a2);
$parcel$export(module.exports, "FAILED_FETCH_ERROR_MESSAGE", () => $5e67ea0dba098f88$export$1f2663aaa83f036d);
$parcel$export(module.exports, "NETWORK_ERROR_MESSAGE", () => $5e67ea0dba098f88$export$65e55894e6e38a89);
$parcel$export(module.exports, "HOST_NOT_FOUND_ERROR_MESSAGE", () => $5e67ea0dba098f88$export$f25400ad927aa79c);
$parcel$export(module.exports, "INVALID_DOMAIN_ERROR_GET_MESSAGE", () => $5e67ea0dba098f88$export$74522527b7af776f);
$parcel$export(module.exports, "INVALID_DOMAIN_POST_ERROR_MESSAGE", () => $5e67ea0dba098f88$export$dfe34f0e34543417);
$parcel$export(module.exports, "EMAIL_BLOCKED", () => $5e67ea0dba098f88$export$c53f16dd5442ef61);
$parcel$export(module.exports, "REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS", () => $5e67ea0dba098f88$export$e27975535396141b);
$parcel$export(module.exports, "ERROR_KEY_NO_DEFAULT_GROUP", () => $5e67ea0dba098f88$export$80a3c1a1eb6f063);
$parcel$export(module.exports, "NO_DEFAULT_GROUP_ERROR_MESSAGE", () => $5e67ea0dba098f88$export$e089e1d2018847da);
$parcel$export(module.exports, "AnalyticsActionSubject", () => $5e67ea0dba098f88$export$4bce2c1f3a5d9f61);
$parcel$export(module.exports, "AnalyticsActionSubjectId", () => $5e67ea0dba098f88$export$19a393ff78a8b176);
$parcel$export(module.exports, "AnalyticsAction", () => $5e67ea0dba098f88$export$30c16f5c43437fd7);
$parcel$export(module.exports, "AnalyticsSource", () => $5e67ea0dba098f88$export$6890652a1aff7d1c);
$parcel$export(module.exports, "Cohort", () => $5e67ea0dba098f88$export$b76685d1b5a37732);
$parcel$export(module.exports, "InviteThirdPartyTeamsIneligibilityReasons", () => $5e67ea0dba098f88$export$beedb3f99d95a18f);
$parcel$export(module.exports, "ZIndex", () => $5e67ea0dba098f88$export$ccb31788083e2069);
$parcel$export(module.exports, "ExperimentKeys", () => $5e67ea0dba098f88$export$69fafa75f060ba9);

var $fJpmn = parcelRequire("fJpmn");
var $5e67ea0dba098f88$export$84ac6743b4a854ba = /*#__PURE__*/ function(InviteProcessingResponseStatus) {
    InviteProcessingResponseStatus["SUCCESS"] = "success";
    InviteProcessingResponseStatus["ERROR"] = "error";
    InviteProcessingResponseStatus["SKIPPED"] = "skipped";
    return InviteProcessingResponseStatus;
}({});
const $5e67ea0dba098f88$export$e69af2c4378638a2 = 'FREE_EDITION';
const $5e67ea0dba098f88$export$7bc7dd5faba7ad6b = 'STANDARD_EDITION';
const $5e67ea0dba098f88$export$3fd0bbb8c68dc4c7 = 'PREMIUM_EDITION';
const $5e67ea0dba098f88$export$5747d23113da6aa6 = 'UNLICENSED';
const $5e67ea0dba098f88$export$df995a7dd740d05d = 'basic';
const $5e67ea0dba098f88$export$f0687e90ca148638 = 'admin';
const $5e67ea0dba098f88$export$22ffbac394665747 = 'trusted';
var $5e67ea0dba098f88$export$e5ad17c39dfb6a42 = /*#__PURE__*/ function(IneligibilityReasons) {
    IneligibilityReasons["ERROR"] = "error";
    IneligibilityReasons["NON_ENGLISH"] = "non-english";
    IneligibilityReasons["NOT_ADMIN_USER"] = "not-admin-user";
    IneligibilityReasons["EDITION_NOT_FREE"] = "edition-not-free";
    IneligibilityReasons["NOT_HAMS"] = "not-hams";
    IneligibilityReasons["NO_COMMERCE_INFO"] = "no-commerce-info";
    IneligibilityReasons["NO_ELIGIBLE_USERS"] = "no-eligible-users";
    IneligibilityReasons["CONFLUENCE_BEFORE_JIRA"] = "confluence-before-jira";
    return IneligibilityReasons;
}({});
const $5e67ea0dba098f88$export$d920ab469024b0a2 = (user)=>{
    // our usage involves Array<InvitedUser> and it could be an empty array,
    // which may result user to be undefined
    // See noUncheckedIndexedAccess in Typescript for details
    if (user && user.email) return true;
    return false;
};
const $5e67ea0dba098f88$export$1f2663aaa83f036d = 'Failed to fetch';
const $5e67ea0dba098f88$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $5e67ea0dba098f88$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $5e67ea0dba098f88$export$74522527b7af776f = 'getDesPromotionEligibleDomain.arg0.domainAri: a valid domain is required';
const $5e67ea0dba098f88$export$dfe34f0e34543417 = 'Invalid domain';
const $5e67ea0dba098f88$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $5e67ea0dba098f88$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $5e67ea0dba098f88$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $5e67ea0dba098f88$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $5e67ea0dba098f88$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $5e67ea0dba098f88$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $5e67ea0dba098f88$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $5e67ea0dba098f88$export$e089e1d2018847da = 'Default group for the requested resource not found.';
var $5e67ea0dba098f88$export$4bce2c1f3a5d9f61 = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["ELIGIBILITY"] = "eligibility";
    AnalyticsActionSubject["INVITE_FORM"] = "inviteForm";
    AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
    AnalyticsActionSubject["USER"] = "user";
    AnalyticsActionSubject["PRODUCT_ACCESS"] = "productAccess";
    AnalyticsActionSubject["INVITE"] = "invite";
    AnalyticsActionSubject["INVITE_REQUEST"] = "inviteRequest";
    AnalyticsActionSubject["SLO_INVITE_REQUEST"] = "sloInviteRequest";
    AnalyticsActionSubject["SLO_THIRD_PARTY_INIT"] = "sloThirdPartyInit";
    AnalyticsActionSubject["THIRD_PARTY_INIT"] = "thirdPartyInit";
    AnalyticsActionSubject["LINK"] = "link";
    AnalyticsActionSubject["BUTTON"] = "button";
    AnalyticsActionSubject["PERMS"] = "permissions";
    AnalyticsActionSubject["INVITE_CAPABILITIES"] = "inviteCapabilities";
    AnalyticsActionSubject["INVITE_PEOPLE_FEATURE"] = "feature";
    AnalyticsActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
    AnalyticsActionSubject["DROPDOWN"] = "dropdown";
    AnalyticsActionSubject["INVITEE_LIST"] = "inviteeList";
    AnalyticsActionSubject["INVITEE_LIST_ITEM"] = "inviteeListItem";
    AnalyticsActionSubject["INVITEE_LIST_ITEM_USER_PICKER"] = "inviteeListItemUserPicker";
    AnalyticsActionSubject["USER_PICKER"] = "userPicker";
    AnalyticsActionSubject["CHECKBOX"] = "checkbox";
    AnalyticsActionSubject["SETTINGS"] = "settings";
    AnalyticsActionSubject["MODAL"] = "modal";
    AnalyticsActionSubject["THIRD_PARTY_INVITES"] = "thirdPartyInvites";
    AnalyticsActionSubject["THIRD_PARTY_INTEGRATION"] = "thirdPartyIntegration";
    AnalyticsActionSubject["THIRD_PARTY_INTEGRATIONS"] = "thirdPartyIntegrations";
    AnalyticsActionSubject["EMAIL_INPUT"] = "emailInput";
    AnalyticsActionSubject["GET_USER_INVITES_SETTINGS"] = "getUserInvitesSettings";
    AnalyticsActionSubject["GET_DIRECT_ACCESS_SETTING"] = "getDirectAccessSetting";
    AnalyticsActionSubject["APPROVED_DOMAIN_SETTINGS"] = "approvedDomainsSettings";
    AnalyticsActionSubject["USER_INVITE_SETTINGS"] = "userInvitesSettings";
    AnalyticsActionSubject["SLO_GET_USER_INVITES_SETTINGS"] = "sloGetUserInvitesSettings";
    AnalyticsActionSubject["SLO_GET_DIRECT_ACCESS_SETTING"] = "sloGetDirectAccessSetting";
    AnalyticsActionSubject["SLO_APPROVED_DOMAIN_SETTINGS"] = "sloApprovedDomainsSettings";
    AnalyticsActionSubject["SLO_USER_INVITE_SETTINGS"] = "sloUserInvitesSettings";
    AnalyticsActionSubject["CORE_INVITE_COMPONENT"] = "coreInviteComponent";
    AnalyticsActionSubject["USER_INVITE_SETTINGS_HISI"] = "userInvitesSettingsHISI";
    AnalyticsActionSubject["SLACK_WORKSPACES"] = "slackWorkspaces";
    AnalyticsActionSubject["ACCOUNT_INFO"] = "accountInfo";
    AnalyticsActionSubject["FETCH_EXISTING_INTEGRATIONS"] = "fetchExistingIntegrations";
    AnalyticsActionSubject["FETCH_ORG_SETTINGS"] = "fetchOrgSettings";
    AnalyticsActionSubject["VALIDATION"] = "validation";
    AnalyticsActionSubject["TEAM_MEMBER_PICKER"] = "teamMemberPicker";
    AnalyticsActionSubject["TEAM_OR_USER_PICKER"] = "teamOrUserPicker";
    AnalyticsActionSubject["SLACK_CHANNEL"] = "slackChannel";
    AnalyticsActionSubject["SLACK_USER"] = "slackUser";
    AnalyticsActionSubject["GET_SLACK_CHANNELS"] = "getSlackChannels";
    AnalyticsActionSubject["VIEW_SLACK_TEAM_MEMBERS"] = "viewSlackTeamMembers";
    AnalyticsActionSubject["NO_INVITE_PERMOISSION_SCREEN"] = "noInvitePermissionScreen";
    AnalyticsActionSubject["FETCH_LINKED_ORG"] = "fetchLinkedOrg";
    AnalyticsActionSubject["FETCH_OPEN_INVITE_NOTE"] = "fetchOpenInviteNote";
    AnalyticsActionSubject["TRANSLATION_MESSAGE"] = "translationMessage";
    AnalyticsActionSubject["INFI_SPOTLIGHT"] = "infiSpotlight";
    AnalyticsActionSubject["SET_USER_AS_ADMIN"] = "setUserAsAdmin";
    AnalyticsActionSubject["FETCH_COMMERCE_INFO"] = "fetchCommerceInfo";
    AnalyticsActionSubject["TEAM_INVITES"] = "teamInvites";
    AnalyticsActionSubject["FETCH_ELIGIBLE_USERS"] = "fetchEligibleUsers";
    AnalyticsActionSubject["DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL"] = "driveMultiProductsSuccessModal";
    AnalyticsActionSubject["PRODUCT_CHECKBOX"] = "productCheckbox";
    return AnalyticsActionSubject;
}({});
var $5e67ea0dba098f88$export$19a393ff78a8b176 = /*#__PURE__*/ function(AnalyticsActionSubjectId) {
    AnalyticsActionSubjectId["CONNECT"] = "connect";
    AnalyticsActionSubjectId["CONTINUE_UPDATE"] = "continueUpdate";
    AnalyticsActionSubjectId["DISCONNECT_UPDATE"] = "disconnectUpdate";
    AnalyticsActionSubjectId["NOT_NOW_UPDATE"] = "notNowUpdate";
    AnalyticsActionSubjectId["UPDATE_WARNING"] = "updateWarning";
    AnalyticsActionSubjectId["FORM"] = "form";
    AnalyticsActionSubjectId["PLUGINS"] = "plugins";
    AnalyticsActionSubjectId["USER_MANAGEMENT"] = "userManagementLink";
    AnalyticsActionSubjectId["ADD_YOUR_TEAM"] = "addYourTeam";
    AnalyticsActionSubjectId["ENABLE_INVITE_LINK_CLOSE"] = "enableInviteLinkCloseButton";
    AnalyticsActionSubjectId["ENABLE_INVITE_LINK_TOGGLE"] = "enableInviteLinkToggle";
    AnalyticsActionSubjectId["COPY_INVITE_LINK_BUTTON"] = "copyInviteLinkButton";
    AnalyticsActionSubjectId["SUBMIT_DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL"] = "submitDriveMultiProductsSuccessModal";
    AnalyticsActionSubjectId["EXIT_DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL"] = "exitDriveMultiProductsSuccessModal";
    return AnalyticsActionSubjectId;
}({});
var $5e67ea0dba098f88$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["CHECKED"] = "checked";
    AnalyticsAction["UNCHECKED"] = "unchecked";
    AnalyticsAction["LOADED"] = "loaded";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["ADDED"] = "added";
    AnalyticsAction["INVITED"] = "invited";
    AnalyticsAction["REQUESTED"] = "requested";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["EXPOSED"] = "exposed";
    AnalyticsAction["OPENED"] = "opened";
    AnalyticsAction["AUTO_OPENED"] = "autoOpened";
    AnalyticsAction["CLOSED"] = "closed";
    AnalyticsAction["SKIPPED"] = "skipped";
    AnalyticsAction["CONNECTED"] = "connected";
    AnalyticsAction["CHANGED"] = "changed";
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["UPDATED"] = "updated";
    AnalyticsAction["UPDATE_FAILED"] = "updateFailed";
    AnalyticsAction["CREATED"] = "created";
    AnalyticsAction["CREATE_FAILED"] = "createFailed";
    AnalyticsAction["FETCHED"] = "fetched";
    AnalyticsAction["FETCH_FAILED"] = "fetchFailed";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["HOVERED"] = "hovered";
    AnalyticsAction["TYPED"] = "typed";
    AnalyticsAction["SENT"] = "sent";
    AnalyticsAction["SELECTED"] = "selected";
    AnalyticsAction["EXCLUDED"] = "excluded";
    AnalyticsAction["PREFILLED"] = "prefilled";
    AnalyticsAction["DISMISSED"] = "dismissed";
    return AnalyticsAction;
}({});
var $5e67ea0dba098f88$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["ADD_PEOPLE"] = "addPeople";
    AnalyticsSource["SLACK_CONNECT_MODAL"] = "slackConnectModal";
    return AnalyticsSource;
}({});
var $5e67ea0dba098f88$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["VARIATION"] = "variation";
    Cohort["EXPERIMENT"] = "experiment";
    Cohort["CONTROL"] = "control";
    Cohort["NOT_ENROLLED"] = "not-enrolled";
    return Cohort;
}({});
var $5e67ea0dba098f88$export$beedb3f99d95a18f = /*#__PURE__*/ function(InviteThirdPartyTeamsIneligibilityReasons) {
    InviteThirdPartyTeamsIneligibilityReasons["NOT_ENROLLED"] = "not-enrolled";
    InviteThirdPartyTeamsIneligibilityReasons["ORG_CONTROL_SETTINGS_OFF"] = "org-control-settings-off";
    InviteThirdPartyTeamsIneligibilityReasons["SLACK_NOT_CONNECTED"] = "slack-app-not-connected";
    InviteThirdPartyTeamsIneligibilityReasons["NON_ENGLISH"] = "non-english";
    InviteThirdPartyTeamsIneligibilityReasons["MOBILE"] = "mobile";
    return InviteThirdPartyTeamsIneligibilityReasons;
}({});
var $5e67ea0dba098f88$export$ccb31788083e2069 = /*#__PURE__*/ function(ZIndex) {
    ZIndex[ZIndex["MODAL"] = 510] = "MODAL";
    ZIndex[ZIndex["DRAWER"] = 550] = "DRAWER";
    ZIndex[ZIndex["FLOATING"] = 560] = "FLOATING";
    return ZIndex;
}({});
var $5e67ea0dba098f88$export$69fafa75f060ba9 = /*#__PURE__*/ function(ExperimentKeys) {
    ExperimentKeys["SLACK_AUTO_CONNECT"] = "core_invites_auto_slack_select";
    ExperimentKeys["STICKY_EMAIL_INVITE"] = "peu_expansion_add_people_modal_sticky_email_invite";
    return ExperimentKeys;
}({});

});
parcelRegister("fJpmn", function(module, exports) {

$parcel$export(module.exports, "Integration", () => $9f1ce306e6694634$export$8912007324034abd);
$parcel$export(module.exports, "ScopeState", () => $9f1ce306e6694634$export$fe404a09c1c6b674);
var $9f1ce306e6694634$export$8912007324034abd = /*#__PURE__*/ function(Integration) {
    Integration["GOOGLE_SERVICE"] = "google-invites";
    Integration["MICROSOFT_SERVICE"] = "microsoft-invites";
    Integration["PLATFORM_SLACK_SERVICE"] = "slack";
    return Integration;
}({});
var $9f1ce306e6694634$export$fe404a09c1c6b674 = /*#__PURE__*/ function(ScopeState) {
    ScopeState["NO_SCOPE"] = "no-scope";
    ScopeState["PARTIAL_SCOPE"] = "partial-scope";
    ScopeState["FULL_SCOPE"] = "full-scope";
    return ScopeState;
}({});

});


parcelRegister("Zeu50", function(module, exports) {

$parcel$export(module.exports, "INVITE_API_MAX_USERS", () => $40d9957c69c42a64$export$d42990f9794abc1);
$parcel$export(module.exports, "InviteApiClientImpl", () => $40d9957c69c42a64$export$72a09965ba18562f);

var $hatDq = parcelRequire("hatDq");

var $z3rjp = parcelRequire("z3rjp");

var $kx8ta = parcelRequire("kx8ta");

var $evtmo = parcelRequire("evtmo");
const $40d9957c69c42a64$var$LICENCE_EXCEEDED_ARI_REGEX = /(\[ari:.*?)(\/.*)(\])/;
const $40d9957c69c42a64$export$d42990f9794abc1 = 10;
class $40d9957c69c42a64$export$72a09965ba18562f {
    constructor(){
        this.clearDESCache = ()=>{
            this.directAccessSettingsCache.clear();
        };
        this.getProductDetails = (productArray)=>productArray.map((p)=>({
                    name: (0, $kx8ta.getProductTitleFromAri)(p),
                    id: (0, $kx8ta.getProductIdFromResource)(p) || '',
                    ari: p
                }));
        this.getProductDetailsWithDomains = (productRecord)=>Object.keys(productRecord).map((p)=>({
                    name: (0, $kx8ta.getProductTitleFromAri)(p),
                    id: (0, $kx8ta.getProductIdFromResource)(p) || '',
                    ari: p,
                    domains: productRecord[p]
                }));
        this.directAccessSettingsCache = new Map();
    }
    async enableInviteLink(resourceId) {
        const enableInviteLinkResponse = await (0, $evtmo.postJson)((0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL) + (0, $z3rjp.ENABLE_INVITE_LINK_URL), 'enableInviteLink', {
            resourceId: resourceId
        });
        return enableInviteLinkResponse;
    }
    // only emails are supported for invites - VULN-1024816
    async inviteUsers(request, recaptchaOptions) {
        return this.inviteUsersCommon(request, (0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL) + (0, $z3rjp.BULK_INVITE_URL), recaptchaOptions);
    }
    // support both aaid and emails, users have to be in the same org, using v3/invitations/invite
    async inviteUsersV3(request, recaptchaOptions) {
        return this.inviteUsersCommon(request, (0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL) + (0, $z3rjp.BULK_INVITE_URL_V3), recaptchaOptions);
    }
    async inviteUsersCommon(request, url, recaptchaOptions) {
        try {
            const inviteApiResponse = await (0, $evtmo.postJson)(url, 'inviteUsers', request, recaptchaOptions);
            return this.handleInviteUsersSuccessResponse(inviteApiResponse);
        } catch (err) {
            if (err instanceof (0, $evtmo.FetchError)) {
                const inviteApiResponse = err.responseJson;
                if (inviteApiResponse) {
                    const failureResponse = {
                        status: err.responseCode,
                        ...inviteApiResponse
                    };
                    return this.handleInviteUsersFailureResponse(failureResponse);
                }
            }
            throw err;
        }
    }
    async inviteCapabilities(cloudId) {
        const resource = `ari:cloud:platform::site/${cloudId}`;
        const url = `${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.INVITE_CAPABILITIES)}?resource=${resource}`;
        const capabilitiesResponse = await (0, $evtmo.fetchJson)(url, 'inviteCapabilities');
        return this.handleCapabilitiesResponse(capabilitiesResponse);
    }
    handleCapabilitiesResponse(response) {
        const directInvite = {};
        const invitePendingApproval = new Set();
        if (Array.isArray(response)) response.forEach((entry)=>{
            if ('NONE' !== entry.directInvite.mode) directInvite[entry.resourceARI] = entry.directInvite.domains;
            if (!invitePendingApproval.has(entry.resourceARI) && 'NONE' !== entry.invitePendingApproval.mode) invitePendingApproval.add(entry.resourceARI);
        });
        return {
            directInvite: this.getProductDetailsWithDomains(directInvite),
            invitePendingApproval: this.getProductDetails(Array.from(invitePendingApproval))
        };
    }
    cleanErrorMessage(message) {
        // Remove AIDs from ARIs in error messages to better group in logs
        // - Licence Exceeded for resources:[ari:cloud:confluence::site/aaaaaaaa-64d4-469e-91df-bbbbbbbbbbbb]
        return message ? message.replace($40d9957c69c42a64$var$LICENCE_EXCEEDED_ARI_REGEX, '$1$3') : '';
    }
    handleInviteUsersFailureResponse(errorResponse) {
        return {
            failure: {
                ...errorResponse,
                message: this.cleanErrorMessage(errorResponse.message)
            }
        };
    }
    hasUser(users, invitedUser) {
        return users.some((user)=>(0, $hatDq.isUserWithEmail)(user) && (0, $hatDq.isUserWithEmail)(invitedUser) && user.email === invitedUser.email || user.id === invitedUser.id);
    }
    handleInviteUsersSuccessResponse(response) {
        return response.reduce((accumulator, userResponse)=>{
            const user = (0, $hatDq.isUserWithEmail)(userResponse) ? {
                id: userResponse.id,
                email: userResponse.email
            } : {
                id: userResponse.id
            };
            Object.keys(userResponse.results).forEach((resource)=>{
                switch(userResponse.results[resource]){
                    case 'INVITED':
                    case 'USER_EXISTS':
                        if (!this.hasUser(accumulator.invited, user)) accumulator.invited.push({
                            ...user,
                            results: userResponse.results
                        });
                        break;
                    case 'INVITED_PENDING_APPROVAL':
                    case 'PENDING_INVITE_EXISTS':
                        if (!this.hasUser(accumulator.accessRequested, user)) accumulator.accessRequested.push({
                            ...user,
                            results: userResponse.results
                        });
                        break;
                    case 'NOT_INVITED':
                    case 'ERROR':
                        accumulator.error.push({
                            ...user,
                            error: userResponse.errorReasons[resource]
                        });
                        break;
                }
            });
            return accumulator;
        }, {
            invited: [],
            accessRequested: [],
            error: []
        });
    }
    async updateDirectAccessSettings({ product: product, cloudId: cloudId, location: location, domains: domains }) {
        const resource = `ari:cloud:${product}::site/${cloudId}`;
        const url = `${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.DIRECT_ACCESS_URL)}`;
        const request = {
            resource: resource,
            domains: domains,
            location: location,
            action: 'ACCEPT',
            setting: 'DIRECT_ACCESS'
        };
        await (0, $evtmo.postRequest)(url, 'updateDirectAccessSettings', request);
        return {
            success: true,
            updateDirectAccessSettings: true
        };
    }
    async getDirectAccessSetting(request) {
        const performFetch = ()=>{
            const url = `${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.DIRECT_ACCESS_URL)}`;
            const queryParams = `resource=${request.productAri}&domain=${request.domain}&setting=${request.setting}${request.roleAri ? '&role=' + request.roleAri : ''}`;
            return (0, $evtmo.fetchJson)(`${url}?${queryParams}`, 'getDirectAccessSetting');
        };
        const cacheValue = this.directAccessSettingsCache.get(request.domain);
        if (cacheValue) return {
            response: cacheValue,
            cached: true
        };
        try {
            const responseJson = await performFetch();
            (0, $kx8ta.tryCacheWithClear)(this.directAccessSettingsCache, request.domain, responseJson);
            return {
                response: responseJson,
                cached: false
            };
        } catch (err) {
            const { responseCode: responseCode, errorMessage: errorMessage } = (0, $kx8ta.resolveError)(err);
            if (responseCode && responseCode >= (0, $evtmo.RespCodes).BAD_REQUESTS && responseCode <= (0, $evtmo.RespCodes).CLIENT_CLOSED_REQUEST) {
                const failResponseJson = {
                    domain: request.domain,
                    errorMessage: errorMessage
                };
                (0, $kx8ta.tryCacheWithClear)(this.directAccessSettingsCache, request.domain, failResponseJson);
            }
            throw err;
        }
    }
}

});
parcelRegister("z3rjp", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_STARGATE_SERVICE_URL", () => $b821d16762307881$export$ab2f49a861856bab);
$parcel$export(module.exports, "PERMS_URL", () => $b821d16762307881$export$66fa0c6c43bacd3);
$parcel$export(module.exports, "BULK_INVITE_URL", () => $b821d16762307881$export$c7fa419e71056b84);
$parcel$export(module.exports, "BULK_INVITE_URL_V3", () => $b821d16762307881$export$700fd7b853cf5f4c);
$parcel$export(module.exports, "INVITE_CAPABILITIES", () => $b821d16762307881$export$df4d1d71f09676b7);
$parcel$export(module.exports, "EXUS_THIRDPARTY_PATH", () => $b821d16762307881$export$127769e597bc5ee5);
$parcel$export(module.exports, "OPEN_INVITE_URL", () => $b821d16762307881$export$8502189f48a6b180);
$parcel$export(module.exports, "PERSONALIZATION_URL", () => $b821d16762307881$export$28fb02d117a2ff8e);
$parcel$export(module.exports, "DIRECT_ACCESS_URL", () => $b821d16762307881$export$e84ade9978c1dd85);
$parcel$export(module.exports, "HAVE_I_SEEN_IT_URL", () => $b821d16762307881$export$c1f083639d344e75);
$parcel$export(module.exports, "ITPT_PATH", () => $b821d16762307881$export$20875166a8676880);
$parcel$export(module.exports, "ITPT_SLACK_CHANNELS", () => $b821d16762307881$export$3f9855fcc7fa383e);
$parcel$export(module.exports, "ITPT_SLACK_CHANNEL_MEMBERS", () => $b821d16762307881$export$f459f1b9d62b623d);
$parcel$export(module.exports, "ITPT_SLACK_USERS_DETAILS", () => $b821d16762307881$export$70c95ef85b316ebb);
$parcel$export(module.exports, "ELIGIBLE_USERS", () => $b821d16762307881$export$6ec4e6be7b1593f6);
$parcel$export(module.exports, "ENABLE_INVITE_LINK_URL", () => $b821d16762307881$export$d28df4155ae9b18c);
$parcel$export(module.exports, "getOpenInviteNoteUrl", () => $b821d16762307881$export$fccab8714d2fb082);
const $b821d16762307881$export$ab2f49a861856bab = '/gateway/api';
const $b821d16762307881$export$66fa0c6c43bacd3 = '/permissions/permitted';
const $b821d16762307881$export$c7fa419e71056b84 = '/invitations/invite';
const $b821d16762307881$export$700fd7b853cf5f4c = '/v3/invitations/invite';
const $b821d16762307881$export$df4d1d71f09676b7 = '/v3/invitations/capabilities';
const $b821d16762307881$export$127769e597bc5ee5 = '/external-users/third-party';
const $b821d16762307881$export$8502189f48a6b180 = '/invitations/v1/settings/open-invite';
const $b821d16762307881$export$28fb02d117a2ff8e = '/gateway/api/tap-delivery/api/v3/personalization';
const $b821d16762307881$export$e84ade9978c1dd85 = '/invitations/v1/settings/domain-enabled-signup-promotion';
const $b821d16762307881$export$c1f083639d344e75 = '/flag/my';
const $b821d16762307881$export$8bad17bb0225d989 = '/external-users/orgs';
const $b821d16762307881$export$20875166a8676880 = '/growth/invite-3rd-party-teams';
const $b821d16762307881$export$3f9855fcc7fa383e = '/slack-channels';
const $b821d16762307881$export$f459f1b9d62b623d = '/slack-channel-members';
const $b821d16762307881$export$70c95ef85b316ebb = '/slack-users-details';
const $b821d16762307881$export$f25cfc1135892102 = `${$b821d16762307881$export$ab2f49a861856bab}/bag`;
const $b821d16762307881$export$6ec4e6be7b1593f6 = '/growth/ci-funnel-improvement/get-eligible-users';
const $b821d16762307881$export$d28df4155ae9b18c = '/invitations/v1/settings/invitation-urls';
const $b821d16762307881$export$fccab8714d2fb082 = (stargateUrl, orgId)=>`${stargateUrl}/invitations/v1/access-settings/org/${orgId}/open-invite/note`;

});

parcelRegister("kx8ta", function(module, exports) {

$parcel$export(module.exports, "adminHubManageUsersHref", () => $11e7e480d4e6ef66$export$86cd9788f4cc29d7);
$parcel$export(module.exports, "CLOUD_ADMIN_URL", () => $11e7e480d4e6ef66$export$995f5f30765d3edb);
$parcel$export(module.exports, "extractDomainFromEmail", () => $11e7e480d4e6ef66$export$c8d36b71889c2b08);
$parcel$export(module.exports, "makeAri", () => $11e7e480d4e6ef66$export$ab73fcfda18c2aeb);
$parcel$export(module.exports, "getProductIdFromResource", () => $11e7e480d4e6ef66$export$8be157e92249183);
$parcel$export(module.exports, "getCloudIdFromResource", () => $11e7e480d4e6ef66$export$b0ff466e2a73d10e);
$parcel$export(module.exports, "JiraProductDiscovery", () => $11e7e480d4e6ef66$export$40da91bfe15db8da);
$parcel$export(module.exports, "JiraWorkManagementProduct", () => $11e7e480d4e6ef66$export$9179982b4340c968);
$parcel$export(module.exports, "JiraServiceManagementProduct", () => $11e7e480d4e6ef66$export$67dec66c2f84e131);
$parcel$export(module.exports, "JiraSoftwareProduct", () => $11e7e480d4e6ef66$export$c4c2eceeb6e5488b);
$parcel$export(module.exports, "JiraProduct", () => $11e7e480d4e6ef66$export$b39a466562b19f41);
$parcel$export(module.exports, "getBillingUrl", () => $11e7e480d4e6ef66$export$776b50dd35ff8711);
$parcel$export(module.exports, "isProductIdWhiteListed", () => $11e7e480d4e6ef66$export$1ef808db151854b6);
$parcel$export(module.exports, "getProductById", () => $11e7e480d4e6ef66$export$5db19e0f3922ef0f);
$parcel$export(module.exports, "getProductTitle", () => $11e7e480d4e6ef66$export$4289783c37f529ba);
$parcel$export(module.exports, "getProductTitleFromAri", () => $11e7e480d4e6ef66$export$ec409465a0eaca4c);
$parcel$export(module.exports, "getProductIcon", () => $11e7e480d4e6ef66$export$22a9451e3bf2233f);
$parcel$export(module.exports, "getLandingPathByProduct", () => $11e7e480d4e6ef66$export$7c8eb7667509870c);
$parcel$export(module.exports, "getDirectAccessLocation", () => $11e7e480d4e6ef66$export$c9b3979837c2ee2e);
$parcel$export(module.exports, "getInstanceUrl", () => $11e7e480d4e6ef66$export$a011c63d9bebc648);
$parcel$export(module.exports, "normalizeJiraSubProduct", () => $11e7e480d4e6ef66$export$837b3431660d7232);
$parcel$export(module.exports, "isMobile", () => $11e7e480d4e6ef66$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "isEnglishLocale", () => $11e7e480d4e6ef66$export$3ea53827ed349b2e);
$parcel$export(module.exports, "Buggy", () => $11e7e480d4e6ef66$export$6b52db8960fbef38);
$parcel$export(module.exports, "getUniqueEmailDomains", () => $11e7e480d4e6ef66$export$271463dc013c475e);
$parcel$export(module.exports, "waitForAllPromises", () => $11e7e480d4e6ef66$export$b43fdcffd84b7b0f);
$parcel$export(module.exports, "tryCacheWithClear", () => $11e7e480d4e6ef66$export$a117c7b833c15650);
$parcel$export(module.exports, "shouldReportFailedInvite", () => $11e7e480d4e6ef66$export$90cda429f609d666);
$parcel$export(module.exports, "isForbidden", () => $11e7e480d4e6ef66$export$7e9cf63a972dd62);
$parcel$export(module.exports, "isAcceptableFailureForUserInvite", () => $11e7e480d4e6ef66$export$1c4c1f7e2d529330);
$parcel$export(module.exports, "isAcceptableFailure", () => $11e7e480d4e6ef66$export$678d91a98f79a24d);
$parcel$export(module.exports, "isAcceptableFailureForDirectAccess", () => $11e7e480d4e6ef66$export$d167fb1c42f7d152);
$parcel$export(module.exports, "resolveInviteProcessingResponseStatus", () => $11e7e480d4e6ef66$export$6a44d7a50b763a1c);
$parcel$export(module.exports, "hasGmailDomain", () => $11e7e480d4e6ef66$export$90f8080789b02ddd);
$parcel$export(module.exports, "resolveError", () => $11e7e480d4e6ef66$export$b164e8e46eadcf65);
$parcel$export(module.exports, "getRecaptchaSiteKey", () => $11e7e480d4e6ef66$export$f6c02f8ff560b96f);
$parcel$export(module.exports, "chunk", () => $11e7e480d4e6ef66$export$5f7ec48d69707ddd);
$parcel$export(module.exports, "slackToExternalUser", () => $11e7e480d4e6ef66$export$db16b8d6f03d2f57);
$parcel$export(module.exports, "removeZeroWidthCharacters", () => $11e7e480d4e6ef66$export$d976e75aaf898758);
$parcel$export(module.exports, "getBooleanLocalStorageKey", () => $11e7e480d4e6ef66$export$ffacee591afa903e);
$parcel$export(module.exports, "getLocalStorageKey", () => $11e7e480d4e6ef66$export$f22967b337b5cd11);
$parcel$export(module.exports, "removeLocalStorageKey", () => $11e7e480d4e6ef66$export$686c665f7e55a917);
$parcel$export(module.exports, "updateLocalStorageKey", () => $11e7e480d4e6ef66$export$c27a17ef9ad21f43);
$parcel$export(module.exports, "adminManageUserInviteLinkHref", () => $11e7e480d4e6ef66$export$e422989e057b7a56);

var $5uXOq = parcelRequire("5uXOq");

var $26yQk = parcelRequire("26yQk");

var $2pBwG = parcelRequire("2pBwG");
var $27vD8 = parcelRequire("27vD8");
var $iItCF = parcelRequire("iItCF");
var $h6M2t = parcelRequire("h6M2t");
var $l9zAL = parcelRequire("l9zAL");
var $jo1Bz = parcelRequire("jo1Bz");
var $e9Y3k = parcelRequire("e9Y3k");
var $39fIG = parcelRequire("39fIG");
var $j7leM = parcelRequire("j7leM");
var $ds5Yo = parcelRequire("ds5Yo");
var $kWm7C = parcelRequire("kWm7C");
var $c9lm5 = parcelRequire("c9lm5");
var $9jZg7 = parcelRequire("9jZg7");
var $8yuGW = parcelRequire("8yuGW");
var $iiu6z = parcelRequire("iiu6z");
var $gNRNP = parcelRequire("gNRNP");

var $2ys8y = parcelRequire("2ys8y");

var $9CLBJ = parcelRequire("9CLBJ");

var $hatDq = parcelRequire("hatDq");

var $8TQ2j = parcelRequire("8TQ2j");

var $evtmo = parcelRequire("evtmo");

var $84Nhj = parcelRequire("84Nhj");
const $11e7e480d4e6ef66$var$userNetworkFailureMessages = [
    (0, $hatDq.FAILED_FETCH_ERROR_MESSAGE),
    (0, $hatDq.NETWORK_ERROR_MESSAGE),
    (0, $hatDq.HOST_NOT_FOUND_ERROR_MESSAGE)
];
const $11e7e480d4e6ef66$var$RECAPTCHA_SITE_KEY_PROD = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $11e7e480d4e6ef66$var$RECAPTCHA_SITE_KEY_STAGING = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $11e7e480d4e6ef66$var$RECAPTCHA_SITE_KEY_DEV = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';
const $11e7e480d4e6ef66$var$DEV_ENV_HOSTNAMES = [
    'localhost',
    '127.0.0.1',
    '0.0.0.0',
    'statlas.atl-paas.net',
    'atlaskit.atlassian.com'
];
const $11e7e480d4e6ef66$export$86cd9788f4cc29d7 = (cloudId)=>`${$11e7e480d4e6ef66$export$995f5f30765d3edb}/s/${cloudId}/users`;
const $11e7e480d4e6ef66$export$1cfdf9a01e3f7773 = ()=>window.location.host.includes('-dev.com') ? false : true;
const $11e7e480d4e6ef66$export$8d028de9c8e0908 = ()=>$11e7e480d4e6ef66$var$DEV_ENV_HOSTNAMES.includes(window.location.hostname);
const $11e7e480d4e6ef66$export$995f5f30765d3edb = `https://${(0, $2ys8y.getATLContextDomain)('admin')}`;
const $11e7e480d4e6ef66$export$c8d36b71889c2b08 = (email)=>{
    const parts = email.split('@');
    if (parts.length === 1) return null;
    else if (parts.length === 2 && !parts[0]) return null;
    else if (!parts[parts.length - 1]) return null;
    return parts[parts.length - 1];
};
const $11e7e480d4e6ef66$export$ab73fcfda18c2aeb = (productId, cloudId)=>`ari:cloud:${productId}::site/${cloudId}`;
const $11e7e480d4e6ef66$export$f8e7d14b19dc8ba5 = (resourceAri)=>{
    const splittedAri = resourceAri.split(':');
    const resourceOwner = splittedAri[2];
    const resourceTypeIdPair = splittedAri[4];
    const [resourceType, ...resourceIdParts] = resourceTypeIdPair.split('/');
    const resourceId = resourceIdParts.join('/');
    return {
        resourceOwner: resourceOwner,
        resourceType: resourceType,
        resourceId: resourceId
    };
};
const $11e7e480d4e6ef66$export$8be157e92249183 = (resourceAri)=>{
    try {
        const { resourceOwner: resourceOwner } = $11e7e480d4e6ef66$export$f8e7d14b19dc8ba5(resourceAri);
        return resourceOwner;
    } catch (err) {
        return undefined;
    }
};
const $11e7e480d4e6ef66$export$b0ff466e2a73d10e = (resourceAri)=>{
    try {
        const { resourceId: resourceId } = $11e7e480d4e6ef66$export$f8e7d14b19dc8ba5(resourceAri);
        return resourceId;
    } catch (err) {
        return undefined;
    }
};
const $11e7e480d4e6ef66$export$dd8cc78d5d02cf89 = {
    id: 'confluence',
    label: 'Confluence',
    landingPath: '/wiki',
    directAccessLocation: 'confluence.core-invites',
    icon: (0, $jo1Bz.ConfluenceIcon)
};
const $11e7e480d4e6ef66$export$40da91bfe15db8da = {
    id: 'jira-product-discovery',
    label: 'Jira Product Discovery',
    landingPath: '',
    directAccessLocation: 'jira.core-invites',
    icon: (0, $j7leM.JiraProductDiscoveryIcon)
};
const $11e7e480d4e6ef66$export$9179982b4340c968 = {
    id: 'jira-core',
    label: 'Jira Work Management',
    landingPath: '',
    directAccessLocation: 'jira.core-invites',
    icon: (0, $c9lm5.JiraWorkManagementIcon)
};
const $11e7e480d4e6ef66$export$f6ec4e033f9ed599 = {
    ...$11e7e480d4e6ef66$export$9179982b4340c968,
    label: 'Jira',
    icon: (0, $39fIG.JiraIcon)
};
const $11e7e480d4e6ef66$export$67dec66c2f84e131 = {
    id: 'jira-servicedesk',
    label: 'Jira Service Management',
    landingPath: '',
    directAccessLocation: 'jira.core-invites',
    icon: (0, $ds5Yo.JiraServiceManagementIcon)
};
const $11e7e480d4e6ef66$export$c4c2eceeb6e5488b = {
    id: 'jira-software',
    label: 'Jira Software',
    landingPath: '',
    directAccessLocation: 'jira.core-invites',
    icon: (0, $kWm7C.JiraSoftwareIcon)
};
const $11e7e480d4e6ef66$export$8e461a64f2fe0930 = {
    ...$11e7e480d4e6ef66$export$c4c2eceeb6e5488b,
    label: 'Jira',
    icon: (0, $39fIG.JiraIcon)
};
const $11e7e480d4e6ef66$export$b39a466562b19f41 = {
    id: 'jira',
    label: 'Jira',
    landingPath: '',
    directAccessLocation: 'jira.core-invites',
    icon: (0, $39fIG.JiraIcon)
};
const $11e7e480d4e6ef66$export$add2222f3be1ba4d = {
    id: 'trello',
    label: 'Trello',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $gNRNP.TrelloIcon)
};
const $11e7e480d4e6ef66$export$bc1299297da00fd1 = {
    id: 'bitbucket',
    label: 'Bitbucket',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $h6M2t.BitbucketIcon)
};
const $11e7e480d4e6ef66$export$258797e2c4e99332 = {
    id: 'statuspage',
    label: 'Statuspage',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $iiu6z.StatuspageIcon)
};
const $11e7e480d4e6ef66$export$7cd05929724a15f2 = {
    id: 'opsgenie',
    label: 'Opsgenie',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $8yuGW.OpsgenieIcon)
};
const $11e7e480d4e6ef66$export$31192b5cccb0825d = {
    id: 'compass',
    label: 'Compass',
    landingPath: '/compass',
    directAccessLocation: 'others.core-invites',
    icon: (0, $l9zAL.CompassIcon)
};
const $11e7e480d4e6ef66$export$5c823b2196b36f8e = {
    id: 'townsquare',
    label: 'Atlas',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $2pBwG.AtlasIcon)
};
const $11e7e480d4e6ef66$export$742bd743f317c0cf = {
    id: 'avp',
    label: 'Atlassian Analytics',
    landingPath: '/analytics',
    directAccessLocation: 'others.core-invites',
    icon: (0, $27vD8.AtlassianAnalyticsIcon)
};
const $11e7e480d4e6ef66$export$31b8979f35864357 = {
    id: 'jira-product-discovery',
    label: 'Jira Product Discovery',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $j7leM.JiraProductDiscoveryIcon)
};
const $11e7e480d4e6ef66$export$5d1c3cf9f58560fa = {
    id: 'mercury',
    label: 'Focus',
    landingPath: '/focus',
    directAccessLocation: 'others.core-invites',
    icon: (0, $e9Y3k.FocusIcon)
};
const $11e7e480d4e6ef66$export$f036eb35a54338c1 = {
    id: 'loom',
    label: 'Loom',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $9jZg7.LoomIcon)
};
const $11e7e480d4e6ef66$var$products = [
    $11e7e480d4e6ef66$export$dd8cc78d5d02cf89,
    $11e7e480d4e6ef66$export$f6ec4e033f9ed599,
    $11e7e480d4e6ef66$export$67dec66c2f84e131,
    $11e7e480d4e6ef66$export$8e461a64f2fe0930,
    $11e7e480d4e6ef66$export$b39a466562b19f41,
    $11e7e480d4e6ef66$export$add2222f3be1ba4d,
    $11e7e480d4e6ef66$export$bc1299297da00fd1,
    $11e7e480d4e6ef66$export$258797e2c4e99332,
    $11e7e480d4e6ef66$export$7cd05929724a15f2,
    $11e7e480d4e6ef66$export$31192b5cccb0825d,
    $11e7e480d4e6ef66$export$5c823b2196b36f8e,
    $11e7e480d4e6ef66$export$742bd743f317c0cf,
    $11e7e480d4e6ef66$export$31b8979f35864357,
    $11e7e480d4e6ef66$export$5d1c3cf9f58560fa,
    $11e7e480d4e6ef66$export$f036eb35a54338c1
];
const $11e7e480d4e6ef66$export$776b50dd35ff8711 = (products, cloudId)=>{
    const baseUrl = `${$11e7e480d4e6ef66$export$995f5f30765d3edb}/s/${cloudId}`;
    return products.length === 1 ? `${baseUrl}/billing/applications/change-edition/${products[0]}.ondemand` : `${baseUrl}/billing-preview`;
};
const $11e7e480d4e6ef66$export$1ef808db151854b6 = (productId)=>{
    const loomEnabled = (0, $84Nhj.getTargetingGate)('loom-in-invite-people');
    if (!loomEnabled && productId === $11e7e480d4e6ef66$export$f036eb35a54338c1.id) return false;
    return !!$11e7e480d4e6ef66$var$products.find((p)=>productId === p.id);
};
const $11e7e480d4e6ef66$export$5db19e0f3922ef0f = (productId)=>$11e7e480d4e6ef66$var$products.find((p)=>productId === p.id);
const $11e7e480d4e6ef66$export$4289783c37f529ba = (productId)=>{
    const foundProduct = $11e7e480d4e6ef66$var$products.find((p)=>productId === p.id);
    return foundProduct ? foundProduct.label : productId || 'Atlassian';
};
const $11e7e480d4e6ef66$export$ec409465a0eaca4c = (resourceAri)=>{
    const productId = $11e7e480d4e6ef66$export$8be157e92249183(resourceAri);
    return $11e7e480d4e6ef66$export$4289783c37f529ba(productId || '');
};
const $11e7e480d4e6ef66$export$bc923b2c79b1b36c = (product)=>{
    const foundProduct = $11e7e480d4e6ef66$var$products.find((p)=>product === p.label);
    return foundProduct ? foundProduct.id : product;
};
const $11e7e480d4e6ef66$export$22a9451e3bf2233f = (productId)=>{
    const foundProduct = $11e7e480d4e6ef66$var$products.find((p)=>productId === p.id);
    return foundProduct ? foundProduct.icon : (0, $iItCF.AtlassianIcon);
};
const $11e7e480d4e6ef66$export$7c8eb7667509870c = (productId)=>{
    const foundProduct = $11e7e480d4e6ef66$var$products.find((p)=>productId === p.id);
    return foundProduct ? foundProduct.landingPath : '';
};
const $11e7e480d4e6ef66$export$c9b3979837c2ee2e = (productId)=>{
    const foundProduct = $11e7e480d4e6ef66$var$products.find((p)=>productId === p.id);
    return foundProduct ? foundProduct.directAccessLocation : 'others.core-invites';
};
const $11e7e480d4e6ef66$export$a011c63d9bebc648 = ()=>{
    return window.location.origin;
};
const $11e7e480d4e6ef66$export$837b3431660d7232 = (subProduct)=>`jira-${subProduct.toLowerCase()}`;
const $11e7e480d4e6ef66$export$d0a8044dce8ff2fc = ()=>{
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $11e7e480d4e6ef66$export$3ea53827ed349b2e = (locale)=>{
    return (locale || '').toLowerCase().startsWith('en');
};
function $11e7e480d4e6ef66$export$6b52db8960fbef38() {
    (0, $5uXOq.useEffect)(()=>{
        throw new Error('Something wrong inside Invite people.');
    });
    return null;
}
const $11e7e480d4e6ef66$export$271463dc013c475e = (emails)=>{
    const domains = new Set();
    emails.forEach((email)=>{
        const domain = $11e7e480d4e6ef66$export$c8d36b71889c2b08(email);
        if (domain) domains.add(domain);
    });
    return Array.from(domains);
};
var $11e7e480d4e6ef66$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
const $11e7e480d4e6ef66$var$markFulfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
const $11e7e480d4e6ef66$var$markRejected = (errorDetails)=>({
        status: "failed",
        errorDetails: errorDetails
    });
const $11e7e480d4e6ef66$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then((successResponse)=>$11e7e480d4e6ef66$var$markFulfilled(successResponse)).catch($11e7e480d4e6ef66$var$markRejected)));
};
const $11e7e480d4e6ef66$export$a117c7b833c15650 = (cache, key, value, size = 50)=>{
    if (cache.size >= size) cache.clear();
    cache.set(key, value);
};
const $11e7e480d4e6ef66$export$9de493bcd9b1d977 = 'bad-request';
const $11e7e480d4e6ef66$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $11e7e480d4e6ef66$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $11e7e480d4e6ef66$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $11e7e480d4e6ef66$export$e5254cb9f7678ab9) return false;
    return true;
};
const $11e7e480d4e6ef66$export$e1b6bb1617649e83 = (errorMessage)=>$11e7e480d4e6ef66$var$userNetworkFailureMessages.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $11e7e480d4e6ef66$export$7e9cf63a972dd62 = (statusCode)=>{
    return statusCode === 403;
};
const $11e7e480d4e6ef66$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (e) {
        return false;
    }
};
const $11e7e480d4e6ef66$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === (0, $hatDq.ERROR_KEY_NO_DEFAULT_GROUP) || errorMessage === (0, $hatDq.NO_DEFAULT_GROUP_ERROR_MESSAGE);
const $11e7e480d4e6ef66$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $11e7e480d4e6ef66$export$678d91a98f79a24d(message, status) || status === 400 && ($11e7e480d4e6ef66$export$cb3290253184cb70(message, (0, $hatDq.EMAIL_BLOCKED)) || $11e7e480d4e6ef66$export$cb3290253184cb70(message, (0, $hatDq.REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS))) || status === 412 && $11e7e480d4e6ef66$export$395f41a02d6a8be0(key, message);
};
const $11e7e480d4e6ef66$export$d167fb1c42f7d152 = (errorMessage, statusCode)=>statusCode === 400 && (errorMessage === (0, $hatDq.INVALID_DOMAIN_ERROR_GET_MESSAGE) || errorMessage.startsWith((0, $hatDq.INVALID_DOMAIN_POST_ERROR_MESSAGE))) || $11e7e480d4e6ef66$export$7e9cf63a972dd62(statusCode);
const $11e7e480d4e6ef66$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $11e7e480d4e6ef66$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $11e7e480d4e6ef66$export$6a44d7a50b763a1c = (status)=>{
    switch(status){
        case (0, $hatDq.InviteProcessingResponseStatus).SUCCESS:
            return true;
        case (0, $hatDq.InviteProcessingResponseStatus).ERROR:
            return false;
        case (0, $hatDq.InviteProcessingResponseStatus).SKIPPED:
            return undefined;
    }
};
const $11e7e480d4e6ef66$export$90f8080789b02ddd = (loggedInEmailDomain)=>Boolean(loggedInEmailDomain && (0, $8TQ2j.GOOGLE_MAIL_DOMAINS).includes(loggedInEmailDomain));
const $11e7e480d4e6ef66$export$b164e8e46eadcf65 = (errorResponse)=>{
    if (errorResponse instanceof (0, $evtmo.FetchError)) return {
        error: errorResponse,
        errorMessage: errorResponse.message,
        responseCode: errorResponse.responseCode
    };
    if (errorResponse instanceof (0, $9CLBJ.FetchError)) return {
        error: errorResponse,
        errorMessage: errorResponse.message,
        responseCode: errorResponse.statusCode
    };
    if (errorResponse instanceof Error) return {
        error: errorResponse,
        errorMessage: errorResponse.message
    };
    const error = (0, $26yQk.default)(errorResponse);
    return {
        error: error,
        errorMessage: error.message
    };
};
const $11e7e480d4e6ef66$export$f6c02f8ff560b96f = ()=>$11e7e480d4e6ef66$export$8d028de9c8e0908() ? $11e7e480d4e6ef66$var$RECAPTCHA_SITE_KEY_DEV : $11e7e480d4e6ef66$export$1cfdf9a01e3f7773() ? $11e7e480d4e6ef66$var$RECAPTCHA_SITE_KEY_PROD : $11e7e480d4e6ef66$var$RECAPTCHA_SITE_KEY_STAGING;
const $11e7e480d4e6ef66$export$5f7ec48d69707ddd = (arr, size)=>{
    const chunks = [];
    let index = 0;
    do {
        const nextIndex = index + size;
        chunks.push(arr.slice(index, nextIndex));
        index = nextIndex;
    }while (index < arr.length);
    return chunks;
};
const $11e7e480d4e6ef66$export$db16b8d6f03d2f57 = (slackUser)=>({
        id: slackUser.id,
        email: slackUser.email,
        name: slackUser.name,
        publicName: slackUser.displayName,
        avatarUrl: slackUser.avatarUrl,
        sources: [
            (0, $8TQ2j.SLACK_SOURCE)
        ],
        type: 'user',
        isExternal: true
    });
const $11e7e480d4e6ef66$export$d976e75aaf898758 = (s)=>s.replace(/[\u200B-\u200D\uFEFF]/g, '');
const $11e7e480d4e6ef66$export$ffacee591afa903e = (key)=>{
    const value = $11e7e480d4e6ef66$export$f22967b337b5cd11(key);
    if (!value) return null;
    if (![
        'true',
        'false'
    ].includes(value)) {
        $11e7e480d4e6ef66$export$686c665f7e55a917(key);
        return null;
    }
    return value === 'true';
};
const $11e7e480d4e6ef66$export$f22967b337b5cd11 = (key)=>{
    try {
        return localStorage.getItem(key);
    } catch (e) {
        return null;
    }
};
const $11e7e480d4e6ef66$export$c27a17ef9ad21f43 = (key, value)=>{
    try {
        localStorage.setItem(key, value);
    } catch (e) {
        return null;
    }
};
const $11e7e480d4e6ef66$export$686c665f7e55a917 = (key)=>{
    try {
        localStorage.removeItem(key);
    } catch (e) {
        return;
    }
};
const $11e7e480d4e6ef66$export$e422989e057b7a56 = (orgId)=>`${$11e7e480d4e6ef66$export$995f5f30765d3edb}/o/${orgId}/user-access-settings`;

});
parcelRegister("2pBwG", function(module, exports) {

$parcel$export(module.exports, "AtlasIcon", () => $ceb998a0bac766cb$export$9d0b19639662f94b);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $ceb998a0bac766cb$var$svg = ({ appearance: appearance }, colorMode)=>{
    let colors = (0, $2uZGe.getColorsFromAppearance)(appearance ? appearance : 'brand', colorMode);
    return `<svg viewBox="0 0 32 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g fill="${colors.iconColor}">
      <path d="M16 28.532c-6.656 0-12.068-5.412-12.068-12.068S9.344 4.396 16 4.396v1.921c-5.597 0-10.146 4.549-10.146 10.146S10.403 26.609 16 26.609zm0 0v-1.921c5.597 0 10.146-4.549 10.146-10.146h1.921c0 6.656-5.412 12.068-12.068 12.068zm12.068-12.068h-1.921c0-5.597-4.549-10.146-10.146-10.146V4.397c6.656 0 12.068 5.412 12.068 12.068zm-6.928 3.695c-1.28-.251-2.292-.706-3.973-1.467-.464-.204-.974-.436-1.559-.696a59 59 0 0 0-1.003-.436c-2.534-1.123-3.926-1.736-5.634-1.736-1.198 0-2.098.325-2.6.937a1.72 1.72 0 0 0-.38 1.448l-1.885.362a3.67 3.67 0 0 1 .78-3.035c.613-.743 1.82-1.634 4.085-1.634 2.116 0 3.824.761 6.414 1.903.316.14.641.288.994.436.594.26 1.114.492 1.578.706 1.606.724 2.488 1.123 3.555 1.327l-.371 1.885Zm1.877.185c-.64 0-1.253-.056-1.875-.185l.371-1.885c.502.102.994.149 1.504.149 1.188 0 2.089-.298 2.609-.864s.539-1.253.51-1.615l1.913-.167c.102 1.169-.251 2.265-1.003 3.082-.622.677-1.82 1.485-4.029 1.485M16 28.532v-1.921c2.757 0 4.4-2.813 4.4-7.52s-1.67-8.652-5.096-12.3l1.402-1.318c3.778 4.02 5.616 8.476 5.616 13.618 0 5.821-2.423 9.441-6.322 9.441m-.001 0c-4.15 0-6.526-3.379-6.526-9.273 0-6.879 3.008-10.722 5.82-13.776l1.412 1.299c-3.277 3.565-5.31 6.888-5.31 12.476 0 6.08 2.506 7.352 4.604 7.352z"/>
      <path d="M10.857 17.467a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494m10.385 3.871a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494M15.998 7.96a2.247 2.247 0 1 0 0-4.493 2.247 2.247 0 0 0 0 4.494Z"/>
    </g>
  </svg>`;
};
const $ceb998a0bac766cb$export$9d0b19639662f94b = ({ appearance: appearance, label: label = 'Atlas', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $ceb998a0bac766cb$var$svg({
            appearance: appearance
        }, colorMode),
        size: size,
        testId: testId
    });
};

});

parcelRegister("27vD8", function(module, exports) {

$parcel$export(module.exports, "AtlassianAnalyticsIcon", () => $940d768d8dc99f99$export$c42ad8a0b925c762);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jJsBW = parcelRequire("jJsBW");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $940d768d8dc99f99$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `<svg height="32" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="12.595" x2="12.595" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient id="${id}-b" x1="28.595" x2="28.595" y1="40" y2="27" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-b" id="${id}-c" x1="20.595" x2="20.595" y2="22"/>
    <linearGradient xlink:href="#${id}-b" id="${id}-d" x1="36.595" x2="36.595" y2="20"/>
  </defs>
  <path d="M10.595 30h4v10h-4z" fill="url(#${id}-a)"/>
  <path d="M26.595 27h4v13h-4z" fill="url(#${id}-b)"/>
  <path d="M18.595 22h4v18h-4z" fill="url(#${id}-c)"/>
  <path d="M34.595 20h4v20h-4z" fill="url(#${id}-d)"/>
  <path fill="${colors.iconColor}" d="m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z" />
</svg>`;
};
const $940d768d8dc99f99$export$c42ad8a0b925c762 = ({ appearance: appearance, label: label = 'Atlassian Analytics', size: size = (0, $kpt43.defaultLogoParams).size, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    const id = (0, $jJsBW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $940d768d8dc99f99$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("h6M2t", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $8d4219c64b075729$export$5fc1066e677788d4);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $8d4219c64b075729$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $8d4219c64b075729$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $8d4219c64b075729$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("l9zAL", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", () => $c6dab1fdf082e360$export$f7857fe64d7161d9);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $c6dab1fdf082e360$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>
      </svg>
    `;
};
const $c6dab1fdf082e360$export$f7857fe64d7161d9 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $c6dab1fdf082e360$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jo1Bz", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $88a43adeb7653a71$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $88a43adeb7653a71$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $88a43adeb7653a71$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $88a43adeb7653a71$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("e9Y3k", function(module, exports) {

$parcel$export(module.exports, "FocusIcon", () => $2883196963418868$export$1e02e7298035a77c);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $2883196963418868$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 48 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z"/>
		</svg>
		`;
};
const $2883196963418868$export$1e02e7298035a77c = ({ appearance: appearance, label: label = 'Focus', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $2883196963418868$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kWm7C", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareIcon", () => $3345272ea1f443f5$export$c3835feba2a66e67);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jJsBW = parcelRequire("jJsBW");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $3345272ea1f443f5$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $kpt43.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $kpt43.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
};
const $3345272ea1f443f5$export$c3835feba2a66e67 = ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    const id = (0, $jJsBW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $3345272ea1f443f5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("c9lm5", function(module, exports) {

$parcel$export(module.exports, "JiraWorkManagementIcon", () => $4c960bdd54f7d44c$export$7330b9fc5718fd30);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jJsBW = parcelRequire("jJsBW");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $4c960bdd54f7d44c$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $kpt43.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $kpt43.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
};
const $4c960bdd54f7d44c$export$7330b9fc5718fd30 = ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    const id = (0, $jJsBW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $4c960bdd54f7d44c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9jZg7", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", () => $da825721c5ac0541$export$8d789f76fde3e05);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $da825721c5ac0541$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsForLoom)(appearance, colorMode);
    return `<svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-hidden="true"
  >
    <path
      d="M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884"
      fill="${colors.iconColor}"
    />
  </svg>`;
};
const $da825721c5ac0541$export$8d789f76fde3e05 = ({ appearance: appearance, label: label = 'Loom', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $da825721c5ac0541$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8yuGW", function(module, exports) {

$parcel$export(module.exports, "OpsgenieIcon", () => $b79dfe8fa23f0848$export$eeccc49dc7a12d9f);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $b79dfe8fa23f0848$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
    </svg>`;
};
const $b79dfe8fa23f0848$export$eeccc49dc7a12d9f = ({ appearance: appearance, label: label = 'Opsgenie', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        svg: $b79dfe8fa23f0848$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iiu6z", function(module, exports) {

$parcel$export(module.exports, "StatuspageIcon", () => $5c2e90c1daaf4ae8$export$f3f5aa321d88adf9);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $5c2e90c1daaf4ae8$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063"/>
    </svg>`;
};
const $5c2e90c1daaf4ae8$export$f3f5aa321d88adf9 = ({ appearance: appearance, label: label = 'Statuspage', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $5c2e90c1daaf4ae8$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gNRNP", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", () => $b2e48a8dbeb67898$export$4384da9b8b140bf4);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $b2e48a8dbeb67898$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} clip-rule="evenodd" d="M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z" fill-rule="evenodd"/>
    </svg>`;
};
const $b2e48a8dbeb67898$export$4384da9b8b140bf4 = ({ appearance: appearance, label: label = 'Trello', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $b2e48a8dbeb67898$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9CLBJ", function(module, exports) {

$parcel$export(module.exports, "fetchItemsWithCursor", () => $35018e22f7b114e7$export$1d3435507f486e79);
$parcel$export(module.exports, "retryFetch", () => $35018e22f7b114e7$export$635968db05579875);
$parcel$export(module.exports, "httpRetryPolicy", () => $35018e22f7b114e7$export$bd28f8bf945907aa);
$parcel$export(module.exports, "FetchError", () => $35018e22f7b114e7$export$26e841bcf1aeb894);
$parcel$export(module.exports, "fetchJson", () => $35018e22f7b114e7$export$6d71b655afe1638d);
$parcel$export(module.exports, "buildQueryString", () => $35018e22f7b114e7$export$6b17a39e52c8ee53);
$parcel$export(module.exports, "sortByName", () => $35018e22f7b114e7$export$7932064324870761);

var $7qDUb = parcelRequire("7qDUb");


var $bHH9y = parcelRequire("bHH9y");
function $35018e22f7b114e7$var$defaultErrorMapper(response) {
    return Promise.resolve({
        code: response.status.toString(),
        message: response.statusText
    });
}
function $35018e22f7b114e7$var$defaultResultMapper(response) {
    return response.json();
}
async function $35018e22f7b114e7$export$1d3435507f486e79({ url: url, queryParams: queryParams = {}, signal: signal, getItems: getItems, getCursor: getCursor, canRetryCheck: canRetryCheck, mapError: mapError = $35018e22f7b114e7$var$defaultErrorMapper }) {
    const items = [];
    let response;
    let page = 0;
    do {
        // Bail out here in case the abort signal is fired between requests.
        if (signal?.aborted) return {
            ok: false,
            aborted: true
        };
        const cursor = response?.ok ? getCursor(response.result) : undefined;
        const queryParamsWithCursor = cursor ? {
            ...queryParams,
            cursor: cursor
        } : queryParams;
        const search = Object.entries(queryParamsWithCursor ?? {}).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
        const urlWithParams = [
            url,
            search
        ].filter(Boolean).join('?');
        // Get the next page and retry in case of intermittent errors
        response = await $35018e22f7b114e7$export$635968db05579875({
            request: ()=>fetch(urlWithParams, {
                    signal: signal
                }),
            mapError: mapError,
            signal: signal,
            canRetryCheck: canRetryCheck
        });
        if (!response.ok) return response.aborted ? response : {
            ...response,
            page: page
        };
        items.push.apply(items, getItems(response.result));
        ++page;
    }while (response?.ok && getCursor(response.result));
    return {
        ok: true,
        items: items,
        pages: page
    };
}
async function $35018e22f7b114e7$export$9369b12211e1fce4({ request: request, canRetryCheck: canRetryCheck, attempt: attempt = 0, signal: signal }) {
    const result = await request(signal);
    if (result.ok || result.aborted || signal?.aborted) return result;
    else {
        const [canRetry, timeToWait] = canRetryCheck(result.status, ++attempt, signal);
        if (canRetry) {
            if (timeToWait) await (0, $bHH9y.wait)(timeToWait);
            return $35018e22f7b114e7$export$9369b12211e1fce4({
                request: request,
                canRetryCheck: canRetryCheck,
                attempt: attempt,
                signal: signal
            });
        }
    }
    return result;
}
const $35018e22f7b114e7$var$DEFAULT_MAX_ATTEMPTS = 3;
const $35018e22f7b114e7$var$DEFAULT_BACKOFF_TIME_MS = 200;
const $35018e22f7b114e7$var$DEFAULT_BACKOFF_TIME_429_MS = 1000;
function $35018e22f7b114e7$export$bd28f8bf945907aa({ maxAttempts: maxAttempts = $35018e22f7b114e7$var$DEFAULT_MAX_ATTEMPTS, backoffTimeMs: backoffTimeMs = $35018e22f7b114e7$var$DEFAULT_BACKOFF_TIME_MS, rateLimitBackoffTimeMs: rateLimitBackoffTimeMs = $35018e22f7b114e7$var$DEFAULT_BACKOFF_TIME_429_MS } = {}) {
    return (status, attempts)=>{
        // Stop if attempts are exhausted
        if (attempts >= maxAttempts) return [
            false,
            0
        ];
        switch(status){
            // Unlikely to recover from these
            case 401:
            case 403:
            case 404:
                return [
                    false,
                    0
                ];
            // Probably rate limiting. Back off and try again.
            case 429:
                return [
                    true,
                    rateLimitBackoffTimeMs
                ];
            // Unknown error. Back off and try again.
            default:
                return [
                    true,
                    backoffTimeMs
                ];
        }
    };
}
function $35018e22f7b114e7$export$635968db05579875({ request: request, mapResult: mapResult = $35018e22f7b114e7$var$defaultResultMapper, mapError: mapError = $35018e22f7b114e7$var$defaultErrorMapper, canRetryCheck: canRetryCheck = $35018e22f7b114e7$export$bd28f8bf945907aa(), signal: signal }) {
    return $35018e22f7b114e7$export$9369b12211e1fce4({
        request: async ()=>{
            let response;
            try {
                response = await request();
                if (response.ok) return {
                    ok: true,
                    result: await mapResult(response)
                };
                const { code: code, message: message } = await mapError(response);
                // Error status
                return {
                    ok: false,
                    aborted: false,
                    status: response.status,
                    code: code,
                    message: message
                };
            } catch (error) {
                if (error instanceof Error) {
                    // Request aborted client-side
                    if (error.name === 'AbortError') return {
                        ok: false,
                        aborted: true
                    };
                    // Client-side networking error
                    return {
                        ok: false,
                        aborted: false,
                        status: (0, $5009317558281709$export$2c32b0fe4533d89e),
                        code: error.name,
                        message: error.message
                    };
                }
                return {
                    ok: false,
                    aborted: false,
                    status: (0, $5009317558281709$export$2c32b0fe4533d89e),
                    code: (0, $5009317558281709$export$9267d266a5449137),
                    message: (0, $5009317558281709$export$33789febc109c023)
                };
            }
        },
        canRetryCheck: canRetryCheck,
        signal: signal
    });
}
class $35018e22f7b114e7$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, errorType){
        super(message);
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.errorType = errorType;
    }
}
const $35018e22f7b114e7$export$6d71b655afe1638d = (url, action, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        throw new $35018e22f7b114e7$export$26e841bcf1aeb894(`Unable to fetch ${action} ${response.statusText}`, response.status);
    });
const $35018e22f7b114e7$var$isNil = (value)=>value === undefined || value === null;
function $35018e22f7b114e7$export$6b17a39e52c8ee53(obj) {
    const query = Object.keys(obj).filter((key)=>!$35018e22f7b114e7$var$isNil(obj[key])).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join('&');
    return query ? '?' + query : query;
}
function $35018e22f7b114e7$export$7932064324870761(values) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(values, ({ name: name })=>name.toLowerCase());
}

});
const $5009317558281709$export$68362b925a39303e = '/gateway/api/slack';
const $5009317558281709$export$83c8d7110915321e = 'invite-people';
const $5009317558281709$export$2c32b0fe4533d89e = 0;
const $5009317558281709$export$9267d266a5449137 = 'NETWORK_ERROR';
const $5009317558281709$export$33789febc109c023 = 'Network error';
const $5009317558281709$export$4804b650706e0b62 = 'CONFLUENCE_METADATA_ERROR';
const $5009317558281709$export$85183a312807388d = 'peopleTeams';
const $5009317558281709$export$d67bd32411617d53 = 480;
const $5009317558281709$export$cce5ee914c2ec5d9 = 924;
const $5009317558281709$export$ab2f49a861856bab = '/gateway/api';
const $5009317558281709$export$127769e597bc5ee5 = '/external-users/third-party';
const $5009317558281709$export$8bad17bb0225d989 = '/external-users/orgs';
const $5009317558281709$export$e468596ea25b5295 = 'integrations';
const $5009317558281709$export$458ba67f45a7f353 = 'Third Party Search';
const $5009317558281709$export$bc2c06c4779f47f2 = 'Organisation Settings';
const $5009317558281709$export$20875166a8676880 = '/growth/invite-3rd-party-teams';
const $5009317558281709$export$3f9855fcc7fa383e = '/slack-channels';
const $5009317558281709$export$2d4bcc939d0de9de = 'google-invites';
const $5009317558281709$export$baca96d2908c1d98 = 'microsoft-invites';
const $5009317558281709$export$89aa938ff9a6aec2 = 3;

parcelRegister("bHH9y", function(module, exports) {

$parcel$export(module.exports, "wait", () => $03ae6f6a41b95562$export$5c069c93d2b7493f);
async function $03ae6f6a41b95562$export$5c069c93d2b7493f(delayMs) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, delayMs);
    });
}

});


parcelRegister("8TQ2j", function(module, exports) {

$parcel$export(module.exports, "GOOGLE_SERVICE", () => $dc4f54c5bc985903$export$2d4bcc939d0de9de);
$parcel$export(module.exports, "MICROSOFT_SERVICE", () => $dc4f54c5bc985903$export$baca96d2908c1d98);
$parcel$export(module.exports, "PLATFORM_SLACK_SERVICE", () => $dc4f54c5bc985903$export$ec85cabf318c7730);
$parcel$export(module.exports, "WINDOW_WIDTH", () => $dc4f54c5bc985903$export$d67bd32411617d53);
$parcel$export(module.exports, "WINDOW_HEIGHT", () => $dc4f54c5bc985903$export$cce5ee914c2ec5d9);
$parcel$export(module.exports, "MAX_USERS", () => $dc4f54c5bc985903$export$e45b57f6c6c40475);
$parcel$export(module.exports, "JIRA_SLACK_URL", () => $dc4f54c5bc985903$export$62d0f9a4ff93a2b0);
$parcel$export(module.exports, "CONFLUENCE_SLACK_URL", () => $dc4f54c5bc985903$export$86eddaf1565821f9);
$parcel$export(module.exports, "GOOGLE_MAIL_DOMAINS", () => $dc4f54c5bc985903$export$4dac05a082a29d1);
$parcel$export(module.exports, "FETCH_INTEGRATIONS_FAILURE_MESSAGE", () => $dc4f54c5bc985903$export$d5b164c0daafb135);
$parcel$export(module.exports, "SLACK_SOURCE", () => $dc4f54c5bc985903$export$88ece45bb5b3dbd0);

var $fJpmn = parcelRequire("fJpmn");
const { GOOGLE_SERVICE: $dc4f54c5bc985903$export$2d4bcc939d0de9de, MICROSOFT_SERVICE: $dc4f54c5bc985903$export$baca96d2908c1d98, PLATFORM_SLACK_SERVICE: $dc4f54c5bc985903$export$ec85cabf318c7730 } = (0, $fJpmn.Integration);
const $dc4f54c5bc985903$export$d67bd32411617d53 = 480;
const $dc4f54c5bc985903$export$cce5ee914c2ec5d9 = 924;
const $dc4f54c5bc985903$export$e45b57f6c6c40475 = 10;
const $dc4f54c5bc985903$export$62d0f9a4ff93a2b0 = 'https://marketplace.atlassian.com/apps/1216863/jira-cloud-for-slack-official';
const $dc4f54c5bc985903$export$86eddaf1565821f9 = 'https://marketplace.atlassian.com/apps/1219518/confluence-cloud-for-slack-official';
const $dc4f54c5bc985903$export$6409af570c59625b = [
    'jira',
    'confluence'
];
const $dc4f54c5bc985903$export$4dac05a082a29d1 = [
    'gmail.com',
    'googlemail.com'
];
const $dc4f54c5bc985903$export$d5b164c0daafb135 = 'Status: Failed fetching integrations.';
var $dc4f54c5bc985903$export$165bf6c90b245257 = /*#__PURE__*/ function(ThirdPartySource) {
    ThirdPartySource["SLACK_SOURCE"] = "slack";
    return ThirdPartySource;
}({});
const { SLACK_SOURCE: $dc4f54c5bc985903$export$88ece45bb5b3dbd0 } = $dc4f54c5bc985903$export$165bf6c90b245257;

});

parcelRegister("evtmo", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $632ded9a486d4d2f$export$26e841bcf1aeb894);
$parcel$export(module.exports, "RespCodes", () => $632ded9a486d4d2f$export$162547ab8fc29e40);
$parcel$export(module.exports, "postRequest", () => $632ded9a486d4d2f$export$42ff643f16b1faa2);
$parcel$export(module.exports, "fetchJson", () => $632ded9a486d4d2f$export$6d71b655afe1638d);
$parcel$export(module.exports, "postJson", () => $632ded9a486d4d2f$export$c776284ef4b1209a);
$parcel$export(module.exports, "putJson", () => $632ded9a486d4d2f$export$d9ed129193d2f249);
$parcel$export(module.exports, "isSLOFailure", () => $632ded9a486d4d2f$export$382fb8e6e96d8f6d);
$parcel$export(module.exports, "getErrorDetails", () => $632ded9a486d4d2f$export$33e83b6fee5d732d);
class $632ded9a486d4d2f$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) super(responseJson.message);
        else super(`Received error response during action ${action}: ${response.statusText}`);
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
var $632ded9a486d4d2f$export$162547ab8fc29e40 = /*#__PURE__*/ function(RespCodes) {
    RespCodes[RespCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
    RespCodes[RespCodes["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    RespCodes[RespCodes["BAD_REQUESTS"] = 400] = "BAD_REQUESTS";
    RespCodes[RespCodes["CLIENT_CLOSED_REQUEST"] = 499] = "CLIENT_CLOSED_REQUEST";
    return RespCodes;
}({});
const $632ded9a486d4d2f$var$handleFailedResponse = async (response, action)=>{
    let failedResponseJson;
    try {
        failedResponseJson = await response.json();
    } catch  {}
    throw new $632ded9a486d4d2f$export$26e841bcf1aeb894(action, response.status, response, failedResponseJson);
};
const $632ded9a486d4d2f$var$handleErrorResponse = (err, message)=>{
    if (err instanceof $632ded9a486d4d2f$export$26e841bcf1aeb894) throw err;
    else if (err instanceof Error) err.message = message + `: ${err.message}`;
    throw err;
};
const $632ded9a486d4d2f$export$42ff643f16b1faa2 = async (url, action, data)=>{
    try {
        const response = await fetch(url, {
            credentials: 'include',
            method: 'POST',
            ...$632ded9a486d4d2f$var$requestTemplate(data)
        });
        if (response.ok) return response;
        else return $632ded9a486d4d2f$var$handleFailedResponse(response, action);
    } catch (err) {
        const message = `Error while executing post request for ${action}`;
        return $632ded9a486d4d2f$var$handleErrorResponse(err, message);
    }
};
const $632ded9a486d4d2f$export$6d71b655afe1638d = async (url, action, init)=>{
    try {
        const response = await fetch(url, {
            credentials: 'include',
            ...init
        });
        if (response.status === 304) return response.json();
        if (response.ok) return response.status === 204 ? undefined : response.json();
        else return $632ded9a486d4d2f$var$handleFailedResponse(response, action);
    } catch (err) {
        const message = `Error while executing fetch for ${action}`;
        return $632ded9a486d4d2f$var$handleErrorResponse(err, message);
    }
};
const $632ded9a486d4d2f$var$requestTemplate = (data, recaptchaOptions)=>({
        headers: {
            'Content-Type': 'application/json',
            ...recaptchaOptions?.recaptchaToken ? {
                'G-Recaptcha-Token': recaptchaOptions.recaptchaToken
            } : {},
            ...recaptchaOptions?.recaptchaAction ? {
                'Recaptcha-Action': recaptchaOptions.recaptchaAction
            } : {}
        },
        body: JSON.stringify(data)
    });
const $632ded9a486d4d2f$export$c776284ef4b1209a = (url, action, data, recatpchaOptions)=>$632ded9a486d4d2f$export$6d71b655afe1638d(url, action, {
        method: 'POST',
        ...$632ded9a486d4d2f$var$requestTemplate(data, recatpchaOptions)
    });
const $632ded9a486d4d2f$export$d9ed129193d2f249 = (url, action, data)=>$632ded9a486d4d2f$export$6d71b655afe1638d(url, action, {
        method: 'PUT',
        ...$632ded9a486d4d2f$var$requestTemplate(data)
    });
const $632ded9a486d4d2f$var$isUnauthorisedError = (error)=>{
    return error.responseCode === 401;
};
const $632ded9a486d4d2f$export$382fb8e6e96d8f6d = (error)=>{
    if (error instanceof $632ded9a486d4d2f$export$26e841bcf1aeb894) return !$632ded9a486d4d2f$var$isUnauthorisedError(error);
    return true;
};
const $632ded9a486d4d2f$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: err instanceof $632ded9a486d4d2f$export$26e841bcf1aeb894 ? err.responseCode : undefined
    });

});

parcelRegister("84Nhj", function(module, exports) {

$parcel$export(module.exports, "getExperimentValue", () => $3aa08254bf007be1$export$df4f69f663fe2d96);
$parcel$export(module.exports, "getTargetingGate", () => $3aa08254bf007be1$export$c123608fb702e1aa);

var $96Irh = parcelRequire("96Irh");
const $3aa08254bf007be1$export$df4f69f663fe2d96 = (experimentKey, defaultCohort, fireExperimentExposure)=>{
    if ((0, $96Irh.default).initializeCalled()) return (0, $96Irh.default).getExperimentValue(experimentKey, 'cohort', defaultCohort, {
        fireExperimentExposure: fireExperimentExposure
    });
    return defaultCohort;
};
const $3aa08254bf007be1$export$c123608fb702e1aa = (experimentKey)=>(0, $96Irh.default).initializeCompleted() && (0, $96Irh.default).checkGate(experimentKey);

});



parcelRegister("a5Jah", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7f1e82648b0f41d$export$2e2bcd8739ae039);
/* InvitePeopleComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $6tzHJ = parcelRequire("6tzHJ");

var $bWfiu = parcelRequire("bWfiu");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $k9nuy = parcelRequire("k9nuy");

var $6HEbe = parcelRequire("6HEbe");

var $5Iax1 = parcelRequire("5Iax1");

var $kx8ta = parcelRequire("kx8ta");

var $fn6W9 = parcelRequire("fn6W9");

var $fJpmn = parcelRequire("fJpmn");

var $6QlEX = parcelRequire("6QlEX");

var $47Stc = parcelRequire("47Stc");
var $dCNWF = parcelRequire("dCNWF");

var $8650U = parcelRequire("8650U");

var $5FXAI = parcelRequire("5FXAI");

var $lWbFO = parcelRequire("lWbFO");

var $fJtAT = parcelRequire("fJtAT");

var $1CnPD = parcelRequire("1CnPD");

var $444qv = parcelRequire("444qv");

var $daXvt = parcelRequire("daXvt");

var $cfWle = parcelRequire("cfWle");

var $tkxOk = parcelRequire("tkxOk");
var $1PtjI = parcelRequire("1PtjI");
var $kKKsG = parcelRequire("kKKsG");
var $78lfI = parcelRequire("78lfI");

var $1SD2y = parcelRequire("1SD2y");

var $daR2j = parcelRequire("daR2j");

var $jorqd = parcelRequire("jorqd");
const $d7f1e82648b0f41d$var$styles = {
    formWrapper: "_195g1wug _kqswh2mm _p12f1j8x",
    formHeader: "_2lx21sbv",
    formHeaderMenu: "_1wpzesu3 _2lx21sbv",
    formTitleBylineWrapper: "_2hwxxy5q _r8nt19lj",
    formTitleByline: "_1reo15vq _18m915vq _k48pi7a9 _19pkze3t _1bto1l2s _o5721q9c",
    formDescriptionWrapper: "_19pku2gc _otyrpxbi",
    formFooter: "_otyr1ejb",
    buttonWrapper: "_otyrpxbi",
    rightAlignedButtonWrapper: "_2lx21sbv _1n261q9c"
};
const $d7f1e82648b0f41d$var$InvitePeopleComponent = ({ alignButtons: alignButtons, cancelButtonLabel: cancelButtonLabel, experimental_formTitleByline: experimental_formTitleByline, experimental_submitButtonRef: experimental_submitButtonRef, formDescription: formDescription, formTitle: formTitle, hideFormHeader: hideFormHeader, hideCancelButton: hideCancelButton, isSendingInvitation: isSendingInvitation, maxNumberOfInputs: maxNumberOfInputs, onCancelButtonClick: onCancelButtonClick, onInviteButtonClick: onInviteButtonClick, onInviteeListChange: onInviteeListChange, productOptions: productOptions, selectedProducts: selectedProducts, sendButtonLabel: customSendButtonLabel, showSecondarySection: showSecondarySection, titleId: titleId, experimental_onCloseTurnOnInviteLinkModal: experimental_onCloseTurnOnInviteLinkModal })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $5Iax1.InvitePeopleAnalytics));
    const pluginAnalytics = (0, $6HEbe.useAnalytics)((0, $tkxOk.InvitePeoplePluginsAnalytics));
    const invitePeopleData = (0, $78lfI.useInvitePeopleData)();
    const [showEmptyError, setShowEmptyError] = (0, $5uXOq.useState)(false);
    const { invitePromptOnLinkV3Cohort: invitePromptOnLinkV3Cohort, jiraSubProduct: jiraSubProduct, loggedInEmailDomain: loggedInEmailDomain, plugins: plugins, productId: productId, source: source, userRole: userRole, userEmail: userEmail, experimental_inviteLink: experimental_inviteLink, cloudId: cloudId, orgId: orgId, experimental_turnOnInviteLinkModalDismissed: experimental_turnOnInviteLinkModalDismissed } = (0, $daXvt.useInvitePeopleContext)();
    const { isCoreInvitesInJiraProjectEnabled: isCoreInvitesInJiraProjectEnabled } = (0, $cfWle.useCoreInvitesJiraProjectContext)();
    const { inviteFromAssignModal: inviteFromAssignModalCohort, isConfluenceInviteLinkFeatureEnabled: isConfluenceInviteLinkFeatureEnabled } = (0, $444qv.useExperimentalFeatures)();
    const { isOk: enableThirdPartyInvites, integrations: thirdPartyIntegrations, orgSettings: thirdPartyOrgSettings } = (0, $dCNWF.useThirdPartyState)();
    const [recaptcha, setRecaptcha] = (0, $5uXOq.useState)();
    const { emails: emails, ids: ids } = (0, $1CnPD.useInviteeListStateContext)();
    let activeShareableLinkModalScreen = 'none';
    if (isConfluenceInviteLinkFeatureEnabled) {
        if (experimental_inviteLink) activeShareableLinkModalScreen = 'copyInviteLink';
        else if (!experimental_turnOnInviteLinkModalDismissed) activeShareableLinkModalScreen = 'turnOnInviteLink';
    }
    (0, $5uXOq.useEffect)(()=>{
        analytics.inviteComponentViewed({
            hasGmailDomain: (0, $kx8ta.hasGmailDomain)(loggedInEmailDomain),
            isConnectedToSlack: thirdPartyIntegrations.has((0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE),
            shareableLinkModalScreen: activeShareableLinkModalScreen,
            ...thirdPartyOrgSettings
        });
    }, [
        analytics,
        loggedInEmailDomain,
        thirdPartyIntegrations,
        thirdPartyOrgSettings,
        activeShareableLinkModalScreen
    ]);
    const isBasicUser = userRole === 'basic';
    const shouldRenderProductSelect = // Display empty product selector when we are unable to determine
    // the defaultProducts that should be selected.
    selectedProducts?.length === 0 || productOptions && productOptions.length > 1 && // show for trusted|admin users
    (!isBasicUser || // OR if Product is Jira and there's no subproduct explicitly passed in
    productId === 'jira' && !jiraSubProduct || // OR if Product is 'platform', which indicates that the caller doesn't
    // know what product subscriptions are available.
    productId === 'platform');
    /**
   * Checks the internal inputs from Invite People (inviteeList and validationState from the user picker), without checking plugins validation.
   * Plugins validation is done through `pluginsOnValidate`.
   */ const isInternalFormDataValid = ()=>{
        const inputValues = [
            ...emails,
            ...ids
        ];
        const isEmptyArray = !inputValues.filter((item)=>item.length).length;
        const isEmptyProducts = shouldRenderProductSelect && selectedProducts.length === 0;
        const validationList = (0, $1SD2y.determineValidationState)(emails, ids, maxNumberOfInputs, userEmail, isCoreInvitesInJiraProjectEnabled);
        if (isEmptyArray || isEmptyProducts) {
            setShowEmptyError(true);
            return false;
        }
        // We also want to cap the number of emails/ids allowed to maxNumberOfInputs
        if (inputValues.filter((item)=>item.length).length > maxNumberOfInputs) return false;
        // If the there is an error state from the the user picker then the button is disabled
        return !(0, $1SD2y.hasError)(validationList);
    };
    const getInviteButtonAnalyticsAttributes = ()=>{
        const inputValues = [
            ...emails,
            ...ids
        ];
        let formError;
        // TODO: remove `formError` from `inviteButton button clicked` event and create a new `validation` event with `formError` and the plugins validation data.
        //       https://atlassian.slack.com/archives/C0138SD4YTH/p1669849389985509?thread_ts=1669768434.466429&cid=C0138SD4YTH
        if (!isInternalFormDataValid()) {
            if (selectedProducts.length === 0) formError = (0, $fn6W9.messages).noProductSelectedMessage.defaultMessage;
            else formError = inputValues.filter((val)=>val.length).length ? (0, $fn6W9.messages).invalidEmailMessage.defaultMessage : (0, $fn6W9.messages).emptyEmailMessage.defaultMessage;
        } else formError = undefined;
        return {
            product: productId,
            numberOfEmails: emails.length,
            numberOfUniqueEmails: [
                ...new Set(emails)
            ].length,
            formError: formError,
            invitedProducts: selectedProducts,
            integration: source,
            source: source,
            inviteFromAssignModalCohort: inviteFromAssignModalCohort
        };
    };
    const handleSendButtonClick = async ()=>{
        if (!isInternalFormDataValid()) return;
        const { isValid: isValid } = await (0, $kKKsG.onValidate)({
            analytics: pluginAnalytics,
            invitePeopleData: invitePeopleData,
            plugins: plugins
        });
        if (!isValid) return;
        (0, $lWbFO.inviteFormSubmitted).addMetadata({
            isThirdPartyIntegrated: Boolean(thirdPartyIntegrations.size > 0)
        });
        (0, $lWbFO.inviteFormSubmitted).start();
        await onInviteButtonClick(selectedProducts, false, recaptcha?.getRecaptchaToken);
    };
    const getUniqueValidEmails = (0, $5uXOq.useCallback)(()=>{
        return [
            ...new Set(emails)
        ];
    }, [
        emails
    ]);
    const handleProductSelectMenuOpen = ()=>{
        analytics.productSelectDropdownOpened({
            productOptions: productOptions?.map((product)=>product.value),
            selectedProducts: selectedProducts
        });
    };
    const getSubmitButtonText = ()=>{
        if (customSendButtonLabel) return customSendButtonLabel;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $fn6W9.messages).sendInviteButton,
            values: {
                numberOfInputs: getUniqueValidEmails().length + ids.length
            }
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: "testId-invite-people-form",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
            xcss: $d7f1e82648b0f41d$var$styles.formWrapper,
            children: [
                enableThirdPartyInvites && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $47Stc.default), {}),
                !hideFormHeader && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                    spread: "space-between",
                    xcss: $d7f1e82648b0f41d$var$styles.formHeader,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                            space: "space.100",
                            xcss: $d7f1e82648b0f41d$var$styles.formHeaderMenu,
                            children: [
                                onCancelButtonClick && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jorqd.CloseButton), {
                                    onClick: onCancelButtonClick
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8650U.Menu), {})
                            ]
                        }),
                        formTitle ? formTitle : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5FXAI.default), {
                            productOptions: productOptions,
                            selectedProducts: selectedProducts,
                            titleId: titleId
                        })
                    ]
                }),
                !!invitePromptOnLinkV3Cohort && experimental_formTitleByline && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                    xcss: $d7f1e82648b0f41d$var$styles.formTitleBylineWrapper,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                        size: "medium",
                        children: experimental_formTitleByline
                    })
                }),
                isConfluenceInviteLinkFeatureEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daR2j.ShareableLinkComponent), {
                    inviteLink: experimental_inviteLink,
                    cloudId: cloudId,
                    orgId: orgId,
                    onCloseTurnOnInviteLinkModal: experimental_onCloseTurnOnInviteLinkModal,
                    turnOnInviteLinkModalDismissed: experimental_turnOnInviteLinkModalDismissed
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $d7f1e82648b0f41d$var$styles.formDescriptionWrapper,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        id: "invite-people-form-description",
                        children: formDescription
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PtjI.PluginRenderer), {
                    plugins: plugins,
                    location: "header"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fJtAT.default), {
                    shouldRenderProductSelect: shouldRenderProductSelect,
                    productOptions: productOptions,
                    handleProductSelectMenuOpen: handleProductSelectMenuOpen,
                    showEmptyError: showEmptyError,
                    onCancelButtonClick: onCancelButtonClick,
                    maxNumberOfInputs: maxNumberOfInputs,
                    onInviteeListChange: onInviteeListChange,
                    selectedProducts: selectedProducts,
                    showSecondarySection: showSecondarySection,
                    recaptcha: recaptcha,
                    setRecaptcha: setRecaptcha
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $d7f1e82648b0f41d$var$styles.formFooter,
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                        space: "space.100",
                        xcss: (0, $6tzHJ.cx)($d7f1e82648b0f41d$var$styles.buttonWrapper, alignButtons === 'right' && $d7f1e82648b0f41d$var$styles.rightAlignedButtonWrapper),
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6QlEX.default), {
                                ref: experimental_submitButtonRef,
                                actionSubjectId: 'inviteButton',
                                analyticsAttributes: getInviteButtonAnalyticsAttributes,
                                appearance: "primary",
                                form: "invitePeopleForm",
                                interactionName: "invite-people-form.submit",
                                isLoading: isSendingInvitation || !recaptcha?.isRecaptchaLoaded && !recaptcha?.recaptchaLoadErrorReason,
                                onClick: handleSendButtonClick,
                                type: "submit",
                                children: getSubmitButtonText()
                            }),
                            !(hideCancelButton || experimental_submitButtonRef) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6QlEX.default), {
                                testId: "testId-invite-people-cancel-button",
                                interactionName: "invite-people-form.cancel",
                                actionSubjectId: 'cancelButton',
                                appearance: "subtle",
                                isDisabled: isSendingInvitation,
                                onClick: onCancelButtonClick,
                                analyticsAttributes: {
                                    integration: source,
                                    source: source,
                                    product: productId
                                },
                                children: cancelButtonLabel ? cancelButtonLabel : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...(0, $fn6W9.messages).cancelButton
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $d7f1e82648b0f41d$export$2e2bcd8739ae039 = $d7f1e82648b0f41d$var$InvitePeopleComponent;

});
parcelRegister("6HEbe", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $5f645e43d67f715b$export$e955abb82869dc84);
$parcel$export(module.exports, "useAnalyticsWithAttributes", () => $5f645e43d67f715b$export$961614c2c20d5679);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $daXvt = parcelRequire("daXvt");

var $gOE0R = parcelRequire("gOE0R");

var $59lp1 = parcelRequire("59lp1");
const $5f645e43d67f715b$export$e955abb82869dc84 = (AnalyticsClass)=>$5f645e43d67f715b$export$961614c2c20d5679(AnalyticsClass, (0, $gOE0R.useCommonAttributesFrom)((0, $daXvt.useInvitePeopleContext)()));
const $5f645e43d67f715b$export$961614c2c20d5679 = (AnalyticsClass, commonAttributes)=>{
    const { fireAnalytics: fireAnalytics } = $5f645e43d67f715b$var$useFireInvitePeopleAnalytics();
    // Why ref and .setCommonAttributes?
    // We want to keep returning the same instance even if attributes change,
    // as many data fetching effects depend on analytics.
    // Attributes can still change, e.g. if they are loaded asynchronously.
    const attributesRef = (0, $5uXOq.useRef)();
    attributesRef.current = commonAttributes;
    const memoizedInstance = (0, $5uXOq.useMemo)(()=>new AnalyticsClass(fireAnalytics, attributesRef.current), [
        AnalyticsClass,
        fireAnalytics
    ]);
    // Ensures events get the newest attributes when fired,
    // even if attributes changed after the instance was created.
    memoizedInstance.setCommonAttributes(attributesRef.current);
    return memoizedInstance;
};
const $5f645e43d67f715b$var$useFireInvitePeopleAnalytics = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (0, $5uXOq.useMemo)(()=>({
            fireAnalytics: (eventPayload)=>(0, $59lp1.fireAnalyticsEvent)(eventPayload, createAnalyticsEvent)
        }), [
        createAnalyticsEvent
    ]);
};

});
parcelRegister("daXvt", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleStateContext", () => $42c464e52720e95a$export$985ff699ae420a62);
$parcel$export(module.exports, "useInvitePeopleContext", () => $42c464e52720e95a$export$6e1f061d7f85285a);
/**
 * This file is needed to avoid a circular dependency between two modules:
 * InvitePeopleContext and analytics (which causes a runtime error in Webpack).
 *
 * `useAnalytics()` grabs common attributes from `InvitePeopleContext`,
 * but `InvitePeopleContext` needs to fire analytics after fetching some data.
 *
 * This file can be imported by both modules, with analytics conditionally using
 * the raw InvitePeopleStateContext.
 */ 
var $5uXOq = parcelRequire("5uXOq");
const $42c464e52720e95a$export$985ff699ae420a62 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $42c464e52720e95a$export$6e1f061d7f85285a = ()=>{
    const state = (0, $5uXOq.useContext)($42c464e52720e95a$export$985ff699ae420a62);
    if (state === undefined) throw new Error('useInvitePeopleContext must be used within a InvitePeopleStateContextProvider');
    return state;
};

});

parcelRegister("gOE0R", function(module, exports) {

$parcel$export(module.exports, "useCommonAttributesFrom", () => $a7a363368d00b5bb$export$b25016f1558e7ae4);

var $5uXOq = parcelRequire("5uXOq");

var $444qv = parcelRequire("444qv");
const $a7a363368d00b5bb$export$b25016f1558e7ae4 = (invitePeopleState)=>{
    const experimentalFeatures = (0, $444qv.useExperimentalFeatures)();
    return (0, $5uXOq.useMemo)(()=>$a7a363368d00b5bb$export$867943f6176417e3(invitePeopleState, experimentalFeatures), [
        invitePeopleState,
        experimentalFeatures
    ]);
};
const $a7a363368d00b5bb$export$867943f6176417e3 = (invitePeopleState, experimentalFeatures)=>{
    const { userEmail: userEmail, loggedInEmailDomain: loggedInEmailDomain, ...invitePeopleStateFiltered } = invitePeopleState;
    return {
        ...invitePeopleStateFiltered,
        experimentalFeatures: experimentalFeatures
    };
};

});
parcelRegister("444qv", function(module, exports) {

$parcel$export(module.exports, "withExperimentalFeatures", () => $93efbd1adbc9d2b3$export$186c8989a43aa0bd);
$parcel$export(module.exports, "useExperimentalFeatures", () => $93efbd1adbc9d2b3$export$de10fd32f1881334);

var $hVdD3 = parcelRequire("hVdD3");
const { withExperimentalFeatures: $93efbd1adbc9d2b3$export$186c8989a43aa0bd, useExperimentalFeatures: $93efbd1adbc9d2b3$export$de10fd32f1881334 } = (0, $hVdD3.defineExperimentalFeatures)({
    inviteFromAssignModal: {
        oneOf: [
            'control',
            'not-enrolled',
            'variation'
        ],
        defaultValue: 'not-enrolled'
    },
    inviteThirdPartyTeams: {
        oneOf: [
            'not-enrolled',
            'control',
            'variation'
        ],
        defaultValue: 'not-enrolled'
    },
    coreInvitesInJiraProjects: {
        oneOf: [
            'not-enrolled',
            'control',
            'invite-only-variation',
            'invite-only-not-enrolled',
            'invite-ra-variation',
            'invite-ra-not-enrolled'
        ],
        defaultValue: 'not-enrolled'
    },
    /**
	 * @deprecated
	 * This prop has no imapct on the component - holdouts are done using Statsig now
	 */ growthTeamHoldout: {
        oneOf: [
            'not-enrolled',
            'control',
            'variation'
        ],
        defaultValue: 'not-enrolled'
    },
    // Describes if the user is eligible for the invite and assign from board experiment
    // but is enrolled in the control cohort.
    isEligibleForInviteAndAssignFromBoard: false,
    // Specifically for Xflow to Confluence - Onboarding Setup Screen
    // Enable to invite same-org users by either AAID or Emails via /gateway/api/v3/invitations/invite
    confluenceXflowOnboarding: false,
    // A Jira experiment that triggers core invite when a user inserted a link in a project
    // and more than 3 project members require access to the linked resource
    invitePromptOnLinkV3: false,
    // Experiment to improve multi product invites
    // https://switcheroo.atlassian.com/ui/gates/7307fe3d-026a-43a2-a3f9-503fec512240/key/core_invites_drive_multi_product_invites
    coreInvitesDriveMultiProductInvites: false,
    // For confluence copy invite link experiment
    isConfluenceInviteLinkFeatureEnabled: false
});
/**
 * **Removing** your experimental feature?
 *   - Move it here to avoid a MAJOR bump.
 *
 * Doing a MAJOR bump?
 *   - **Clear** this back to `{} as const`.
 */ const $93efbd1adbc9d2b3$var$LEGACY_FEATURES = {
};

});
parcelRegister("hVdD3", function(module, exports) {

$parcel$export(module.exports, "defineExperimentalFeatures", () => $1c2848e8efaa3e0a$export$3cc2af425fada9c6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ANW0j = parcelRequire("ANW0j");
const $1c2848e8efaa3e0a$export$3cc2af425fada9c6 = (definitions)=>{
    let ExperimentalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext((0, $ANW0j.featuresResolver)(definitions)({}));
    const ExperimentalProvider = ({ value: propValue, children: children })=>{
        // Cache the resolver for each use of the Provider, using the useState() trick.
        // (Can't use useMemo() as it's just a performance hint, not a memoization guarantee)
        const [resolveFeatures] = (0, $5uXOq.useState)(()=>(0, $ANW0j.featuresResolver)(definitions));
        const resolved = resolveFeatures(propValue);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ExperimentalContext.Provider, {
            value: resolved,
            children: children
        });
    };
    const useExperimentalFeatures = ()=>(0, $5uXOq.useContext)(ExperimentalContext);
    const withExperimentalFeatures = (Component)=>(props)=>/*#__PURE__*/ (0, $2OMIu.jsx)(ExperimentalProvider, {
                value: props.experimentalFeatures,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...props
                })
            });
    return {
        ExperimentalContext: ExperimentalContext,
        ExperimentalProvider: ExperimentalProvider,
        useExperimentalFeatures: useExperimentalFeatures,
        withExperimentalFeatures: withExperimentalFeatures
    };
};

});
parcelRegister("ANW0j", function(module, exports) {

$parcel$export(module.exports, "featuresResolver", () => $7bef53919c6a5f6d$export$8a08447eee49a4c8);
const $7bef53919c6a5f6d$export$8a08447eee49a4c8 = (definitions)=>{
    let prevFeaturesProp = null;
    let prevResult = null;
    let compiledDefinitions = null;
    return (featuresProp = {})=>{
        const changedResult = {};
        let changed = false;
        compiledDefinitions = compiledDefinitions ?? $7bef53919c6a5f6d$var$compileFeatures(definitions);
        for (const featureKey of Object.keys(definitions)){
            const rawDefinition = definitions[featureKey];
            const compiledDefinition = compiledDefinitions[featureKey];
            const featureValueFromProp = featuresProp[featureKey];
            if (prevFeaturesProp && prevResult) {
                const prevFeatureValueFromProp = prevFeaturesProp[featureKey];
                if (featureValueFromProp === prevFeatureValueFromProp) {
                    changedResult[featureKey] = prevResult[featureKey];
                    continue;
                }
            }
            changed = true;
            changedResult[featureKey] = compiledDefinition.resolve(featureValueFromProp, rawDefinition);
        }
        const result = changed || prevResult === null ? changedResult : prevResult;
        prevFeaturesProp = featuresProp;
        prevResult = result;
        return result;
    };
};
const $7bef53919c6a5f6d$var$compileFeatures = (definitions)=>{
    const result = {};
    for (let featureKey of Object.keys(definitions))result[featureKey] = $7bef53919c6a5f6d$var$compileFeature(definitions, featureKey);
    return result;
};
const $7bef53919c6a5f6d$var$compileFeature = (definitions, featureKey)=>{
    const definition = definitions[featureKey];
    if ($7bef53919c6a5f6d$var$isCustomMultivariateDescriptor(definition)) return {
        resolve: $7bef53919c6a5f6d$var$customMultivariateDescriptorResolver
    };
    else return {
        resolve: $7bef53919c6a5f6d$var$simpleDefaultValueResolver
    };
};
const $7bef53919c6a5f6d$var$isCustomMultivariateDescriptor = (definition)=>{
    if (!definition) return false;
    const descriptor = definition;
    return Array.isArray(descriptor.oneOf) && descriptor.defaultValue !== undefined;
};
const $7bef53919c6a5f6d$var$simpleDefaultValueResolver = (valueFromProp, definition)=>valueFromProp ?? definition;
const $7bef53919c6a5f6d$var$customMultivariateDescriptorResolver = (valueFromProp, definition)=>valueFromProp ?? definition.defaultValue;

});




parcelRegister("59lp1", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsEvent", () => $70543bfb9167be42$export$c7d191551feb734);

var $9Iej8 = parcelRequire("9Iej8");

const $70543bfb9167be42$var$createAndFireEventOnPeopleTeams = (0, $9Iej8.default)((0, $241a88bae7861acc$export$85183a312807388d));
const $70543bfb9167be42$export$c7d191551feb734 = (payload, createAnalyticsEvent)=>{
    const fire = $70543bfb9167be42$var$createAndFireEventOnPeopleTeams(payload);
    fire(createAnalyticsEvent);
};

});
const $241a88bae7861acc$export$85183a312807388d = 'peopleTeams';



parcelRegister("5Iax1", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleAnalytics", () => $f98e9f5c592214e2$export$314fcea5dcdb0997);

var $lp06J = parcelRequire("lp06J");

var $hatDq = parcelRequire("hatDq");
const $f98e9f5c592214e2$var$mapToInviteResultList = (result = {})=>Object.keys(result).map((resourceAri)=>({
            resourceAri: resourceAri,
            status: result[resourceAri]
        }));
const $f98e9f5c592214e2$export$9ef30cb834a0dc18 = 'productSelect';
class $f98e9f5c592214e2$export$314fcea5dcdb0997 extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    inviteRequestSucceeded(products, response, isRecaptchaTokenPresent, inviteFromSuccessModal) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INVITE_REQUEST,
            action: (0, $hatDq.AnalyticsAction).SUCCEEDED,
            attributes: {
                integration: source,
                permissionLevel: userRole,
                products: products,
                invited: response.invited,
                accessRequested: response.accessRequested,
                error: response.error,
                isRecaptchaTokenPresent: isRecaptchaTokenPresent,
                inviteFromSuccessModal: inviteFromSuccessModal
            }
        });
    }
    productSelectDropdownOpened(attributes) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        const { productOptions: productOptions, selectedProducts: selectedProducts } = attributes;
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).DROPDOWN,
            actionSubjectId: $f98e9f5c592214e2$export$9ef30cb834a0dc18,
            action: (0, $hatDq.AnalyticsAction).OPENED,
            attributes: {
                integration: source,
                source: source,
                userRole: userRole,
                productOptions: productOptions,
                selectedProducts: selectedProducts
            }
        });
    }
    userInvited(attributes) {
        const { originAttributes: originAttributes, userId: userId, products: products, inviteResult: inviteResult, externalUserType: externalUserType, externalUserSubtype: externalUserSubtype, isUserEmailVisible: isUserEmailVisible, ...rest } = attributes;
        const { inviteFromAssignModalCohort: inviteFromAssignModalCohort, isEligibleForInviteAndAssignFromBoard: isEligibleForInviteAndAssignFromBoard, source: source, userRole: userRole } = this.commonAttributes;
        this.fireTrack({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).USER,
            actionSubjectId: userId,
            action: (0, $hatDq.AnalyticsAction).INVITED,
            attributes: {
                ...originAttributes,
                permissionLevel: userRole,
                products: products,
                integration: source,
                inviteResult: $f98e9f5c592214e2$var$mapToInviteResultList(inviteResult),
                externalUserType: externalUserType,
                externalUserSubtype: externalUserSubtype,
                isUserEmailVisible: isUserEmailVisible,
                ...isEligibleForInviteAndAssignFromBoard && {
                    inviteAndAssignFromBoardCohort: 'control'
                },
                inviteFromAssignModalCohort: inviteFromAssignModalCohort,
                ...rest
            }
        });
    }
    userAccessRequested(attributes) {
        const { originAttributes: originAttributes, userId: userId, products: products, inviteResult: inviteResult, externalUserType: externalUserType, externalUserSubtype: externalUserSubtype, isUserEmailVisible: isUserEmailVisible, ...rest } = attributes;
        const { inviteFromAssignModalCohort: inviteFromAssignModalCohort, source: source, userRole: userRole } = this.commonAttributes;
        this.fireTrack({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).PRODUCT_ACCESS,
            actionSubjectId: userId,
            action: (0, $hatDq.AnalyticsAction).REQUESTED,
            attributes: {
                ...originAttributes,
                permissionLevel: userRole,
                products: products,
                requestedForUserId: userId,
                integration: source,
                inviteResult: $f98e9f5c592214e2$var$mapToInviteResultList(inviteResult),
                externalUserType: externalUserType,
                externalUserSubtype: externalUserSubtype,
                isUserEmailVisible: isUserEmailVisible,
                inviteFromAssignModalCohort: inviteFromAssignModalCohort,
                ...rest
            }
        });
    }
    inviteRequestFailed(products, isRecaptchaTokenPresent, code, message, status, inviteFromSuccessModal) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INVITE_REQUEST,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                code: code,
                message: message,
                permissionLevel: userRole,
                products: products,
                integration: source,
                status: status,
                isRecaptchaTokenPresent: isRecaptchaTokenPresent,
                inviteFromSuccessModal: inviteFromSuccessModal
            }
        });
    }
    fetchingEligibleUsersFailed(products) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).FETCH_ELIGIBLE_USERS,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                permissionLevel: userRole,
                products: products,
                integration: source
            }
        });
    }
    userInviteSettingsFailed(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).USER_INVITE_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).UPDATE_FAILED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    inviteFormLoaded(duration, hasPermissionToInviteOrRequestAccess) {
        const { source: source } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INVITE_FORM,
            action: (0, $hatDq.AnalyticsAction).LOADED,
            attributes: {
                integration: source,
                duration: duration,
                hasPermissionToInviteOrRequestAccess: hasPermissionToInviteOrRequestAccess
            }
        });
    }
    inviteComponentViewed(attributes) {
        const { disableNoInviteError: disableNoInviteError, inviteFromAssignModalCohort: inviteFromAssignModalCohort, plugins: plugins, productTitle: productTitle, source: source, userRole: userRole, viewAs: viewAs, experimentalFeatures: experimentalFeatures } = this.commonAttributes;
        const pluginsLocation = plugins ? Object.keys(plugins).map((location)=>location) : undefined;
        this.fireScreen({
            name: (0, $hatDq.AnalyticsActionSubject).CORE_INVITE_COMPONENT,
            attributes: {
                ...attributes,
                disableNoInviteError: disableNoInviteError,
                inviteFromAssignModalCohort: inviteFromAssignModalCohort,
                pluginsLocation: pluginsLocation,
                product: productTitle,
                source: source,
                userRole: userRole,
                viewAs: viewAs,
                invitePromptOnLinkV3Cohort: experimentalFeatures?.invitePromptOnLinkV3 ?? false
            }
        });
    }
    getPermsFailed(resourceId, message) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).PERMS,
            actionSubjectId: resourceId,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                message: message
            }
        });
    }
    getPermsSucceeded(resourceId, isInviteUsersPermitted, isManagePermitted) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).PERMS,
            actionSubjectId: resourceId,
            action: (0, $hatDq.AnalyticsAction).SUCCEEDED,
            attributes: {
                isInviteUsersPermitted: isInviteUsersPermitted,
                isManagePermitted: isManagePermitted
            }
        });
    }
    accountInfoFailed(error) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).ACCOUNT_INFO,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                error: error
            }
        });
    }
    approvedDomainsSettingsFailed(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).APPROVED_DOMAIN_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).UPDATE_FAILED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    inviteFailedSLO(isItptEnabled, isAioliv3Enabled, code, message, status) {
        const { source: source } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).SLO_INVITE_REQUEST,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                isAioliv3Enabled: isAioliv3Enabled,
                isItptEnabled: isItptEnabled,
                status: status,
                code: code,
                message: message,
                integration: source
            }
        });
    }
    inviteSucceededSLO(isItptEnabled, isAioliv3Enabled) {
        const { source: source } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).SLO_INVITE_REQUEST,
            action: (0, $hatDq.AnalyticsAction).SUCCEEDED,
            attributes: {
                isAioliv3Enabled: isAioliv3Enabled,
                isItptEnabled: isItptEnabled,
                integration: source
            }
        });
    }
    approvedDomainsSettingsSucceededSLO(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireTrack({
            // Matches naming from admin hub
            actionSubject: (0, $hatDq.AnalyticsActionSubject).APPROVED_DOMAIN_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).UPDATED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    approvedDomainsSettingsFailedSLO(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).SLO_APPROVED_DOMAIN_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).UPDATE_FAILED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    userInviteSettingsSucceededSLO(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireTrack({
            // Matches naming from admin hub
            actionSubject: (0, $hatDq.AnalyticsActionSubject).USER_INVITE_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).UPDATED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    userInviteSettingsFailedSLO(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).SLO_USER_INVITE_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).UPDATE_FAILED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
}

});
parcelRegister("lp06J", function(module, exports) {

$parcel$export(module.exports, "BaseInvitePeopleAnalytics", () => $1ef9241e8a6ddeee$export$8575d6a2e31b2c24);

class $1ef9241e8a6ddeee$export$8575d6a2e31b2c24 {
    constructor(fireAnalytics, attributes){
        this.fireAnalytics = fireAnalytics;
        this.setCommonAttributes(attributes);
    }
    setCommonAttributes(attributes) {
        this.commonAttributes = attributes;
    }
    fireUI(payload) {
        this.fireAnalytics({
            ...payload,
            eventType: (0, $4e2819b72987a07d$export$a1562d08625f5d7e)
        });
    }
    fireTrack(payload) {
        this.fireAnalytics({
            ...payload,
            eventType: (0, $4e2819b72987a07d$export$947dac6c72b26f81)
        });
    }
    fireOperational(payload) {
        this.fireAnalytics({
            ...payload,
            eventType: (0, $4e2819b72987a07d$export$12346a674644c156)
        });
    }
    fireScreen(payload) {
        this.fireAnalytics({
            ...payload,
            eventType: (0, $4e2819b72987a07d$export$f1d537d508d2945a)
        });
    }
}

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $4e2819b72987a07d$export$a1562d08625f5d7e = 'ui';
const $4e2819b72987a07d$export$947dac6c72b26f81 = 'track';
const $4e2819b72987a07d$export$f1d537d508d2945a = 'screen';
const $4e2819b72987a07d$export$12346a674644c156 = 'operational';
const $4e2819b72987a07d$export$b055de0e665cb20c = 'unknown';



parcelRegister("fn6W9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3bac65c5d927b923$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3bac65c5d927b923$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    formTitle: {
        id: 'ptc.ip.form.title.people.experiment',
        defaultMessage: 'Add people',
        description: 'The default title for the invite users form'
    },
    formTitleProduct: {
        id: 'ptc.ip.users.form.title.product.people.experiment',
        defaultMessage: 'Add people to {product}',
        description: 'A title for the invite users form stating to which product users should be invited'
    },
    formMoreActionsButtonLabel: {
        id: 'ptc.ip.form.moreActionsDropdown.label',
        defaultMessage: 'More actions',
        description: 'The label of the the more actions drop down menu button'
    },
    formManageAccessSettingsLabel: {
        id: 'ptc.ip.form.siteAccessSettings.label',
        defaultMessage: 'Site access settings',
        description: 'The label of the manage access settings link in the drop down menu'
    },
    sendInviteButton: {
        id: 'ptc.ip.form.sendButton.count.experiment',
        defaultMessage: `{numberOfInputs, plural,
        =0 {Add}
        one {Add {numberOfInputs} person}
        other {Add {numberOfInputs} people}}`,
        description: 'Text for send invite button. Should be one of "Add", "Add 1 person", "Add n people"'
    },
    usersSendInviteButton: {
        id: 'ptc.ip.users.form.sendButton',
        defaultMessage: 'Add teammates',
        description: 'Text for Send invite button'
    },
    cancelButton: {
        id: 'ptc.ip.form.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Text for cancel invite button'
    },
    invalidEmailMessage: {
        id: 'ptc.ip.form.invalid-email-message',
        defaultMessage: 'Please enter a valid email address',
        description: 'Error message to be shown when the users adds an invalid email address'
    },
    emptyEmailMessage: {
        id: 'ptc.ip.form.empty-email-message.person',
        defaultMessage: 'Choose at least one person',
        description: 'Error message to be shown when the user tries to submit the invite form without add any email'
    },
    noProductSelectedMessage: {
        id: 'ptc.ip.form.no-product-selected-message.choose',
        defaultMessage: 'Choose at least one product',
        description: 'Error message to be shown when the user tries to submit the invite form with no product selected'
    },
    productSelect: {
        id: 'ptc.ip.form.select-products.label.choose.experiment',
        defaultMessage: 'Add to other Atlassian products?',
        description: 'Label for product select field'
    },
    productSelectNoCurrentProduct: {
        id: 'ptc.ip.form.select-products.label.no.current.product',
        defaultMessage: 'Select one or more products',
        description: 'Label for product select field when no there are no current products'
    },
    jiraCoreMessage: {
        id: 'ptc.ip.form.jira-core-message',
        defaultMessage: 'Jira Core is included with other Jira products.',
        description: 'Warning message to be shown when the user select any of the Jira products'
    },
    optionIncludedWithOtherJiraProducts: {
        id: 'people-and-teams.invite-people.form.option-included-with-other-jira-products',
        defaultMessage: 'Included with other Jira products',
        description: 'Shown in the product select dropdown, next to a Jira product that was included for free with other Jira products'
    },
    emailInputLabel: {
        id: 'ptc.ip.form.email-input-label',
        defaultMessage: 'Email address',
        description: 'Label to the field where the user will add the email'
    },
    inviteSuccessFlagDescriptionMultiProduct: {
        id: 'ptc.ip.flag.invite-success-flag-description-multi-product',
        defaultMessage: `{inviteCount, plural, one {You've invited {emailInvited}.} other {You've invited {inviteCount} people.}}`,
        description: `This message notifies the user that they have successfully invited people to multiple products. The final string should read like "You've invited user@email.com." or "You've invited 2 people."`
    },
    inviteSuccessFlagDescriptionSingleProduct: {
        id: 'ptc.ip.flag.invite-success-flag-description-single-product',
        defaultMessage: `{inviteCount, plural, one {You've invited {emailInvited} to {product}.} other {You've invited {inviteCount} people to {product}.}}`,
        description: `This message notifies the user that they have successfully invited people to one product. The final string should read like "You've invited user@email.com to Confluence." or "You've invited 2 people to Confluence."`
    },
    zeroRequestAccessFlagDescription: {
        id: 'ptc.ip.flag.zero-request-access-flag-description',
        defaultMessage: 'You have not requested access for anyone.'
    },
    contactSupportActionLabel: {
        id: 'ptc.ip.flag.contact-support-action-label',
        defaultMessage: 'Contact support'
    },
    viewUsersActionLabel: {
        id: 'ptc.ip.flag.view-users-action-label',
        defaultMessage: 'View users'
    },
    upgradePlanActionLabel: {
        id: 'ptc.ip.flag.upgrade-plan-action-label',
        defaultMessage: 'Upgrade plan'
    },
    jiraCoreOptionSubText: {
        id: 'ptc.ip.jira.core.option.subtext',
        defaultMessage: 'Included with other Jira products'
    },
    selectPlaceholder: {
        id: 'ptc.ip.product.select.placeholder.experiment',
        defaultMessage: 'Select products',
        description: 'Product selector placeholder text when no other products are selected'
    },
    selectAllOption: {
        id: 'ptc.ip.product.select.alloption.choose',
        defaultMessage: 'Choose all'
    },
    inviteeListUserPickerPlaceholder: {
        id: 'ptc.ip.form.invitee-list.user-picker.email.placeholder.experiment',
        defaultMessage: 'e.g., Maria, maria@company.com',
        description: 'Placeholder to show in user picker in invitee list when no integrations are connected(This needs to be gender neutral)'
    },
    inviteeListLabel: {
        id: 'ptc.ip.form.invitee-list.label',
        defaultMessage: 'Add with email',
        description: 'Label to be shown above the invitee list text field.'
    },
    inviteeListLabelThirdParty: {
        id: 'ptc.ip.form.invitee-list-third-party.no-integrations.label.invite.experiment',
        defaultMessage: 'Names or emails',
        description: 'Label to be shown above the invitee list user picker field'
    },
    inviteeListLabelThirdPartyTeamsSlackChannelByline: {
        id: 'ptc.ip.form.invitee-list-third-party-teams.slack-channel.byline',
        defaultMessage: 'Select members in channel',
        description: 'Byline to be shown below slack channel in user picker field.'
    },
    inviteeListLabelThirdPartyTeamMemberPickerBackButton: {
        id: 'ptc.ip.form.invitee-list-third-party-teams.team-member-picker.back-button',
        defaultMessage: 'Go back',
        description: 'Back button to be shown in team member picker.'
    },
    inviteeListLabelThirdPartyTeamMemberPickerContinueButton: {
        id: 'ptc.ip.form.invitee-list-third-party-teams.team-member-picker.continue-button',
        defaultMessage: 'Continue',
        description: 'Continue button to be shown in team member picker.'
    },
    thirdPartyTeamHasMoreMembersWarningLabel: {
        id: 'ptc.ip.form.invitee-list-third-party-teams.more-members.label',
        defaultMessage: 'Not displaying all members',
        description: 'Accessibility label for warning icon which appears when there are too many channel members to display'
    },
    thirdPartyTeamHasMoreMembersWarningText: {
        id: 'ptc.ip.form.invitee-list-third-party-teams.more-members.text',
        defaultMessage: 'We are only able to display {memberCount, plural, one {# member} other {# members}}. Try searching for people or a smaller team.',
        description: 'Text displayed when hovering over the warning icon which appears when there are too many members to display. maxMembers will always be plural (eg. 30).'
    },
    inviteeListLabelThirdPartyTeamMemberByline: {
        id: 'ptc.ip.form.invitee-list-third-party-teams.team-member.byline',
        defaultMessage: 'Invite from Slack',
        description: 'Byline to be shown with each member in team member picker.'
    },
    inviteSelfMessage: {
        id: 'ptc.ip.form.invalid-self-invite',
        defaultMessage: "Remove your own name or email \u2014 you can't add yourself.",
        description: 'Error message to be shown when the users attempts to invite themselves.'
    },
    invalidMultipleEmailMessage: {
        id: 'ptc.ip.form.invalid-multiple-email-message',
        defaultMessage: 'To send your invites, please correct any invalid addresses.',
        description: 'Error message to be shown when the users adds an invalid email address to the multiple email input'
    },
    tooManyEmailAddresses: {
        id: 'ptc.ip.form.too-many-email-addresses',
        defaultMessage: 'You can only send up to {maxEmails, plural, one {{maxEmails} email invite} other {{maxEmails} email invites}} at once.',
        description: 'Error message to be shown when the users adds too many email addresses to the multiple email input'
    },
    tooManyEmailAddressesInProject: {
        id: 'ptc.ip.form.too-many-email-addresses-in-projects',
        defaultMessage: 'You can only add up to {maxEmails, plural, one {{maxEmails} person} other {{maxEmails} people}} at once.',
        description: 'Error message to be shown when the users adds too many email addresses to the multiple email input'
    },
    inviteeListNote: {
        id: 'ptc.ip.form.invitee-list.note',
        defaultMessage: 'Enter up to {maxEmails, plural, one {{maxEmails} email address} other {{maxEmails} email addresses}}, separated by a comma.',
        description: 'Note to be shown below the invitee list text field.'
    },
    inviteeListPickerNote: {
        id: 'ptc.ip.form.invitee-list-picker.note.choose',
        defaultMessage: 'Choose at least one person',
        description: 'Note to be shown below the invitee list user picker field if user tries to submit empty form.'
    },
    googleThirdPartyConnectedTooltip: {
        id: 'ptc.ip.thirdparty.google.connected.tooltip',
        defaultMessage: 'Disconnect Google',
        description: 'Tooltip to show over unlink icon for google integration'
    },
    googleThirdPartyButton: {
        id: 'ptc.ip.thirdparty.google.button',
        defaultMessage: 'Google',
        description: 'Starts a connection flow between the users atlassian account to his google account in order to invite google users to atlassian'
    },
    microsoftThirdPartyConnectedTooltip: {
        id: 'ptc.ip.thirdparty.microsoft.connected.tooltip',
        defaultMessage: 'Disconnect Microsoft',
        description: 'Tooltip to show over unlink icon for microsoft integration'
    },
    microsoftThirdPartyButton: {
        id: 'ptc.ip.thirdparty.microsoft.button',
        defaultMessage: 'Microsoft',
        description: 'Starts a connection flow between the users atlassian account to his microsoft account in order to invite microsoft users to atlassian'
    },
    slackThirdPartyConnectedTooltip: {
        id: 'ptc.ip.thirdparty.slack.connected.tooltip',
        defaultMessage: 'Manage this connection',
        description: 'Tooltip to show over cog icon for slack integration'
    },
    slackThirdPartyButton: {
        id: 'ptc.ip.thirdparty.slack.button',
        defaultMessage: 'Slack',
        description: 'Opens a modal allowing the user to connect third party invites to one of his connected slack workspaces'
    },
    unknownThirdParty: {
        id: 'ptc.ip.thirdparty.unknown.button',
        defaultMessage: 'Unknown',
        description: 'Button label to handle unknown integration case'
    },
    thirdPartyConnect: {
        id: 'ptc.ip.thirdparty-connect.connect.label.people.experiment',
        defaultMessage: 'or add from',
        description: 'Label telling to user to connect teammates from listed integrations'
    },
    thirdPartyConnectedTo: {
        id: 'ptc.ip.thirdparty.connect-to.label',
        defaultMessage: 'Connected to',
        description: 'Label on list of connected third party sources for user invitess'
    },
    slackWorkspacesConnectDialogHeading: {
        id: 'ptc.ip.slack.workspaces.connect.dialog.heading',
        defaultMessage: 'Connect Slack workspace',
        description: 'Heading for the Connect Slack workspaces dialog'
    },
    slackWorkspacesManageDialogHeading: {
        id: 'ptc.ip.slack.workspaces.manage.dialog.heading',
        defaultMessage: 'Manage Slack connection',
        description: 'Heading for the Manage Slack workspaces dialog'
    },
    slackWorkspacesDialogBody: {
        id: 'ptc.ip.slack.workspaces.dialog.body',
        defaultMessage: "Select one workspace that you\u2019d like to invite users from.",
        description: 'Body for the Slack workspaces dialog'
    },
    slackWorkspacesDialogDisconnectSlack: {
        id: 'ptc.ip.slack.workspaces.dialog.disconnect.slack',
        defaultMessage: 'Disconnect Slack',
        description: 'Text for the Disconnect Slack link on the Slack workspaces dialog'
    },
    slackWorkspacesDoneButton: {
        id: 'ptc.ip.slack.workspaces.dialog.connet-workspace',
        defaultMessage: 'Connect workspace',
        description: 'Text for connectioon button in slack workspace selection dialog'
    },
    slackWorkspacesDisconnectDialogHeading: {
        id: 'ptc.ip.slack.workspaces.disconnect.dialog.heading',
        defaultMessage: 'Disconnect Slack',
        description: 'Title for the Disconnect Slack workspaces dialog'
    },
    slackWorkspacesDisconnectDialogBody: {
        id: 'ptc.ip.slack.workspaces.disconnect.dialog.body',
        defaultMessage: "You're about to disconnect this Slack workspace and limit your ability to search through its contacts.",
        description: 'text too shoow in the body of the Disconnect Slack workspaces dialog'
    },
    disconnectButton: {
        id: 'ptc.ip.slack.disconnect.dialog.disconnect.button',
        defaultMessage: 'Disconnect',
        description: 'Text for Disconnect slack button'
    },
    slackConnectSuccessFlagTitle: {
        id: 'ptc.ip.flag.slack-connect-success-flag-title',
        defaultMessage: "\u2018{workspace}\u2019 from Slack connected",
        description: 'Flag header for slack connection'
    },
    slackConnectSuccessFlagDescription: {
        id: 'ptc.ip.flag.slack-connect-success-flag-description',
        defaultMessage: "You can now search through this workspace\u2019s list of contacts.",
        description: 'Flag description for slack connection'
    },
    slackDisconnectSuccessFlagTitle: {
        id: 'ptc.ip.flag.slack-disconnect-success-flag-title',
        defaultMessage: 'Slack disconnected',
        description: 'Flag header for slack disconnection'
    },
    slackDiscnnectSuccessFlagDescription: {
        id: 'ptc.ip.flag.slack-disconnect-success-flag-description',
        defaultMessage: "You can no longer search through this workspace\u2019s list of contacts.",
        description: 'Flag description for slack disconnection'
    },
    microsoftConnectSuccessFlagTitle: {
        id: 'ptc.ip.flag.microsoft-connect-success-flag-title',
        defaultMessage: 'Microsoft connected',
        description: 'Flag header for successful microsoft connection'
    },
    microsoftConnectSuccessFlagDescription: {
        id: 'ptc.ip.flag.microsoft-connect-success-flag-description',
        defaultMessage: 'You can now search through its list of contacts.',
        description: 'Flag description for successful microsoft connection'
    },
    googleConnectSuccessFlagTitle: {
        id: 'ptc.ip.flag.google-connect-success-flag-title',
        defaultMessage: 'Google Workspace connected',
        description: 'Flag header for successful google workspace connection'
    },
    googleConnectSuccessFlagDescription: {
        id: 'ptc.ip.flag.google-connect-success-flag-description',
        defaultMessage: 'You can now search through its list of contacts.',
        description: 'Flag description for successful google workspace connection'
    },
    thirdPartyTeamSelectAllLabel: {
        id: 'ptc.ip.form.invitee-list-third-party-teams.select-all.label',
        defaultMessage: 'Select {numSelectable, plural, one {member} other {all {numSelectable} members}}',
        description: 'Label for button to select all inviteable members in a Slack channel'
    },
    thirdPartyTeamDeselectAllLabel: {
        id: 'ptc.ip.form.invitee-list-third-party-teams.deselect-all.label',
        defaultMessage: 'Deselect {numSelected, plural, one {member} other {all {numSelected} members}}',
        description: 'Label for button to deselect all selected members in a Slack channel'
    },
    errorHeading: {
        id: `ptc.ip.error-heading`,
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in Invite people. Usually due to failed network requests.'
    },
    errorText: {
        id: `ptc.ip.error-text`,
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Invite People.'
    },
    errorImageAltText: {
        id: `ptc.ip.error-image-alt-text`,
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Invite People'
    },
    viralSettingsHeading: {
        id: 'ptc.ip.viral-settings.heading.experiment',
        defaultMessage: 'Allow',
        description: 'Sub-heading for viral settings in the Invite People component'
    },
    directAccessDescription: {
        id: 'ptc.ip.viral-settings.direct-access.description.experiment',
        defaultMessage: 'Verified {domainWithStyling} email users to join.',
        description: 'Text explaining to the user what enabling direct access will do. Will only be a single domain at any given time.'
    },
    directAccessExtendedDescription: {
        id: 'ptc.ip.viral-settings.open-invite.extended-description',
        defaultMessage: 'People in your org can join without an invite when they need to collaborate.',
        description: 'An extended description of what enabling direct access will do.'
    },
    openInviteDescription: {
        id: 'ptc.ip.viral-settings.open-invite.description.users.experiment',
        defaultMessage: 'Site users to invite other people.',
        description: 'Text explaining to the user what enabling open invite will do, will only update the currently selected product.'
    },
    openInviteSuccessFlagTitle: {
        id: 'ptc.ip.flag.viral-settings.open-invite.success.title',
        defaultMessage: 'You updated {product} invite settings',
        description: 'The title of a notification shown to users when they enable user invites.'
    },
    openInviteSuccessFlagDescription: {
        id: 'ptc.ip.flag.viral-settings.open-invite.success.description',
        defaultMessage: 'Your teammates can now invite other people without your approval.',
        description: 'The description of a notification shown to users when they enable user invites.'
    },
    openInviteFailureFlagTitle: {
        id: 'ptc.ip.flag.viral-settings.open-invite.failure.title',
        defaultMessage: "We couldn\u2019t save your invite settings",
        description: 'The title of a notification shown to users when they failed to enable user invites.'
    },
    openInviteFailureFlagDescription: {
        id: 'ptc.ip.flag.viral-settings.open-invite.failure.description',
        defaultMessage: 'Go to Administration to allow your teammates to invite other people to {product}.',
        description: 'The title of a notification shown to users when they failed to enable user invites.'
    },
    viralSettingsSuccessFlagActionLabel: {
        id: 'ptc.ip.flag.viral-settings.success.action-label',
        defaultMessage: 'See access settings',
        description: 'The action label of all viral settings success notifications, shown to users when they successfully enable a viral setting.'
    },
    viralSettingsFailureFlagActionLabel: {
        id: 'ptc.ip.flag.viral-settings.failure.action-label',
        defaultMessage: 'See access settings in Administration',
        description: 'The action label of all viral settings failure notifications, shown to users when the system failed to enable a/both viral setting.'
    },
    directAccessSuccessFlagTitle: {
        id: 'ptc.ip.flag.viral-settings.direct-access.success.title',
        defaultMessage: 'You updated {product} join settings',
        description: 'The title of a notification shown to users when they enable direct access.'
    },
    directAccessSuccessFlagDescription: {
        id: 'ptc.ip.flag.viral-settings.direct-access.success.description',
        defaultMessage: 'New users with a verified {domains} email address can now join without an invite.',
        description: 'The description of a notification shown to users when they enable direct access.'
    },
    directAccessFailureFlagTitle: {
        id: 'ptc.ip.flag.viral-settings.direct-access.failure.title',
        defaultMessage: "We couldn\u2019t save your join settings",
        description: 'The title of a notification shown to users when the system fails to enable direct access'
    },
    directAccessFailureFlagDescription: {
        id: 'ptc.ip.flag.viral-settings.direct-access.failure.description',
        defaultMessage: 'Go to Administration to allow new users with a verified {domain} email address to join {product}.',
        description: 'The title of a notification shown to users when the system fails to enable direct access'
    },
    viralSettingsSuccessFlagTitle: {
        id: 'ptc.ip.flag.viral-settings.success.title',
        defaultMessage: 'You updated {product} access settings',
        description: 'The title of a notification shown to users when they enable both direct access and open invite.'
    },
    viralSettingsSuccessFlagDescription: {
        id: 'ptc.ip.flag.viral-settings.success.description',
        defaultMessage: 'Users can invite new users, and org members with a verified {domains} email can join without an invite.',
        description: 'The description of a notification shown to users when they enable both direct access and open invite.'
    },
    viewTeamActionLabel: {
        id: 'ptc.ip.flag.view-team-action-label',
        defaultMessage: 'View team',
        description: 'Text for view team action button on teams invite flags.'
    },
    openInviteExtendedDescription: {
        id: 'ptc.ip.viral-settings.direct-access.extended-description',
        defaultMessage: 'Your users will be able to invite new collaborators as needed.',
        description: 'An extended description of what enabling open invite will do.'
    },
    slackWorkspaceAddNewWorkspaceOption: {
        id: 'ptc.ip.slack.workspace.dropdown.add-new-workspace',
        defaultMessage: 'Add a new Workspace',
        description: 'Option which allows to add a new Slack workspace'
    },
    spotlightTitle: {
        id: 'ptc.ip.slack.teams.spotlight.title',
        defaultMessage: 'Add teams from Slack',
        description: 'Spotlight title informing users of the slack teams feature'
    },
    spotlightDescription: {
        id: 'ptc.ip.slack.teams.spotlight.description',
        defaultMessage: 'You can now search teams from Slack and select people to add into {product}.',
        description: 'Spotlight description explaining that the slack team feature is available'
    },
    spotlightAction: {
        id: 'ptc.ip.slack.teams.spotlight.action',
        defaultMessage: 'Got it',
        description: 'Button to close the slack team spotlight'
    },
    infiSpotlightTitle: {
        id: 'ptc.ip.thirdparty.spotlight.title',
        defaultMessage: 'Connect and find people faster',
        description: 'Spotlight title informing users of the infi feature'
    },
    infiSpotlightDescription: {
        id: 'ptc.ip.thirdparty.spotlight.description',
        defaultMessage: 'Connect your Google, Microsoft, and Slack accounts to quickly find and add your teammates to this site.',
        description: 'Spotlight description explaining that the infi feature is available'
    },
    infiSpotlightAction: {
        id: 'ptc.ip.infi.spotlight.action',
        defaultMessage: 'OK',
        description: 'Button to close the infi spotlight'
    },
    adminSyncSlackContactsDescription: {
        id: 'ptc.ip.third.party.users.dropdown.sync-option-description',
        defaultMessage: 'Allow people to search for Slack contacts. Manage in admin.atlassian.com',
        description: 'Dropdown option description telling admin that they can ehance collaboration by connection slack for all users'
    },
    adminSyncSlackContactsOption: {
        id: 'ptc.ip.third.party.users.dropdown.sync-option-label',
        defaultMessage: 'Help teams find Slack contacts',
        description: 'Dropdown option label telling the admin to help teams in their org to find slack contacts'
    },
    adminManageConnectionOption: {
        id: 'ptc.ip.slack.menu.dropdown.manage-connection-label',
        defaultMessage: 'Manage Slack connection',
        description: 'Dropdown option label telling the admin to manage the slack connection for the invite people dialog'
    },
    thirdPartyAdminOnboardingSpotlight1Heading: {
        id: 'ptc.ip.slack.admin-onboarding.spotlight1.heading',
        defaultMessage: 'Help teams find the right people',
        description: 'Heading for first step of third-party admin import onboarding'
    },
    thirdPartyAdminOnboardingSpotlight1Body: {
        id: 'ptc.ip.slack.admin-onboarding.spotlight1.body',
        defaultMessage: 'Allow users to quickly find and add people from Slack.',
        description: 'Body for first step of third-party admin import onboarding'
    },
    thirdPartyAdminOnboardingSpotlight1Next: {
        id: 'ptc.ip.slack.admin-onboarding.spotlight1.next',
        defaultMessage: 'See how',
        description: 'Button to go to second step of third-party admin import onboarding'
    },
    thirdPartyAdminOnboardingSpotlight2Body: {
        id: 'ptc.ip.slack.admin-onboarding.spotlight2.body',
        defaultMessage: 'Add Slack accounts, control access in admin.atlassian.com',
        description: 'Body for second step of third-party admin import onboarding'
    },
    thirdPartyAdminOnboardingSpotlight2Import: {
        id: 'ptc.ip.slack.admin-onboarding.spotlight1.import',
        defaultMessage: 'Add accounts',
        description: 'Button to go to complete third-party admin import onboarding and start import process'
    },
    thirdPartyAdminOnboardingSpotlightDismiss: {
        id: 'ptc.ip.slack.admin-onboarding.spotlight.dismiss',
        defaultMessage: 'Not now',
        description: 'Button to dismiss third-party admin import onboarding'
    },
    reviewConnection: {
        id: 'ptc.ip.thirdparty.review-connection.notification',
        defaultMessage: `{integration} was disconnected because of an update. Reconnect to invite people from {integration}.`,
        description: 'The warning notification shown to users when they need to update their connection.'
    },
    reviewConnectionTitle: {
        id: 'ptc.ip.thirdparty.review-connection.title',
        defaultMessage: 'Reconnect {integration}',
        description: 'The warning notification title when they click on the notification.'
    },
    reviewConnectionDescription: {
        id: 'ptc.ip.thirdparty.review-connection.description',
        defaultMessage: 'To continue inviting teammates from {integration}, reconnect to the app.',
        description: 'The warning notification body when they click on the notification.'
    },
    reviewAccessNoScope: {
        id: 'ptc.ip.thirdparty.review-access.no.access.notification',
        defaultMessage: `We can\u{2019}t access your {integration} contacts. Let\u{2019}s fix it.`,
        description: 'The warning notification shown to users when they are not fully connected.'
    },
    reviewAccessNoScopeTitle: {
        id: 'ptc.ip.thirdparty.review-access.no.acess.title',
        defaultMessage: 'Finish approving access',
        description: 'The warning notification title when they click on the notification.'
    },
    reviewAccessNoScopeDescription: {
        id: 'ptc.ip.thirdparty.review-access.no.access.description',
        defaultMessage: 'To help you find people from {integration}, we need to access your contacts list.',
        description: 'The warning notification body when they click on the notification.'
    },
    reviewAccessPartialScope: {
        id: 'ptc.ip.thirdparty.review-access.partial.notification',
        defaultMessage: 'Check {integration} access settings',
        description: 'The warning notification shown to users when they are not fully connected.'
    },
    reviewAccessPartialAccessTitle: {
        id: 'ptc.ip.thirdparty.review-access.partial.title',
        defaultMessage: 'Accessing your {integration} {space}',
        description: 'The warning notification title when they click on the notification.'
    },
    reviewAccessPartialAccessDescription: {
        id: 'ptc.ip.thirdparty.review-access.partial.access.description',
        defaultMessage: `We can only search your {integration} contact's list. Want to find more people? Give us access to your {integration} {space} too.`,
        description: 'The warning notification body when they click on the notification.'
    },
    reviewAccessContinue: {
        id: 'ptc.ip.thirdparty.review-access.continue',
        defaultMessage: 'Continue',
        description: 'Continue button to reconnect for the user within the notification for review access.'
    },
    reviewAccessDisconnect: {
        id: 'ptc.ip.thirdparty.review-access.disconnect',
        defaultMessage: 'Disconnect',
        description: 'Disconnect button to be redirected to disconnect for users within the notification for review access.'
    },
    reviewAccessNotNow: {
        id: 'ptc.ip.thirdparty.review-access.not-now',
        defaultMessage: 'Not now',
        description: 'Not now dismiss for user to dismiss message within the notification for review access.'
    },
    googleSpace: {
        id: 'ptc.ip.thirdparty.google.space',
        defaultMessage: 'Workspace',
        description: 'The GSuite term for Google'
    },
    inviteeListLabelThirdPartyTeams: {
        id: 'ptc.ip.form.invitee-list-third-party-teams.no-integrations.label.invite',
        defaultMessage: 'Search people and teams',
        description: 'Label to be shown above the invitee list user picker field'
    },
    inviteeListUserPickerEmailPlaceholderThirdPartyTeams: {
        id: 'ptc.ip.form.invitee-list-third-party-teams.user-picker.email.placeholder.experiment',
        defaultMessage: 'e.g., Maria, maria@company.com, team-lemon',
        description: 'Placeholder to show in user picker in invitee list when the Slack integration is connected'
    },
    secondarySectionHeading: {
        id: 'ptc.ip.secondary.section.heading',
        defaultMessage: 'Other products and access',
        description: 'Heading for secondary section with both product selector and viral settings in the Invite People component'
    },
    secondarySectionHeadingWithProductSelector: {
        id: 'ptc.ip.secondary.section.heading.product.selector.only',
        defaultMessage: 'Other products',
        description: 'Heading for secondary section with product selector only in the Invite People component'
    },
    secondarySectionHeadingWithViralSettings: {
        id: 'ptc.ip.secondary.section.heading.viral.settings.only',
        defaultMessage: 'Access',
        description: 'Heading for secondary section with viral settings only in the Invite People component'
    },
    secondarySectionHeadingNoCurrentProduct: {
        id: 'ptc.ip.secondary.section.heading.no.current.product.and.viral.settings',
        defaultMessage: 'Select products and access',
        description: 'Heading for secondary section when there is viral settings and no current product'
    },
    secondarySectionHeadingWithProductSelectorNoCurrentProduct: {
        id: 'ptc.ip.secondary.section.heading.no.current.product',
        defaultMessage: 'Select products',
        description: 'Heading for secondary section when there is no current product'
    },
    teamsInviteSectionHeading: {
        id: 'ptc.ip.teams-invite-section.heading',
        defaultMessage: 'Teams',
        description: 'Heading for teams invite section in the Invite People component'
    },
    teamsInviteSectionNewLozenge: {
        id: 'ptc.ip.teams-invite-section.new-lozenge',
        defaultMessage: 'New',
        description: 'Lozenge for teams invite section in the Invite People component'
    },
    teamsInviteSectionCheckboxLabel: {
        id: 'ptc.ip.teams-invite-section.checkbox-label',
        defaultMessage: 'Add invited people to a new or existing team',
        description: 'Label for the invite people to a team checkbox in the teams invite section in the Invite People component'
    },
    teamsInviteSectionCheckboxTooltipPart1: {
        id: 'ptc.ip.teams-invite-section.checkbox-tooltip-part-1',
        defaultMessage: 'Add invited people to a team and collaborate with @mentions, your own team profile, and search results filtered to your team.',
        description: 'Tooltip content for the invite people to a team checkbox in the teams invite section in the Invite People component'
    },
    teamsInviteSectionCheckboxTooltipPart2: {
        id: 'ptc.ip.teams-invite-section.checkbox-tooltip-part-2',
        defaultMessage: 'You can use the same team across Atlassian products and projects.',
        description: 'Tooltip content for the invite people to a team checkbox in the teams invite section in the Invite People component'
    },
    genericSuccessFlagTitle: {
        id: 'ptc.ip.flag.generic-success-flag-title.experiment',
        defaultMessage: 'Successfully added',
        description: 'Flag title for generic success flag'
    },
    inviteSuccessFlagDescriptionSingleProductNamed: {
        id: 'ptc.ip.flag.invite-success-flag-description-single-product.named.experiment',
        defaultMessage: `{lessThanFiveInviteNames, select,
      true {We sent {formattedInviteNames} a Slack message confirming you added them to {product}.}
      other {We sent a Slack message to <b>everyone</b> confirming you added them to {product}.}}`,
        description: `This message notifies the user that they have successfully invited people to one product. If less than 5 people are invited, it will include a list of user's first names e.g. "Alex, Bob, Candice and Dennis"`
    },
    inviteSuccessFlagDescriptionSingleProductEmail: {
        id: 'ptc.ip.flag.invite-success-flag-description-single-product.email.experiment',
        defaultMessage: `{inviteCount, plural,
      one {We sent an email to <b>{emailInvited}</b> confirming you added them to {product}.}
      other {We sent an email to <b>everyone</b> confirming you added them to {product}.}}`,
        description: `This message notifies the user that they have successfully invited people to one product. If only one email is invited, it will show the email invited`
    },
    inviteSuccessFlagDescriptionMultiProductEmail: {
        id: 'ptc.ip.flag.invite-success-flag-description-multi-product.email.experiment',
        defaultMessage: `{inviteCount, plural,
      one {We sent an email to <b>{emailInvited}</b> confirming you added them.}
      other {We sent an email to <b>everyone</b> confirming you added them.}}`,
        description: `This message notifies the user that they have successfully invited people to one product. If only one email is invited, it will show the email invited`
    },
    requestAccessSuccessFlagTitle: {
        id: 'ptc.ip.flag.request-access-success-flag-title.experiment',
        defaultMessage: `Access request sent to your admin`,
        description: 'Flag title for generic request access flag'
    },
    requestAccessSuccessFlagDescription: {
        id: 'ptc.ip.flag.request-access-success-flag-description.experiment',
        defaultMessage: `{requestAccessCount, plural, one {Your admin needs to approve access for <b>{emailRequestedAccess}</b>.} other {Your admin needs to approve access for <b>everyone</b>.}}`,
        description: 'This message notifies the user that they have requested access'
    },
    hybridSuccessFlagTitle: {
        id: 'ptc.ip.flag.hybrid-success-flag-title.experiment',
        defaultMessage: 'Nearly done...',
        description: 'Flag title for hybrid flags of invite and request access'
    },
    hybridSuccessFlagDescriptionOneEach: {
        id: 'ptc.ip.flag.hybrid-success-flag-description-one-each.experiment',
        defaultMessage: '<p><b>{emailInvited}</b> has been added.</p><p>An access request for <b>{emailRequestedAccess}</b> has been sent to your admin.</p>',
        description: 'This message notifies the user they have invited one person and requested access for one person'
    },
    invitedHybridPlural: {
        id: 'ptc.ip.flag.invited-hybrid-plural.experiment',
        defaultMessage: `{inviteCount, plural, one {You added <b>{emailInvited}</b>} other {You've added {inviteCount} people}}`,
        description: `This is a segment of a larger message which notifies the user that they have invited people and requested access for others. The final string should read like "You've added alex@email.com and requested access for 2 others" or "You've added 2 people and requested access for alex@email.com" or "You've added 2 people and requested access for 3 others"`
    },
    requestAccessHybridPlural: {
        id: 'ptc.ip.flag.request-access-hybrid-plural.experiment',
        defaultMessage: '{requestAccessCount, plural, one {requested access for <b>{emailRequestedAccess}</b>} other {requested access for {requestAccessCount} others}}',
        description: `This is a segment of a larger message which notifies the user that they have invited people and requested access for others. The final string should read like "You've added alex@email.com and requested access for 2 others" or "You've added 2 people and requested access for alex@email.com" or "You've added 2 people and requested access for 3 others"`
    },
    hybridSuccessFlagDescription: {
        id: 'ptc.ip.flag.hybrid-success-flag-description.experiment',
        defaultMessage: '{invitedHybridPluralCoreInvitesOptimisation}, and {requestAccessHybridPluralCoreInvitesOptimisation}.',
        description: `This message notifies the user that they have invited people and requested access for others. The final string should read like "You've added alex@email.com and requested access for 2 others" or "You've added 2 people and requested access for alex@email.com" or "You've added 2 people and requested access for 3 others"`
    },
    inviteFailedFlagTitle: {
        id: 'ptc.ip.flag.invite-failed-flag-title.experiment',
        defaultMessage: `{failedInviteCount, plural, one {Can't add this person right now} other {We can't add those people right now}}`
    },
    inviteFailedFlagDescription: {
        id: 'ptc.ip.flag.invite-failed-flag-description.experiment',
        defaultMessage: `We {failedInviteCount, plural, one {can't add <b>{emailFailedToInvite}</b> right now.} other {couldn\u{2019}t send {failedInviteCount} of your invites}}. {isAdmin, select, false {Contact your admin for help.} other { }}`,
        description: `This message notifies the admin or user their invites have failed`
    },
    requestAccessFailedFlagTitleCoreInvitesOptimisation: {
        id: 'ptc.ip.flag.request-access-failed-flag-title.experiment',
        defaultMessage: `Access request wasn't sent`
    },
    requestAccessFailedFlagDescriptionCoreInvitesOptimisation: {
        id: 'ptc.ip.flag.request-access-failed-flag-description.experiment',
        defaultMessage: `{failedRequestCount, plural, one {We can't request access for <b>{emailRequestedAccess}</b>. Contact your admin for help.} other {We can't send those access requests. Contact your admin for help}}`,
        description: `This message notifies the user that the access requests have failed`
    },
    genericFailedFlagTitle: {
        id: 'ptc.ip.flag.generic-failed-flag-title.experiment',
        defaultMessage: 'Something went wrong'
    },
    genericFailedFlagDescription: {
        id: 'ptc.ip.flag.generic-failed-flag-description.experiment',
        defaultMessage: "We can't add anyone right now. {isAdmin, select, false {Contact your admin for help.} true {} other {}}",
        description: `This message notifies the user that their invite and request have failed`
    },
    licenceExceededFlagDescription: {
        id: 'ptc.ip.flag.license-exceeded-flag-description.experiment',
        defaultMessage: "{userRole, select, admin {You've reached your user limit. Upgrade your plan or remove other users.} other {You've reached your user limit. Contact your admin for help.}}",
        description: 'This is special message when users cannot be invited due to license exceeded error'
    },
    licenceExceededFlagTitle: {
        id: 'ptc.ip.flag.license-exceeded-flag-title.experiment',
        defaultMessage: "Can't add more people",
        description: 'This is title message when users cannot be invited due to license exceeded error'
    },
    addMorePeopleActionLabel: {
        id: 'ptc.ip.flag.add-more-people-action-label.experiment',
        defaultMessage: 'Add more people'
    },
    gotItActionLabelCoreInvitesOptimisation: {
        id: 'ptc.ip.flag.ok-got-it-action-label.experiment',
        defaultMessage: 'OK, got it'
    },
    formUserManagementLabel: {
        id: 'ptc.ip.form.userManagement.label',
        defaultMessage: 'User management',
        description: 'The label of the user management link in the drop down menu'
    },
    adminDropdownItemGroupTitle: {
        id: 'ptc.ip.dropdown-menu.admin.title',
        defaultMessage: 'Admin'
    },
    connectToDropdownItemGroupTitle: {
        id: 'ptc.ip.dropdown-menu.connect-to.title',
        defaultMessage: 'Connect More'
    },
    manageConnectionsDropItemGroupTitle: {
        id: 'ptc.ip.dropdown-menu.manage-connections.title',
        defaultMessage: 'Manage Connections'
    },
    revokeGoogleMenuItemTitle: {
        id: 'ptc.ip.dropdown-menu.revoke-google.title',
        defaultMessage: 'Revoke Google'
    },
    manageSlackMenuItemTitle: {
        id: 'ptc.ip.dropdown-menu.manage-slack.title',
        defaultMessage: 'Manage Slack'
    },
    revokeMicrosoftMenuItemTitle: {
        id: 'ptc.ip.dropdown-menu.revoke-slack.title',
        defaultMessage: 'Revoke Microsoft'
    },
    noInvitePermissionTitle: {
        id: 'ptc.ip.no-invite-permission.title',
        defaultMessage: "You can't invite people",
        description: 'A title for the invite users when a user do not have permission to invite'
    },
    defaultNoInvitePermissionDescription: {
        id: 'ptc.ip.no-invite-permission.description',
        defaultMessage: "You don't have permission to invite people to {productName}. Contact your admin for more information.\n",
        description: 'The default note to inform a user the reason they cannot proceed with the invite flow'
    },
    noInvitePermissionButtonTitle: {
        id: 'ptc.ip.no-invite-permission.button.title',
        defaultMessage: 'OK',
        description: 'Text for "Acknowledge" button. Clicking it will close the invite flow'
    },
    optionalMessageLabel: {
        id: 'ptc.ip.form.invite-optional-message.label',
        defaultMessage: 'Add a personalized message (Optional)',
        description: 'Label text for optional message box'
    },
    optionalMessageCharacterCountHelper: {
        id: 'ptc.ip.form.invite-optional-message.character-count-helper',
        defaultMessage: `{count, plural, one {{count} character remaining} other {{count} characters remaining}}`,
        description: `Helper text to inform the user about current character limit`
    },
    inviteLinkLabel: {
        id: 'ptc.ip.shareable-link.invite-link.label',
        defaultMessage: 'Invite Link',
        description: 'Label text for invite link'
    },
    copyInviteButtonLabel: {
        id: 'ptc.ip.shareable-link.copy-link-button.label',
        defaultMessage: 'Copy Link',
        description: 'Label text for copy link button'
    },
    copyInviteButtonCopiedLabel: {
        id: 'ptc.ip.shareable-link.copy-link-button.copied-popup.label',
        defaultMessage: 'Link copied to clipboard',
        description: 'Label text for copy link button after clicked'
    },
    shareableLinkSubMessageLabel: {
        id: 'ptc.ip.shareable-link.sub-message.label',
        defaultMessage: 'Anyone with this link can join Confluence without admin approval',
        description: 'The help message of shareable link'
    },
    turnOnShareableLinkTitle: {
        id: 'ptc.ip.shareable-link.turn-on.title',
        defaultMessage: 'Enable access via invite link',
        description: 'The title in turn on shareable link module.'
    },
    turnOnShareableLinkHelpText: {
        id: 'ptc.ip.shareable-link.turn-on.help.text',
        defaultMessage: 'You can disable this later in <a>settings</a>.',
        description: 'The help message for understanding turn on shareable link.'
    },
    turnOnShareableLinkToggleLabel: {
        id: 'ptc.ip.shareable-link.turn-on.toggle.label',
        defaultMessage: 'Enable access to link',
        description: 'The label for the toggle that turn on invite link'
    },
    multiInviteProductCheckboxDescriptionJiraAndConfluence: {
        id: 'ptc.ip.multi-product-discovery.product-checkbox-description-jira-confluence',
        defaultMessage: `Frequently used with {invitedProduct} to manage projects.`,
        description: `Helper text to inform user how adding this product can help`
    },
    multiInviteProductCheckboxDescriptionJiraAndJpd: {
        id: 'ptc.ip.multi-product-discovery.product-checkbox-description-jira-jpd',
        defaultMessage: `Frequently used with {invitedProduct} to prioritize ideas.`,
        description: `Helper text to inform user how adding this product can help`
    },
    multiInviteProductCheckboxDescriptionConfluenceAndJpd: {
        id: 'ptc.ip.multi-product-discovery.product-checkbox-description-confluence-jpd',
        defaultMessage: `Frequently used with {invitedProduct} to plan project roadmaps.`,
        description: `Helper text to inform user how adding this product can help`
    },
    multiInviteProductCheckboxDescriptionDefault: {
        id: 'ptc.ip.multi-product-discovery.product-checkbox-description-default',
        defaultMessage: `Frequently used with {invitedProduct}.`,
        description: `Helper text to inform user how adding this product can help`
    },
    multiProductInviteAddProductHelper: {
        id: 'ptc.ip.multi-product-invite.add-product-helper',
        defaultMessage: `Add <b>{count, plural, one {{user}} other {{count} people}}</b> to other available products`,
        description: `Helper text to add invitees to other products`
    },
    multiProductInviteCancelButton: {
        id: 'ptc.ip.multi-product-invite.cancel-button',
        defaultMessage: `No thanks`,
        description: `Cancel button for multi product invite`
    },
    multiProductInviteSubmitButton: {
        id: 'ptc.ip.multi-product-invite.submit-button',
        defaultMessage: `Add`,
        description: `Submit button for multi product invite`
    }
});

});

parcelRegister("6QlEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e165592c3892393$export$2e2bcd8739ae039);

var $1nSOt = parcelRequire("1nSOt");

var $6hFkp = parcelRequire("6hFkp");
var $6e165592c3892393$export$2e2bcd8739ae039 = (0, $6hFkp.asInstrumentedButton)((0, $1nSOt.default));

});
parcelRegister("6hFkp", function(module, exports) {

$parcel$export(module.exports, "asInstrumentedButton", () => $3a8cfc92c37ebdc2$export$e2c7c81b8d84c16f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6HEbe = parcelRequire("6HEbe");

var $9luLX = parcelRequire("9luLX");
const $3a8cfc92c37ebdc2$export$e2c7c81b8d84c16f = (Button)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ actionSubjectId: actionSubjectId, analyticsAttributes: analyticsAttributes, ...props }, ref)=>{
        const analytics = (0, $6HEbe.useAnalytics)((0, $9luLX.InstrumentedButtonAnalytics));
        const onClick = (reactEvent, analyticsEvent)=>{
            analytics.buttonClicked(actionSubjectId, typeof analyticsAttributes === 'function' ? analyticsAttributes() : analyticsAttributes);
            return props.onClick?.(reactEvent, analyticsEvent);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useImperativeHandle(ref, ()=>({
                onClick: async (event, analyticsEvent)=>{
                    await onClick(event, analyticsEvent);
                }
            }));
        if (ref) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
            ...props,
            onClick: onClick,
            ref: ref
        });
    });

});
parcelRegister("9luLX", function(module, exports) {

$parcel$export(module.exports, "InstrumentedButtonAnalytics", () => $2c635466b832f8dc$export$fec0684eff51fa44);

var $lp06J = parcelRequire("lp06J");

var $hatDq = parcelRequire("hatDq");
class $2c635466b832f8dc$export$fec0684eff51fa44 extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    buttonClicked(actionSubjectId, attributes) {
        this.fireUI({
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
}

});



parcelRegister("47Stc", function(module, exports) {

$parcel$export(module.exports, "default", () => $83f5eab29108cf8e$export$2e2bcd8739ae039);
/* SlackWorkspacesDialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $asiGE = parcelRequire("asiGE");

var $hordk = parcelRequire("hordk");
var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");
var $kW74I = parcelRequire("kW74I");

var $jHTSg = parcelRequire("jHTSg");
var $cNW3X = parcelRequire("cNW3X");

var $5sLH0 = parcelRequire("5sLH0");
var $7rJgC = parcelRequire("7rJgC");
var $k9nuy = parcelRequire("k9nuy");

var $hatDq = parcelRequire("hatDq");

var $fn6W9 = parcelRequire("fn6W9");

var $gZC93 = parcelRequire("gZC93");

var $6HEbe = parcelRequire("6HEbe");

var $27zXU = parcelRequire("27zXU");

var $2JxEL = parcelRequire("2JxEL");

var $3GGdh = parcelRequire("3GGdh");

var $dCNWF = parcelRequire("dCNWF");

var $iTzFN = parcelRequire("iTzFN");

var $86tbn = parcelRequire("86tbn");

var $84Nhj = parcelRequire("84Nhj");
const $83f5eab29108cf8e$var$styles = {
    footerWrapper: "_1bsb1osq",
    disconnectButton: "_1rjcze3t _18zrze3t _bfhk1w7a"
};
const $83f5eab29108cf8e$var$SlackWorkspacesDialog = ()=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $iTzFN.ThirdPartyAnalytics));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isSlackDisconnectDialogOpen, setIsSlackDisconnectDialogOpen] = (0, $5uXOq.useState)(false);
    const { setOnSlackConnected: setOnSlackConnected } = (0, $86tbn.useInviteThirdPartyTeams)();
    const connectedSlackWorkspaceId = (0, $27zXU.getConnectedSlackWorkSpace)();
    const autoConnectSlack = (0, $5uXOq.useMemo)(()=>{
        return (0, $84Nhj.getExperimentValue)((0, $hatDq.ExperimentKeys).SLACK_AUTO_CONNECT, (0, $hatDq.Cohort).NOT_ENROLLED, false) === (0, $hatDq.Cohort).VARIATION;
    }, []);
    const { slackWorkspaces: slackWorkspaces, openSlackConnectDialog: openSlackConnectDialog, closeSlackConnectDialog: closeSlackConnectDialog, isSlackConnectDialogOpen: isSlackConnectDialogOpen, onChangeSelectedSlackWorkspace: onChangeSelectedSlackWorkspace, onDisconnectSlackWorkspace: onDisconnectSlackWorkspace } = (0, $dCNWF.useThirdPartyState)();
    const [selectedOption, setSelectedOption] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        setSelectedOption(slackWorkspaces.find((w)=>w.id === connectedSlackWorkspaceId) || slackWorkspaces[0]);
    }, [
        slackWorkspaces,
        connectedSlackWorkspaceId
    ]);
    const closeSlackDisconnectDialog = ()=>{
        setIsSlackDisconnectDialogOpen(false);
        openSlackConnectDialog();
    };
    const openSlackDisconnectDialog = ()=>setIsSlackDisconnectDialogOpen(true);
    const onDisconnectSlackLink = ()=>{
        analytics.slackDisconnectButtonClicked(connectedSlackWorkspaceId);
        closeSlackConnectDialog();
        openSlackDisconnectDialog();
    };
    const onDisconnectClick = ()=>{
        onDisconnectSlackWorkspace();
        setIsSlackDisconnectDialogOpen(false);
    };
    const onConnectSlackWorkspaceButton = ()=>{
        setOnSlackConnected(true);
        if (selectedOption) {
            analytics.slackDoneButtonClicked(selectedOption.id);
            if (selectedOption.id !== connectedSlackWorkspaceId) onChangeSelectedSlackWorkspace(selectedOption);
            closeSlackConnectDialog();
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        if (isSlackConnectDialogOpen) analytics.slackConnectModalShown();
    }, [
        analytics,
        isSlackConnectDialogOpen
    ]);
    const DisconnectModalFooter = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7CjwE.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                alignBlock: "end",
                xcss: $83f5eab29108cf8e$var$styles.footerWrapper,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jHTSg.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gZC93.default), {
                            actionSubjectId: "disconnectCancel",
                            analyticsAttributes: {
                                selectedTeamId: connectedSlackWorkspaceId
                            },
                            type: "submit",
                            onClick: closeSlackDisconnectDialog,
                            children: formatMessage((0, $fn6W9.messages).cancelButton)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gZC93.default), {
                            actionSubjectId: "disconnectConfirm",
                            analyticsAttributes: {
                                selectedTeamId: connectedSlackWorkspaceId
                            },
                            appearance: "danger",
                            type: "submit",
                            onClick: onDisconnectClick,
                            children: formatMessage((0, $fn6W9.messages).disconnectButton)
                        })
                    ]
                })
            })
        });
    const ConnectModalHeader = ()=>{
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eUaFh.default), {
            hasCloseButton: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Sb4G.default), {
                children: formatMessage(connectedSlackWorkspaceId ? (0, $fn6W9.messages).slackWorkspacesManageDialogHeading : (0, $fn6W9.messages).slackWorkspacesConnectDialogHeading)
            })
        });
    };
    const ConnectModalFooter = ()=>{
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7CjwE.default), {
            children: [
                connectedSlackWorkspaceId && autoConnectSlack === false && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                    onClick: onDisconnectSlackLink,
                    xcss: $83f5eab29108cf8e$var$styles.disconnectButton,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        color: "color.text.danger",
                        children: formatMessage((0, $fn6W9.messages).slackWorkspacesDialogDisconnectSlack)
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                    type: "submit",
                    appearance: "primary",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: {
                        marginLeft: 'auto'
                    },
                    isDisabled: !Boolean(selectedOption),
                    onClick: onConnectSlackWorkspaceButton,
                    children: formatMessage((0, $fn6W9.messages).slackWorkspacesDoneButton)
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            slackWorkspaces && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kW74I.default), {
                children: isSlackConnectDialogOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hordk.default), {
                    width: 'small',
                    shouldScrollInViewport: true,
                    onClose: closeSlackConnectDialog,
                    testId: "slack-workspace-dialog",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)(ConnectModalHeader, {}),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g1QfP.default), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                    as: "p",
                                    children: formatMessage((0, $fn6W9.messages).slackWorkspacesDialogBody)
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2JxEL.default), {
                                    slackWorkspaces: slackWorkspaces,
                                    selectedOption: selectedOption,
                                    onSelect: setSelectedOption
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3GGdh.default), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)(ConnectModalFooter, {})
                    ]
                })
            }),
            connectedSlackWorkspaceId && autoConnectSlack === false && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kW74I.default), {
                children: isSlackDisconnectDialogOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hordk.default), {
                    width: 'small',
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eUaFh.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Sb4G.default), {
                                appearance: "danger",
                                children: formatMessage((0, $fn6W9.messages).slackWorkspacesDisconnectDialogHeading)
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g1QfP.default), {
                            children: [
                                formatMessage((0, $fn6W9.messages).slackWorkspacesDisconnectDialogBody),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3GGdh.default), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)(DisconnectModalFooter, {})
                    ]
                })
            })
        ]
    });
};
const $83f5eab29108cf8e$var$analyticsContextData = {
    source: (0, $hatDq.AnalyticsSource).SLACK_CONNECT_MODAL,
    componentName: 'slackConnectModal'
};
var $83f5eab29108cf8e$export$2e2bcd8739ae039 = (0, $asiGE.default)($83f5eab29108cf8e$var$analyticsContextData)($83f5eab29108cf8e$var$SlackWorkspacesDialog);

});
parcelRegister("gZC93", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7e212cf42ad69b2$export$2e2bcd8739ae039);

var $cNW3X = parcelRequire("cNW3X");

var $6hFkp = parcelRequire("6hFkp");
var $b7e212cf42ad69b2$export$2e2bcd8739ae039 = (0, $6hFkp.asInstrumentedButton)((0, $cNW3X.default));

});

parcelRegister("27zXU", function(module, exports) {

$parcel$export(module.exports, "getConnectedSlackWorkSpace", () => $f009f7a7d504e3a5$export$85295e886b0bc188);
$parcel$export(module.exports, "setConnectedSlackWorkSpace", () => $f009f7a7d504e3a5$export$16d6297e9e3fb8ee);
$parcel$export(module.exports, "disconnectSlackWorkSpace", () => $f009f7a7d504e3a5$export$ced2c8904ba748c6);

var $kx8ta = parcelRequire("kx8ta");
const $f009f7a7d504e3a5$var$CONNECTED_SLACK_WORKSPACE_KEY_PREFIX = 'infi-slack-workspace-';
const $f009f7a7d504e3a5$export$fa39fb16b65ab54f = 'platform';
const $f009f7a7d504e3a5$export$85295e886b0bc188 = ()=>(0, $kx8ta.getLocalStorageKey)(`${$f009f7a7d504e3a5$var$CONNECTED_SLACK_WORKSPACE_KEY_PREFIX}${$f009f7a7d504e3a5$export$fa39fb16b65ab54f}`);
const $f009f7a7d504e3a5$export$16d6297e9e3fb8ee = (value)=>(0, $kx8ta.updateLocalStorageKey)(`${$f009f7a7d504e3a5$var$CONNECTED_SLACK_WORKSPACE_KEY_PREFIX}${$f009f7a7d504e3a5$export$fa39fb16b65ab54f}`, value);
const $f009f7a7d504e3a5$export$ced2c8904ba748c6 = ()=>(0, $kx8ta.removeLocalStorageKey)(`${$f009f7a7d504e3a5$var$CONNECTED_SLACK_WORKSPACE_KEY_PREFIX}${$f009f7a7d504e3a5$export$fa39fb16b65ab54f}`);

});

parcelRegister("2JxEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7521abf3fe0172a7$export$2e2bcd8739ae039);
/* SlackWorkspacesDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $5sLH0 = parcelRequire("5sLH0");

var $lau8t = parcelRequire("lau8t");
const $7521abf3fe0172a7$var$styles = {
    optionWrapper: "",
    image: "_1bsbgktf _4t3igktf _u5f3u2gc"
};
const $7521abf3fe0172a7$var$SlackWorkspacesDropdown = ({ slackWorkspaces: slackWorkspaces, selectedOption: selectedOption, onSelect: onSelect })=>{
    const formatOptionLabel = (option)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            xcss: $7521abf3fe0172a7$var$styles.optionWrapper,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                    alt: option.avatar,
                    src: option.avatar,
                    className: (0, $bwpsq.default)([
                        $7521abf3fe0172a7$var$styles.image
                    ])
                }),
                option.name
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lau8t.default), {
        name: "slack-workspace-select",
        isSearchable: false,
        value: selectedOption,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "single-select",
        classNamePrefix: "react-select",
        getOptionValue: (w)=>w.id,
        options: slackWorkspaces,
        formatOptionLabel: formatOptionLabel,
        isDisabled: slackWorkspaces.length === 1,
        onChange: (selectedSlackWorkspace)=>onSelect(selectedSlackWorkspace)
    });
};
var $7521abf3fe0172a7$export$2e2bcd8739ae039 = $7521abf3fe0172a7$var$SlackWorkspacesDropdown;

});
parcelRegister("lau8t", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $da5b97c526f06b5a$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $da5b97c526f06b5a$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $9Iej8 = parcelRequire("9Iej8");
var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");

var $fdJB9 = parcelRequire("fdJB9");

var $7Qatx = parcelRequire("7Qatx");
const $da5b97c526f06b5a$var$packageName = "platform-pkg";
const $da5b97c526f06b5a$var$packageVersion = "0.0.0-use.local";
const $da5b97c526f06b5a$export$d1de3b251ccaa8a3 = (0, $7Qatx.default)((0, $fdJB9.default));
const $da5b97c526f06b5a$var$createAndFireEventOnAtlaskit = (0, $9Iej8.default)('atlaskit');
const $da5b97c526f06b5a$var$Select = (0, $asiGE.default)({
    componentName: 'select',
    packageName: $da5b97c526f06b5a$var$packageName,
    packageVersion: $da5b97c526f06b5a$var$packageVersion
})((0, $3TR0I.default)({
    onChange: $da5b97c526f06b5a$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $da5b97c526f06b5a$var$packageName,
            packageVersion: $da5b97c526f06b5a$var$packageVersion
        }
    })
})($da5b97c526f06b5a$export$d1de3b251ccaa8a3));
var $da5b97c526f06b5a$export$2e2bcd8739ae039 = $da5b97c526f06b5a$var$Select;

});
parcelRegister("fdJB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4292f0009a275a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("2OKnX")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $djBXi = parcelRequire("djBXi");

var $2OKnX = parcelRequire("2OKnX");

var $63z2N = parcelRequire("63z2N");
const $a4292f0009a275a8$var$AsyncSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $2OKnX.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $63z2N.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $djBXi.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a4292f0009a275a8$export$2e2bcd8739ae039 = $a4292f0009a275a8$var$AsyncSelect;

});
parcelRegister("djBXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $17a9f59c5814b8a9$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5a34e = parcelRequire("5a34e");

var $fHpHg = parcelRequire("fHpHg");

var $jwj8k = parcelRequire("jwj8k");

var $b1kcy = parcelRequire("b1kcy");

var $2PbHi = parcelRequire("2PbHi");
var $2dBDF = parcelRequire("2dBDF");
var $hFt5x = parcelRequire("hFt5x");

var $StbfM = parcelRequire("StbfM");

var $1NMZ0 = parcelRequire("1NMZ0");

var $fW3un = parcelRequire("fW3un");

var $gInKw = parcelRequire("gInKw");

var $1BKyN = parcelRequire("1BKyN");

var $b0fMV = parcelRequire("b0fMV");
const $17a9f59c5814b8a9$export$9c21a3269931e1e6 = {
    // aria-live is by default with the live region so we don't need it
    // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
    'aria-live': (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $b0fMV.isTouchCapable)(),
    captureMenuScroll: !(0, $b0fMV.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $gInKw.createFilter)(),
    formatGroupLabel: (0, $jwj8k.formatGroupLabel),
    getOptionLabel: (0, $jwj8k.getOptionLabel),
    getOptionValue: (0, $jwj8k.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $jwj8k.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $b0fMV.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $17a9f59c5814b8a9$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $17a9f59c5814b8a9$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $17a9f59c5814b8a9$var$isOptionSelected(props, option, selectValue);
    const label = $17a9f59c5814b8a9$var$getOptionLabel(props, option);
    const value = $17a9f59c5814b8a9$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $17a9f59c5814b8a9$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$17a9f59c5814b8a9$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$17a9f59c5814b8a9$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $17a9f59c5814b8a9$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $17a9f59c5814b8a9$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $b0fMV.notNullish));
}
function $17a9f59c5814b8a9$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $17a9f59c5814b8a9$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $17a9f59c5814b8a9$var$buildFocusableOptions(props, selectValue) {
    return $17a9f59c5814b8a9$var$buildFocusableOptionsFromCategorizedOptions($17a9f59c5814b8a9$var$buildCategorizedOptions(props, selectValue));
}
function $17a9f59c5814b8a9$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$17a9f59c5814b8a9$var$shouldHideSelectedOptions(props) || !isSelected) && $17a9f59c5814b8a9$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $17a9f59c5814b8a9$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $17a9f59c5814b8a9$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $17a9f59c5814b8a9$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $17a9f59c5814b8a9$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $17a9f59c5814b8a9$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $17a9f59c5814b8a9$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $17a9f59c5814b8a9$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $17a9f59c5814b8a9$var$getOptionValue(props, option);
    return selectValue.some((i)=>$17a9f59c5814b8a9$var$getOptionValue(props, i) === candidate);
}
function $17a9f59c5814b8a9$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $17a9f59c5814b8a9$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $17a9f59c5814b8a9$var$instanceId = 1;
class $17a9f59c5814b8a9$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $17a9f59c5814b8a9$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isVoiceOver = (0, $fHpHg.fg)('design_system_select-a11y-improvement') && (0, $5a34e.isAppleDevice)(), // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $b0fMV.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $b0fMV.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $b0fMV.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $b0fMV.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $b0fMV.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $b0fMV.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $b0fMV.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $17a9f59c5814b8a9$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $17a9f59c5814b8a9$var$buildFocusableOptionsWithIds($17a9f59c5814b8a9$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $b0fMV.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $17a9f59c5814b8a9$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $17a9f59c5814b8a9$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = (0, $1BKyN.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $b1kcy.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$17a9f59c5814b8a9$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$17a9f59c5814b8a9$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $b0fMV.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $17a9f59c5814b8a9$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $fHpHg.fg)('platform_dst_layer_observer_select')) return;
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$17a9f59c5814b8a9$var$instanceId);
        this.state.selectValue = (0, $b0fMV.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $17a9f59c5814b8a9$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $b0fMV.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $17a9f59c5814b8a9$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $17a9f59c5814b8a9$var$buildFocusableOptionsWithIds($17a9f59c5814b8a9$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $17a9f59c5814b8a9$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $17a9f59c5814b8a9$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $17a9f59c5814b8a9$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $b0fMV.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $b0fMV.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $b0fMV.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $17a9f59c5814b8a9$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $17a9f59c5814b8a9$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $17a9f59c5814b8a9$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription(action) {
        const descriptionProp = this.props['aria-describedby'] || this.props['descriptionId'];
        const { isMulti: isMulti } = this.props;
        const { selectValue: selectValue } = this.state;
        const defaultDescription = selectValue.length ? this.getElementId('live-region') : this.getElementId('placeholder');
        if (!isMulti && selectValue.length && action !== 'initial-input-focus') return;
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            return {
                'aria-describedby': descriptionProp ? [
                    descriptionProp,
                    defaultDescription,
                    multiMessage
                ].join(' ') : [
                    defaultDescription,
                    multiMessage
                ].join(' ')
            };
        } else return {
            'aria-describedby': descriptionProp ? [
                descriptionProp,
                defaultDescription
            ].join(' ') : defaultDescription
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-describedby': this.props['aria-describedby'] || descriptionId,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription(ariaSelection?.action)
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PbHi.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $b0fMV.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $5uXOq.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $5uXOq.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    'data-testid': `${testId}-select--multivalue-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled && (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : isDisabled,
                'aria-describedby': (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? headingId : undefined,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $5uXOq.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $5uXOq.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const calculateListboxLabel = ()=>{
            // First in name calculation, overwrites aria-label
            if (labelId) return {
                'aria-labelledby': labelId
            };
            // Second in name calcuation, overwrites everything else except aria-labelledby
            if (label) return {
                'aria-label': label
            };
            // Fallback if no label or labelId is provided, might catch label via <label for> otherwise
            // will most likely not have an accessible name
            return {
                'aria-labelledby': this.inputRef?.id || this.getElementId('input')
            };
        };
        const menuElement = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fW3un.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hFt5x.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    'aria-multiselectable': (this.isVoiceOver || !commonProps.isMulti) && (0, $fHpHg.fg)('design_system_select-a11y-improvement') || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox when ff is on
                                    ...(0, $fHpHg.fg)('design_system_select-a11y-improvement') && calculateListboxLabel()
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $2OMIu.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2dBDF.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1NMZ0.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isVoiceOver
        });
    }
    renderMultiselectMessage() {
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: ", multiple selections available,"
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $2OMIu.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $StbfM.NotifyOpenLayerObserver), {
                    isOpen: (0, $fHpHg.fg)('platform_dst_layer_observer_select') && this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("5a34e", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $838c050d2f176b76$export$95df08bae54cb4df);
$parcel$export(module.exports, "isAppleDevice", () => $838c050d2f176b76$export$e1865c3bedcd822b);
function $838c050d2f176b76$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $838c050d2f176b76$var$isIPhone() {
    return $838c050d2f176b76$var$testPlatform(/^iPhone/i);
}
function $838c050d2f176b76$var$isMac() {
    return $838c050d2f176b76$var$testPlatform(/^Mac/i);
}
function $838c050d2f176b76$var$isIPad() {
    return $838c050d2f176b76$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $838c050d2f176b76$var$isMac() && navigator.maxTouchPoints > 1;
}
function $838c050d2f176b76$var$isIOS() {
    return $838c050d2f176b76$var$isIPhone() || $838c050d2f176b76$var$isIPad();
}
function $838c050d2f176b76$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $838c050d2f176b76$export$e1865c3bedcd822b() {
    return $838c050d2f176b76$var$isMac() || $838c050d2f176b76$var$isIOS();
}

});

parcelRegister("jwj8k", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $dff534f610407347$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $dff534f610407347$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $dff534f610407347$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $dff534f610407347$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $dff534f610407347$export$f4da216a6ca54656 = (group)=>group.label;
const $dff534f610407347$export$dac6ace3020563ca = (option)=>option.label;
const $dff534f610407347$export$40be908210c5a79c = (option)=>option.value;
const $dff534f610407347$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("b1kcy", function(module, exports) {

$parcel$export(module.exports, "components", () => $bf570c186c29adcc$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $bf570c186c29adcc$export$71abc632aa29e6fe);

var $cSGW3 = parcelRequire("cSGW3");

var $gGvqh = parcelRequire("gGvqh");

var $iluyz = parcelRequire("iluyz");

var $6oGQp = parcelRequire("6oGQp");

var $4S2FY = parcelRequire("4S2FY");

var $fW3un = parcelRequire("fW3un");

var $g6y65 = parcelRequire("g6y65");

var $FpaWY = parcelRequire("FpaWY");

var $41aBa = parcelRequire("41aBa");

var $aPWnT = parcelRequire("aPWnT");
const $bf570c186c29adcc$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $6oGQp.ClearIndicator),
    Control: (0, $gGvqh.default),
    DropdownIndicator: (0, $6oGQp.DropdownIndicator),
    Group: (0, $iluyz.default),
    GroupHeading: (0, $iluyz.GroupHeading),
    IndicatorsContainer: (0, $cSGW3.IndicatorsContainer),
    Input: (0, $4S2FY.default),
    LoadingIndicator: (0, $6oGQp.LoadingIndicator),
    Menu: (0, $fW3un.default),
    MenuList: (0, $fW3un.MenuList),
    MenuPortal: (0, $fW3un.MenuPortal),
    LoadingMessage: (0, $fW3un.LoadingMessage),
    NoOptionsMessage: (0, $fW3un.NoOptionsMessage),
    MultiValue: (0, $g6y65.default),
    MultiValueContainer: (0, $g6y65.MultiValueContainer),
    MultiValueLabel: (0, $g6y65.MultiValueLabel),
    MultiValueRemove: (0, $g6y65.MultiValueRemove),
    Option: (0, $FpaWY.default),
    Placeholder: (0, $41aBa.default),
    SelectContainer: (0, $cSGW3.SelectContainer),
    SingleValue: (0, $aPWnT.default),
    ValueContainer: (0, $cSGW3.ValueContainer)
};
const $bf570c186c29adcc$export$71abc632aa29e6fe = (props)=>({
        ...$bf570c186c29adcc$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("cSGW3", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $679454c07f89009f$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $679454c07f89009f$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $679454c07f89009f$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $679454c07f89009f$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $679454c07f89009f$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $679454c07f89009f$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");

var $kU1q1 = parcelRequire("kU1q1");

var $b0fMV = parcelRequire("b0fMV");
const $679454c07f89009f$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        position: 'relative',
        font: (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        pointerEvents: 'all',
        cursor: isDisabled ? 'not-allowed' : undefined,
        [`${(0, $kU1q1.media).above.xs}`]: {
            font: (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : undefined
        }
    });
const $679454c07f89009f$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $679454c07f89009f$export$47aec73c7aa6b9aa = ({ isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        padding: `${isCompact ? 0 : "var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
    });
const $679454c07f89009f$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $b0fMV.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $679454c07f89009f$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0,
        paddingRight: "var(--ds-space-050, 4px)"
    });
const $679454c07f89009f$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("b0fMV", function(module, exports) {

$parcel$export(module.exports, "noop", () => $edcdeb7b1e79d8a8$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $edcdeb7b1e79d8a8$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $edcdeb7b1e79d8a8$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $edcdeb7b1e79d8a8$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $edcdeb7b1e79d8a8$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $edcdeb7b1e79d8a8$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $edcdeb7b1e79d8a8$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $edcdeb7b1e79d8a8$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $edcdeb7b1e79d8a8$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $edcdeb7b1e79d8a8$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $edcdeb7b1e79d8a8$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $edcdeb7b1e79d8a8$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $edcdeb7b1e79d8a8$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $edcdeb7b1e79d8a8$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $edcdeb7b1e79d8a8$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $edcdeb7b1e79d8a8$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $edcdeb7b1e79d8a8$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $edcdeb7b1e79d8a8$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $edcdeb7b1e79d8a8$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $edcdeb7b1e79d8a8$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $edcdeb7b1e79d8a8$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $edcdeb7b1e79d8a8$export$4213b25a1c4e877);
const $edcdeb7b1e79d8a8$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $edcdeb7b1e79d8a8$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $edcdeb7b1e79d8a8$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$edcdeb7b1e79d8a8$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $edcdeb7b1e79d8a8$export$33f062f47f21a01 = (value)=>{
    if ($edcdeb7b1e79d8a8$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $edcdeb7b1e79d8a8$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $edcdeb7b1e79d8a8$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $edcdeb7b1e79d8a8$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $edcdeb7b1e79d8a8$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $edcdeb7b1e79d8a8$export$2e0654fad740d2e4(el) {
    if ($edcdeb7b1e79d8a8$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $edcdeb7b1e79d8a8$export$c4a223a8ba9e4ea5(el) {
    if ($edcdeb7b1e79d8a8$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $edcdeb7b1e79d8a8$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($edcdeb7b1e79d8a8$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $edcdeb7b1e79d8a8$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $edcdeb7b1e79d8a8$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $edcdeb7b1e79d8a8$export$858c30343199f3af(element, to, duration = 200, callback = $edcdeb7b1e79d8a8$export$8793edee2d425525) {
    const start = $edcdeb7b1e79d8a8$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $edcdeb7b1e79d8a8$var$easeOutCubic(currentTime, start, change, duration);
        $edcdeb7b1e79d8a8$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $edcdeb7b1e79d8a8$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $edcdeb7b1e79d8a8$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $edcdeb7b1e79d8a8$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $edcdeb7b1e79d8a8$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $edcdeb7b1e79d8a8$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $edcdeb7b1e79d8a8$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $edcdeb7b1e79d8a8$var$passiveOptionAccessed = false;
const $edcdeb7b1e79d8a8$var$options = {
    get passive () {
        return $edcdeb7b1e79d8a8$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $edcdeb7b1e79d8a8$var$w = typeof window !== 'undefined' ? window : {};
if ($edcdeb7b1e79d8a8$var$w.addEventListener && $edcdeb7b1e79d8a8$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $edcdeb7b1e79d8a8$var$w.addEventListener('p', $edcdeb7b1e79d8a8$export$8793edee2d425525, $edcdeb7b1e79d8a8$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $edcdeb7b1e79d8a8$var$w.removeEventListener('p', $edcdeb7b1e79d8a8$export$8793edee2d425525, false);
}
const $edcdeb7b1e79d8a8$export$b0622a6911dbeaf5 = $edcdeb7b1e79d8a8$var$passiveOptionAccessed;
function $edcdeb7b1e79d8a8$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $edcdeb7b1e79d8a8$var$isArray(arg) {
    return Array.isArray(arg);
}
function $edcdeb7b1e79d8a8$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $edcdeb7b1e79d8a8$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $edcdeb7b1e79d8a8$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $edcdeb7b1e79d8a8$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("gGvqh", function(module, exports) {

$parcel$export(module.exports, "css", () => $fc91e92c64db0b1d$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $fc91e92c64db0b1d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $fc91e92c64db0b1d$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, isCompact: isCompact, appearance: appearance })=>{
    let borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    let backgroundColor = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)";
    let backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    let borderColorHover = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    if (isDisabled) {
        backgroundColor = "var(--ds-background-disabled, #091E4208)";
        borderColor = "var(--ds-background-disabled, #091E4208)";
    }
    if (isInvalid) {
        borderColor = "var(--ds-border-danger, #E2483D)";
        borderColorHover = "var(--ds-border-danger, #E2483D)";
    }
    const transitionDuration = '200ms';
    if (appearance === 'subtle') {
        borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : 'transparent';
        backgroundColor = isFocused ? "var(--ds-surface, #FFFFFF)" : 'transparent';
        backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    }
    if (appearance === 'none') {
        borderColor = 'transparent';
        backgroundColor = 'transparent';
        backgroundColorHover = 'transparent';
        borderColorHover = 'transparent';
    }
    return {
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        outline: '0 !important',
        position: 'relative',
        // Turn pointer events off when disabled - this makes it so hover etc don't work.
        pointerEvents: isDisabled ? 'none' : undefined,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        boxShadow: isInvalid ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
        '&:focus-within': {
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
        },
        minHeight: isCompact ? 32 : 40,
        padding: 0,
        transition: `background-color ${transitionDuration} ease-in-out,
border-color ${transitionDuration} ease-in-out`,
        '::-webkit-scrollbar': {
            height: 8,
            width: 8
        },
        '::-webkit-scrollbar-corner': {
            display: 'none'
        },
        ':hover': {
            '::-webkit-scrollbar-thumb': {
                // scrollbars occur only if the user passes in a custom component with overflow: scroll
                backgroundColor: 'rgba(0,0,0,0.2)'
            },
            cursor: 'pointer',
            backgroundColor: backgroundColorHover,
            borderColor: borderColorHover
        },
        '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0,0,0,0.4)'
        }
    };
};
const $fc91e92c64db0b1d$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        ...(0, $b0fMV.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fc91e92c64db0b1d$export$2e2bcd8739ae039 = $fc91e92c64db0b1d$var$Control;

});

parcelRegister("iluyz", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $4652dd5e4b6c9504$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $4652dd5e4b6c9504$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $4652dd5e4b6c9504$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $4652dd5e4b6c9504$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $4652dd5e4b6c9504$export$b6794329c1460634 = ({})=>({
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingTop: "var(--ds-space-100, 8px)"
    });
const $4652dd5e4b6c9504$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, children));
};
const $4652dd5e4b6c9504$export$e5a7fbb542efcb7d = ({})=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        marginBottom: '0.25em',
        paddingLeft: "var(--ds-space-150, 12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: "var(--ds-text-subtle, #44546F)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textTransform: 'none'
    });
const $4652dd5e4b6c9504$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $b0fMV.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4652dd5e4b6c9504$export$2e2bcd8739ae039 = $4652dd5e4b6c9504$var$Group;

});

parcelRegister("6oGQp", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $c9370124461878f7$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $c9370124461878f7$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $c9370124461878f7$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $c9370124461878f7$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $c9370124461878f7$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $c9370124461878f7$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dGKFs = parcelRequire("dGKFs");

var $7K2aG = parcelRequire("7K2aG");

var $2Eqc8 = parcelRequire("2Eqc8");
var $gVM6m = parcelRequire("gVM6m");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");

var $b0fMV = parcelRequire("b0fMV");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $c9370124461878f7$var$iconContainerStyles = (0, $2s57o.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $c9370124461878f7$var$dropdownWrapperStyles = (0, $2s57o.xcss)({
    padding: 'space.075'
});
const $c9370124461878f7$export$e1687335805e1230 = ({ isCompact: isCompact, isDisabled: isDisabled })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtle, #44546F)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $c9370124461878f7$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children ? children : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Eqc8.default), {
        as: "span",
        xcss: $c9370124461878f7$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
};
const $c9370124461878f7$export$9c0419fd944c1def = ({ isCompact: isCompact })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: "var(--ds-text-subtlest, #626F86)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $c9370124461878f7$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear' } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gVM6m.default), {
        xcss: $c9370124461878f7$var$iconContainerStyles,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7K2aG))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
};
const $c9370124461878f7$export$1d3f24cde248e6b5 = ({ isCompact: isCompact })=>({
        label: 'loadingIndicator',
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`
    });
const $c9370124461878f7$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $clxo5.default), {
        size: "small"
    }));
};

});
parcelRegister("7K2aG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7da2857c3151a92889bed61f5baa1334>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a2e8376ca30e11c$var$_react = $5a2e8376ca30e11c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5a2e8376ca30e11c$var$_crossCircle = $5a2e8376ca30e11c$var$_interopRequireDefault((parcelRequire("8wCU9")));

var $5a2e8376ca30e11c$var$_selectClear = $5a2e8376ca30e11c$var$_interopRequireDefault((parcelRequire("85kPS")));
function $5a2e8376ca30e11c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a2e8376ca30e11c$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $5a2e8376ca30e11c$var$_react.default.createElement($5a2e8376ca30e11c$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $5a2e8376ca30e11c$var$_selectClear.default
    }, props));
$5a2e8376ca30e11c$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $5a2e8376ca30e11c$var$_default = module.exports.default = $5a2e8376ca30e11c$var$CrossCircleIcon;

});
parcelRegister("8wCU9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23b3104937a360e799abf4f0ea698b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $634f7d853690f284$var$_react = $634f7d853690f284$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $634f7d853690f284$var$_baseNew = $634f7d853690f284$var$_interopRequireDefault((parcelRequire("enEmH")));
function $634f7d853690f284$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $634f7d853690f284$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $634f7d853690f284$var$_react.default.createElement($634f7d853690f284$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$634f7d853690f284$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $634f7d853690f284$var$_default = module.exports.default = $634f7d853690f284$var$CrossCircleIcon;

});

parcelRegister("85kPS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e2ef3e5407a9744$var$_react = $5e2ef3e5407a9744$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $5e2ef3e5407a9744$var$_crossCircle = $5e2ef3e5407a9744$var$_interopRequireDefault((parcelRequire("hvAON")));
function $5e2ef3e5407a9744$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5e2ef3e5407a9744$var$SelectClearIcon = (props)=>/*#__PURE__*/ $5e2ef3e5407a9744$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $5e2ef3e5407a9744$var$_crossCircle.default
    }));
$5e2ef3e5407a9744$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $5e2ef3e5407a9744$var$_default = module.exports.default = $5e2ef3e5407a9744$var$SelectClearIcon;

});



parcelRegister("4S2FY", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $c70f729c4b739a40$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $c70f729c4b739a40$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $c70f729c4b739a40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value })=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$c70f729c4b739a40$var$containerStyle,
        margin: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingTop: "var(--ds-space-025, 2px)",
        color: "var(--ds-text, #172B4D)"
    });
const $c70f729c4b739a40$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $c70f729c4b739a40$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$c70f729c4b739a40$var$spacingStyle
    }
};
const $c70f729c4b739a40$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$c70f729c4b739a40$var$spacingStyle
    });
const $c70f729c4b739a40$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $b0fMV.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $c70f729c4b739a40$var$inputStyle(isHidden),
        disabled: isDisabled,
        "data-testid": dataId,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c70f729c4b739a40$export$2e2bcd8739ae039 = $c70f729c4b739a40$var$Input;

});

parcelRegister("fW3un", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $d762f5ed921736bb$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $d762f5ed921736bb$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $d762f5ed921736bb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $d762f5ed921736bb$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $d762f5ed921736bb$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $d762f5ed921736bb$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $d762f5ed921736bb$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $d762f5ed921736bb$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $d762f5ed921736bb$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $d762f5ed921736bb$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $d762f5ed921736bb$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $fHpHg = parcelRequire("fHpHg");

var $6eFvr = parcelRequire("6eFvr");

var $b0fMV = parcelRequire("b0fMV");
function $d762f5ed921736bb$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $b0fMV.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $b0fMV.normalizedHeight)(scrollParent);
    const scrollTop = (0, $b0fMV.getScrollTop)(scrollParent);
    // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $fHpHg.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $b0fMV.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $d762f5ed921736bb$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $d762f5ed921736bb$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $d762f5ed921736bb$export$a228922d5ca42a79 = ({ placement: placement })=>({
        label: 'menu',
        [$d762f5ed921736bb$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        borderRadius: "var(--ds-border-radius, 4px)",
        marginBottom: "var(--ds-space-100, 8px)",
        marginTop: "var(--ds-space-100, 8px)",
        backgroundColor: "var(--ds-surface-overlay, white)",
        boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
    });
const $d762f5ed921736bb$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $d762f5ed921736bb$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($d762f5ed921736bb$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $d762f5ed921736bb$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $d762f5ed921736bb$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $d762f5ed921736bb$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d762f5ed921736bb$export$2e2bcd8739ae039 = $d762f5ed921736bb$var$Menu;
const $d762f5ed921736bb$export$abafed69cff95d5e = ({ maxHeight: maxHeight })=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        paddingTop: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)"
    });
const $d762f5ed921736bb$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $d762f5ed921736bb$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $d762f5ed921736bb$export$cf0e22534d8b0074 = $d762f5ed921736bb$var$noticeCSS;
const $d762f5ed921736bb$export$98ec46397a8cb3cd = $d762f5ed921736bb$var$noticeCSS;
const $d762f5ed921736bb$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6eFvr.default), {
        color: "color.text.subtle"
    }, children));
};
const $d762f5ed921736bb$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6eFvr.default), {
        color: "color.text.subtle"
    }, children));
};
const $d762f5ed921736bb$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $d762f5ed921736bb$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($d762f5ed921736bb$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $b0fMV.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $b0fMV.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($d762f5ed921736bb$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("g9RrE", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $bc36f1aefc070984$export$deee3a793edee05f);

var $gSfPF = parcelRequire("gSfPF");
var $cVo0M = parcelRequire("cVo0M");

var $cVo0M = parcelRequire("cVo0M");

var $f8LYQ = parcelRequire("f8LYQ");
function $bc36f1aefc070984$var$getCssDimensions(element) {
    const css = (0, $f8LYQ.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $f8LYQ.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cVo0M.round)(width) !== offsetWidth || (0, $cVo0M.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bc36f1aefc070984$var$unwrapElement(element) {
    return !(0, $f8LYQ.isElement)(element) ? element.contextElement : element;
}
function $bc36f1aefc070984$var$getScale(element) {
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    if (!(0, $f8LYQ.isHTMLElement)(domElement)) return (0, $cVo0M.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cVo0M.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cVo0M.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bc36f1aefc070984$var$noOffsets = /*#__PURE__*/ (0, $cVo0M.createCoords)(0);
function $bc36f1aefc070984$var$getVisualOffsets(element) {
    const win = (0, $f8LYQ.getWindow)(element);
    if (!(0, $f8LYQ.isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $f8LYQ.getWindow)(element)) return false;
    return isFixed;
}
function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    let scale = (0, $cVo0M.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $f8LYQ.isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
        } else scale = $bc36f1aefc070984$var$getScale(element);
    }
    const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, $cVo0M.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $f8LYQ.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $f8LYQ.isElement)(offsetParent) ? (0, $f8LYQ.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $f8LYQ.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $f8LYQ.getWindow)(currentIFrame);
            currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        }
    }
    return (0, $cVo0M.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $f8LYQ.getNodeScroll)(element).scrollLeft;
    if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, $f8LYQ.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $f8LYQ.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cVo0M.createCoords)(1);
    const offsets = (0, $cVo0M.createCoords)(0);
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if ((0, $f8LYQ.isHTMLElement)(offsetParent)) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
            scale = $bc36f1aefc070984$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, $cVo0M.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bc36f1aefc070984$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bc36f1aefc070984$var$getDocumentRect(element) {
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const scroll = (0, $f8LYQ.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cVo0M.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cVo0M.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $f8LYQ.getComputedStyle)(body).direction === 'rtl') x += (0, $cVo0M.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
    const win = (0, $f8LYQ.getWindow)(element);
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $f8LYQ.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $f8LYQ.isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, $cVo0M.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, $f8LYQ.getDocumentElement)(element));
    else if ((0, $f8LYQ.isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $cVo0M.rectToClientRect)(rect);
}
function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $f8LYQ.getParentNode)(element);
    if (parentNode === stopNode || !(0, $f8LYQ.isElement)(parentNode) || (0, $f8LYQ.isLastTraversableNode)(parentNode)) return false;
    return (0, $f8LYQ.getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $f8LYQ.getOverflowAncestors)(element, [], false).filter((el)=>(0, $f8LYQ.isElement)(el) && (0, $f8LYQ.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $f8LYQ.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $f8LYQ.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $f8LYQ.isElement)(currentNode) && !(0, $f8LYQ.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $f8LYQ.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $f8LYQ.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $f8LYQ.isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $f8LYQ.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bc36f1aefc070984$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $f8LYQ.isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cVo0M.max)(rect.top, accRect.top);
        accRect.right = (0, $cVo0M.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cVo0M.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cVo0M.max)(rect.left, accRect.left);
        return accRect;
    }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bc36f1aefc070984$var$getDimensions(element) {
    const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cVo0M.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, $cVo0M.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bc36f1aefc070984$var$isStaticPositioned(element) {
    return (0, $f8LYQ.getComputedStyle)(element).position === 'static';
}
function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $f8LYQ.isHTMLElement)(element) || (0, $f8LYQ.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $f8LYQ.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
    const win = (0, $f8LYQ.getWindow)(element);
    if ((0, $f8LYQ.isTopLayer)(element)) return win;
    if (!(0, $f8LYQ.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $f8LYQ.getParentNode)(element);
        while(svgOffsetParent && !(0, $f8LYQ.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $f8LYQ.isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $f8LYQ.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $f8LYQ.isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $f8LYQ.isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, $f8LYQ.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $f8LYQ.getContainingBlock)(element) || win;
}
const $bc36f1aefc070984$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bc36f1aefc070984$var$isRTL(element) {
    return (0, $f8LYQ.getComputedStyle)(element).direction === 'rtl';
}
const $bc36f1aefc070984$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $f8LYQ.getDocumentElement,
    getClippingRect: $bc36f1aefc070984$var$getClippingRect,
    getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
    getElementRects: $bc36f1aefc070984$var$getElementRects,
    getClientRects: $bc36f1aefc070984$var$getClientRects,
    getDimensions: $bc36f1aefc070984$var$getDimensions,
    getScale: $bc36f1aefc070984$var$getScale,
    isElement: $f8LYQ.isElement,
    isRTL: $bc36f1aefc070984$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bc36f1aefc070984$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $f8LYQ.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cVo0M.floor)(top);
        const insetRight = (0, $cVo0M.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cVo0M.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cVo0M.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cVo0M.max)(0, (0, $cVo0M.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $f8LYQ.getOverflowAncestors)(referenceEl) : [],
        ...(0, $f8LYQ.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, $gSfPF.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bc36f1aefc070984$export$cc800923e997bb8 = (0, $gSfPF.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, $gSfPF.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bc36f1aefc070984$export$fba63a578e423eb = (0, $gSfPF.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, $gSfPF.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bc36f1aefc070984$export$346677f925de839c = (0, $gSfPF.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bc36f1aefc070984$export$fe8985bb6374093c = (0, $gSfPF.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, $gSfPF.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, $gSfPF.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, $gSfPF.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bc36f1aefc070984$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $gSfPF.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("gSfPF", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $c48df878d8118962$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $c48df878d8118962$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $c48df878d8118962$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $c48df878d8118962$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $c48df878d8118962$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $c48df878d8118962$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $c48df878d8118962$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $c48df878d8118962$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $c48df878d8118962$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $c48df878d8118962$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $c48df878d8118962$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("cVo0M")).rectToClientRect);

var $cVo0M = parcelRequire("cVo0M");
function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cVo0M.getSideAxis)(placement);
    const alignmentAxis = (0, $cVo0M.getAlignmentAxis)(placement);
    const alignLength = (0, $cVo0M.getAxisLength)(alignmentAxis);
    const side = (0, $cVo0M.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cVo0M.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state);
    const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cVo0M.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cVo0M.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cVo0M.getAlignmentAxis)(placement);
            const length = (0, $cVo0M.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cVo0M.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cVo0M.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cVo0M.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cVo0M.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cVo0M.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cVo0M.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cVo0M.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cVo0M.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cVo0M.placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cVo0M.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cVo0M.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cVo0M.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cVo0M.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cVo0M.getSide)(placement);
            const initialSideAxis = (0, $cVo0M.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cVo0M.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cVo0M.getOppositePlacement)(initialPlacement)
            ] : (0, $cVo0M.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cVo0M.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cVo0M.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cVo0M.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
    return (0, $cVo0M.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $c48df878d8118962$var$getBoundingRect(rects) {
    const minX = (0, $cVo0M.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cVo0M.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cVo0M.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cVo0M.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $c48df878d8118962$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cVo0M.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cVo0M.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cVo0M.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cVo0M.getSide)(placement) === 'left';
                    const maxRight = (0, $cVo0M.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cVo0M.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $c48df878d8118962$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cVo0M.getSide)(placement);
    const alignment = (0, $cVo0M.getAlignment)(placement);
    const isVertical = (0, $cVo0M.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cVo0M.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c48df878d8118962$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cVo0M.getSideAxis)((0, $cVo0M.getSide)(placement));
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cVo0M.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cVo0M.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cVo0M.getSideAxis)(placement);
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cVo0M.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $cVo0M.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c48df878d8118962$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cVo0M.getSide)(placement);
            const alignment = (0, $cVo0M.getAlignment)(placement);
            const isYAxis = (0, $cVo0M.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cVo0M.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cVo0M.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cVo0M.max)(overflow.left, 0);
                const xMax = (0, $cVo0M.max)(overflow.right, 0);
                const yMin = (0, $cVo0M.max)(overflow.top, 0);
                const yMax = (0, $cVo0M.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cVo0M.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cVo0M.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cVo0M", function(module, exports) {

$parcel$export(module.exports, "sides", () => $968d6f1d7e429938$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $968d6f1d7e429938$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $968d6f1d7e429938$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $968d6f1d7e429938$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $968d6f1d7e429938$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $968d6f1d7e429938$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $968d6f1d7e429938$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $968d6f1d7e429938$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $968d6f1d7e429938$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $968d6f1d7e429938$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $968d6f1d7e429938$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $968d6f1d7e429938$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $968d6f1d7e429938$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $968d6f1d7e429938$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $968d6f1d7e429938$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $968d6f1d7e429938$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $968d6f1d7e429938$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $968d6f1d7e429938$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $968d6f1d7e429938$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $968d6f1d7e429938$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $968d6f1d7e429938$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $968d6f1d7e429938$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $968d6f1d7e429938$export$803cd8101b6c182b = /*#__PURE__*/ $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $968d6f1d7e429938$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $968d6f1d7e429938$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
    return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
}
function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
    return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
}
function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
    const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
    const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
    return [
        $968d6f1d7e429938$export$2b182c584985588b(placement),
        oppositePlacement,
        $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
    ];
}
function $968d6f1d7e429938$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
}
function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
    }
    return list;
}
function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
}
function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("f8LYQ", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $b05cd24baa7455b6$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $b05cd24baa7455b6$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $b05cd24baa7455b6$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $b05cd24baa7455b6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b05cd24baa7455b6$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $b05cd24baa7455b6$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $b05cd24baa7455b6$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $b05cd24baa7455b6$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $b05cd24baa7455b6$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $b05cd24baa7455b6$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $b05cd24baa7455b6$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $b05cd24baa7455b6$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $b05cd24baa7455b6$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $b05cd24baa7455b6$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $b05cd24baa7455b6$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $b05cd24baa7455b6$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $b05cd24baa7455b6$export$7bf1f8740e3e34af);
function $b05cd24baa7455b6$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $b05cd24baa7455b6$export$651544f548703224(node) {
    if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b05cd24baa7455b6$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
}
function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
}
function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
    if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($b05cd24baa7455b6$export$651544f548703224(element));
}
function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
    const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $b05cd24baa7455b6$export$940d8225183e1404(element) {
    let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
    while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
        if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b05cd24baa7455b6$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($b05cd24baa7455b6$export$651544f548703224(node));
}
function $b05cd24baa7455b6$export$3735103072e4a80(element) {
    return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
    if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
    if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b05cd24baa7455b6$export$e495491855dc5418(node);
    return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
    const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
    if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
}
function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = (0, $5uXOq.useLayoutEffect);

});


parcelRegister("g6y65", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $81905f6290625738$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $81905f6290625738$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $81905f6290625738$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $81905f6290625738$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $81905f6290625738$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $81905f6290625738$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $81905f6290625738$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $85kPS = parcelRequire("85kPS");

var $gANiX = parcelRequire("gANiX");

var $fHpHg = parcelRequire("fHpHg");

var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $b0fMV = parcelRequire("b0fMV");
function $81905f6290625738$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $81905f6290625738$export$23c213f7717186af = ({ isDisabled: isDisabled, isFocused: isFocused })=>{
    let backgroundColor;
    let color;
    if (isDisabled) {
        // Use the basic neutral background so it is slightly separate from the
        // field's background
        backgroundColor = "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text-disabled, #091E424F)";
    } else if (isFocused) {
        backgroundColor = "var(--ds-background-selected, #E9F2FF)";
        color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
    } else {
        backgroundColor = (0, $fHpHg.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text, hsl(0, 0%, 20%))";
    }
    return {
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        margin: "var(--ds-space-025, 2px)",
        borderRadius: "var(--ds-border-radius-050, 2px)",
        backgroundColor: backgroundColor,
        boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
        maxWidth: '100%',
        '@media screen and (-ms-high-contrast: active)': {
            border: isFocused ? '1px solid transparent' : 'none'
        },
        color: color,
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') && {
            borderRadius: "var(--ds-border-radius-100, 4px)",
            // Hardcode this color for visual refresh as there is no token color yet
            borderColor: '#B7B9BE',
            borderWidth: "var(--ds-border-width, 1px)",
            borderStyle: 'solid',
            backgroundColor: "var(--ds-background-input, #FFFFFF)"
        }
    };
};
const $81905f6290625738$export$f40612612e0af964 = ({ cropWithEllipsis: cropWithEllipsis, isDisabled: isDisabled })=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '85%',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        padding: "var(--ds-space-025, 2px)",
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : 'inherit',
        paddingLeft: "var(--ds-space-075, 6px)",
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') && {
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: "var(--ds-space-050, 4px)"
        }
    });
const $81905f6290625738$export$283467f6c4ac142b = ({ isFocused: isFocused })=>({
        alignItems: 'center',
        display: 'flex',
        backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, transparent)" : undefined,
        fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
        paddingLeft: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-025, 2px)",
        borderRadius: '0px 2px 2px 0px',
        // DSP-6470 we should style like Tag once we have the :has selector
        ':hover': {
            backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)",
            fill: "var(--ds-text-danger, #000)"
        },
        ':active': {
            backgroundColor: "var(--ds-background-danger-pressed, #FD9891)",
            fill: "var(--ds-text-danger, #000)"
        },
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') && {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            border: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            appearance: 'none',
            borderRadius: "var(--ds-border-radius, 4px)",
            color: "var(--ds-text, #172B4D)",
            padding: "var(--ds-space-025, 2px)",
            marginRight: "var(--ds-space-025, 2px)",
            ':focus-visible': {
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            },
            ':hover': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            },
            ':active': {
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
            }
        }
    });
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $81905f6290625738$var$MultiValueGeneric = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $81905f6290625738$export$cf9cf2a30a59265c = $81905f6290625738$var$MultiValueGeneric;
const $81905f6290625738$export$544aeea2a5ce08ee = $81905f6290625738$var$MultiValueGeneric;
const $81905f6290625738$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $81905f6290625738$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $81905f6290625738$var$iconWrapperStyles = (0, $2s57o.xcss)({
    padding: 'space.025'
});
const $81905f6290625738$var$renderIcon = ()=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $fHpHg.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
        label: "",
        color: "currentColor"
    });
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $fHpHg.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Eqc8.default), {
        xcss: $81905f6290625738$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
        label: "",
        color: "currentColor"
    }));
    return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85kPS))), {
        label: "",
        primaryColor: "transparent",
        size: "small",
        secondaryColor: "inherit"
    }));
};
function $81905f6290625738$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, innerProps: innerProps }) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: isDisabled ? $81905f6290625738$var$disabledStyles : $81905f6290625738$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, $81905f6290625738$var$renderIcon())));
}
const $81905f6290625738$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $b0fMV.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $b0fMV.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $b0fMV.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            role: 'button',
            tabIndex: -1,
            'aria-label': `${ariaLabel || 'option'}, remove`,
            ...removeProps
        },
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$81905f6290625738$export$2e2bcd8739ae039 = $81905f6290625738$var$MultiValue;

});

parcelRegister("FpaWY", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $3f5146e3502d3009$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $3f5146e3502d3009$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $3f5146e3502d3009$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    let color = "var(--ds-text, #172B4D)";
    if (isDisabled) color = "var(--ds-text-disabled, #091E424F)";
    else if (isSelected) color = "var(--ds-text-selected, #0C66E4)";
    let boxShadow;
    let backgroundColor;
    if (isDisabled) backgroundColor = undefined;
    else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, #CCE0FF)";
    else if (isSelected) backgroundColor = "var(--ds-background-selected, #E9F2FF)";
    else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
    if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${"var(--ds-border-selected, #0C66E4)"}`;
    const cursor = isDisabled ? 'not-allowed' : 'default';
    return {
        label: 'option',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        backgroundColor: backgroundColor,
        color: color,
        cursor: cursor,
        boxShadow: boxShadow,
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, #85B8FF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)" : undefined
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
        }
    };
};
const $3f5146e3502d3009$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3f5146e3502d3009$export$2e2bcd8739ae039 = $3f5146e3502d3009$var$Option;

});

parcelRegister("41aBa", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $46d5944cb8b3b0b7$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $46d5944cb8b3b0b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $46d5944cb8b3b0b7$export$5f3ffacd6594d90f = ({ isDisabled: isDisabled })=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtlest, #626F86)"
    });
const $46d5944cb8b3b0b7$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$46d5944cb8b3b0b7$export$2e2bcd8739ae039 = $46d5944cb8b3b0b7$var$Placeholder;

});

parcelRegister("aPWnT", function(module, exports) {

$parcel$export(module.exports, "css", () => $d266cade0fb9c8f9$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $d266cade0fb9c8f9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $d266cade0fb9c8f9$export$dbf350e5966cf602 = ({ isDisabled: isDisabled })=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)"
    });
const $d266cade0fb9c8f9$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d266cade0fb9c8f9$export$2e2bcd8739ae039 = $d266cade0fb9c8f9$var$SingleValue;

});


parcelRegister("2PbHi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef926a855a779be$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $9ef926a855a779be$var$dummyInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $9ef926a855a779be$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $b0fMV.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $9ef926a855a779be$var$dummyInputStyles
    });
}

});

parcelRegister("2dBDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $14249926a63529ad$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $bKnKN = parcelRequire("bKnKN");
function $14249926a63529ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $14249926a63529ad$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $14249926a63529ad$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $14249926a63529ad$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $bKnKN.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$14249926a63529ad$export$2e2bcd8739ae039 = $14249926a63529ad$var$RequiredInput;

});

parcelRegister("hFt5x", function(module, exports) {

$parcel$export(module.exports, "default", () => $86de9e85d01f60c4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f9MvN = parcelRequire("f9MvN");

var $25zrI = parcelRequire("25zrI");
function $86de9e85d01f60c4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86de9e85d01f60c4$var$styles = {
    name: "qzxev8",
    styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
};
const $86de9e85d01f60c4$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $86de9e85d01f60c4$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $f9MvN.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $25zrI.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onClick: $86de9e85d01f60c4$var$blurSelectInput,
        css: $86de9e85d01f60c4$var$styles
    }), children(targetRef));
}

});
parcelRegister("f9MvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c785698eb20a81e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b0fMV = parcelRequire("b0fMV");
const $6c785698eb20a81e$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $6c785698eb20a81e$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $6c785698eb20a81e$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $b0fMV.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("25zrI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d1383606735f058$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $4d1383606735f058$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $4d1383606735f058$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $4d1383606735f058$var$preventTouchMove(e) {
    e.preventDefault();
}
function $4d1383606735f058$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $4d1383606735f058$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $4d1383606735f058$var$isTouchDevice() {
    // eslint-disable-next-line compat/compat
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $4d1383606735f058$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $4d1383606735f058$var$activeScrollLocks = 0;
const $4d1383606735f058$var$listenerOptions = {
    capture: false,
    passive: false
};
function $4d1383606735f058$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$4d1383606735f058$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $4d1383606735f058$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $4d1383606735f058$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($4d1383606735f058$var$LOCK_STYLES).forEach((key)=>{
                const val = $4d1383606735f058$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $4d1383606735f058$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $4d1383606735f058$var$preventTouchMove, $4d1383606735f058$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $4d1383606735f058$var$preventInertiaScroll, $4d1383606735f058$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $4d1383606735f058$var$allowTouchMove, $4d1383606735f058$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $4d1383606735f058$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$4d1383606735f058$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $4d1383606735f058$var$activeScrollLocks = Math.max($4d1383606735f058$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $4d1383606735f058$var$activeScrollLocks < 1) $4d1383606735f058$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $4d1383606735f058$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $4d1383606735f058$var$preventTouchMove, $4d1383606735f058$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $4d1383606735f058$var$preventInertiaScroll, $4d1383606735f058$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $4d1383606735f058$var$allowTouchMove, $4d1383606735f058$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("StbfM", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $10d04a4d3c9b7a75$export$17baa7c95b6ba1b8);

var $8Oct0 = parcelRequire("8Oct0");
function $10d04a4d3c9b7a75$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    (0, $8Oct0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("1NMZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $221388b1d82bde88$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");

var $gER7R = parcelRequire("gER7R");

var $dZ6CW = parcelRequire("dZ6CW");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $221388b1d82bde88$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $fHpHg.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $gER7R.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $5uXOq.useRef)('');
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        if ((0, $fHpHg.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-results"
    }, ariaResults), !(0, $fHpHg.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance)));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dZ6CW.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dZ6CW.default), {
        "aria-live": ariaLive,
        "aria-atomic": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
        "aria-relevant": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
        role: (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? 'status' : 'log'
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$221388b1d82bde88$export$2e2bcd8739ae039 = $221388b1d82bde88$var$LiveRegion;

});
parcelRegister("gER7R", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $f2979f887e9391fd$export$a7265767c78f9bae);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $fHpHg = parcelRequire("fHpHg");
const $f2979f887e9391fd$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length && (0, $fHpHg.fg)('design_system_select-a11y-improvement') || !(0, $fHpHg.fg)('design_system_select-a11y-improvement') ? `option ${label}, deselected` : ''; // TODO: this should be handled on backspace|delete if no value, but doing it here first
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return label.length && (0, $fHpHg.fg)('design_system_select-a11y-improvement') || !(0, $fHpHg.fg)('design_system_select-a11y-improvement') ? `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.` : '';
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        // No longer needed after fg('design_system_select-a11y-improvement') is cleaned up
        if (context === 'menu' && !(0, $fHpHg.fg)('design_system_select-a11y-improvement')) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ' not selected'}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("dZ6CW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1ab6e61bd8eba4f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $d1ab6e61bd8eba4f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $d1ab6e61bd8eba4f$var$styles = {
    name: "jvmzbk-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;user-select:none;white-space:nowrap"
};
const $d1ab6e61bd8eba4f$var$A11yText = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $d1ab6e61bd8eba4f$var$styles,
        ...props
    });
var $d1ab6e61bd8eba4f$export$2e2bcd8739ae039 = $d1ab6e61bd8eba4f$var$A11yText;

});


parcelRegister("gInKw", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $9499cdf192fc0df5$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $a36ws = parcelRequire("a36ws");
const $9499cdf192fc0df5$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $a36ws.stripDiacritics));
const $9499cdf192fc0df5$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $9499cdf192fc0df5$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $9499cdf192fc0df5$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $9499cdf192fc0df5$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $9499cdf192fc0df5$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $9499cdf192fc0df5$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $9499cdf192fc0df5$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $a36ws.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("a36ws", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $b90cbf4384c79b10$export$b5bee4b27048330b);
const $b90cbf4384c79b10$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $b90cbf4384c79b10$var$anyDiacritic = new RegExp('[' + $b90cbf4384c79b10$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $b90cbf4384c79b10$var$diacriticToBase = {};
for(let i = 0; i < $b90cbf4384c79b10$var$diacritics.length; i++){
    let diacritic = $b90cbf4384c79b10$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$b90cbf4384c79b10$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $b90cbf4384c79b10$export$b5bee4b27048330b = (str)=>{
    return str.replace($b90cbf4384c79b10$var$anyDiacritic, (match)=>$b90cbf4384c79b10$var$diacriticToBase[match]);
};

});


parcelRegister("1BKyN", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $a295ff46d412df78$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $a295ff46d412df78$export$e618dc39ac9ad607);

var $cSGW3 = parcelRequire("cSGW3");

var $gGvqh = parcelRequire("gGvqh");

var $iluyz = parcelRequire("iluyz");

var $6oGQp = parcelRequire("6oGQp");

var $4S2FY = parcelRequire("4S2FY");

var $fW3un = parcelRequire("fW3un");

var $g6y65 = parcelRequire("g6y65");

var $FpaWY = parcelRequire("FpaWY");

var $41aBa = parcelRequire("41aBa");

var $aPWnT = parcelRequire("aPWnT");
const $a295ff46d412df78$export$214b055320e0bf32 = {
    clearIndicator: (0, $6oGQp.clearIndicatorCSS),
    container: (0, $cSGW3.containerCSS),
    control: (0, $gGvqh.css),
    dropdownIndicator: (0, $6oGQp.dropdownIndicatorCSS),
    group: (0, $iluyz.groupCSS),
    groupHeading: (0, $iluyz.groupHeadingCSS),
    indicatorsContainer: (0, $cSGW3.indicatorsContainerCSS),
    input: (0, $4S2FY.inputCSS),
    loadingIndicator: (0, $6oGQp.loadingIndicatorCSS),
    loadingMessage: (0, $fW3un.loadingMessageCSS),
    menu: (0, $fW3un.menuCSS),
    menuList: (0, $fW3un.menuListCSS),
    menuPortal: (0, $fW3un.menuPortalCSS),
    multiValue: (0, $g6y65.multiValueCSS),
    multiValueLabel: (0, $g6y65.multiValueLabelCSS),
    multiValueRemove: (0, $g6y65.multiValueRemoveCSS),
    noOptionsMessage: (0, $fW3un.noOptionsMessageCSS),
    option: (0, $FpaWY.optionCSS),
    placeholder: (0, $41aBa.placeholderCSS),
    singleValue: (0, $aPWnT.css),
    valueContainer: (0, $cSGW3.valueContainerCSS)
};
function $a295ff46d412df78$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("2OKnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2689712370970f9b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b0fMV = parcelRequire("b0fMV");
function $2689712370970f9b$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $5uXOq.useRef)(undefined);
    const mounted = (0, $5uXOq.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5uXOq.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $b0fMV.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("63z2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $52e9513a75e7f00c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $52e9513a75e7f00c$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("7Qatx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac7c8ad4681692a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $5IVHm = parcelRequire("5IVHm");
function $5ac7c8ad4681692a$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'assertive',
            ariaLiveMessages: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            //TO DO: Still need live region for PopupSelect because of the menu being open by default
            (0, $5IVHm.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $5IVHm.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("5IVHm", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $e1e3dc8406f8de80$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $e1e3dc8406f8de80$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $e1e3dc8406f8de80$export$8ee33f304118fce4);

var $fHpHg = parcelRequire("fHpHg");
function $e1e3dc8406f8de80$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    if (focused.label && groupData?.label && (0, $fHpHg.fg)('design_system_select-a11y-improvement')) return `${focused.label}, ${groupData?.label}`;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $e1e3dc8406f8de80$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $e1e3dc8406f8de80$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});




parcelRegister("3GGdh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a2ef132323f827c$export$2e2bcd8739ae039);
/*
  This Component sets the z-index of a modal to greater than that of
  drawers where they will be triggered to show from.
  The invite drawer modal sets their z-index to 550 when
  triggered by another modal as shown in this PR:
  https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/7042

  */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hatDq = parcelRequire("hatDq");
const $1a2ef132323f827c$var$DrawerDialogZIndexSetter = ()=>{
    const zIndexRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((node)=>{
        if (node !== null) {
            const portalElement = node.closest && node.closest('.atlaskit-portal');
            if (portalElement) // We set it to 560 because we want it to stay above the drawer (set at 550),
            // and below the flag, spotlight and tooltip.
            // See https://atlaskit.atlassian.com/packages/design-system/theme/docs/constants
            // Directly setting the style property is the safer option than setAttribute()
            // because we don't know what other possible style properties could be.
            portalElement.style['z-index'] = (0, $hatDq.ZIndex).FLOATING;
        }
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: zIndexRef
    });
};
var $1a2ef132323f827c$export$2e2bcd8739ae039 = $1a2ef132323f827c$var$DrawerDialogZIndexSetter;

});

parcelRegister("dCNWF", function(module, exports) {

$parcel$export(module.exports, "ThirdPartyContext", () => $0092ba34afb44c98$export$7e31acee6ee63234);
$parcel$export(module.exports, "useThirdPartyState", () => $0092ba34afb44c98$export$8569d1ff85ba1bfc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7Jxgt = parcelRequire("7Jxgt");

var $bngFq = parcelRequire("bngFq");

var $e1E0W = parcelRequire("e1E0W");

var $aEKq5 = parcelRequire("aEKq5");

var $hatDq = parcelRequire("hatDq");
var $fJpmn = parcelRequire("fJpmn");

var $evtmo = parcelRequire("evtmo");

var $lWbFO = parcelRequire("lWbFO");

var $kx8ta = parcelRequire("kx8ta");

var $dgnuV = parcelRequire("dgnuV");

var $6HEbe = parcelRequire("6HEbe");

var $e7PpL = parcelRequire("e7PpL");

var $daXvt = parcelRequire("daXvt");

var $8TQ2j = parcelRequire("8TQ2j");

var $cyXdR = parcelRequire("cyXdR");

var $27zXU = parcelRequire("27zXU");

var $2ys8y = parcelRequire("2ys8y");

var $5lX4X = parcelRequire("5lX4X");

var $bRt4Y = parcelRequire("bRt4Y");

var $2mmNQ = parcelRequire("2mmNQ");

var $aTU7b = parcelRequire("aTU7b");

var $e6nNA = parcelRequire("e6nNA");

var $vt9aE = parcelRequire("vt9aE");

var $84Nhj = parcelRequire("84Nhj");
const $0092ba34afb44c98$var$ThirdPartyStateContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $0092ba34afb44c98$export$7e31acee6ee63234 = ({ enableThirdParty: enableThirdParty, showFlag: showFlag, displayInfiSpotlight: displayInfiSpotlight = false, children: children, onCancelButtonClick: onCancelButtonClick })=>{
    const intl = (0, $koVbs.default)();
    const { orgId: orgId, cloudId: cloudId, productId: productId } = (0, $daXvt.useInvitePeopleContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const analytics = (0, $6HEbe.useAnalytics)((0, $5lX4X.ThirdPartyContextAnalytics));
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const [isAfterSlackConnect, setIsAfterSlackConnect] = (0, $5uXOq.useState)(false);
    const [isOk, setIsOk] = (0, $5uXOq.useState)(undefined);
    const [isConnected, setIsConnected] = (0, $5uXOq.useState)(false);
    const [slackService, setSlackService] = (0, $5uXOq.useState)(undefined);
    const [slackWorkspaces, setSlackWorkspaces] = (0, $5uXOq.useState)([]);
    const [selectedSlackWorkspace, setSelectedSlackWorkspace] = (0, $5uXOq.useState)(null);
    const [integrations, setIntegrations] = (0, $5uXOq.useState)(null);
    const [isSlackConnectDialogOpen, setIsSlackConnectDialogOpen] = (0, $5uXOq.useState)(false);
    const [updateThirdPartyIntegrations, setUpdateThirdPartyIntegrations] = (0, $5uXOq.useState)({
        noScope: new Set(),
        partialScope: new Set()
    });
    const [integrationMetadata, setIntegrationMetadata] = (0, $5uXOq.useState)(undefined);
    const { isLoading: isOrgSettingsLoading, settings: orgSettings } = (0, $dgnuV.useOrgControlSettings)(orgId || null);
    const [enabledIntegrations, setEnabledIntegrations] = (0, $5uXOq.useState)(new Set());
    const abortThirdPartyRequests = (0, $5uXOq.useCallback)(()=>{
        if (slackService) slackService.abort();
    }, [
        slackService
    ]);
    const slackUserSearcher = (0, $5uXOq.useRef)((0, $cyXdR.fuseFactory)([]));
    const { getUserByThirdPartyId: getUserByThirdPartyId, cacheUserByThirdPartyId: cacheUserByThirdPartyId } = (0, $e6nNA.useUsersByThirdPartyId)();
    (0, $5uXOq.useEffect)(()=>{
        async function onSetWorkspace() {
            if (!cloudId || !productId) return;
            slackUserSearcher.current = (0, $cyXdR.fuseFactory)([]);
            if (selectedSlackWorkspace && slackService) {
                slackService.abort();
                slackService.streamUsers(selectedSlackWorkspace.id, (slackUsers)=>{
                    if (slackUsers && slackUsers.ok) for (const slackUser of slackUsers.result){
                        const externalUser = (0, $kx8ta.slackToExternalUser)(slackUser);
                        slackUserSearcher.current.add(externalUser);
                        cacheUserByThirdPartyId((0, $8TQ2j.SLACK_SOURCE), slackUser.id, externalUser);
                    }
                });
            }
        }
        onSetWorkspace();
    }, [
        selectedSlackWorkspace,
        cloudId,
        productId,
        slackService,
        cacheUserByThirdPartyId
    ]);
    const connectedIntegrations = (0, $5uXOq.useMemo)(()=>{
        if (!integrations) return new Set();
        const res = new Set([
            // connected integrations aside from slack
            ...integrations.filter((integration)=>integration !== (0, $8TQ2j.PLATFORM_SLACK_SERVICE)),
            // we only want to set slack as connected if it is connected according
            // to exus and a workspace is selected
            ...integrations.includes((0, $8TQ2j.PLATFORM_SLACK_SERVICE)) && selectedSlackWorkspace ? [
                (0, $8TQ2j.PLATFORM_SLACK_SERVICE)
            ] : []
        ]);
        analytics.integrationsFetched({
            integrations: [
                ...res
            ]
        });
        return res;
    }, [
        analytics,
        integrations,
        selectedSlackWorkspace
    ]);
    const initSlack = (0, $5uXOq.useCallback)(()=>{
        if (!cloudId) return [];
        const productSlackService = (0, $e1E0W.slackServiceFactory)(cloudId, 'platform', createAnalyticsEvent);
        setSlackService(productSlackService);
    }, [
        cloudId,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!integrationMetadata) {
            setIsConnected(connectedIntegrations.size > 0);
            return;
        }
        const noScope = new Set();
        const partialScope = new Set();
        const connectedProductSlackWorkspace = (0, $27zXU.getConnectedSlackWorkSpace)();
        if (connectedProductSlackWorkspace) {
            const connectedTeam = integrationMetadata?.[(0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE]?.teams?.find((team)=>team.id === connectedProductSlackWorkspace);
            if (connectedTeam) {
                if (connectedTeam.scopeState === (0, $fJpmn.ScopeState).NO_SCOPE) noScope.add((0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE);
            } else noScope.add((0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE);
        }
        connectedIntegrations.forEach((product)=>{
            if (product !== (0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE) {
                if (integrationMetadata?.[product]?.scopeState === (0, $fJpmn.ScopeState).NO_SCOPE) noScope.add(product);
                if (integrationMetadata?.[product]?.scopeState === (0, $fJpmn.ScopeState).PARTIAL_SCOPE) partialScope.add(product);
            }
        });
        setIsConnected(connectedIntegrations.size > noScope.size);
        setUpdateThirdPartyIntegrations({
            noScope: noScope,
            partialScope: partialScope
        });
    }, [
        integrationMetadata,
        connectedIntegrations,
        selectedSlackWorkspace?.id,
        productId
    ]);
    const fetchExistingIntegrationsWithMarker = (0, $5uXOq.useCallback)(async (cloudId)=>{
        (0, $lWbFO.invitePeopleRendered).mark((0, $lWbFO.invitePeopleRenderedTimings).fetchExistingIntegrations.startMark);
        const integrationsResponse = await (0, $aEKq5.fetchExistingIntegrations)(cloudId);
        (0, $lWbFO.invitePeopleRendered).mark((0, $lWbFO.invitePeopleRenderedTimings).fetchExistingIntegrations.endMark);
        return integrationsResponse;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        async function getThirdPartyIntegrations() {
            if (!cloudId || !productId) {
                setIsLoading(false);
                return;
            }
            try {
                if (enableThirdParty === true) {
                    setIsLoading(true);
                    initSlack();
                    const integrationsResponse = await fetchExistingIntegrationsWithMarker(cloudId);
                    if (!integrationsResponse) throw new Error((0, $8TQ2j.FETCH_INTEGRATIONS_FAILURE_MESSAGE));
                    setIntegrations(integrationsResponse.connectedIntegrations);
                    setEnabledIntegrations(new Set(integrationsResponse.enabledIntegrations));
                    setIntegrationMetadata(integrationsResponse?.integrationMetadata);
                    // slack workspaces from EXUS filtered by valid scope
                    const workspaces = integrationsResponse?.integrationMetadata?.[(0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE]?.teams?.filter((workspace)=>workspace.scopeState !== (0, $fJpmn.ScopeState).NO_SCOPE) || [];
                    setSlackWorkspaces(workspaces);
                    const slackWorkspaceId = (0, $27zXU.getConnectedSlackWorkSpace)();
                    if (workspaces.length > 0) {
                        const slackWorkspace = slackWorkspaceId ? workspaces.find((slackWorkspace)=>slackWorkspace.id === slackWorkspaceId) : undefined;
                        if (slackWorkspace) setSelectedSlackWorkspace(slackWorkspace);
                        else {
                            const shouldAutoConnect = (0, $84Nhj.getExperimentValue)((0, $hatDq.ExperimentKeys).SLACK_AUTO_CONNECT, (0, $hatDq.Cohort).NOT_ENROLLED, true) === (0, $hatDq.Cohort).VARIATION;
                            if (shouldAutoConnect) {
                                setSelectedSlackWorkspace(workspaces[0]);
                                (0, $27zXU.setConnectedSlackWorkSpace)(workspaces[0].id);
                                analytics.integrationConnected({
                                    serviceKey: (0, $8TQ2j.PLATFORM_SLACK_SERVICE),
                                    teamId: workspaces[0].id,
                                    auto: true
                                });
                            }
                        }
                    }
                    setIsOk(integrationsResponse.enabledIntegrations.length > 0);
                    analytics.sloThirdPartyInitSuccess({
                        enabledIntegrations: integrationsResponse.enabledIntegrations,
                        connectedIntegrations: integrationsResponse.connectedIntegrations,
                        selectedSlackWorkspace: slackWorkspaceId ?? undefined
                    });
                } else setIsOk(false);
            } catch (error) {
                setIsOk(false);
                const { errorMessage: errorMessage, responseCode: responseCode } = (0, $kx8ta.resolveError)(error);
                const is4xxError = responseCode && [
                    400,
                    401,
                    403
                ].includes(responseCode);
                if (errorMessage === (0, $8TQ2j.FETCH_INTEGRATIONS_FAILURE_MESSAGE)) analytics.fetchExistingIntegrationsFailed({
                    ari: cloudId,
                    errorMessage: errorMessage,
                    responseCode: responseCode
                });
                if (is4xxError || (0, $kx8ta.isAcceptableFailure)(errorMessage, responseCode)) // Only fired in error cases that should not be measured in the SLO
                analytics.thirdPartyInitFailed(String(error));
                else if ((0, $evtmo.isSLOFailure)(error)) analytics.sloThirdPartyInitFailed(String(error));
            } finally{
                setIsLoading(false);
            }
        }
        getThirdPartyIntegrations();
    }, [
        cloudId,
        productId,
        createAnalyticsEvent,
        enableThirdParty,
        initSlack,
        analytics,
        fetchExistingIntegrationsWithMarker
    ]);
    const onChangeSelectedSlackWorkspace = (0, $bRt4Y.useOnChangeSelectedSlackWorkspace)({
        analytics: analytics,
        setSelectedSlackWorkspace: setSelectedSlackWorkspace,
        showFlag: showFlag
    });
    const { slackDisconnect: slackDisconnect } = (0, $e7PpL.useThirdPartyIntegrationsFlags)();
    const onDisconnectSlackWorkspace = (0, $5uXOq.useCallback)(()=>{
        if (showFlag) showFlag(slackDisconnect());
        setSelectedSlackWorkspace(null);
        (0, $27zXU.disconnectSlackWorkSpace)();
    }, [
        showFlag,
        slackDisconnect
    ]);
    const onThirdPartyIntegrationsChange = (0, $5uXOq.useCallback)(async ()=>{
        if (!cloudId) return;
        try {
            const integrationsResponse = await (0, $aEKq5.fetchExistingIntegrations)(cloudId);
            if (!integrationsResponse) return;
            setIntegrations(integrationsResponse.connectedIntegrations);
            setIntegrationMetadata(integrationsResponse.integrationMetadata);
            // set slack workspaces from EXUS filtered by valid scope
            setSlackWorkspaces(integrationsResponse.integrationMetadata?.[(0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE]?.teams?.filter((workspace)=>workspace.scopeState !== (0, $fJpmn.ScopeState).NO_SCOPE) || []);
        } catch (error) {
            const { errorMessage: errorMessage, responseCode: responseCode } = (0, $kx8ta.resolveError)(error);
            analytics.fetchExistingIntegrationsFailed({
                ari: cloudId,
                errorMessage: errorMessage,
                responseCode: responseCode
            });
            return;
        }
    }, [
        cloudId,
        analytics
    ]);
    const closeSlackConnectDialog = ()=>setIsSlackConnectDialogOpen(false);
    const openSlackConnectDialog = ()=>setIsSlackConnectDialogOpen(true);
    const inviteThirdPartyTeams = (0, $vt9aE.useInviteThirdPartyTeamsEligibility)({
        isThirdPartyStateLoading: isLoading,
        integrations: connectedIntegrations,
        enabledIntegrations: enabledIntegrations
    });
    const infiSpotlight = {
        isEnabled: displayInfiSpotlight,
        isLoading: isLoading
    };
    const { querySlackChannels: querySlackChannels } = (0, $aTU7b.useQuerySlackChannels)({
        isEnabled: inviteThirdPartyTeams.isEnabled,
        analytics: analytics,
        intl: intl,
        selectedSlackWorkspace: selectedSlackWorkspace,
        slackService: slackService
    });
    const queryThirdParty = (0, $5uXOq.useCallback)(async (searchText)=>{
        if (!cloudId || !searchText || searchText.trim().length === 0 || connectedIntegrations.size === 0) return [];
        const ufoExperienceId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        (0, $lWbFO.startUfoExperience)((0, $lWbFO.thirdPartyResultsLoaded), ufoExperienceId, {
            connectedIntegrations: Array.from(connectedIntegrations).join(', ')
        });
        const isNonSlackIntegrationConnected = connectedIntegrations.has((0, $8TQ2j.GOOGLE_SERVICE)) || connectedIntegrations.has((0, $8TQ2j.MICROSOFT_SERVICE));
        // query backend for users on if MS/Google are connected
        let users = isNonSlackIntegrationConnected ? await (0, $aEKq5.search)(searchText, cloudId).catch((e)=>{
            (0, $lWbFO.failUfoExperience)((0, $lWbFO.thirdPartyResultsLoaded), ufoExperienceId);
            return [];
        }) : [];
        if (slackUserSearcher.current) {
            const slackUsers = slackUserSearcher.current.search(searchText).map((result)=>result.item);
            users = (0, $cyXdR.mergeExternalUsers)([
                users,
                slackUsers.slice(0, Math.min(slackUsers.length, (0, $8TQ2j.MAX_USERS)))
            ]);
        }
        const fuse = (0, $cyXdR.fuseFactory)(users);
        const searchResult = fuse.search(searchText).map((result)=>result.item);
        (0, $lWbFO.succeedUfoExperience)((0, $lWbFO.thirdPartyResultsLoaded), ufoExperienceId);
        return searchResult.slice(0, Math.min(searchResult.length, (0, $8TQ2j.MAX_USERS)));
    }, [
        connectedIntegrations,
        cloudId
    ]);
    const openSlackSettings = (0, $5uXOq.useCallback)(()=>{
        (0, $cyXdR.manageSlackWorkspaces)(Boolean(selectedSlackWorkspace), slackWorkspaces, isSlackConnectDialogOpen, openSlackConnectDialog, onChangeSelectedSlackWorkspace, productId, onCancelButtonClick);
    }, [
        isSlackConnectDialogOpen,
        onChangeSelectedSlackWorkspace,
        onCancelButtonClick,
        slackWorkspaces,
        selectedSlackWorkspace,
        productId
    ]);
    // We use this useEffect to open the slack settings after some
    // state (e.g. slackWorkspaces) is changed. we have this on it's own
    // useEffect since we want it to run after setState has finished
    (0, $5uXOq.useEffect)(()=>{
        // Do nothing if user did not manually connect
        if (!isAfterSlackConnect) return;
        setIsAfterSlackConnect(false);
        openSlackSettings();
    }, [
        isAfterSlackConnect,
        openSlackSettings,
        slackWorkspaces
    ]);
    const onConnectProvider = (0, $2mmNQ.useOnConnectProvider)({
        analytics: analytics,
        integrations: integrations,
        onThirdPartyIntegrationsChange: onThirdPartyIntegrationsChange,
        openSlackSettings: openSlackSettings,
        setIsAfterSlackConnect: setIsAfterSlackConnect,
        showFlag: showFlag,
        slackWorkspaces: slackWorkspaces
    });
    const onDisconnectProvider = (0, $5uXOq.useCallback)((serviceKey)=>{
        if (serviceKey === (0, $8TQ2j.PLATFORM_SLACK_SERVICE)) {
            if (slackWorkspaces.length) openSlackConnectDialog();
            else {
                setSelectedSlackWorkspace(null);
                (0, $27zXU.disconnectSlackWorkSpace)();
                onThirdPartyIntegrationsChange().then(()=>showFlag && showFlag(slackDisconnect()));
            }
            return;
        }
        const manageAppsUrl = `${(0, $2ys8y.getATLContextUrl)('id')}/manage-profile/apps`;
        window.open(manageAppsUrl);
        if (onCancelButtonClick) onCancelButtonClick();
    }, [
        onCancelButtonClick,
        onThirdPartyIntegrationsChange,
        showFlag,
        slackDisconnect,
        slackWorkspaces.length
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($0092ba34afb44c98$var$ThirdPartyStateContext.Provider, {
        value: {
            isLoading: isLoading || isOrgSettingsLoading,
            isOk: isOk,
            slackWorkspaces: slackWorkspaces,
            selectedSlackWorkspace: selectedSlackWorkspace,
            isSlackConnectDialogOpen: isSlackConnectDialogOpen,
            integrations: connectedIntegrations,
            enabledIntegrations: enabledIntegrations,
            updateIntegrations: updateThirdPartyIntegrations,
            openSlackConnectDialog: openSlackConnectDialog,
            closeSlackConnectDialog: closeSlackConnectDialog,
            onDisconnectSlackWorkspace: onDisconnectSlackWorkspace,
            onThirdPartyIntegrationsChange: onThirdPartyIntegrationsChange,
            onChangeSelectedSlackWorkspace: onChangeSelectedSlackWorkspace,
            queryThirdParty: queryThirdParty,
            inviteThirdPartyTeams: inviteThirdPartyTeams,
            infiSpotlight: infiSpotlight,
            getUserByThirdPartyId: getUserByThirdPartyId,
            cacheUserByThirdPartyId: cacheUserByThirdPartyId,
            querySlackChannels: querySlackChannels,
            onConnectProvider: onConnectProvider,
            onDisconnectProvider: onDisconnectProvider,
            abortThirdPartyRequests: abortThirdPartyRequests,
            orgSettings: orgSettings,
            isConnected: isConnected
        },
        children: children
    });
};
const $0092ba34afb44c98$export$8569d1ff85ba1bfc = ()=>{
    const state = (0, $5uXOq.useContext)($0092ba34afb44c98$var$ThirdPartyStateContext);
    if (state === undefined) throw new Error('useThirdPartyState must be used within a ThirdPartyStateProvider');
    return state;
};

});
parcelRegister("e1E0W", function(module, exports) {

$parcel$export(module.exports, "slackServiceFactory", () => $edd2b46f8edc6196$export$b2ac8baa522556a7);

var $cNy0g = parcelRequire("cNy0g");

var $iAD4l = parcelRequire("iAD4l");

var $8MliT = parcelRequire("8MliT");
function $edd2b46f8edc6196$export$b2ac8baa522556a7(cloudId, product, createAnalyticsEvent) {
    switch(product){
        case 'platform':
            return new (0, $8MliT.default)(cloudId, createAnalyticsEvent);
        case 'confluence':
            return new (0, $cNy0g.default)(cloudId, createAnalyticsEvent);
        default:
            return new (0, $iAD4l.default)(cloudId, createAnalyticsEvent);
    }
}

});
parcelRegister("cNy0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef0580595270c3cb$export$2e2bcd8739ae039);

var $1arCF = parcelRequire("1arCF");

var $b7TQW = parcelRequire("b7TQW");

var $9LYrq = parcelRequire("9LYrq");
class $ef0580595270c3cb$export$2e2bcd8739ae039 extends (0, $1arCF.default) {
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $b7TQW.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'confluence', analytics);
        this.confluenceAnalytics = (0, $b7TQW.getConfluenceSlackServiceAnalytics)(createUIAnalyticsEvent);
    }
    async primeConsentUrl() {
        if (this.consentUrl) return;
        const location = typeof window === 'undefined' ? undefined : window.location;
        if (location) {
            const urlResult = await (0, $9LYrq.default)(location, this.confluenceAnalytics, this.abortController?.signal);
            if (urlResult.ok) this.consentUrl = urlResult.result;
            else throw new Error('Failed priming consent URL');
        }
    }
}

});
parcelRegister("1arCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec9ca8100f0368bb$export$2e2bcd8739ae039);

var $2VHHh = parcelRequire("2VHHh");

var $7qDUb = parcelRequire("7qDUb");

var $7Jxgt = parcelRequire("7Jxgt");


var $jTza1 = parcelRequire("jTza1");

var $gvgWv = parcelRequire("gvgWv");

var $6ha5s = parcelRequire("6ha5s");

var $9CLBJ = parcelRequire("9CLBJ");
const $ec9ca8100f0368bb$var$POPUP_WIDTH = 500;
const $ec9ca8100f0368bb$var$POPUP_HEIGHT = 900;
const $ec9ca8100f0368bb$var$USER_FETCH_LIMIT = 1000;
const $ec9ca8100f0368bb$var$retryOptions = {
    maxAttempts: 3,
    backoffTimeMs: 200,
    rateLimitBackoffTimeMs: 1000
};
class $ec9ca8100f0368bb$export$2e2bcd8739ae039 {
    constructor(cloudId, product, analytics){
        this.cloudId = cloudId;
        this.product = product;
        this.analytics = analytics;
        this.windowName = (0, $7Jxgt.v4)();
        this.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
        this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        this.onMessage = ({ data: data, target: target, source: source })=>{
            if (!source || target !== window || data !== 'success') return;
            window.removeEventListener('message', this.onMessage);
            const popupWindow = source;
            if (!this.popupWindow) return;
            popupWindow.close();
            this.popupWindow = undefined;
            this.onSuccess?.();
        };
        this.baseUrl = `${0, $5009317558281709$export$68362b925a39303e}/${product}`;
    }
    abort() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
        }
    }
    async getConsent(onSuccess) {
        await this.primeConsentUrl();
        this.onSuccess = onSuccess;
        window.addEventListener('message', this.onMessage);
        const popupWindow = window.open(this.consentUrl, this.windowName, (0, $jTza1.default)($ec9ca8100f0368bb$var$POPUP_WIDTH, $ec9ca8100f0368bb$var$POPUP_HEIGHT));
        if (popupWindow) this.popupWindow = popupWindow;
    }
    async isSlackEnabled() {
        const result = await (0, $9CLBJ.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/enabled?cloudId=${this.cloudId}`, {
                    signal: this.abortController?.signal
                }),
            mapResult: (response)=>response.json().then(({ enabled: enabled })=>enabled),
            mapError: (response)=>response.json().then((obj)=>{
                    const { code: code, message: message } = obj;
                    return {
                        code: code ?? '',
                        message: message ?? ''
                    };
                })
        });
        if (result.ok) this.analytics.onGetEnabledSucceeded();
        else if (!result.aborted && !(0, $gvgWv.isAcceptableFailure)(result.status)) this.analytics.onGetEnabledFailed({
            status: result.status,
            errorMessage: result.message
        });
        return result;
    }
    async getTeams() {
        const response = await (0, $9CLBJ.fetchItemsWithCursor)({
            url: `${this.baseUrl}/teams`,
            queryParams: {
                cloudId: this.cloudId
            },
            signal: this.abortController?.signal,
            getItems: (response)=>response.teams,
            getCursor: (response)=>response.nextCursor,
            canRetryCheck: (0, $9CLBJ.httpRetryPolicy)($ec9ca8100f0368bb$var$retryOptions)
        });
        if (response.ok) {
            this.analytics.onFetchTeamsSucceeded({
                teams: response.items.length,
                pages: response.pages
            });
            return {
                ok: true,
                result: (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(response.items, [
                    ({ name: name })=>name.toLowerCase()
                ])
            };
        } else if (response.aborted) return response;
        else {
            this.analytics.onFetchTeamsFailed({
                page: response.page,
                status: response.status,
                errorMessage: response.message
            });
            return response;
        }
    }
    streamUsers(teamId, onResponse, cursor) {
        if (!cursor) this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        (0, $9CLBJ.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/recipients${(0, $9CLBJ.buildQueryString)({
                    cloudId: this.cloudId,
                    teamId: teamId,
                    cursor: cursor,
                    limit: $ec9ca8100f0368bb$var$USER_FETCH_LIMIT
                })}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $9CLBJ.httpRetryPolicy)($ec9ca8100f0368bb$var$retryOptions)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) this.analytics.onFetchUsersFailed({
                    teamId: teamId,
                    page: this.userStream.pages,
                    status: resp.status,
                    errorMessage: resp.message
                });
                onResponse(resp);
                return;
            }
            this.userStream.pages++;
            this.userStream.count += resp.result.recipients.length;
            this.userStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.recipients,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamUsers(teamId, onResponse, resp.result.nextCursor);
            else // This event may not consistently fire because it is possible for the user to select and share before
            // all pages have loaded
            this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: this.userStream.count,
                pages: this.userStream.pages
            });
        });
    }
    streamChannels(teamId, onResponse, cursor) {
        if (!cursor) this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        (0, $9CLBJ.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/channels${(0, $9CLBJ.buildQueryString)({
                    cloudId: this.cloudId,
                    teamId: teamId,
                    cursor: cursor
                })}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $9CLBJ.httpRetryPolicy)($ec9ca8100f0368bb$var$retryOptions)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) this.analytics.onFetchChannelsFailed({
                    teamId: teamId,
                    page: this.channelStream.pages,
                    status: resp.status,
                    errorMessage: resp.message
                });
                onResponse(resp);
                return;
            }
            this.channelStream.pages++;
            this.channelStream.count += resp.result.channels.length;
            this.channelStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.channels,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamChannels(teamId, onResponse, resp.result.nextCursor);
            else // This event may not consistently fire because it is possible for the user to select and share before
            // all pages have loaded
            this.analytics.onFetchChannelsSucceeded({
                teamId: teamId,
                channels: this.channelStream.count,
                pages: this.channelStream.pages
            });
        });
    }
    async fetchSlackUsers(teamId) {
        const response = await (0, $9CLBJ.fetchItemsWithCursor)({
            url: `${this.baseUrl}/recipients`,
            queryParams: {
                cloudId: this.cloudId,
                teamId: teamId
            },
            signal: this.abortController?.signal,
            getItems: (response)=>response.recipients,
            getCursor: (response)=>response.nextCursor,
            canRetryCheck: (0, $9CLBJ.httpRetryPolicy)($ec9ca8100f0368bb$var$retryOptions)
        });
        if (response.ok) {
            const users = (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(response.items, [
                ({ name: name })=>name.toLowerCase()
            ]);
            this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: response.items.length,
                pages: response.pages
            });
            return {
                ok: true,
                result: users
            };
        } else if (response.aborted) return response;
        else {
            this.analytics.onFetchUsersFailed({
                teamId: teamId,
                page: response.page,
                status: response.status,
                errorMessage: response.message
            });
            return response;
        }
    }
    async share({ teamId: teamId, conversationId: conversationId, conversationType: conversationType, link: link, message: message }) {
        (0, $6ha5s.startUfoExperience)((0, $6ha5s.UfoExperiences).SLACK_REQUEST_SENT);
        const origin = new (0, $2VHHh.default)({
            product: this.product
        });
        const response = await (0, $9CLBJ.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/share`, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        cloudId: this.cloudId,
                        teamId: teamId,
                        conversation: {
                            id: conversationId,
                            type: conversationType
                        },
                        link: origin.addToUrl(link),
                        message: message
                    }),
                    signal: this.abortController?.signal
                }),
            mapResult: ()=>Promise.resolve(),
            mapError: (response)=>response.json().then((obj)=>{
                    const { code: code, message: message } = obj;
                    return {
                        code: code ?? '',
                        message: message ?? ''
                    };
                }),
            signal: this.abortController?.signal
        });
        if (response.ok) {
            const successAttributes = {
                product: this.product,
                teamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                messageLength: message.length || 0,
                userCount: this.userStream.count
            };
            this.analytics.onShareSucceeded(successAttributes);
            (0, $6ha5s.succeedUfoExperience)((0, $6ha5s.UfoExperiences).SLACK_REQUEST_SENT, successAttributes);
        } else if (!response.aborted && !(0, $gvgWv.isAcceptableFailure)(response.status)) {
            const failedAttributes = {
                product: this.product,
                teamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                status: response.status,
                errorMessage: response.message
            };
            this.analytics.onShareFailed(failedAttributes);
            (0, $6ha5s.failUfoExperience)((0, $6ha5s.UfoExperiences).SLACK_REQUEST_SENT, failedAttributes);
        }
        return response.ok ? {
            ok: true,
            result: origin
        } : response;
    }
}

});
parcelRegister("jTza1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c8ec19028eb6173$export$2e2bcd8739ae039);
function $8c8ec19028eb6173$export$2e2bcd8739ae039(preferredWidth, preferredHeight) {
    const width = Math.min(preferredWidth, window.screen.availWidth);
    const height = Math.min(preferredHeight, window.screen.availHeight);
    return Object.entries({
        toolbar: 0,
        menubar: 0,
        location: 0,
        status: 0,
        scrollbars: 1,
        resizable: 0,
        chrome: 'yes',
        width: width,
        height: height,
        left: Math.round((window.innerWidth - width) / 2 + window.screenX),
        top: Math.round((window.innerHeight - height) / 3 + window.screenY)
    }).map(([key, value])=>`${key}=${value}`).join(',');
}

});

parcelRegister("gvgWv", function(module, exports) {

$parcel$export(module.exports, "isAcceptableFailure", () => $cb38076aa89e9423$export$678d91a98f79a24d);
const $cb38076aa89e9423$export$678d91a98f79a24d = (statusCode)=>!statusCode || statusCode === 400 || statusCode === 401 || statusCode === 403;

});

parcelRegister("6ha5s", function(module, exports) {

$parcel$export(module.exports, "UfoExperiences", () => $29b4594ff3a5f189$export$72df3c76208340b5);
$parcel$export(module.exports, "ufoExperiences", () => $29b4594ff3a5f189$export$615f888019c45765);
$parcel$export(module.exports, "startUfoExperience", () => $29b4594ff3a5f189$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $29b4594ff3a5f189$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $29b4594ff3a5f189$export$8dda83bafca11b77);
$parcel$export(module.exports, "abortUfoExperience", () => $29b4594ff3a5f189$export$b1021040eb94cdca);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
var $29b4594ff3a5f189$export$72df3c76208340b5 = /*#__PURE__*/ function(UfoExperiences) {
    UfoExperiences["SLACK_SEGMENT_RENDERED"] = "slack-segment-rendered";
    UfoExperiences["SLACK_REQUEST_SENT"] = "slack-request-sent";
    UfoExperiences["SLACK_FORM_ENABLED"] = "share-form-enabled";
    UfoExperiences["PLATFORM_SLACK_USERS_PAGE_FETCHED"] = "platform-slack-users-page-fetched";
    return UfoExperiences;
}({});
var $29b4594ff3a5f189$var$PlatformComponent = /*#__PURE__*/ function(PlatformComponent) {
    PlatformComponent["ShareToSlack"] = "share-to-slack";
    PlatformComponent["CoreInvites"] = "core-invites";
    return PlatformComponent;
}($29b4594ff3a5f189$var$PlatformComponent || {});
const $29b4594ff3a5f189$export$615f888019c45765 = {
    ["slack-request-sent"]: new (0, $kkzI0.UFOExperience)("slack-request-sent", {
        type: (0, $lrUJ4.ExperienceTypes).Experience,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "share-to-slack"
        }
    }),
    ["slack-segment-rendered"]: new (0, $kkzI0.UFOExperience)("slack-segment-rendered", {
        type: (0, $lrUJ4.ExperienceTypes).Load,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: "share-to-slack"
        }
    }),
    ["share-form-enabled"]: new (0, $kkzI0.UFOExperience)("share-form-enabled", {
        type: (0, $lrUJ4.ExperienceTypes).Load,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "share-to-slack"
        }
    }),
    ["platform-slack-users-page-fetched"]: new (0, $kkzI0.UFOExperience)("platform-slack-users-page-fetched", {
        type: (0, $lrUJ4.ExperienceTypes).Load,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "core-invites"
        }
    })
};
const $29b4594ff3a5f189$export$5e9287b6a10f8075 = (experienceName, properties)=>{
    const experience = $29b4594ff3a5f189$export$615f888019c45765[experienceName];
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $29b4594ff3a5f189$export$c5a5cf072c836c0e = (experienceName, properties)=>{
    const experience = $29b4594ff3a5f189$export$615f888019c45765[experienceName];
    experience.success({
        metadata: properties
    });
};
const $29b4594ff3a5f189$export$8dda83bafca11b77 = (experienceName, properties)=>{
    const experience = $29b4594ff3a5f189$export$615f888019c45765[experienceName];
    experience.failure({
        metadata: properties
    });
};
const $29b4594ff3a5f189$export$b1021040eb94cdca = (experienceName, properties)=>{
    const experience = $29b4594ff3a5f189$export$615f888019c45765[experienceName];
    experience.abort({
        metadata: properties
    });
};

});


parcelRegister("b7TQW", function(module, exports) {

$parcel$export(module.exports, "getSlackServiceAnalytics", () => $3131936266927c64$export$2b9ff26dd710d5d7);
$parcel$export(module.exports, "getConfluenceSlackServiceAnalytics", () => $3131936266927c64$export$2cc68fa43a97a8c);


var $9Iej8 = parcelRequire("9Iej8");

const $3131936266927c64$var$createAndFireEventOnPeopleTeams = (0, $9Iej8.default)((0, $5009317558281709$export$85183a312807388d));
var $3131936266927c64$var$AnalyticsActionSubject = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["INTEGRATION_SUCCEEDED"] = "integrationEnabled";
    AnalyticsActionSubject["INTEGRATION_TEAMS"] = "integrationTeams";
    AnalyticsActionSubject["INTEGRATION_CONVERSATIONS"] = "integrationConversations";
    AnalyticsActionSubject["INTEGRATION_METADATA"] = "integrationMetadata";
    AnalyticsActionSubject["INTEGRATION_TOKEN"] = "integrationCsrfToken";
    AnalyticsActionSubject["SHARE"] = "share";
    return AnalyticsActionSubject;
}($3131936266927c64$var$AnalyticsActionSubject || {});
var $3131936266927c64$var$AnalyticsAction = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    return AnalyticsAction;
}($3131936266927c64$var$AnalyticsAction || {});
const $3131936266927c64$export$e0925453bd625a62 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "integrationEnabled",
        action: "succeeded"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$d533ef9287e29338 = (createAnalyticsEvent, { status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "integrationEnabled",
        action: "failed",
        attributes: {
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$10723e48240e4b6a = (createAnalyticsEvent, { teams: teams, pages: pages })=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "integrationTeams",
        action: "succeeded",
        attributes: {
            teams: teams,
            pages: pages
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$77d7c2557ef0cb5b = (createAnalyticsEvent, { page: page, status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "integrationTeams",
        action: "failed",
        attributes: {
            page: page,
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$1fb50f4a006f5510 = (createAnalyticsEvent, { slackTeamId: slackTeamId, conversationTypes: conversationTypes, conversations: conversations, pages: pages })=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "integrationConversations",
        action: "succeeded",
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            conversations: conversations,
            pages: pages
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$121a5feec5d3a18f = (createAnalyticsEvent, { slackTeamId: slackTeamId, conversationTypes: conversationTypes, page: page, status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "integrationConversations",
        action: "failed",
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            page: page,
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$503ff4642f649174 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "integrationMetadata",
        action: "succeeded"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$68485a36cbb1a06f = (createAnalyticsEvent, params)=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "integrationMetadata",
        action: "failed",
        attributes: {
            ...params
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$5cc3ad7b898341e7 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "integrationMetadata",
        action: "succeeded"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$757b1ed45dd16a84 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "integrationCsrfToken",
        action: "failed"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$var$productActionSubjectId = {
    jira: 'issue',
    confluence: 'page',
    // default to issue at the moment but should
    // be something else depending on what is actually shared
    // once we implement sharing with the platform slack app
    platform: 'issue'
};
const $3131936266927c64$export$24b0574fd3374a47 = ({ product: product, slackTeamId: slackTeamId, conversationType: conversationType, conversationId: conversationId, messageLength: messageLength, userCount: userCount }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "share",
        action: "succeeded",
        actionSubjectId: $3131936266927c64$var$productActionSubjectId[product],
        attributes: {
            integrationTeamId: slackTeamId,
            integrationConversationType: conversationType,
            integrationConversationId: conversationId,
            messageLength: messageLength,
            workspaceSize: userCount
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$867fe86603399772 = ({ product: product, slackTeamId: slackTeamId, conversationType: conversationType, conversationId: conversationId, status: status, errorMessage: errorMessage }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "share",
        action: "failed",
        actionSubjectId: $3131936266927c64$var$productActionSubjectId[product],
        attributes: {
            integrationTeamId: slackTeamId,
            integrationConversationType: conversationType,
            integrationConversationId: conversationId,
            status: status,
            errorMessage: errorMessage
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$5a5d58e4161f41aa = ({ slackTeamId: slackTeamId, conversationTypes: conversationTypes, conversations: conversations, pages: pages, actionSubjectId: actionSubjectId }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: 'integrationConversations',
        action: "succeeded",
        actionSubjectId: actionSubjectId,
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            conversations: conversations,
            pages: pages
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$1286eed6ab074bde = ({ slackTeamId: slackTeamId, conversationTypes: conversationTypes, page: page, status: status, errorMessage: errorMessage, actionSubjectId: actionSubjectId }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $3131936266927c64$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: 'integrationConversations',
        action: "failed",
        actionSubjectId: actionSubjectId,
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            page: page,
            status: status,
            errorMessage: errorMessage
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $3131936266927c64$export$2b9ff26dd710d5d7 = (createAnalyticsEvent)=>({
        onGetEnabledSucceeded: ()=>$3131936266927c64$export$e0925453bd625a62(createAnalyticsEvent),
        onGetEnabledFailed: (params)=>$3131936266927c64$export$d533ef9287e29338(createAnalyticsEvent, params),
        onFetchTeamsSucceeded: (params)=>$3131936266927c64$export$10723e48240e4b6a(createAnalyticsEvent, params),
        onFetchTeamsFailed: (params)=>$3131936266927c64$export$77d7c2557ef0cb5b(createAnalyticsEvent, params),
        onFetchUsersSucceeded: ({ teamId: teamId, users: users, pages: pages })=>$3131936266927c64$export$1fb50f4a006f5510(createAnalyticsEvent, {
                slackTeamId: teamId || '',
                conversationTypes: [
                    'directMessage'
                ],
                conversations: users || 0,
                pages: pages
            }),
        onFetchUsersFailed: ({ teamId: teamId, page: page, status: status, errorMessage: errorMessage })=>$3131936266927c64$export$121a5feec5d3a18f(createAnalyticsEvent, {
                slackTeamId: teamId,
                conversationTypes: [
                    'directMessage'
                ],
                page: page,
                status: status,
                errorMessage: errorMessage
            }),
        onShareSucceeded: ({ product: product, teamId: teamId, conversationType: conversationType, conversationId: conversationId, messageLength: messageLength, userCount: userCount })=>{
            $3131936266927c64$export$24b0574fd3374a47({
                product: product,
                slackTeamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                messageLength: messageLength,
                userCount: userCount
            }, createAnalyticsEvent);
        },
        onShareFailed: ({ product: product, teamId: teamId, conversationType: conversationType, conversationId: conversationId, status: status, errorMessage: errorMessage })=>{
            $3131936266927c64$export$867fe86603399772({
                product: product,
                slackTeamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                status: status,
                errorMessage: errorMessage
            }, createAnalyticsEvent);
        },
        onFetchChannelsSucceeded: ({ teamId: teamId, channels: channels, pages: pages })=>{
            $3131936266927c64$export$5a5d58e4161f41aa({
                slackTeamId: teamId,
                conversationTypes: [
                    'public',
                    'private'
                ],
                conversations: channels,
                pages: pages,
                actionSubjectId: 'channels'
            }, createAnalyticsEvent);
        },
        onFetchChannelsFailed: ({ teamId: teamId, page: page, status: status, errorMessage: errorMessage })=>{
            $3131936266927c64$export$1286eed6ab074bde({
                slackTeamId: teamId,
                conversationTypes: [
                    'public',
                    'private'
                ],
                page: page,
                status: status,
                errorMessage: errorMessage,
                actionSubjectId: 'channels'
            }, createAnalyticsEvent);
        }
    });
const $3131936266927c64$export$2cc68fa43a97a8c = (createAnalyticsEvent)=>({
        onFetchConnectMetadataSucceeded: ()=>$3131936266927c64$export$503ff4642f649174(createAnalyticsEvent),
        onFetchConnectMetadataFailed: (params)=>$3131936266927c64$export$68485a36cbb1a06f(createAnalyticsEvent, params),
        onRefreshIntegrationCsrfTokenSucceeded: ()=>$3131936266927c64$export$5cc3ad7b898341e7(createAnalyticsEvent),
        onRefreshIntegrationCsrfTokenFailed: ()=>$3131936266927c64$export$757b1ed45dd16a84(createAnalyticsEvent)
    });

});

parcelRegister("9LYrq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd91c89d7971f95d$export$2e2bcd8739ae039);


var $cVtMg = parcelRequire("cVtMg");

var $iCqLM = parcelRequire("iCqLM");
const $cd91c89d7971f95d$var$consentUrl = {
    prod: `https://confluence-chats-integr.services.atlassian.com/api/slack/teams/login?source=${(0, $5009317558281709$export$83c8d7110915321e)}`,
    staging: `https://confluence-chats-integr.stg.services.atlassian.com/api/slack/teams/login?source=${(0, $5009317558281709$export$83c8d7110915321e)}`
};
const $cd91c89d7971f95d$var$connectKey = {
    prod: 'confluence-chats-integration',
    staging: 'confluence-chats-integration-stg-east'
};
const $cd91c89d7971f95d$var$ACQUIRE_CSRF_TIMEOUT_MS = 2000;
async function $cd91c89d7971f95d$export$2e2bcd8739ae039(location, analytics, signal) {
    const environment = (0, $cVtMg.default)(location.hostname);
    const response = await $cd91c89d7971f95d$var$getConfluenceSlackIntegrationDialogParams(location, signal);
    if (!response.ok) {
        if (!response.aborted) analytics.onFetchConnectMetadataFailed({
            status: response.status,
            errorMessage: response.message
        });
        return response;
    }
    analytics.onFetchConnectMetadataSucceeded();
    const { contextJwt: contextJwt, url: url } = response.result;
    // Prime the consent URL’s origin with any cookies it needs (namely, the CSRF
    // token) which would ordinarily be set by integration’s dialog.
    //
    // Explanation: This ensures a cookie containing a valid CSRF token is set on
    // the Slack consent popup window’s origin. This is a necessary step because
    // the Slack integration requires a valid CSRF token in the consent page
    // request when its URL contains a jwt query parameter. Failure to provide a
    // CSRF token cookie results in an invalid CSRF token error.
    try {
        await (0, $iCqLM.default)(url, $cd91c89d7971f95d$var$ACQUIRE_CSRF_TIMEOUT_MS);
        analytics.onRefreshIntegrationCsrfTokenSucceeded();
    } catch (error) {
        analytics.onRefreshIntegrationCsrfTokenFailed();
    // Ignore and hope there’s already a valid CSRF token.
    }
    return {
        ok: true,
        result: `${$cd91c89d7971f95d$var$consentUrl[environment]}&jwt=${encodeURIComponent(contextJwt)}`
    };
}
async function $cd91c89d7971f95d$var$getConfluenceSlackIntegrationDialogParams(location, signal) {
    const connectPath = $cd91c89d7971f95d$var$getConnectPath(location);
    try {
        const response = await fetch(connectPath, {
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            signal: signal,
            body: Object.entries({
                'plugin-key': 'confluence-chats-integration',
                key: 'dialog',
                productContext: '{}',
                classifier: 'json'
            }).map((kvp)=>kvp.map(encodeURIComponent).join('=')).join('&')
        });
        if (response.ok) return {
            ok: true,
            result: await response.json()
        };
        return {
            ok: false,
            aborted: false,
            status: response.status,
            code: `${response.status}`,
            message: await response.text()
        };
    } catch (error) {
        if (error instanceof Error) {
            if (error.name === 'AbortError') return {
                ok: false,
                aborted: true
            };
            return {
                ok: false,
                aborted: false,
                status: (0, $5009317558281709$export$2c32b0fe4533d89e),
                code: (0, $5009317558281709$export$9267d266a5449137),
                message: error.message || (0, $5009317558281709$export$33789febc109c023)
            };
        }
        return {
            ok: false,
            aborted: false,
            status: (0, $5009317558281709$export$2c32b0fe4533d89e),
            code: (0, $5009317558281709$export$9267d266a5449137),
            message: (0, $5009317558281709$export$33789febc109c023)
        };
    }
}
function $cd91c89d7971f95d$var$getConnectPath(location) {
    const environment = (0, $cVtMg.default)(location.hostname);
    return `/wiki/plugins/servlet/ac/${$cd91c89d7971f95d$var$connectKey[environment]}/dialog`;
}

});
parcelRegister("cVtMg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c68a7e1332d57f91$export$2e2bcd8739ae039);
function $c68a7e1332d57f91$export$2e2bcd8739ae039(hostname) {
    return hostname.endsWith('jira-dev.com') || hostname.endsWith('localhost') ? 'staging' : 'prod';
}

});

parcelRegister("iCqLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c50773f349feabb6$export$2e2bcd8739ae039);
/**
 * Fetch the specified URL, which is expected to set one or more cookies on its
 * origin.
 *
 * In order for this to work, a same-origin request is made by temporarily
 * creating an iframe.
 *
 * @param url       - the URL to fetch
 * @param timeoutMs - milliseconds to wait before timing out
 */ function $c50773f349feabb6$export$2e2bcd8739ae039(url, timeoutMs) {
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.width = '0';
    iframe.height = '0';
    iframe.style.position = 'absolute';
    iframe.style.visibility = 'hidden';
    iframe.style.borderWidth = '0';
    document.body.appendChild(iframe);
    return new Promise((resolve, reject)=>{
        let completed = false;
        const timeout = setTimeout(()=>{
            completed = true;
            document.body.removeChild(iframe);
            reject();
        }, timeoutMs);
        iframe.onload = ()=>{
            if (!completed) {
                clearTimeout(timeout);
                completed = true;
                document.body.removeChild(iframe);
                resolve();
            }
        };
    });
}

});



parcelRegister("iAD4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6fa7b87bdce7289$export$2e2bcd8739ae039);

var $1arCF = parcelRequire("1arCF");

var $b7TQW = parcelRequire("b7TQW");

var $6nzmR = parcelRequire("6nzmR");
class $d6fa7b87bdce7289$export$2e2bcd8739ae039 extends (0, $1arCF.default) {
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $b7TQW.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'jira', analytics);
    }
    async primeConsentUrl() {
        if (!this.consentUrl) this.consentUrl = (0, $6nzmR.default)(location);
    }
}

});
parcelRegister("6nzmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $290eb8af41349268$export$2e2bcd8739ae039);


var $cVtMg = parcelRequire("cVtMg");
const $290eb8af41349268$var$consentUrl = {
    prod: `https://atlassian-slack-integration.services.atlassian.com/api/slack/login?source=${(0, $5009317558281709$export$83c8d7110915321e)}`,
    staging: `https://atlassian-slack-integration.stg.services.atlassian.com/api/slack/login?source=${(0, $5009317558281709$export$83c8d7110915321e)}`
};
function $290eb8af41349268$export$2e2bcd8739ae039(location) {
    const environment = (0, $cVtMg.default)(location.hostname);
    return $290eb8af41349268$var$consentUrl[environment];
}

});


parcelRegister("8MliT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab74b7ecb218f477$export$2e2bcd8739ae039);

var $1arCF = parcelRequire("1arCF");

var $b7TQW = parcelRequire("b7TQW");


var $6ha5s = parcelRequire("6ha5s");

var $9CLBJ = parcelRequire("9CLBJ");
const $ab74b7ecb218f477$var$USER_FETCH_LIMIT = 500;
const $ab74b7ecb218f477$var$RETRY_OPTIONS = {
    maxAttempts: 3,
    backoffTimeMs: 200,
    rateLimitBackoffTimeMs: 1000
};
class $ab74b7ecb218f477$export$2e2bcd8739ae039 extends (0, $1arCF.default) {
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $b7TQW.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'platform', analytics);
    }
    streamUsers(teamId, onResponse, cursor) {
        (0, $6ha5s.startUfoExperience)((0, $6ha5s.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED, {
            limit: $ab74b7ecb218f477$var$USER_FETCH_LIMIT
        });
        if (!cursor) this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        const queryString = new URLSearchParams({
            teamId: teamId,
            cloudId: this.cloudId,
            limit: $ab74b7ecb218f477$var$USER_FETCH_LIMIT.toString(),
            ...cursor ? {
                cursor: cursor
            } : {}
        });
        (0, $9CLBJ.retryFetch)({
            request: ()=>fetch(`${(0, $5009317558281709$export$ab2f49a861856bab)}${(0, $5009317558281709$export$127769e597bc5ee5)}/slack/users?${queryString}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $9CLBJ.httpRetryPolicy)($ab74b7ecb218f477$var$RETRY_OPTIONS)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) {
                    this.analytics.onFetchUsersFailed({
                        teamId: teamId,
                        page: this.userStream.pages,
                        status: resp.status,
                        errorMessage: resp.message
                    });
                    (0, $6ha5s.failUfoExperience)((0, $6ha5s.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED);
                } else (0, $6ha5s.abortUfoExperience)((0, $6ha5s.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED);
                onResponse(resp);
                return;
            }
            this.userStream.pages++;
            this.userStream.count += resp.result.users.length;
            this.userStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.users.map(({ id: id, email: email, displayName: displayName, realName: name, avatar: avatarUrl })=>({
                        id: id,
                        name: name,
                        displayName: displayName,
                        avatarUrl: avatarUrl,
                        email: email,
                        type: 'directMessage'
                    })),
                nextCursor: resp.result.nextCursor
            });
            (0, $6ha5s.succeedUfoExperience)((0, $6ha5s.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED, {
                numResults: resp.result.users.length
            });
            if (resp.result.nextCursor) this.streamUsers(teamId, onResponse, resp.result.nextCursor);
            else this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: this.userStream.count,
                pages: this.userStream.pages
            });
        });
    }
    /*
	 * Temporary experiment endpoint for Invite 3rd Party Team (ITPT)
	 */ streamChannelsExperiment(workspaceId, onResponse, onError, cursor) {
        if (!cursor) this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        const queryString = new URLSearchParams({
            workspaceId: workspaceId,
            ...cursor ? {
                cursor: cursor
            } : {}
        });
        (0, $9CLBJ.retryFetch)({
            request: ()=>fetch(`${(0, $5009317558281709$export$ab2f49a861856bab)}${(0, $5009317558281709$export$20875166a8676880)}${(0, $5009317558281709$export$3f9855fcc7fa383e)}?${queryString}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $9CLBJ.httpRetryPolicy)($ab74b7ecb218f477$var$RETRY_OPTIONS)
        }).then((resp)=>{
            if (!resp.ok) {
                onResponse(resp);
                return;
            }
            this.channelStream.pages++;
            this.channelStream.count += resp.result.channels.length;
            this.channelStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.channels,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamChannelsExperiment(workspaceId, onResponse, onError, resp.result.nextCursor);
        }).catch((error)=>{
            onError(error);
        });
    }
    // This was necessary since it was abstract in the base class
    // but is not used in this slack service
    async primeConsentUrl() {}
}

});


parcelRegister("aEKq5", function(module, exports) {

$parcel$export(module.exports, "fetchExistingIntegrations", () => $6ef48c28b8af317c$export$49def98438208aa5);
$parcel$export(module.exports, "search", () => $6ef48c28b8af317c$export$d76128d007d19019);
$parcel$export(module.exports, "fetchOrgSettings", () => $6ef48c28b8af317c$export$a9cfb3d0ddea2a6c);

var $el0OJ = parcelRequire("el0OJ");


var $9CLBJ = parcelRequire("9CLBJ");

var $3bpHA = parcelRequire("3bpHA");
const $6ef48c28b8af317c$var$exusThirdPartyUrl = (path)=>`${0, $5009317558281709$export$ab2f49a861856bab}${0, $5009317558281709$export$127769e597bc5ee5}/${path}`;
const $6ef48c28b8af317c$var$exusOrgsUrl = (path)=>`${0, $5009317558281709$export$ab2f49a861856bab}${0, $5009317558281709$export$8bad17bb0225d989}/${path}`;
const $6ef48c28b8af317c$export$49def98438208aa5 = async (cloudId, shouldRetry = false)=>{
    const maxAttempts = shouldRetry ? (0, $5009317558281709$export$89aa938ff9a6aec2) : 0;
    const queryString = new URLSearchParams({
        cloudId: cloudId
    });
    const fetchUrl = $6ef48c28b8af317c$var$exusThirdPartyUrl((0, $5009317558281709$export$e468596ea25b5295));
    const result = await (0, $9CLBJ.retryFetch)({
        request: ()=>fetch(`${fetchUrl}?${queryString}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }),
        canRetryCheck: (0, $9CLBJ.httpRetryPolicy)({
            maxAttempts: maxAttempts
        })
    });
    if (result.ok) return result.result;
    else if (!result.aborted) throw new (0, $9CLBJ.FetchError)(`Unable to fetch integrations, status: ${result.code} text: ${result.message}`, result.status);
};
const $6ef48c28b8af317c$export$8f22789f6b8c44c4 = (serviceKey, analytics, callback)=>{
    const url = $6ef48c28b8af317c$var$exusThirdPartyUrl(`connect?serviceKey=${serviceKey}`);
    const windowLeft = window.screen.width / 2 - (0, $5009317558281709$export$d67bd32411617d53) / 2;
    const windowTop = window.screen.height / 2 - (0, $5009317558281709$export$cce5ee914c2ec5d9) / 2;
    const options = `menubar, width=${(0, $5009317558281709$export$d67bd32411617d53)}, height=${(0, $5009317558281709$export$cce5ee914c2ec5d9)}, top=${windowTop}, left=${windowLeft}`;
    (0, $el0OJ.auth)(url, options).then(()=>{
        (0, $3bpHA.triggerAnalyticsForIntegrationConnected)(analytics.createAnalyticsEvent, serviceKey, analytics.analyticsChannel, analytics.teamId, analytics.attributes);
        callback?.(true);
    }).catch((error)=>{
        (0, $3bpHA.triggerAnalyticsForIntegrationFailed)(analytics.createAnalyticsEvent, serviceKey, analytics.analyticsChannel, error, analytics.attributes);
        callback?.(false, error);
    });
};
const $6ef48c28b8af317c$export$d76128d007d19019 = async (query, cloudId)=>{
    const queryString = new URLSearchParams({
        query: query,
        cloudId: cloudId
    });
    const fetchUrl = $6ef48c28b8af317c$var$exusThirdPartyUrl(`search?${queryString}`);
    const resp = await (0, $9CLBJ.fetchJson)(fetchUrl, (0, $5009317558281709$export$458ba67f45a7f353));
    return resp.map((d)=>{
        return {
            id: d.email,
            email: d.email,
            name: d.displayName,
            publicName: d.displayName,
            avatarUrl: d.avatarUrl,
            type: 'user',
            isExternal: true,
            sources: d.sources.map((s)=>s.toLowerCase())
        };
    });
};
const $6ef48c28b8af317c$export$a9cfb3d0ddea2a6c = async (orgId)=>{
    const fetchUrl = $6ef48c28b8af317c$var$exusOrgsUrl(`${orgId}/settings`);
    return (0, $9CLBJ.fetchJson)(fetchUrl, (0, $5009317558281709$export$bc2c06c4779f47f2));
};

});
parcelRegister("el0OJ", function(module, exports) {

$parcel$export(module.exports, "auth", () => $0d3e98f4c817bb51$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("9DkoQ")).AuthError);

var $9DkoQ = parcelRequire("9DkoQ");

var $iCnhe = parcelRequire("iCnhe");
function $0d3e98f4c817bb51$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $iCnhe.isOfTypeAuthError)(errorType)) reject(new (0, $9DkoQ.AuthError)(data.message, errorType));
                    else reject(new (0, $9DkoQ.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $9DkoQ.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("9DkoQ", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $7c990ff1a3258a51$export$145273558d58e0ac);
class $7c990ff1a3258a51$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("iCnhe", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $c1516448e949f67e$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $c1516448e949f67e$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("3bpHA", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForIntegrationConnected", () => $6f264f80f95a2e77$export$e36afdcb278d2465);
$parcel$export(module.exports, "triggerAnalyticsForIntegrationFailed", () => $6f264f80f95a2e77$export$c19a27308ae179b);


var $9Iej8 = parcelRequire("9Iej8");

var $6f264f80f95a2e77$var$AnalyticsActionSubject = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["THIRD_PARTY_INTEGRATION"] = "thirdPartyIntegration";
    return AnalyticsActionSubject;
}($6f264f80f95a2e77$var$AnalyticsActionSubject || {});
var $6f264f80f95a2e77$var$AnalyticsAction = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["CONNECTED"] = "connected";
    return AnalyticsAction;
}($6f264f80f95a2e77$var$AnalyticsAction || {});
const $6f264f80f95a2e77$export$e36afdcb278d2465 = (createAnalyticsEvent, serviceKey, analyticsChannel = (0, $5009317558281709$export$85183a312807388d), teamId, eventAttributes)=>{
    const fireEventWithPayload = (0, $9Iej8.default)(analyticsChannel)({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "thirdPartyIntegration",
        action: "connected",
        attributes: {
            integration: serviceKey,
            teamId: teamId,
            ...eventAttributes
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $6f264f80f95a2e77$export$c19a27308ae179b = (createAnalyticsEvent, serviceKey, analyticsChannel = (0, $5009317558281709$export$85183a312807388d), error, eventAttributes)=>{
    const fireEventWithPayload = (0, $9Iej8.default)(analyticsChannel)({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: "thirdPartyIntegration",
        action: "failed",
        attributes: {
            integration: serviceKey,
            errorType: error ? error.type : undefined,
            ...eventAttributes
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};

});


parcelRegister("lWbFO", function(module, exports) {

$parcel$export(module.exports, "invitePeopleRenderedTimings", () => $5a8a40c54d550684$export$a968444c71dc68c6);
$parcel$export(module.exports, "invitePeopleRendered", () => $5a8a40c54d550684$export$2a3414fdbfd8a2af);
$parcel$export(module.exports, "inviteFormSubmittedTimings", () => $5a8a40c54d550684$export$d9b2187d827ca57a);
$parcel$export(module.exports, "inviteFormSubmitted", () => $5a8a40c54d550684$export$57415b8193dc14c8);
$parcel$export(module.exports, "thirdPartyResultsLoaded", () => $5a8a40c54d550684$export$c27b328e50448605);
$parcel$export(module.exports, "controlSettingsLoaded", () => $5a8a40c54d550684$export$cdabcb904f0492f);
$parcel$export(module.exports, "domainsSettingsUpdated", () => $5a8a40c54d550684$export$323b055db80365a2);
$parcel$export(module.exports, "inviteSettingsUpdated", () => $5a8a40c54d550684$export$78c49e7734a12bcb);
$parcel$export(module.exports, "parallelInviteRequestSubmitted", () => $5a8a40c54d550684$export$f4c946ac2a44c48a);
$parcel$export(module.exports, "recaptchaLoaded", () => $5a8a40c54d550684$export$b97b16bc7fe47920);
$parcel$export(module.exports, "startUfoExperience", () => $5a8a40c54d550684$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $5a8a40c54d550684$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $5a8a40c54d550684$export$8dda83bafca11b77);
$parcel$export(module.exports, "noInvitePermissionRenderedTimings", () => $5a8a40c54d550684$export$d90144118191fa45);
$parcel$export(module.exports, "noInvitePermissionRendered", () => $5a8a40c54d550684$export$afcd850890541869);

var $gQm2p = parcelRequire("gQm2p");
var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
var $5a8a40c54d550684$export$1f2009f2d8a17b6c = /*#__PURE__*/ function(UfoExperience) {
    UfoExperience["InvitePeopleRendered"] = "invite-people-rendered";
    UfoExperience["InviteFormSubmitted"] = "invite-form-submitted";
    UfoExperience["RecaptchaExecuted"] = "recaptcha-executed";
    UfoExperience["ThirdPartyResultsLoaded"] = "third-party-results-loaded";
    UfoExperience["ExternalUsersLoaded"] = "external-users-loaded";
    UfoExperience["ControlSettingsLoaded"] = "control-settings-loaded";
    UfoExperience["NoInvitePermissionRendered"] = "no-invite-permission-rendered";
    UfoExperience["InviteSettingsUpdated"] = "invite-settings-updated";
    UfoExperience["DomainSettingsUpdated"] = "domain-settings-updated";
    UfoExperience["parallelInviteRequestSubmitted"] = "parallel-invite-request-submitted";
    UfoExperience["TeamsInviteSectionExperience"] = "teams-invite-section-experience";
    UfoExperience["RecaptchaLoaded"] = "recaptcha-loaded";
    return UfoExperience;
}({});
var $5a8a40c54d550684$var$ExperienceComponent = /*#__PURE__*/ function(ExperienceComponent) {
    ExperienceComponent["InvitePeople"] = "invite-people";
    ExperienceComponent["InviteeList"] = "invitee-list";
    return ExperienceComponent;
}($5a8a40c54d550684$var$ExperienceComponent || {});
const $5a8a40c54d550684$var$buildExperience = (performanceType, component = "invite-people", experienceType = (0, $lrUJ4.ExperienceTypes).Load)=>{
    return {
        type: experienceType,
        performanceType: performanceType,
        platform: {
            component: component
        }
    };
};
const $5a8a40c54d550684$var$createUFOTimings = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $5a8a40c54d550684$export$a968444c71dc68c6 = {
    getAccountInfo: $5a8a40c54d550684$var$createUFOTimings('get_account_info'),
    getInviteCapabilities: $5a8a40c54d550684$var$createUFOTimings('get_invite_capabilities'),
    checkEligibility: $5a8a40c54d550684$var$createUFOTimings('check_eligibility'),
    fetchOrgSettings: $5a8a40c54d550684$var$createUFOTimings('fetch_org_settings'),
    fetchExistingIntegrations: $5a8a40c54d550684$var$createUFOTimings('fetch_existing_integrations'),
    initSlack: $5a8a40c54d550684$var$createUFOTimings('init_slack'),
    getUserPermission: $5a8a40c54d550684$var$createUFOTimings('get_user_permission')
};
const $5a8a40c54d550684$export$2a3414fdbfd8a2af = new (0, $kkzI0.UFOExperience)("invite-people-rendered", {
    ...$5a8a40c54d550684$var$buildExperience((0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad),
    timings: Object.values($5a8a40c54d550684$export$a968444c71dc68c6)
});
const $5a8a40c54d550684$export$d9b2187d827ca57a = {
    updateOpenInviteSettings: $5a8a40c54d550684$var$createUFOTimings('update_open_invites_settings'),
    updateDirectAccessSettings: $5a8a40c54d550684$var$createUFOTimings('update_direct_access_settings'),
    inviteUsersPromise: $5a8a40c54d550684$var$createUFOTimings('invite_users'),
    getRecaptchaToken: $5a8a40c54d550684$var$createUFOTimings('get_recaptcha_token')
};
const $5a8a40c54d550684$export$57415b8193dc14c8 = new (0, $kkzI0.UFOExperience)("invite-form-submitted", {
    ...$5a8a40c54d550684$var$buildExperience((0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad),
    timings: Object.values($5a8a40c54d550684$export$d9b2187d827ca57a)
});
const $5a8a40c54d550684$export$c27b328e50448605 = new (0, $gQm2p.ConcurrentExperience)("third-party-results-loaded", $5a8a40c54d550684$var$buildExperience((0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad, "invitee-list"));
const $5a8a40c54d550684$export$a408090913cd7114 = new (0, $gQm2p.ConcurrentExperience)("external-users-loaded", $5a8a40c54d550684$var$buildExperience((0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad, "invitee-list"));
const $5a8a40c54d550684$export$cdabcb904f0492f = new (0, $kkzI0.UFOExperience)("control-settings-loaded", $5a8a40c54d550684$var$buildExperience((0, $lrUJ4.ExperiencePerformanceTypes).Custom));
const $5a8a40c54d550684$export$323b055db80365a2 = new (0, $kkzI0.UFOExperience)("domain-settings-updated", $5a8a40c54d550684$var$buildExperience((0, $lrUJ4.ExperiencePerformanceTypes).Custom));
const $5a8a40c54d550684$export$78c49e7734a12bcb = new (0, $kkzI0.UFOExperience)("invite-settings-updated", $5a8a40c54d550684$var$buildExperience((0, $lrUJ4.ExperiencePerformanceTypes).Custom));
const $5a8a40c54d550684$export$f4c946ac2a44c48a = new (0, $kkzI0.UFOExperience)("parallel-invite-request-submitted", $5a8a40c54d550684$var$buildExperience((0, $lrUJ4.ExperiencePerformanceTypes).Custom));
const $5a8a40c54d550684$export$b97b16bc7fe47920 = new (0, $kkzI0.UFOExperience)("recaptcha-loaded", $5a8a40c54d550684$var$buildExperience((0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad));
const $5a8a40c54d550684$export$5e9287b6a10f8075 = (ufoExperience, id, properties)=>{
    const experience = ufoExperience.getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $5a8a40c54d550684$export$c5a5cf072c836c0e = (ufoExperience, id, properties)=>{
    const experience = ufoExperience.getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $5a8a40c54d550684$export$8dda83bafca11b77 = (ufoExperience, id, properties)=>{
    const experience = ufoExperience.getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $5a8a40c54d550684$export$b1021040eb94cdca = (ufoExperience, id, properties)=>{
    const experience = ufoExperience.getInstance(id);
    experience.abort({
        metadata: properties
    });
};
const $5a8a40c54d550684$export$d90144118191fa45 = {
    getOpenInviteNote: $5a8a40c54d550684$var$createUFOTimings('get_open_invite_note')
};
const $5a8a40c54d550684$export$afcd850890541869 = new (0, $kkzI0.UFOExperience)("no-invite-permission-rendered", {
    ...$5a8a40c54d550684$var$buildExperience((0, $lrUJ4.ExperiencePerformanceTypes).PageLoad),
    timings: Object.values($5a8a40c54d550684$export$a968444c71dc68c6)
});

});
parcelRegister("gQm2p", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $a30c3a6282b0052a$export$ac1cddfee07ba6ac);

var $2eEra = parcelRequire("2eEra");

var $kkzI0 = parcelRequire("kkzI0");
class $a30c3a6282b0052a$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $kkzI0.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $2eEra.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});


parcelRegister("dgnuV", function(module, exports) {

$parcel$export(module.exports, "useOrgControlSettings", () => $034f968b04999ba4$export$eef572fe72ca98c3);

var $5uXOq = parcelRequire("5uXOq");

var $aEKq5 = parcelRequire("aEKq5");

var $lWbFO = parcelRequire("lWbFO");

var $6HEbe = parcelRequire("6HEbe");

var $79Yw4 = parcelRequire("79Yw4");

var $kx8ta = parcelRequire("kx8ta");
const $034f968b04999ba4$export$eef572fe72ca98c3 = (orgId)=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $79Yw4.ExperimentsAnalytics));
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const [settings, setData] = (0, $5uXOq.useState)({});
    (0, $5uXOq.useEffect)(()=>{
        if (!orgId) {
            setIsLoading(false);
            return;
        }
        (async ()=>{
            (0, $lWbFO.controlSettingsLoaded).start();
            setIsLoading(true);
            try {
                (0, $lWbFO.invitePeopleRendered).mark((0, $lWbFO.invitePeopleRenderedTimings).fetchOrgSettings.startMark);
                const settings = await (0, $aEKq5.fetchOrgSettings)(orgId);
                (0, $lWbFO.invitePeopleRendered).mark((0, $lWbFO.invitePeopleRenderedTimings).fetchOrgSettings.endMark);
                (0, $lWbFO.controlSettingsLoaded).success();
                setData(settings);
            } catch (error) {
                const { errorMessage: errorMessage, responseCode: responseCode } = (0, $kx8ta.resolveError)(error);
                analytics.fetchOrgSettingsFailed({
                    orgId: orgId,
                    errorMessage: errorMessage,
                    responseCode: responseCode
                });
                (0, $lWbFO.controlSettingsLoaded).failure();
            } finally{
                setIsLoading(false);
            }
        })();
    }, [
        analytics,
        orgId
    ]);
    return {
        isLoading: isLoading,
        settings: settings
    };
};

});
parcelRegister("79Yw4", function(module, exports) {

$parcel$export(module.exports, "ExperimentsAnalytics", () => $179d195f4ca144ad$export$1d5f1019c49a0a8b);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $179d195f4ca144ad$export$1d5f1019c49a0a8b extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    teamsFieldToggled(opened) {
        this.fireTrack({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).TEAM_INVITES,
            action: (0, $hatDq.AnalyticsAction).CHANGED,
            attributes: {
                opened: opened
            }
        });
    }
    teamsFieldUsersInvited(attributes) {
        this.fireTrack({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).TEAM_INVITES,
            action: (0, $hatDq.AnalyticsAction).INVITED,
            attributes: attributes
        });
    }
    fetchOrgSettingsFailed(attributes) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).FETCH_ORG_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: attributes
        });
    }
}

});


parcelRegister("e7PpL", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyIntegrationsFlags", () => $0f745a1a436005cc$export$bc49b6d3cc4ab213);

var $koVbs = parcelRequire("koVbs");

var $7p5dg = parcelRequire("7p5dg");
const $0f745a1a436005cc$export$bc49b6d3cc4ab213 = ()=>{
    const intl = (0, $koVbs.default)();
    return {
        success: (serviceKey, workspace)=>(0, $7p5dg.getSuccessIntegrationFlag)(serviceKey, intl, workspace),
        slackDisconnect: ()=>(0, $7p5dg.getSlackDisconnectedFlag)(intl)
    };
};

});
parcelRegister("7p5dg", function(module, exports) {

$parcel$export(module.exports, "getSuccessIntegrationFlag", () => $1bfc4947be935877$export$9419a7a0b292dbaa);
$parcel$export(module.exports, "getSlackDisconnectedFlag", () => $1bfc4947be935877$export$3a56bd38da99afd0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bMdrA = parcelRequire("bMdrA");


var $8TQ2j = parcelRequire("8TQ2j");

var $fn6W9 = parcelRequire("fn6W9");
const $1bfc4947be935877$export$9419a7a0b292dbaa = (serviceKey, intl, workspace)=>{
    let title;
    let description;
    switch(serviceKey){
        case 0, $8TQ2j.PLATFORM_SLACK_SERVICE:
            title = intl.formatMessage((0, $fn6W9.messages).slackConnectSuccessFlagTitle, {
                workspace: workspace
            });
            description = intl.formatMessage((0, $fn6W9.messages).slackConnectSuccessFlagDescription);
            break;
        case 0, $8TQ2j.MICROSOFT_SERVICE:
            title = intl.formatMessage((0, $fn6W9.messages).microsoftConnectSuccessFlagTitle);
            description = intl.formatMessage((0, $fn6W9.messages).microsoftConnectSuccessFlagDescription);
            break;
        case 0, $8TQ2j.GOOGLE_SERVICE:
            title = intl.formatMessage((0, $fn6W9.messages).googleConnectSuccessFlagTitle);
            description = intl.formatMessage((0, $fn6W9.messages).googleConnectSuccessFlagDescription);
            break;
    }
    return {
        appearance: 'success',
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
            label: "success",
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$exports).G400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
        }),
        title: title,
        description: description
    };
};
const $1bfc4947be935877$export$3a56bd38da99afd0 = (intl)=>{
    return {
        appearance: 'success',
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
            label: "success",
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$exports).G400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
        }),
        title: intl.formatMessage((0, $fn6W9.messages).slackDisconnectSuccessFlagTitle),
        description: intl.formatMessage((0, $fn6W9.messages).slackDiscnnectSuccessFlagDescription)
    };
};

});
var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';



parcelRegister("cyXdR", function(module, exports) {

$parcel$export(module.exports, "beginThirdPartyOauth", () => $0629f51282930daf$export$14154b2d1be1b2ff);
$parcel$export(module.exports, "mergeExternalUsers", () => $0629f51282930daf$export$6b9f91f1f35a2e37);
$parcel$export(module.exports, "manageSlackWorkspaces", () => $0629f51282930daf$export$8970233c3a7a7b7e);
$parcel$export(module.exports, "mergeAndSearchExternalUsers", () => $0629f51282930daf$export$a23f84077156f281);
$parcel$export(module.exports, "fuseFactory", () => $0629f51282930daf$export$459d5a134a493201);
$parcel$export(module.exports, "mergeAndSearchExternalTeamsOrUsers", () => $0629f51282930daf$export$9bf48c717bd26754);

var $el0OJ = parcelRequire("el0OJ");

var $9v2Tk = parcelRequire("9v2Tk");

var $8TQ2j = parcelRequire("8TQ2j");

var $z3rjp = parcelRequire("z3rjp");
function $0629f51282930daf$var$getAuthUrl(serviceKey) {
    return `${0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL}${0, $z3rjp.EXUS_THIRDPARTY_PATH}/connect?serviceKey=${serviceKey}`;
}
function $0629f51282930daf$export$14154b2d1be1b2ff(serviceKey, callback) {
    const url = $0629f51282930daf$var$getAuthUrl(serviceKey);
    const windowLeft = window.screen.width / 2 - (0, $8TQ2j.WINDOW_WIDTH) / 2;
    const windowTop = window.screen.height / 2 - (0, $8TQ2j.WINDOW_HEIGHT) / 2;
    const options = 'menubar, width=' + (0, $8TQ2j.WINDOW_WIDTH) + ', height=' + (0, $8TQ2j.WINDOW_HEIGHT) + ', top=' + windowTop + ', left=' + windowLeft;
    (0, $el0OJ.auth)(url, options).then(()=>{
        if (callback) callback(true);
    }).catch((error)=>{
        if (callback) callback(false, error);
    });
}
function $0629f51282930daf$var$deleteFalsyValues(obj) {
    Object.keys(obj).filter((k)=>!obj[k]).forEach((k)=>delete obj[k]);
    return obj;
}
function $0629f51282930daf$export$6b9f91f1f35a2e37(userLists) {
    const usersById = userLists.reduce((flatUsersList, users)=>{
        flatUsersList.push(...users);
        return flatUsersList;
    }, []).reduce((result, currentValue)=>{
        const key = currentValue.email || currentValue.id;
        if (!result[key]) result[key] = [];
        result[key].push(currentValue);
        return result;
    }, {});
    return Object.keys(usersById).map((userId)=>{
        return usersById[userId].reduce((result, currentValue)=>{
            const sources = [
                ...new Set([
                    ...result.sources,
                    ...currentValue.sources
                ])
            ];
            const mergedUser = {
                ...$0629f51282930daf$var$deleteFalsyValues(result),
                ...$0629f51282930daf$var$deleteFalsyValues(currentValue)
            };
            mergedUser.sources = sources;
            return mergedUser;
        });
    });
}
const $0629f51282930daf$export$8970233c3a7a7b7e = (isConnected, slackWorkspaces, isSlackConnectDialogOpen, openSlackConnectDialog, onSelectedSlackWorkspaceChange, product, closeModal)=>{
    if (slackWorkspaces.length === 0) {
        if (product === 'jira') {
            window.open((0, $8TQ2j.JIRA_SLACK_URL));
            if (closeModal) closeModal();
        } else if (product === 'confluence') {
            window.open((0, $8TQ2j.CONFLUENCE_SLACK_URL));
            if (closeModal) closeModal();
        }
    } else if (!isConnected && slackWorkspaces.length === 1) onSelectedSlackWorkspaceChange(slackWorkspaces[0]);
    else if (!isSlackConnectDialogOpen) openSlackConnectDialog();
};
const $0629f51282930daf$export$a23f84077156f281 = (data)=>{
    const { providedAdditionalUsers: providedAdditionalUsers, connectedThirdPartyUsers: connectedThirdPartyUsers, searchText: searchText } = data;
    const additionalUsersWithEmail = providedAdditionalUsers.filter((user)=>user.email);
    const additionalUsersWithoutEmail = providedAdditionalUsers.filter((user)=>!user.email);
    const users = $0629f51282930daf$export$6b9f91f1f35a2e37([
        additionalUsersWithEmail,
        connectedThirdPartyUsers
    ]);
    const fuse = $0629f51282930daf$export$459d5a134a493201(users);
    const searchResult = fuse.search(searchText).map((result)=>result.item);
    const searchResultWithAdditionalUsers = [
        // Unable to include additional users in search as emails are filtered via the API
        ...additionalUsersWithoutEmail.slice(0, Math.min(additionalUsersWithoutEmail.length, (0, $8TQ2j.MAX_USERS))),
        ...searchResult
    ];
    return searchResultWithAdditionalUsers.slice(0, Math.min(searchResultWithAdditionalUsers.length, (0, $8TQ2j.MAX_USERS)));
};
const $0629f51282930daf$export$9bf48c717bd26754 = (searchText, users, teams)=>{
    const teamsOrUsers = [
        ...users,
        ...teams
    ];
    const fuse = $0629f51282930daf$export$459d5a134a493201(teamsOrUsers);
    const searchResult = fuse.search(searchText).map((result)=>result.item);
    return searchResult.slice(0, Math.min(searchResult.length, (0, $8TQ2j.MAX_USERS)));
};
function $0629f51282930daf$export$459d5a134a493201(items) {
    return new (0, $9v2Tk.default)(items, {
        keys: [
            'displayName',
            'name',
            'email',
            'publicName'
        ],
        threshold: 0.2
    });
}

});
parcelRegister("9v2Tk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ea9407dd5346122$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $6ea9407dd5346122$var$isArray(value) {
    return !Array.isArray ? $6ea9407dd5346122$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $6ea9407dd5346122$var$INFINITY = 1 / 0;
function $6ea9407dd5346122$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$6ea9407dd5346122$var$INFINITY ? '-0' : result;
}
function $6ea9407dd5346122$var$toString(value) {
    return value == null ? '' : $6ea9407dd5346122$var$baseToString(value);
}
function $6ea9407dd5346122$var$isString(value) {
    return typeof value === 'string';
}
function $6ea9407dd5346122$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $6ea9407dd5346122$var$isBoolean(value) {
    return value === true || value === false || $6ea9407dd5346122$var$isObjectLike(value) && $6ea9407dd5346122$var$getTag(value) == '[object Boolean]';
}
function $6ea9407dd5346122$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $6ea9407dd5346122$var$isObjectLike(value) {
    return $6ea9407dd5346122$var$isObject(value) && value !== null;
}
function $6ea9407dd5346122$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $6ea9407dd5346122$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $6ea9407dd5346122$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $6ea9407dd5346122$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $6ea9407dd5346122$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $6ea9407dd5346122$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $6ea9407dd5346122$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $6ea9407dd5346122$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $6ea9407dd5346122$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $6ea9407dd5346122$var$hasOwn = Object.prototype.hasOwnProperty;
class $6ea9407dd5346122$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $6ea9407dd5346122$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $6ea9407dd5346122$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($6ea9407dd5346122$var$isString(key) || $6ea9407dd5346122$var$isArray(key)) {
        src = key;
        path = $6ea9407dd5346122$var$createKeyPath(key);
        id = $6ea9407dd5346122$var$createKeyId(key);
    } else {
        if (!$6ea9407dd5346122$var$hasOwn.call(key, 'name')) throw new Error($6ea9407dd5346122$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($6ea9407dd5346122$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($6ea9407dd5346122$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $6ea9407dd5346122$var$createKeyPath(name);
        id = $6ea9407dd5346122$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $6ea9407dd5346122$var$createKeyPath(key) {
    return $6ea9407dd5346122$var$isArray(key) ? key : key.split('.');
}
function $6ea9407dd5346122$var$createKeyId(key) {
    return $6ea9407dd5346122$var$isArray(key) ? key.join('.') : key;
}
function $6ea9407dd5346122$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$6ea9407dd5346122$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$6ea9407dd5346122$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($6ea9407dd5346122$var$isString(value) || $6ea9407dd5346122$var$isNumber(value) || $6ea9407dd5346122$var$isBoolean(value))) list.push($6ea9407dd5346122$var$toString(value));
            else if ($6ea9407dd5346122$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $6ea9407dd5346122$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $6ea9407dd5346122$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $6ea9407dd5346122$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $6ea9407dd5346122$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $6ea9407dd5346122$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $6ea9407dd5346122$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $6ea9407dd5346122$var$Config = {
    ...$6ea9407dd5346122$var$BasicOptions,
    ...$6ea9407dd5346122$var$MatchOptions,
    ...$6ea9407dd5346122$var$FuzzyOptions,
    ...$6ea9407dd5346122$var$AdvancedOptions
};
const $6ea9407dd5346122$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $6ea9407dd5346122$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($6ea9407dd5346122$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $6ea9407dd5346122$var$FuseIndex {
    constructor({ getFn: getFn = $6ea9407dd5346122$var$Config.getFn, fieldNormWeight: fieldNormWeight = $6ea9407dd5346122$var$Config.fieldNormWeight } = {}){
        this.norm = $6ea9407dd5346122$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($6ea9407dd5346122$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($6ea9407dd5346122$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$6ea9407dd5346122$var$isDefined(doc) || $6ea9407dd5346122$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$6ea9407dd5346122$var$isDefined(value)) return;
            if ($6ea9407dd5346122$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$6ea9407dd5346122$var$isDefined(value)) continue;
                    if ($6ea9407dd5346122$var$isString(value) && !$6ea9407dd5346122$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($6ea9407dd5346122$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($6ea9407dd5346122$var$isString(value) && !$6ea9407dd5346122$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $6ea9407dd5346122$var$createIndex(keys, docs, { getFn: getFn = $6ea9407dd5346122$var$Config.getFn, fieldNormWeight: fieldNormWeight = $6ea9407dd5346122$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $6ea9407dd5346122$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($6ea9407dd5346122$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $6ea9407dd5346122$var$parseIndex(data, { getFn: getFn = $6ea9407dd5346122$var$Config.getFn, fieldNormWeight: fieldNormWeight = $6ea9407dd5346122$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $6ea9407dd5346122$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $6ea9407dd5346122$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $6ea9407dd5346122$var$Config.distance, ignoreLocation: ignoreLocation = $6ea9407dd5346122$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $6ea9407dd5346122$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $6ea9407dd5346122$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $6ea9407dd5346122$var$MAX_BITS = 32;
function $6ea9407dd5346122$var$search(text, pattern, patternAlphabet, { location: location = $6ea9407dd5346122$var$Config.location, distance: distance = $6ea9407dd5346122$var$Config.distance, threshold: threshold = $6ea9407dd5346122$var$Config.threshold, findAllMatches: findAllMatches = $6ea9407dd5346122$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $6ea9407dd5346122$var$Config.minMatchCharLength, includeMatches: includeMatches = $6ea9407dd5346122$var$Config.includeMatches, ignoreLocation: ignoreLocation = $6ea9407dd5346122$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $6ea9407dd5346122$var$MAX_BITS) throw new Error($6ea9407dd5346122$var$PATTERN_LENGTH_TOO_LARGE($6ea9407dd5346122$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $6ea9407dd5346122$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $6ea9407dd5346122$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $6ea9407dd5346122$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $6ea9407dd5346122$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $6ea9407dd5346122$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $6ea9407dd5346122$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $6ea9407dd5346122$var$BitapSearch {
    constructor(pattern, { location: location = $6ea9407dd5346122$var$Config.location, threshold: threshold = $6ea9407dd5346122$var$Config.threshold, distance: distance = $6ea9407dd5346122$var$Config.distance, includeMatches: includeMatches = $6ea9407dd5346122$var$Config.includeMatches, findAllMatches: findAllMatches = $6ea9407dd5346122$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $6ea9407dd5346122$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $6ea9407dd5346122$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $6ea9407dd5346122$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $6ea9407dd5346122$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $6ea9407dd5346122$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $6ea9407dd5346122$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $6ea9407dd5346122$var$MAX_BITS), i);
                i += $6ea9407dd5346122$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $6ea9407dd5346122$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $6ea9407dd5346122$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $6ea9407dd5346122$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $6ea9407dd5346122$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $6ea9407dd5346122$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $6ea9407dd5346122$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $6ea9407dd5346122$var$ExactMatch extends $6ea9407dd5346122$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $6ea9407dd5346122$var$InverseExactMatch extends $6ea9407dd5346122$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $6ea9407dd5346122$var$PrefixExactMatch extends $6ea9407dd5346122$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $6ea9407dd5346122$var$InversePrefixExactMatch extends $6ea9407dd5346122$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $6ea9407dd5346122$var$SuffixExactMatch extends $6ea9407dd5346122$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $6ea9407dd5346122$var$InverseSuffixExactMatch extends $6ea9407dd5346122$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $6ea9407dd5346122$var$FuzzyMatch extends $6ea9407dd5346122$var$BaseMatch {
    constructor(pattern, { location: location = $6ea9407dd5346122$var$Config.location, threshold: threshold = $6ea9407dd5346122$var$Config.threshold, distance: distance = $6ea9407dd5346122$var$Config.distance, includeMatches: includeMatches = $6ea9407dd5346122$var$Config.includeMatches, findAllMatches: findAllMatches = $6ea9407dd5346122$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $6ea9407dd5346122$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $6ea9407dd5346122$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $6ea9407dd5346122$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $6ea9407dd5346122$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $6ea9407dd5346122$var$IncludeMatch extends $6ea9407dd5346122$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $6ea9407dd5346122$var$searchers = [
    $6ea9407dd5346122$var$ExactMatch,
    $6ea9407dd5346122$var$IncludeMatch,
    $6ea9407dd5346122$var$PrefixExactMatch,
    $6ea9407dd5346122$var$InversePrefixExactMatch,
    $6ea9407dd5346122$var$InverseSuffixExactMatch,
    $6ea9407dd5346122$var$SuffixExactMatch,
    $6ea9407dd5346122$var$InverseExactMatch,
    $6ea9407dd5346122$var$FuzzyMatch
];
const $6ea9407dd5346122$var$searchersLen = $6ea9407dd5346122$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $6ea9407dd5346122$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $6ea9407dd5346122$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $6ea9407dd5346122$var$parseQuery(pattern, options = {}) {
    return pattern.split($6ea9407dd5346122$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($6ea9407dd5346122$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $6ea9407dd5346122$var$searchersLen){
                const searcher = $6ea9407dd5346122$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $6ea9407dd5346122$var$searchersLen){
                const searcher = $6ea9407dd5346122$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $6ea9407dd5346122$var$MultiMatchSet = new Set([
    $6ea9407dd5346122$var$FuzzyMatch.type,
    $6ea9407dd5346122$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $6ea9407dd5346122$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $6ea9407dd5346122$var$Config.isCaseSensitive, includeMatches: includeMatches = $6ea9407dd5346122$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $6ea9407dd5346122$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $6ea9407dd5346122$var$Config.ignoreLocation, findAllMatches: findAllMatches = $6ea9407dd5346122$var$Config.findAllMatches, location: location = $6ea9407dd5346122$var$Config.location, threshold: threshold = $6ea9407dd5346122$var$Config.threshold, distance: distance = $6ea9407dd5346122$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $6ea9407dd5346122$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($6ea9407dd5346122$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $6ea9407dd5346122$var$registeredSearchers = [];
function $6ea9407dd5346122$var$register(...args) {
    $6ea9407dd5346122$var$registeredSearchers.push(...args);
}
function $6ea9407dd5346122$var$createSearcher(pattern, options) {
    for(let i = 0, len = $6ea9407dd5346122$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $6ea9407dd5346122$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $6ea9407dd5346122$var$BitapSearch(pattern, options);
}
const $6ea9407dd5346122$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $6ea9407dd5346122$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $6ea9407dd5346122$var$isExpression = (query)=>!!(query[$6ea9407dd5346122$var$LogicalOperator.AND] || query[$6ea9407dd5346122$var$LogicalOperator.OR]);
const $6ea9407dd5346122$var$isPath = (query)=>!!query[$6ea9407dd5346122$var$KeyType.PATH];
const $6ea9407dd5346122$var$isLeaf = (query)=>!$6ea9407dd5346122$var$isArray(query) && $6ea9407dd5346122$var$isObject(query) && !$6ea9407dd5346122$var$isExpression(query);
const $6ea9407dd5346122$var$convertToExplicit = (query)=>({
        [$6ea9407dd5346122$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $6ea9407dd5346122$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $6ea9407dd5346122$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$6ea9407dd5346122$var$isExpression(query)) return next($6ea9407dd5346122$var$convertToExplicit(query));
        if ($6ea9407dd5346122$var$isLeaf(query)) {
            const key = isQueryPath ? query[$6ea9407dd5346122$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$6ea9407dd5346122$var$KeyType.PATTERN] : query[key];
            if (!$6ea9407dd5346122$var$isString(pattern)) throw new Error($6ea9407dd5346122$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $6ea9407dd5346122$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $6ea9407dd5346122$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($6ea9407dd5346122$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$6ea9407dd5346122$var$isExpression(query)) query = $6ea9407dd5346122$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $6ea9407dd5346122$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $6ea9407dd5346122$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $6ea9407dd5346122$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$6ea9407dd5346122$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$6ea9407dd5346122$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $6ea9407dd5346122$var$transformScore(result, data) {
    data.score = result.score;
}
function $6ea9407dd5346122$var$format(results, docs, { includeMatches: includeMatches = $6ea9407dd5346122$var$Config.includeMatches, includeScore: includeScore = $6ea9407dd5346122$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($6ea9407dd5346122$var$transformMatches);
    if (includeScore) transformers.push($6ea9407dd5346122$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $6ea9407dd5346122$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$6ea9407dd5346122$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $6ea9407dd5346122$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $6ea9407dd5346122$var$FuseIndex)) throw new Error($6ea9407dd5346122$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $6ea9407dd5346122$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$6ea9407dd5346122$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $6ea9407dd5346122$var$isString(query) ? $6ea9407dd5346122$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $6ea9407dd5346122$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($6ea9407dd5346122$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $6ea9407dd5346122$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $6ea9407dd5346122$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$6ea9407dd5346122$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $6ea9407dd5346122$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $6ea9407dd5346122$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($6ea9407dd5346122$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $6ea9407dd5346122$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$6ea9407dd5346122$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$6ea9407dd5346122$var$isDefined(value)) return [];
        let matches = [];
        if ($6ea9407dd5346122$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$6ea9407dd5346122$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$6ea9407dd5346122$export$2e2bcd8739ae039.version = '6.6.2';
$6ea9407dd5346122$export$2e2bcd8739ae039.createIndex = $6ea9407dd5346122$var$createIndex;
$6ea9407dd5346122$export$2e2bcd8739ae039.parseIndex = $6ea9407dd5346122$var$parseIndex;
$6ea9407dd5346122$export$2e2bcd8739ae039.config = $6ea9407dd5346122$var$Config;
$6ea9407dd5346122$export$2e2bcd8739ae039.parseQuery = $6ea9407dd5346122$var$parse;
$6ea9407dd5346122$var$register($6ea9407dd5346122$var$ExtendedSearch);

});


parcelRegister("5lX4X", function(module, exports) {

$parcel$export(module.exports, "ThirdPartyContextAnalytics", () => $d9c873f319f66779$export$f307a6cb9ff48fb9);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $d9c873f319f66779$export$f307a6cb9ff48fb9 extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    integrationsFetched(attributes) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).THIRD_PARTY_INTEGRATIONS,
            action: (0, $hatDq.AnalyticsAction).FETCHED,
            attributes: attributes
        });
    }
    fetchExistingIntegrationsFailed(attributes) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).FETCH_EXISTING_INTEGRATIONS,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: attributes
        });
    }
    integrationConnected({ previousStatus: previousStatus = 'neverConnected', serviceKey: serviceKey, teamId: teamId, auto: auto = false }) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).THIRD_PARTY_INTEGRATION,
            action: (0, $hatDq.AnalyticsAction).CONNECTED,
            attributes: {
                integration: serviceKey,
                teamId: teamId,
                auto: auto,
                previousStatus: previousStatus
            }
        });
    }
    integrationFailed(serviceKey, error) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).THIRD_PARTY_INTEGRATION,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                integration: serviceKey,
                errorType: error ? error.type : undefined
            }
        });
    }
    sloThirdPartyInitSuccess(attributes) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).SLO_THIRD_PARTY_INIT,
            action: (0, $hatDq.AnalyticsAction).SUCCEEDED,
            attributes: attributes
        });
    }
    sloThirdPartyInitFailed(error) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).SLO_THIRD_PARTY_INIT,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                error: error
            }
        });
    }
    thirdPartyInitFailed(error) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).THIRD_PARTY_INIT,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                error: error
            }
        });
    }
    slackChannelFailed(errorMessage, status) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).SLACK_CHANNEL,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                context: 'invite-user-picker',
                pickerType: 'multi',
                errorMessage: errorMessage,
                status: status
            }
        });
    }
    getSlackChannelsSucceeded() {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).GET_SLACK_CHANNELS,
            action: (0, $hatDq.AnalyticsAction).SUCCEEDED
        });
    }
    getSlackChannelsFailed() {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).GET_SLACK_CHANNELS,
            action: (0, $hatDq.AnalyticsAction).FAILED
        });
    }
}

});

parcelRegister("bRt4Y", function(module, exports) {

$parcel$export(module.exports, "useOnChangeSelectedSlackWorkspace", () => $fa472d4a1e383a1d$export$231dc27510b9dc3b);

var $5uXOq = parcelRequire("5uXOq");

var $e7PpL = parcelRequire("e7PpL");

var $27zXU = parcelRequire("27zXU");

var $8TQ2j = parcelRequire("8TQ2j");
const $fa472d4a1e383a1d$export$231dc27510b9dc3b = ({ analytics: analytics, setSelectedSlackWorkspace: setSelectedSlackWorkspace, showFlag: showFlag })=>{
    const thirdPartyIntegrationsFlags = (0, $e7PpL.useThirdPartyIntegrationsFlags)();
    return (0, $5uXOq.useCallback)((selectedSlackWorkspace)=>{
        setSelectedSlackWorkspace(selectedSlackWorkspace);
        // We'll make sure to remove the settings for the product slack app if
        // we are using the platform slack app
        (0, $27zXU.disconnectSlackWorkSpace)();
        (0, $27zXU.setConnectedSlackWorkSpace)(selectedSlackWorkspace.id);
        analytics.integrationConnected({
            serviceKey: (0, $8TQ2j.PLATFORM_SLACK_SERVICE),
            teamId: selectedSlackWorkspace.id
        });
        if (showFlag) showFlag(thirdPartyIntegrationsFlags.success((0, $8TQ2j.PLATFORM_SLACK_SERVICE), selectedSlackWorkspace.name));
    }, [
        analytics,
        setSelectedSlackWorkspace,
        showFlag,
        thirdPartyIntegrationsFlags
    ]);
};

});

parcelRegister("2mmNQ", function(module, exports) {

$parcel$export(module.exports, "useOnConnectProvider", () => $75805c21052e2741$export$1ce02b3868b8dd2f);

var $5uXOq = parcelRequire("5uXOq");

var $fJpmn = parcelRequire("fJpmn");

var $e7PpL = parcelRequire("e7PpL");

var $8TQ2j = parcelRequire("8TQ2j");

var $cyXdR = parcelRequire("cyXdR");
const $75805c21052e2741$export$1ce02b3868b8dd2f = ({ analytics: analytics, integrations: integrations, onThirdPartyIntegrationsChange: onThirdPartyIntegrationsChange, openSlackSettings: openSlackSettings, setIsAfterSlackConnect: setIsAfterSlackConnect, showFlag: showFlag, slackWorkspaces: slackWorkspaces })=>{
    const thirdPartyIntegrationsFlags = (0, $e7PpL.useThirdPartyIntegrationsFlags)();
    return (0, $5uXOq.useCallback)((args)=>{
        const { serviceKey: serviceKey, scopeState: scopeState } = args;
        // Open slack settings instead of reconnecting if we are already
        // connected and have slack workspaces with valid scope
        if (serviceKey === (0, $8TQ2j.PLATFORM_SLACK_SERVICE) && integrations?.includes((0, $8TQ2j.PLATFORM_SLACK_SERVICE)) && slackWorkspaces.length > 0) {
            openSlackSettings();
            return;
        }
        (0, $cyXdR.beginThirdPartyOauth)(serviceKey, (success, error)=>{
            onThirdPartyIntegrationsChange().then(()=>{
                // show slack workspaces dialog if just connected platform slack
                if (success && serviceKey === (0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE) setIsAfterSlackConnect(true);
            });
            if (success) {
                analytics.integrationConnected({
                    serviceKey: serviceKey,
                    previousStatus: scopeState
                });
                if (serviceKey !== (0, $8TQ2j.PLATFORM_SLACK_SERVICE) && showFlag) showFlag(thirdPartyIntegrationsFlags.success(serviceKey));
            } else analytics.integrationFailed(serviceKey, error);
        });
    }, [
        analytics,
        integrations,
        onThirdPartyIntegrationsChange,
        openSlackSettings,
        setIsAfterSlackConnect,
        showFlag,
        slackWorkspaces.length,
        thirdPartyIntegrationsFlags
    ]);
};

});

parcelRegister("aTU7b", function(module, exports) {

$parcel$export(module.exports, "useQuerySlackChannels", () => $2b5eb8c6a45b07b8$export$d7fac9fbd6e35666);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8MliT = parcelRequire("8MliT");

var $jRUyo = parcelRequire("jRUyo");


var $fn6W9 = parcelRequire("fn6W9");

var $cyXdR = parcelRequire("cyXdR");

var $8TQ2j = parcelRequire("8TQ2j");
const $2b5eb8c6a45b07b8$export$d7fac9fbd6e35666 = ({ isEnabled: isEnabled, analytics: analytics, intl: intl, selectedSlackWorkspace: selectedSlackWorkspace, slackService: slackService })=>{
    const slackChannelSearcher = (0, $5uXOq.useRef)((0, $cyXdR.fuseFactory)([]));
    const [isLoadingFirstBatch, setLoadingFirstBatch] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isEnabled && selectedSlackWorkspace && slackService instanceof (0, $8MliT.default)) {
            slackChannelSearcher.current = (0, $cyXdR.fuseFactory)([]);
            let hasReceivedChannels = false;
            setLoadingFirstBatch(true);
            slackService.streamChannelsExperiment(selectedSlackWorkspace.id, (response)=>{
                setLoadingFirstBatch(false);
                if (response.ok) {
                    if (!hasReceivedChannels) {
                        // backend should respond with at least 1 channel
                        if (response.result.length >= 1) {
                            hasReceivedChannels = true;
                            analytics.getSlackChannelsSucceeded();
                        } else analytics.getSlackChannelsFailed();
                    }
                    response.result.forEach((channelOrGroupResult)=>{
                        const channelOrGroup = {
                            avatarUrl: (0, $d65afe1996371623$export$5bcb1a08900e562e),
                            byline: intl.formatMessage((0, $fn6W9.messages).inviteeListLabelThirdPartyTeamsSlackChannelByline),
                            id: channelOrGroupResult.id,
                            lozenge: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jRUyo.default), {}),
                            name: `# ${channelOrGroupResult.name}`,
                            sources: [
                                'slack'
                            ],
                            type: (0, $d65afe1996371623$export$2fc7d0f2376458)
                        };
                        slackChannelSearcher.current.add(channelOrGroup);
                    });
                } else if (!response.aborted) analytics.slackChannelFailed(response.message, response.status);
            }, (error)=>{
                setLoadingFirstBatch(false);
                analytics.slackChannelFailed(String(error));
            });
        } else setLoadingFirstBatch(false);
    }, [
        analytics,
        selectedSlackWorkspace,
        slackService,
        intl,
        isEnabled
    ]);
    const querySlackChannels = (0, $5uXOq.useCallback)(async (searchText)=>{
        if (!searchText || !slackChannelSearcher.current) return [];
        const searchResult = slackChannelSearcher.current.search(searchText).map((result)=>result.item);
        return searchResult.slice(0, Math.min(searchResult.length, (0, $8TQ2j.MAX_USERS)));
    }, []);
    return (0, $5uXOq.useMemo)(()=>({
            isLoadingFirstBatch: isLoadingFirstBatch,
            querySlackChannels: querySlackChannels
        }), [
        isLoadingFirstBatch,
        querySlackChannels
    ]);
};

});
parcelRegister("jRUyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $838ef9d22ac956cf$export$2e2bcd8739ae039);
/* ChevronRight.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cwX8H = parcelRequire("cwX8H");

var $5sRpy = parcelRequire("5sRpy");

const $838ef9d22ac956cf$var$styles = {
    wrapper: "_y4ti1b66"
};
var $838ef9d22ac956cf$export$2e2bcd8739ae039 = ()=>{
    const [isMouseHovered, setHoverState] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setHoverState(true), [
        setHoverState
    ]);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setHoverState(false), [
        setHoverState
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        role: "presentation",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        xcss: $838ef9d22ac956cf$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))), {
            spacing: "spacious",
            testId: "chevron-right-icon",
            label: "chevron right",
            color: `var(--ds-icon-subtle, ${isMouseHovered ? (0, $a7f8c6b391092279$export$f563ee71e9ee74cd) : (0, $a7f8c6b391092279$export$8754fc7e6d8b3000)})`,
            LEGACY_size: "large",
            LEGACY_margin: `0 ${"var(--ds-space-negative-050, -4px)"} 0 0`
        })
    });
};

});

const $d65afe1996371623$export$da46cb6a7468a9c2 = 'virality';
const $d65afe1996371623$export$2fc7d0f2376458 = 'custom';
const $d65afe1996371623$export$5bcb1a08900e562e = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzMSIgaGVpZ2h0PSIzMSIgcng9IjE1LjUiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMC43NzQ4IDE4LjM1MjJDMTAuNzc0OCAxOS4zOTEgOS45MjYxOSAyMC4yMzk2IDguODg3MzkgMjAuMjM5NkM3Ljg0ODYgMjAuMjM5NiA3IDE5LjM5MSA3IDE4LjM1MjJDNyAxNy4zMTM0IDcuODQ4NiAxNi40NjQ4IDguODg3MzkgMTYuNDY0OEgxMC43NzQ4VjE4LjM1MjJaIiBmaWxsPSIjRTAxRTVBIi8+CjxwYXRoIGQ9Ik0xMS43MjQ5IDE4LjM1MjdDMTEuNzI0OSAxNy4zMTM5IDEyLjU3MzQgMTYuNDY1MyAxMy42MTIyIDE2LjQ2NTNDMTQuNjUxIDE2LjQ2NTMgMTUuNDk5NiAxNy4zMTM5IDE1LjQ5OTYgMTguMzUyN1YyMy4wNzg1QzE1LjQ5OTYgMjQuMTE3MyAxNC42NTEgMjQuOTY1OSAxMy42MTIyIDI0Ljk2NTlDMTIuNTczNCAyNC45NjU5IDExLjcyNDkgMjQuMTE3MyAxMS43MjQ5IDIzLjA3ODVWMTguMzUyN1oiIGZpbGw9IiNFMDFFNUEiLz4KPHBhdGggZD0iTTEzLjYxMjIgMTAuNzc0OEMxMi41NzM0IDEwLjc3NDggMTEuNzI0OSA5LjkyNjE4IDExLjcyNDkgOC44ODczOUMxMS43MjQ5IDcuODQ4NTkgMTIuNTczNCA3IDEzLjYxMjIgN0MxNC42NTEgNyAxNS40OTk2IDcuODQ4NTkgMTUuNDk5NiA4Ljg4NzM5VjEwLjc3NDhIMTMuNjEyMloiIGZpbGw9IiMzNkM1RjAiLz4KPHBhdGggZD0iTTEzLjYxMzIgMTEuNzI1NkMxNC42NTIgMTEuNzI1NiAxNS41MDA2IDEyLjU3NDIgMTUuNTAwNiAxMy42MTNDMTUuNTAwNiAxNC42NTE4IDE0LjY1MiAxNS41MDA0IDEzLjYxMzIgMTUuNTAwNEg4Ljg4NzM5QzcuODQ4NiAxNS41MDA0IDcgMTQuNjUxOCA3IDEzLjYxM0M3IDEyLjU3NDIgNy44NDg2IDExLjcyNTYgOC44ODczOSAxMS43MjU2SDEzLjYxMzJaIiBmaWxsPSIjMzZDNUYwIi8+CjxwYXRoIGQ9Ik0yMS4xOTE1IDEzLjYxM0MyMS4xOTE1IDEyLjU3NDIgMjIuMDQwMSAxMS43MjU2IDIzLjA3ODkgMTEuNzI1NkMyNC4xMTc3IDExLjcyNTYgMjQuOTY2MyAxMi41NzQyIDI0Ljk2NjMgMTMuNjEzQzI0Ljk2NjMgMTQuNjUxOCAyNC4xMTc3IDE1LjUwMDQgMjMuMDc4OSAxNS41MDA0SDIxLjE5MTVWMTMuNjEzWiIgZmlsbD0iIzJFQjY3RCIvPgo8cGF0aCBkPSJNMjAuMjM4OSAxMy42MTMyQzIwLjIzODkgMTQuNjUyIDE5LjM5MDMgMTUuNTAwNiAxOC4zNTE1IDE1LjUwMDZDMTcuMzEyNyAxNS41MDA2IDE2LjQ2NDEgMTQuNjUyIDE2LjQ2NDEgMTMuNjEzMlY4Ljg4NzM5QzE2LjQ2NDEgNy44NDg1OSAxNy4zMTI3IDcgMTguMzUxNSA3QzE5LjM5MDMgNyAyMC4yMzg5IDcuODQ4NTkgMjAuMjM4OSA4Ljg4NzM5VjEzLjYxMzJaIiBmaWxsPSIjMkVCNjdEIi8+CjxwYXRoIGQ9Ik0xOC4zNTI3IDIxLjE5MTRDMTkuMzkxNSAyMS4xOTE0IDIwLjI0MDEgMjIuMDQgMjAuMjQwMSAyMy4wNzg4QzIwLjI0MDEgMjQuMTE3NiAxOS4zOTE1IDI0Ljk2NjIgMTguMzUyNyAyNC45NjYyQzE3LjMxMzkgMjQuOTY2MiAxNi40NjUzIDI0LjExNzYgMTYuNDY1MyAyMy4wNzg4VjIxLjE5MTRIMTguMzUyN1oiIGZpbGw9IiNFQ0IyMkUiLz4KPHBhdGggZD0iTTE4LjM1MjQgMjAuMjM5NkMxNy4zMTM2IDIwLjIzOTYgMTYuNDY1IDE5LjM5MSAxNi40NjUgMTguMzUyMkMxNi40NjUgMTcuMzEzNCAxNy4zMTM2IDE2LjQ2NDggMTguMzUyNCAxNi40NjQ4SDIzLjA3ODJDMjQuMTE3IDE2LjQ2NDggMjQuOTY1NiAxNy4zMTM0IDI0Ljk2NTYgMTguMzUyMkMyNC45NjU2IDE5LjM5MSAyNC4xMTcgMjAuMjM5NiAyMy4wNzgyIDIwLjIzOTZIMTguMzUyNFoiIGZpbGw9IiNFQ0IyMkUiLz4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzMSIgaGVpZ2h0PSIzMSIgcng9IjE1LjUiIHN0cm9rZT0iI0RGRTFFNiIvPgo8L3N2Zz4K';
const $d65afe1996371623$export$cd5b61e2523869c9 = 'confluence.ondemand.activationDate';
const $d65afe1996371623$export$f54381c274f897fb = 'jira-software.ondemand.activationDate';
const $d65afe1996371623$export$ad9850d60736acbb = 'jira-software';
const $d65afe1996371623$export$c04487fe1ed80406 = 'firstIntentToInvite';


parcelRegister("e6nNA", function(module, exports) {

$parcel$export(module.exports, "useUsersByThirdPartyId", () => $cf2924af47abe3dd$export$e0935aa995f7eb20);

var $5uXOq = parcelRequire("5uXOq");
const $cf2924af47abe3dd$var$getThirdPartyUsersKey = (source, id)=>`${source}:${id}`;
const $cf2924af47abe3dd$export$e0935aa995f7eb20 = ()=>{
    const usersByThirdPartyId = (0, $5uXOq.useRef)(new Map());
    const getUserByThirdPartyId = (0, $5uXOq.useCallback)((source, id)=>usersByThirdPartyId.current.get($cf2924af47abe3dd$var$getThirdPartyUsersKey(source, id)), []);
    const cacheUserByThirdPartyId = (0, $5uXOq.useCallback)((source, id, user)=>usersByThirdPartyId.current.set($cf2924af47abe3dd$var$getThirdPartyUsersKey(source, id), user), []);
    return {
        getUserByThirdPartyId: getUserByThirdPartyId,
        cacheUserByThirdPartyId: cacheUserByThirdPartyId
    };
};

});

parcelRegister("vt9aE", function(module, exports) {

$parcel$export(module.exports, "useInviteThirdPartyTeamsEligibility", () => $d46b11caad6e2628$export$d42c865bede0c02d);

var $5uXOq = parcelRequire("5uXOq");

var $fJpmn = parcelRequire("fJpmn");
var $hatDq = parcelRequire("hatDq");

var $kx8ta = parcelRequire("kx8ta");

var $koVbs = parcelRequire("koVbs");

var $444qv = parcelRequire("444qv");

var $daXvt = parcelRequire("daXvt");

var $6HEbe = parcelRequire("6HEbe");

var $79Yw4 = parcelRequire("79Yw4");
const $d46b11caad6e2628$export$d42c865bede0c02d = ({ isThirdPartyStateLoading: isThirdPartyStateLoading, integrations: integrations, enabledIntegrations: enabledIntegrations })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $79Yw4.ExperimentsAnalytics));
    const [isLoading, setLoading] = (0, $5uXOq.useState)(true);
    const [isEnabled, setEnabled] = (0, $5uXOq.useState)(false);
    const [onSlackConnected, setOnSlackConnected] = (0, $5uXOq.useState)(false);
    const { locale: locale } = (0, $koVbs.default)();
    const { inviteThirdPartyTeams: inviteThirdPartyTeams } = (0, $444qv.useExperimentalFeatures)();
    const { cloudId: cloudId } = (0, $daXvt.useInvitePeopleContext)();
    const setOnSlackConnectedDelayed = ()=>{
        // Delay slack spotlight from appearing.
        setTimeout(()=>setOnSlackConnected(true), 100);
    };
    const isSlackConnected = (0, $5uXOq.useMemo)(()=>integrations.has((0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE), [
        integrations
    ]);
    const isSlackEnabled = (0, $5uXOq.useMemo)(()=>enabledIntegrations.has((0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE), [
        enabledIntegrations
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isThirdPartyStateLoading) return;
        if (!cloudId) {
            setLoading(false);
            setEnabled(false);
            return;
        }
        const ineligibilityReasons = [];
        if (!isSlackEnabled) ineligibilityReasons.push((0, $hatDq.InviteThirdPartyTeamsIneligibilityReasons).ORG_CONTROL_SETTINGS_OFF);
        if (!isSlackConnected) ineligibilityReasons.push((0, $hatDq.InviteThirdPartyTeamsIneligibilityReasons).SLACK_NOT_CONNECTED);
        if ((0, $kx8ta.isMobile)()) ineligibilityReasons.push((0, $hatDq.InviteThirdPartyTeamsIneligibilityReasons).MOBILE);
        setEnabled(ineligibilityReasons.length === 0);
        setLoading(false);
    }, [
        analytics,
        cloudId,
        isSlackConnected,
        locale,
        isThirdPartyStateLoading,
        inviteThirdPartyTeams,
        isSlackEnabled
    ]);
    return {
        isLoading: isLoading,
        isEnabled: isEnabled,
        onSlackConnected: onSlackConnected,
        setOnSlackConnected: setOnSlackConnectedDelayed
    };
};

});


parcelRegister("iTzFN", function(module, exports) {

$parcel$export(module.exports, "ThirdPartyAnalytics", () => $51b1486a72032bba$export$fd3aba480a4de341);

var $hatDq = parcelRequire("hatDq");
var $fJpmn = parcelRequire("fJpmn");

var $lp06J = parcelRequire("lp06J");
const $51b1486a72032bba$export$4ebc92125c7b235c = 'noScopeMessage';
const $51b1486a72032bba$export$e25e35805e13a213 = 'partialScopeMessage';
const $51b1486a72032bba$var$THIRD_PARTY_DROPDOWN_MENU = 'thirdPartyDropdownMenu';
const $51b1486a72032bba$var$SLACK_CONNECT_MODAL = 'slackConnectModal';
const $51b1486a72032bba$export$2707ebe13f6c03b7 = {
    ADD_NOW: 'addNow',
    ADD_SLACK_ACCOUNTS: 'addSlackAccounts',
    DISCONNECT: 'disconnect',
    DONE: 'done',
    INTEGRATION_SETTINGS: 'integrationSettings',
    MAYBE_LATER: 'maybeLater',
    SHOW_ME_HOW: 'showMeHow'
};
class $51b1486a72032bba$export$fd3aba480a4de341 extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    updateConnectionShown(serviceKey, scope) {
        const name = scope === (0, $fJpmn.ScopeState).NO_SCOPE ? $51b1486a72032bba$export$4ebc92125c7b235c : $51b1486a72032bba$export$e25e35805e13a213;
        this.fireScreen({
            name: name,
            attributes: {
                integration: serviceKey
            }
        });
    }
    updateWarningClicked(serviceKey, orgId, scopeState) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).LINK,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubjectId).UPDATE_WARNING,
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            attributes: {
                integration: serviceKey,
                orgId: orgId,
                scopeState: scopeState
            }
        });
    }
    scopeUpdateButtonClicked(serviceKey, scopeState) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubjectId).CONTINUE_UPDATE,
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            attributes: {
                integration: serviceKey,
                scopeState: scopeState
            }
        });
    }
    integrationSettingsButtonClicked(serviceKey, orgId) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: $51b1486a72032bba$export$2707ebe13f6c03b7.INTEGRATION_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            attributes: {
                integration: serviceKey,
                orgId: orgId
            }
        });
    }
    thirdPartyDropdownMenuShown(thirdParty, orgId) {
        this.fireScreen({
            name: $51b1486a72032bba$var$THIRD_PARTY_DROPDOWN_MENU,
            attributes: {
                thirdParty: thirdParty,
                orgId: orgId
            }
        });
    }
    slackConnectModalShown() {
        this.fireScreen({
            name: $51b1486a72032bba$var$SLACK_CONNECT_MODAL
        });
    }
    slackDoneButtonClicked(teamId) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: $51b1486a72032bba$export$2707ebe13f6c03b7.DONE,
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            attributes: {
                selectedTeamId: teamId
            }
        });
    }
    slackDisconnectButtonClicked(teamId) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: $51b1486a72032bba$export$2707ebe13f6c03b7.DISCONNECT,
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            attributes: {
                selectedTeamId: teamId
            }
        });
    }
    connectButtonClicked(serviceKey) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubjectId).CONNECT,
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            attributes: {
                integration: serviceKey,
                source: this.commonAttributes.source
            }
        });
    }
}

});

parcelRegister("86tbn", function(module, exports) {

$parcel$export(module.exports, "useInviteThirdPartyTeams", () => $49a8e668db8dd665$export$1a601b84cb44d67b);

var $dCNWF = parcelRequire("dCNWF");
const $49a8e668db8dd665$export$1a601b84cb44d67b = ()=>(0, $dCNWF.useThirdPartyState)().inviteThirdPartyTeams;

});


parcelRegister("8650U", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $1ca423c023a0baf9$export$d9b273488cd8ce6f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $1Seuh = parcelRequire("1Seuh");

var $j7m8K = parcelRequire("j7m8K");

var $elaEw = parcelRequire("elaEw");

var $84G45 = parcelRequire("84G45");

var $dCNWF = parcelRequire("dCNWF");

var $eDhuZ = parcelRequire("eDhuZ");

var $ejkBi = parcelRequire("ejkBi");

var $daXvt = parcelRequire("daXvt");

var $fn6W9 = parcelRequire("fn6W9");
const $1ca423c023a0baf9$export$d9b273488cd8ce6f = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { userRole: userRole } = (0, $daXvt.useInvitePeopleContext)();
    // Enabled integrations are to show Connect To menu items
    // Connected integrations are to show Revoke menu items
    const { integrations: connectedIntegrations } = (0, $dCNWF.useThirdPartyState)();
    const relevantIntegrationSize = connectedIntegrations.size;
    const thirdPartyMenuGroup = relevantIntegrationSize > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eDhuZ.default), {}) : null;
    const adminMenuGroup = (0, $84G45.qualifiesForViralSettings)(userRole) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ejkBi.default), {}) : null;
    if (!adminMenuGroup && !thirdPartyMenuGroup) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": "testId-invite-people-dropdown-menu",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j7m8K.default), {
            placement: "bottom-end",
            zIndex: 560,
            trigger: ({ triggerRef: triggerRef, ...providedProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    ...providedProps,
                    ref: triggerRef,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($elaEw))),
                    label: formatMessage((0, $fn6W9.messages).formMoreActionsButtonLabel),
                    appearance: "subtle"
                }),
            testId: "testId-invite-people-dropdown-menu",
            children: [
                thirdPartyMenuGroup,
                adminMenuGroup
            ]
        })
    });
};
var $1ca423c023a0baf9$export$2e2bcd8739ae039 = $1ca423c023a0baf9$export$d9b273488cd8ce6f;

});
parcelRegister("84G45", function(module, exports) {

$parcel$export(module.exports, "USER_PICKER_ID", () => $c0274483f823f2c5$export$fec77d3db2f319e5);
$parcel$export(module.exports, "TEAM_OR_USER_PICKER_ID", () => $c0274483f823f2c5$export$518dae76d6af34f8);
$parcel$export(module.exports, "qualifiesForViralSettings", () => $c0274483f823f2c5$export$6bcb65c6ec0ed966);

var $6HEbe = parcelRequire("6HEbe");

var $lp06J = parcelRequire("lp06J");

var $gOE0R = parcelRequire("gOE0R");
const $c0274483f823f2c5$export$b3f21e4c1b35ac72 = 'CreateableSelect';
const $c0274483f823f2c5$export$fec77d3db2f319e5 = 'UserPicker';
const $c0274483f823f2c5$export$518dae76d6af34f8 = 'TeamOrUserPicker';
const $c0274483f823f2c5$export$6bcb65c6ec0ed966 = (role)=>role === 'admin';

});

parcelRegister("eDhuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $127a9be5c1f5563f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3jAdT = parcelRequire("3jAdT");

var $fn6W9 = parcelRequire("fn6W9");

var $6HEbe = parcelRequire("6HEbe");

var $dOhiJ = parcelRequire("dOhiJ");

var $chonD = parcelRequire("chonD");

var $dCNWF = parcelRequire("dCNWF");

var $6ZOwv = parcelRequire("6ZOwv");
const $127a9be5c1f5563f$var$ThirdPartyMenuGroup = ()=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $6ZOwv.DropdownMenuAnalytics));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { enabledIntegrations: enabledIntegrations, integrations: connectedIntegrations, onConnectProvider: onConnectProvider, onDisconnectProvider: onDisconnectProvider } = (0, $dCNWF.useThirdPartyState)();
    const connectableIntegrations = (0, $5uXOq.useMemo)(()=>[
            ...enabledIntegrations
        ].filter((itg)=>!connectedIntegrations.has(itg)), [
        connectedIntegrations,
        enabledIntegrations
    ]);
    const handleConnectItemClick = (0, $5uXOq.useCallback)((serviceKey)=>()=>{
            analytics.dropdownMenuItemClicked({
                actionSubjectId: 'connectIntegration',
                attributes: {
                    integration: serviceKey
                }
            });
            if (onConnectProvider) onConnectProvider({
                serviceKey: serviceKey
            });
        }, [
        analytics,
        onConnectProvider
    ]);
    const handleManageConnectionItemClick = (0, $5uXOq.useCallback)((serviceKey)=>()=>{
            analytics.dropdownMenuItemClicked({
                actionSubjectId: 'manageIntegration',
                attributes: {
                    integration: serviceKey
                }
            });
            if (onDisconnectProvider) onDisconnectProvider(serviceKey);
        }, [
        analytics,
        onDisconnectProvider
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            connectableIntegrations.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3jAdT.default), {
                title: formatMessage((0, $fn6W9.messages).connectToDropdownItemGroupTitle),
                children: connectableIntegrations.map((integration)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dOhiJ.default), {
                        onClick: handleConnectItemClick(integration),
                        integration: integration
                    }, `${integration}`))
            }),
            connectedIntegrations.size > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3jAdT.default), {
                title: formatMessage((0, $fn6W9.messages).manageConnectionsDropItemGroupTitle),
                children: [
                    ...connectedIntegrations
                ].map((integration)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $chonD.default), {
                        onClick: handleManageConnectionItemClick(integration),
                        integration: integration
                    }, `${integration}`))
            })
        ]
    });
};
var $127a9be5c1f5563f$export$2e2bcd8739ae039 = $127a9be5c1f5563f$var$ThirdPartyMenuGroup;

});
parcelRegister("dOhiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e66bf603965e95f1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1eETS = parcelRequire("1eETS");

var $52kUs = parcelRequire("52kUs");
const $e66bf603965e95f1$var$ConnectIntegrationMenuItem = ({ integration: integration, onClick: onClick })=>{
    const { icon: icon, connectButtonText: connectButtonText } = (0, $52kUs.useIntegrationComponents)(integration);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
        testId: `${integration}-connect-menu-item`,
        elemBefore: icon,
        onClick: onClick,
        children: connectButtonText
    });
};
var $e66bf603965e95f1$export$2e2bcd8739ae039 = $e66bf603965e95f1$var$ConnectIntegrationMenuItem;

});
parcelRegister("52kUs", function(module, exports) {

$parcel$export(module.exports, "useIntegrationComponents", () => $f7472372fb680b2a$export$9da1038490aaa764);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $fLNVv = parcelRequire("fLNVv");

var $STeDz = parcelRequire("STeDz");

var $g7ZGR = parcelRequire("g7ZGR");

var $fn6W9 = parcelRequire("fn6W9");

var $8TQ2j = parcelRequire("8TQ2j");
const $f7472372fb680b2a$var$ICON_HEIGHT = 16;
const $f7472372fb680b2a$var$ICON_WIDTH = $f7472372fb680b2a$var$ICON_HEIGHT;
const $f7472372fb680b2a$export$9da1038490aaa764 = (integration)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let icon = null;
    let connectButtonText = null;
    let toolTip = null;
    switch(integration){
        case 0, $8TQ2j.PLATFORM_SLACK_SERVICE:
            icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g7ZGR.SlackIcon), {
                height: $f7472372fb680b2a$var$ICON_HEIGHT,
                width: $f7472372fb680b2a$var$ICON_WIDTH
            }, integration);
            connectButtonText = formatMessage((0, $fn6W9.messages).slackThirdPartyButton);
            toolTip = formatMessage((0, $fn6W9.messages).slackThirdPartyConnectedTooltip);
            break;
        case 0, $8TQ2j.GOOGLE_SERVICE:
            icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNVv.GoogleIcon), {
                height: $f7472372fb680b2a$var$ICON_HEIGHT,
                width: $f7472372fb680b2a$var$ICON_WIDTH
            }, integration);
            connectButtonText = formatMessage((0, $fn6W9.messages).googleThirdPartyButton);
            toolTip = formatMessage((0, $fn6W9.messages).googleThirdPartyConnectedTooltip);
            break;
        case 0, $8TQ2j.MICROSOFT_SERVICE:
            icon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $STeDz.MicrosoftIcon), {
                height: $f7472372fb680b2a$var$ICON_HEIGHT,
                width: $f7472372fb680b2a$var$ICON_WIDTH
            }, integration);
            connectButtonText = formatMessage((0, $fn6W9.messages).microsoftThirdPartyButton);
            toolTip = formatMessage((0, $fn6W9.messages).microsoftThirdPartyConnectedTooltip);
            break;
    }
    return {
        icon: icon,
        connectButtonText: connectButtonText,
        toolTip: toolTip
    };
};

});
parcelRegister("fLNVv", function(module, exports) {

$parcel$export(module.exports, "GoogleIcon", () => $f716f38c744ae26f$export$6314f2dd65e45f24);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // TODO : https://product-fabric.atlassian.net/browse/DSP-3537

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $f716f38c744ae26f$export$6314f2dd65e45f24(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.6412 6.42664L20.0279 3.11999C17.9479 1.18666 15.2413 0 12.0012 0C7.30792 0 3.25458 2.69332 1.28125 6.6133L5.16125 9.62662C6.13458 6.7333 8.82792 4.63998 12.0012 4.63998C14.2546 4.63998 15.7746 5.61331 16.6412 6.42664Z",
                fill: "#EB4335"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.52 12.2666C23.52 11.2799 23.44 10.5599 23.2667 9.81323H12V14.2665H18.6133C18.48 15.3732 17.76 17.0399 16.16 18.1599L19.9467 21.0932C22.2133 18.9999 23.52 15.9199 23.52 12.2666V12.2666V12.2666Z",
                fill: "#4285F4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.17333 14.3732C4.92 13.6266 4.77333 12.8266 4.77333 11.9999C4.77333 11.1733 4.92 10.3733 5.16 9.6266L1.28 6.61328C0.466667 8.23994 0 10.0666 0 11.9999C0 13.9332 0.466667 15.7599 1.28 17.3866L5.17333 14.3732V14.3732Z",
                fill: "#FBBC05"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0006 24C15.2406 24 17.9606 22.9334 19.9473 21.0934L16.1606 18.1601C15.1473 18.8667 13.7873 19.3601 12.0006 19.3601C8.82728 19.3601 6.13394 17.2667 5.17394 14.3734L1.29395 17.3867C3.26728 21.3067 7.30728 24 12.0006 24V24V24Z",
                fill: "#34A853"
            })
        ]
    });
}

});

parcelRegister("STeDz", function(module, exports) {

$parcel$export(module.exports, "MicrosoftIcon", () => $f2b71c08382aa5fd$export$ad6b83e535366949);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // TODO : https://product-fabric.atlassian.net/browse/DSP-3537

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $f2b71c08382aa5fd$export$ad6b83e535366949(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M0.5 0H11.9047V11.4047H0.5V0Z",
                        fill: "#F25022"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M13.0952 0H24.4999V11.4047H13.0952V0Z",
                        fill: "#7FBA00"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M0.5 12.5955H11.9047V24.0001H0.5V12.5955Z",
                        fill: "#00A4EF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M13.0952 12.5955H24.4999V24.0001H13.0952V12.5955Z",
                        fill: "#FFB900"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "24",
                        height: "23.9999",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
}

});

parcelRegister("g7ZGR", function(module, exports) {

$parcel$export(module.exports, "SlackIcon", () => $e158bdaeda8f772e$export$b33fb54b08bb6422);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // TODO : https://product-fabric.atlassian.net/browse/DSP-3537

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $e158bdaeda8f772e$export$b33fb54b08bb6422(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M5.53305 15.1364C5.53305 16.5215 4.40159 17.6529 3.01653 17.6529C1.63146 17.6529 0.5 16.5215 0.5 15.1364C0.5 13.7513 1.63146 12.6199 3.01653 12.6199H5.53305V15.1364Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M6.7998 15.1373C6.7998 13.7522 7.93127 12.6207 9.31633 12.6207C10.7014 12.6207 11.8329 13.7522 11.8329 15.1373V21.4383C11.8329 22.8234 10.7014 23.9548 9.31633 23.9548C7.93127 23.9548 6.7998 22.8234 6.7998 21.4383V15.1373Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M9.31633 5.03305C7.93127 5.03305 6.7998 3.90159 6.7998 2.51653C6.7998 1.13146 7.93127 0 9.31633 0C10.7014 0 11.8329 1.13146 11.8329 2.51653V5.03305H9.31633Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M9.3176 6.30078C10.7027 6.30078 11.8341 7.43224 11.8341 8.81731C11.8341 10.2024 10.7027 11.3338 9.3176 11.3338H3.01653C1.63146 11.3338 0.5 10.2024 0.5 8.81731C0.5 7.43224 1.63146 6.30078 3.01653 6.30078H9.3176Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M19.4219 8.81731C19.4219 7.43224 20.5533 6.30078 21.9384 6.30078C23.3235 6.30078 24.4549 7.43224 24.4549 8.81731C24.4549 10.2024 23.3235 11.3338 21.9384 11.3338H19.4219V8.81731Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M18.1517 8.8176C18.1517 10.2027 17.0202 11.3341 15.6352 11.3341C14.2501 11.3341 13.1187 10.2027 13.1187 8.8176V2.51653C13.1187 1.13146 14.2501 0 15.6352 0C17.0202 0 18.1517 1.13146 18.1517 2.51653V8.8176Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M15.6371 18.9215C17.0222 18.9215 18.1537 20.053 18.1537 21.438C18.1537 22.8231 17.0222 23.9546 15.6371 23.9546C14.2521 23.9546 13.1206 22.8231 13.1206 21.438V18.9215H15.6371Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M15.6366 17.6529C14.2516 17.6529 13.1201 16.5215 13.1201 15.1364C13.1201 13.7513 14.2516 12.6199 15.6366 12.6199H21.9377C23.3228 12.6199 24.4542 13.7513 24.4542 15.1364C24.4542 16.5215 23.3228 17.6529 21.9377 17.6529H15.6366Z",
                        fill: "#ECB22E"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "24",
                        height: "23.9999",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
}

});



parcelRegister("chonD", function(module, exports) {

$parcel$export(module.exports, "default", () => $41458c2e6767bfaf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $1eETS = parcelRequire("1eETS");

var $fJpmn = parcelRequire("fJpmn");

var $fn6W9 = parcelRequire("fn6W9");
const $41458c2e6767bfaf$var$ManageIntegrationMenuItem = ({ integration: integration, onClick: onClick })=>{
    const menuTitle = (0, $5uXOq.useMemo)(()=>{
        switch(integration){
            case (0, $fJpmn.Integration).GOOGLE_SERVICE:
                return (0, $fn6W9.messages).revokeGoogleMenuItemTitle;
            case (0, $fJpmn.Integration).MICROSOFT_SERVICE:
                return (0, $fn6W9.messages).revokeMicrosoftMenuItemTitle;
            case (0, $fJpmn.Integration).PLATFORM_SLACK_SERVICE:
                return (0, $fn6W9.messages).manageSlackMenuItemTitle;
        }
        return undefined;
    }, [
        integration
    ]);
    if (!menuTitle) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
        testId: `manage-${integration}-integration-menu-item`,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...menuTitle
        })
    });
};
var $41458c2e6767bfaf$export$2e2bcd8739ae039 = $41458c2e6767bfaf$var$ManageIntegrationMenuItem;

});

parcelRegister("6ZOwv", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuAnalytics", () => $1c73d710050702a1$export$eb38bfb0a571f3e4);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $1c73d710050702a1$export$eb38bfb0a571f3e4 extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    dropdownMenuItemClicked(analyticsContext = {
        attributes: {}
    }) {
        this.fireUI({
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).DROPDOWN_ITEM,
            actionSubjectId: analyticsContext.actionSubjectId,
            attributes: analyticsContext.attributes
        });
    }
}

});


parcelRegister("ejkBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e188a8ee3c3696$export$2e2bcd8739ae039);
/* AdminMenuGroup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $2Do6f = parcelRequire("2Do6f");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $k9nuy = parcelRequire("k9nuy");

var $6HEbe = parcelRequire("6HEbe");

var $kx8ta = parcelRequire("kx8ta");

var $fn6W9 = parcelRequire("fn6W9");

var $6ZOwv = parcelRequire("6ZOwv");

var $daXvt = parcelRequire("daXvt");
const $39e188a8ee3c3696$var$styles = {
    dropdownItemIcon: "_2hwxu2gc"
};
const $39e188a8ee3c3696$var$AdminMenuGroup = ()=>{
    const invitePeopleData = (0, $daXvt.useInvitePeopleContext)();
    const cloudId = invitePeopleData.cloudId ?? '';
    const analytics = (0, $6HEbe.useAnalytics)((0, $6ZOwv.DropdownMenuAnalytics));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const adminMenuTitle = formatMessage((0, $fn6W9.messages).adminDropdownItemGroupTitle);
    const onSiteAccessSettingsMenuItemClick = (0, $5uXOq.useCallback)(()=>{
        analytics.dropdownMenuItemClicked({
            actionSubjectId: 'siteAccessSettingsLink'
        });
    }, [
        analytics
    ]);
    const onUserManagementMenuItemClick = (0, $5uXOq.useCallback)(()=>{
        analytics.dropdownMenuItemClicked({
            actionSubjectId: 'userManagementLink'
        });
    }, [
        analytics
    ]);
    const userManagementMenuItem = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
            testId: "testId-invite-people-user-management-menu-item",
            href: (0, $kx8ta.adminHubManageUsersHref)(cloudId),
            onClick: onUserManagementMenuItemClick,
            target: "new",
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        as: "span",
                        xcss: $39e188a8ee3c3696$var$styles.dropdownItemIcon,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Do6f))), {
                            color: "currentColor",
                            label: "open",
                            LEGACY_size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $fn6W9.messages).formUserManagementLabel
                        })
                    })
                ]
            })
        });
    }, [
        cloudId,
        onUserManagementMenuItemClick
    ]);
    const siteAccessSettingsMenuItem = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
            testId: "testId-invite-people-manage-access-settings-menu-item",
            href: `${(0, $kx8ta.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
            onClick: onSiteAccessSettingsMenuItemClick,
            target: "new",
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        as: "span",
                        xcss: $39e188a8ee3c3696$var$styles.dropdownItemIcon,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Do6f))), {
                            color: "currentColor",
                            label: "open",
                            LEGACY_size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $fn6W9.messages).formManageAccessSettingsLabel
                        })
                    })
                ]
            })
        });
    }, [
        cloudId,
        onSiteAccessSettingsMenuItemClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3jAdT.default), {
        title: adminMenuTitle,
        children: [
            userManagementMenuItem,
            siteAccessSettingsMenuItem
        ]
    });
};
var $39e188a8ee3c3696$export$2e2bcd8739ae039 = $39e188a8ee3c3696$var$AdminMenuGroup;

});


parcelRegister("5FXAI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8925538e1f746e73$export$2e2bcd8739ae039);
/* FormTitle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bWfiu = parcelRequire("bWfiu");

var $5sRpy = parcelRequire("5sRpy");

var $fn6W9 = parcelRequire("fn6W9");

var $kx8ta = parcelRequire("kx8ta");

var $daXvt = parcelRequire("daXvt");
const $8925538e1f746e73$var$styles = {
    wrapper: "_1q511ejb _85i5v77o"
};
const $8925538e1f746e73$var$FormTitle = ({ productOptions: productOptions, selectedProducts: selectedProducts, titleId: titleId })=>{
    const { jiraSubProduct: jiraSubProduct, productTitle: productTitle } = (0, $daXvt.useInvitePeopleContext)();
    const getProductForTitle = (0, $5uXOq.useCallback)(()=>{
        if (selectedProducts.length === 1) {
            const selectedOption = (productOptions || []).find(({ value: value })=>value === selectedProducts[0]);
            if (selectedOption) {
                const isJiraProduct = [
                    (0, $kx8ta.JiraWorkManagementProduct).id,
                    (0, $kx8ta.JiraSoftwareProduct).id
                ].includes(selectedOption.value);
                return isJiraProduct ? (0, $kx8ta.JiraProduct).label : selectedOption.label;
            } else return !!jiraSubProduct ? (0, $kx8ta.getProductTitle)(jiraSubProduct) : productTitle;
        }
        return null;
    }, [
        productTitle,
        productOptions,
        jiraSubProduct,
        selectedProducts
    ]);
    const selectedProductTitle = getProductForTitle();
    const formattedSelectedProductTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $fn6W9.messages).formTitleProduct,
        values: {
            product: selectedProductTitle
        }
    });
    const formattedDefaultTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $fn6W9.messages).formTitle
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $8925538e1f746e73$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
            as: "h1",
            id: titleId ?? 'invite-people-title',
            size: "medium",
            children: !!selectedProductTitle ? formattedSelectedProductTitle : formattedDefaultTitle
        })
    });
};
var $8925538e1f746e73$export$2e2bcd8739ae039 = $8925538e1f746e73$var$FormTitle;

});

parcelRegister("fJtAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d14f4918580f19c8$export$2e2bcd8739ae039);
/* InvitePeopleForm.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bWfiu = parcelRequire("bWfiu");

var $5sRpy = parcelRequire("5sRpy");

var $fwW2H = parcelRequire("fwW2H");

var $e3724 = parcelRequire("e3724");

var $hLdbz = parcelRequire("hLdbz");
var $dCNWF = parcelRequire("dCNWF");

var $hofb1 = parcelRequire("hofb1");
var $jmZyU = parcelRequire("jmZyU");

var $3nIQz = parcelRequire("3nIQz");

var $dVJUv = parcelRequire("dVJUv");

var $4zFDR = parcelRequire("4zFDR");

var $fn6W9 = parcelRequire("fn6W9");

var $1PtjI = parcelRequire("1PtjI");

var $daXvt = parcelRequire("daXvt");
const $d14f4918580f19c8$var$styles = {
    form: "_19pkze3t _otyr1ejb",
    formSection: "_otyrpxbi"
};
const $d14f4918580f19c8$var$InvitePeopleForm = ({ shouldRenderProductSelect: shouldRenderProductSelect, productOptions: productOptions, handleProductSelectMenuOpen: handleProductSelectMenuOpen, showEmptyError: showEmptyError, maxNumberOfInputs: maxNumberOfInputs, onInviteeListChange: onInviteeListChange, selectedProducts: selectedProducts, showSecondarySection: showSecondarySection, recaptcha: recaptcha, setRecaptcha: setRecaptcha })=>{
    const { isOk: enableThirdPartyInvites, integrations: thirdPartyIntegrations, isConnected: thirdPartyConnected } = (0, $dCNWF.useThirdPartyState)();
    const { plugins: plugins, invitePromptOnLinkV3Cohort: invitePromptOnLinkV3Cohort } = (0, $daXvt.useInvitePeopleContext)();
    const { showOpenInvite: showOpenInvite, eligibleDomains: eligibleDomains, isViralSettingsEnabled: isViralSettingsEnabled } = (0, $hofb1.useViralSettingsContext)();
    const showViralSettingsSection = isViralSettingsEnabled && (showOpenInvite || eligibleDomains.length > 0);
    const hasSecondarySection = !invitePromptOnLinkV3Cohort && (shouldRenderProductSelect || showViralSettingsSection) && showSecondarySection;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const currentProduct = selectedProducts[0];
    const isCurrentProductInitiallyUndefined = (0, $5uXOq.useRef)(currentProduct === undefined);
    const secondarySectionTitle = (0, $5uXOq.useMemo)(()=>{
        if (isCurrentProductInitiallyUndefined.current) {
            if (shouldRenderProductSelect && showViralSettingsSection) return (0, $fn6W9.messages).secondarySectionHeadingNoCurrentProduct;
            else if (shouldRenderProductSelect) return (0, $fn6W9.messages).secondarySectionHeadingWithProductSelectorNoCurrentProduct;
            else return (0, $fn6W9.messages).secondarySectionHeadingWithViralSettings;
        }
        if (shouldRenderProductSelect && showViralSettingsSection) return (0, $fn6W9.messages).secondarySectionHeading;
        else if (shouldRenderProductSelect) return (0, $fn6W9.messages).secondarySectionHeadingWithProductSelector;
        else return (0, $fn6W9.messages).secondarySectionHeadingWithViralSettings;
    }, [
        shouldRenderProductSelect,
        showViralSettingsSection
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("form", {
        onSubmit: (e)=>{
            e.preventDefault();
        },
        className: (0, $bwpsq.default)([
            $d14f4918580f19c8$var$styles.form
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $d14f4918580f19c8$var$styles.formSection,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e3724.default), {
                    maxEmails: maxNumberOfInputs,
                    onInviteeListChange: onInviteeListChange,
                    showEmptyError: showEmptyError
                })
            }),
            enableThirdPartyInvites && !invitePromptOnLinkV3Cohort && thirdPartyIntegrations && !thirdPartyConnected && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $d14f4918580f19c8$var$styles.formSection,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLdbz.default), {})
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dVJUv.SlideAnimationWrapper), {
                shouldTriggerAnimation: hasSecondarySection,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3nIQz.LineDivider), {}),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $d14f4918580f19c8$var$styles.formSection,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                                size: "xsmall",
                                as: "h2",
                                children: formatMessage(secondarySectionTitle)
                            })
                        }),
                        shouldRenderProductSelect && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $d14f4918580f19c8$var$styles.formSection,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fwW2H.default), {
                                productOptions: productOptions,
                                onMenuOpen: handleProductSelectMenuOpen,
                                formInvalid: showEmptyError
                            })
                        }),
                        showViralSettingsSection && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jmZyU.default), {
                            product: selectedProducts[0]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PtjI.PluginRenderer), {
                plugins: plugins,
                location: "footer"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $d14f4918580f19c8$var$styles.formSection,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4zFDR.Recaptcha), {
                    isLoading: !recaptcha?.isRecaptchaLoaded && !recaptcha?.recaptchaLoadErrorReason,
                    onChange: setRecaptcha
                })
            })
        ]
    });
};
var $d14f4918580f19c8$export$2e2bcd8739ae039 = $d14f4918580f19c8$var$InvitePeopleForm;

});
parcelRegister("fwW2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $3be37f059d5492e9$export$2e2bcd8739ae039);
/* ProductSelect.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $k5Wbc = parcelRequire("k5Wbc");
var $cUUCJ = parcelRequire("cUUCJ");

var $3Alw1 = parcelRequire("3Alw1");
var $b1kcy = parcelRequire("b1kcy");
var $lau8t = parcelRequire("lau8t");

var $cNW3X = parcelRequire("cNW3X");

var $c6Cwb = parcelRequire("c6Cwb");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");


var $5KCCi = parcelRequire("5KCCi");

var $fn6W9 = parcelRequire("fn6W9");

var $kx8ta = parcelRequire("kx8ta");

var $hatDq = parcelRequire("hatDq");

var $4gxY5 = parcelRequire("4gxY5");

var $gcIuM = parcelRequire("gcIuM");

var $6HEbe = parcelRequire("6HEbe");

var $hkLbH = parcelRequire("hkLbH");
const $3be37f059d5492e9$var$MAX_VISIBLE_PRODUCTS = 2;
const $3be37f059d5492e9$var$styles = {
    fieldWrapper: "_kqswh2mm",
    iconWrapper: "_2rko1sit _1rjcv77o _18zrv77o _1bsb1f4h _4t3i1f4h _18u01b66 _2hwxu2gc",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug",
    label: "_11c816g6 _1e0c1ule _k48p1pd9 _syaz131l _19pkze3t _otyr1b66",
    productValues: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    chooseAllButtonWrapper: "_1rjcu2gc _bozgv47k _y4tiutpp"
};
const $3be37f059d5492e9$var$isJiraCoreImplied = (option, selectedOptions)=>option.value === (0, $kx8ta.JiraWorkManagementProduct).id && (0, $gcIuM.hasNonCoreJira)(selectedOptions.map((option)=>option.value));
const $3be37f059d5492e9$var$customOptionLabel = (option, { context: context, selectValue: selectValue })=>{
    let LabelIcon = (0, $kx8ta.getProductIcon)(option.value);
    // If the label is Jira Work Management (due to JSW and JWM is shown in same place)
    // then it should render original JWM icon instead of the rebranded Jira icon.
    if (option.label === (0, $kx8ta.JiraWorkManagementProduct).label) LabelIcon = (0, $kx8ta.JiraWorkManagementProduct).icon;
    if (context === 'menu') {
        const isImpliedJiraCore = $3be37f059d5492e9$var$isJiraCoreImplied(option, selectValue);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
            content: isImpliedJiraCore ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $fn6W9.messages).optionIncludedWithOtherJiraProducts
            }) : undefined,
            position: 'right',
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                testId: `test-id-option-${option.value}`,
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        backgroundColor: "color.background.neutral",
                        xcss: $3be37f059d5492e9$var$styles.iconWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(LabelIcon, {
                            size: "small",
                            appearance: "brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                        xcss: $3be37f059d5492e9$var$styles.labelWrapper,
                        children: option.label
                    }),
                    isImpliedJiraCore && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c6Cwb))), {
                        label: 'EditorPanelIcon',
                        color: `var(--ds-icon-subtle, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`
                    })
                ]
            })
        });
    }
    return option.label;
};
const $3be37f059d5492e9$var$ProductSelect = ({ onMenuOpen: onMenuOpen, formInvalid: formInvalid })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $hkLbH.ProductSelectAnalytics));
    const { selectedProducts: selectedProducts, setSelectedProducts: setSelectedProducts, availableProductOptions: availableProductOptions } = (0, $4gxY5.useProducts)();
    const [isInvalid, setIsInvalid] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    (0, $5uXOq.useEffect)(()=>{
        analytics.productSelectRendered(availableProductOptions);
    }, [
        availableProductOptions,
        analytics
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (formInvalid && (!selectedProducts || !selectedProducts.length)) setIsInvalid(formInvalid);
    }, [
        formInvalid,
        selectedProducts
    ]);
    // Disable JWM if another jira product is selected
    const isOptionDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((option)=>{
        return option.value === (0, $kx8ta.JiraWorkManagementProduct).id && (0, $gcIuM.hasNonCoreJira)(selectedProducts);
    }, [
        selectedProducts
    ]);
    const isOptionSelected = (option, selectedOptions)=>{
        return selectedOptions.some((currentOption)=>option.value === currentOption.value) || $3be37f059d5492e9$var$isJiraCoreImplied(option, selectedOptions);
    };
    const handleOnChangeProduct = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((values, _action)=>{
        if (!values) return;
        const selectedOptions = [
            ...values
        ];
        setSelectedProducts((0, $gcIuM.removeJiraCoreIfImplied)(selectedOptions.map((option)=>option.value)));
        setIsInvalid(!(selectedOptions && selectedOptions.length));
    }, [
        setSelectedProducts
    ]);
    const customMenuListFactory = ({ onSelectAll: onSelectAll = (_allProducts)=>{} })=>(props)=>{
            const onClickSelectAll = ()=>{
                const allOptions = [
                    ...props.options
                ];
                props.setValue(allOptions, 'select-option');
                onSelectAll(allOptions);
            };
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b1kcy.components).MenuList, {
                ...props,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: $3be37f059d5492e9$var$styles.chooseAllButtonWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                            onMouseDown: onClickSelectAll,
                            appearance: "link",
                            spacing: "none",
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: {
                                fontWeight: "var(--ds-font-weight-regular, 400)"
                            },
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $fn6W9.messages).selectAllOption
                            })
                        })
                    }),
                    props.children
                ]
            });
        };
    const handleMenuOpen = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        setIsOpen(true);
        if (onMenuOpen) onMenuOpen();
    }, [
        onMenuOpen
    ]);
    const handleMenuClose = ()=>setIsOpen(false);
    const customComponents = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            MenuList: customMenuListFactory({
                onSelectAll: (selectedProducts)=>{
                    analytics.selectAllClicked(selectedProducts.map((p)=>String(p.value)));
                    setIsOpen(false);
                }
            }),
            MultiValue: (props)=>{
                const selectValue = props.selectProps.value || [];
                // `index` *is* passed by react-select, despite not being in MultiValueProps
                const { data: data, index: index } = props;
                const isLast = index === selectValue.length - 1;
                let suffix = ',';
                if (isLast) suffix = '';
                else if (index >= 1) suffix = ', ...';
                return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                    children: [
                        data.label,
                        suffix,
                        "\xa0"
                    ]
                });
            },
            Option: (props)=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Alw1.CheckboxOption), {
                    ...props
                });
            },
            ValueContainer: ({ children: children, ...props })=>{
                const selectedOptions = children[0];
                return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b1kcy.components).ValueContainer, {
                    ...props,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                            as: "span",
                            xcss: $3be37f059d5492e9$var$styles.productValues,
                            children: children
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            children: props.hasValue && selectedOptions.length > $3be37f059d5492e9$var$MAX_VISIBLE_PRODUCTS && `(+${selectedOptions.length - $3be37f059d5492e9$var$MAX_VISIBLE_PRODUCTS})`
                        })
                    ]
                });
            }
        }), [
        analytics
    ]);
    const customStyles = {
        // main area
        control: (provided, state)=>({
                ...provided,
                cursor: 'pointer',
                background: state.selectProps.menuIsOpen ? `var(--ds-background-selected, ${0, $a7f8c6b391092279$export$226de0355ed012f8})` : state.isFocused ? `var(--ds-background-neutral, ${0, $a7f8c6b391092279$export$3e51e8f1440314ba})` : `var(--ds-background-input, ${0, $a7f8c6b391092279$export$29a4f05edc054374})`,
                height: '48px',
                paddingLeft: "var(--ds-space-150, 12px)",
                borderRadius: '3px',
                borderColor: state.isFocused ? state.selectProps.menuIsOpen ? 'transparent' : `var(--ds-border-focused, ${0, $a7f8c6b391092279$export$ecfc1dff386a3e7a})` : `var(--ds-border, ${0, $a7f8c6b391092279$export$1ce2d1575d444ceb})`,
                ':hover': {
                    background: state.selectProps.menuIsOpen ? `var(--ds-background-selected, ${0, $a7f8c6b391092279$export$226de0355ed012f8})` : `var(--ds-background-neutral-hovered, ${0, $a7f8c6b391092279$export$1ce2d1575d444ceb})`,
                    borderColor: state.isFocused ? state.selectProps.menuIsOpen ? 'transparent' : `var(--ds-border-focused, ${0, $a7f8c6b391092279$export$ecfc1dff386a3e7a})` : 'transparent'
                }
            }),
        valueContainer: (provided, state)=>({
                ...provided,
                color: state.selectProps.menuIsOpen ? `var(--ds-text-brand, ${0, $a7f8c6b391092279$export$e62e8919cca44969})` : `var(--ds-text, ${0, $a7f8c6b391092279$export$fbda843f0a27fe96})`,
                display: 'flex',
                flexWrap: 'nowrap',
                minWidth: 0,
                [`> span > span:nth-child(n + ${$3be37f059d5492e9$var$MAX_VISIBLE_PRODUCTS + 1})`]: {
                    display: 'none'
                }
            }),
        placeholder: (provided, state)=>({
                ...provided,
                color: state.selectProps.menuIsOpen ? `var(--ds-text-brand, ${0, $a7f8c6b391092279$export$e62e8919cca44969})` : `var(--ds-text, ${0, $a7f8c6b391092279$export$fbda843f0a27fe96})`
            }),
        dropdownIndicator: (provided, state)=>({
                ...provided,
                color: state.selectProps.menuIsOpen ? `var(--ds-text-brand, ${0, $a7f8c6b391092279$export$e62e8919cca44969})` : `var(--ds-text, ${0, $a7f8c6b391092279$export$fbda843f0a27fe96})`,
                ':hover': 'none'
            }),
        menuPortal: (provided)=>({
                ...provided,
                zIndex: (0, $hatDq.ZIndex).FLOATING
            })
    };
    const selectedValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        const selectedOptions = (0, $gcIuM.mapProductIdsToProductSelectOptions)(selectedProducts);
        const hasBothJSWAndJWM = availableProductOptions.find(({ value: value })=>value === (0, $kx8ta.JiraWorkManagementProduct).id) && availableProductOptions.find(({ value: value })=>value === (0, $kx8ta.JiraSoftwareProduct).id);
        // If JSW and JWM are both shown in options,
        // it should show original label of JWM as Jira Work Management instead of rebranded Jira label
        return hasBothJSWAndJWM ? selectedOptions.map((option)=>option.value === (0, $kx8ta.JiraWorkManagementProduct).id ? {
                label: (0, $kx8ta.JiraWorkManagementProduct).label,
                value: option.value
            } : option) : selectedOptions;
    }, [
        selectedProducts,
        availableProductOptions
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
        testId: "test-id-invite-people-select-product",
        xcss: $3be37f059d5492e9$var$styles.fieldWrapper,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                as: "label",
                htmlFor: "product-select",
                xcss: $3be37f059d5492e9$var$styles.label,
                children: [
                    selectedProducts.length === 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $fn6W9.messages).productSelectNoCurrentProduct
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $fn6W9.messages).productSelect
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cUUCJ.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lau8t.default), {
                isMulti: true,
                styles: customStyles,
                isClearable: false,
                isSearchable: false,
                name: "product-select",
                inputId: "product-select",
                placeholder: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $fn6W9.messages).selectPlaceholder
                }),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "checkbox-select",
                classNamePrefix: "select",
                closeMenuOnSelect: false,
                components: customComponents,
                hideSelectedOptions: false,
                options: availableProductOptions,
                value: selectedValue,
                formatOptionLabel: $3be37f059d5492e9$var$customOptionLabel,
                onChange: handleOnChangeProduct,
                isOptionDisabled: isOptionDisabled,
                isOptionSelected: isOptionSelected,
                onMenuOpen: handleMenuOpen,
                onMenuClose: handleMenuClose,
                menuIsOpen: isOpen,
                validationState: isInvalid ? 'error' : 'default',
                menuPortalTarget: document.body,
                menuPosition: 'absolute',
                isRequired: true
            }),
            isInvalid ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k5Wbc.ErrorMessage), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $fn6W9.messages).noProductSelectedMessage
                })
            }) : null
        ]
    });
};
var $3be37f059d5492e9$export$2e2bcd8739ae039 = $3be37f059d5492e9$var$ProductSelect;

});
parcelRegister("k5Wbc", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $17b56f3c99dc4004$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $17b56f3c99dc4004$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $17b56f3c99dc4004$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $17b56f3c99dc4004$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iZXAi = parcelRequire("iZXAi");

var $35I2R = parcelRequire("35I2R");

var $bU9TL = parcelRequire("bU9TL");
const $17b56f3c99dc4004$var$messageStyles = null;
const $17b56f3c99dc4004$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $17b56f3c99dc4004$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $17b56f3c99dc4004$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $17b56f3c99dc4004$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $17b56f3c99dc4004$var$messageIcons = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iZXAi))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($35I2R))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $17b56f3c99dc4004$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $17b56f3c99dc4004$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($17b56f3c99dc4004$var$MessageWrapperContext);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $17b56f3c99dc4004$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $17b56f3c99dc4004$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $17b56f3c99dc4004$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $17b56f3c99dc4004$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $17b56f3c99dc4004$var$MessageWrapperContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $17b56f3c99dc4004$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("iZXAi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98606756a92a07f2e7585c76d3cbd084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd4c24b8075762c6$var$_react = $dd4c24b8075762c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dd4c24b8075762c6$var$_error = $dd4c24b8075762c6$var$_interopRequireDefault((parcelRequire("65KuH")));

var $dd4c24b8075762c6$var$_error2 = $dd4c24b8075762c6$var$_interopRequireDefault((parcelRequire("hWOvD")));
function $dd4c24b8075762c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd4c24b8075762c6$var$ErrorIcon = (props)=>/*#__PURE__*/ $dd4c24b8075762c6$var$_react.default.createElement($dd4c24b8075762c6$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $dd4c24b8075762c6$var$_error2.default
    }, props));
$dd4c24b8075762c6$var$ErrorIcon.Name = 'ErrorIconMigration';
var $dd4c24b8075762c6$var$_default = module.exports.default = $dd4c24b8075762c6$var$ErrorIcon;

});
parcelRegister("65KuH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d97879d6b889ef4621929c7dd705b0ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46f7467bbb627311$var$_react = $46f7467bbb627311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $46f7467bbb627311$var$_baseNew = $46f7467bbb627311$var$_interopRequireDefault((parcelRequire("enEmH")));
function $46f7467bbb627311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46f7467bbb627311$var$ErrorIcon = (props)=>/*#__PURE__*/ $46f7467bbb627311$var$_react.default.createElement($46f7467bbb627311$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$46f7467bbb627311$var$ErrorIcon.displayName = 'ErrorIcon';
var $46f7467bbb627311$var$_default = module.exports.default = $46f7467bbb627311$var$ErrorIcon;

});


parcelRegister("35I2R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d345d1980a5e7ce7680063890c36f7e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24040126ddf3179f$var$_react = $24040126ddf3179f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $24040126ddf3179f$var$_success = $24040126ddf3179f$var$_interopRequireDefault((parcelRequire("aZZu2")));

var $24040126ddf3179f$var$_success2 = $24040126ddf3179f$var$_interopRequireDefault((parcelRequire("8VK5X")));
function $24040126ddf3179f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $24040126ddf3179f$var$SuccessIcon = (props)=>/*#__PURE__*/ $24040126ddf3179f$var$_react.default.createElement($24040126ddf3179f$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $24040126ddf3179f$var$_success2.default
    }, props));
$24040126ddf3179f$var$SuccessIcon.Name = 'SuccessIconMigration';
var $24040126ddf3179f$var$_default = module.exports.default = $24040126ddf3179f$var$SuccessIcon;

});
parcelRegister("aZZu2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b91b2ac4848db507d9eb71a2b738b7fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $801f4b37378597d1$var$_react = $801f4b37378597d1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $801f4b37378597d1$var$_baseNew = $801f4b37378597d1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $801f4b37378597d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $801f4b37378597d1$var$SuccessIcon = (props)=>/*#__PURE__*/ $801f4b37378597d1$var$_react.default.createElement($801f4b37378597d1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$801f4b37378597d1$var$SuccessIcon.displayName = 'SuccessIcon';
var $801f4b37378597d1$var$_default = module.exports.default = $801f4b37378597d1$var$SuccessIcon;

});

parcelRegister("8VK5X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6807671dacf23c57$var$_react = $6807671dacf23c57$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $6807671dacf23c57$var$_success = $6807671dacf23c57$var$_interopRequireDefault((parcelRequire("cFUJ2")));
function $6807671dacf23c57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6807671dacf23c57$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $6807671dacf23c57$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $6807671dacf23c57$var$_success.default
    }));
$6807671dacf23c57$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $6807671dacf23c57$var$_default = module.exports.default = $6807671dacf23c57$var$EditorSuccessIcon;

});


parcelRegister("bU9TL", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $fd4ca56d0899c490$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $fd4ca56d0899c490$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("cUUCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7ed1e0c62cc06b$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $4a7ed1e0c62cc06b$var$requiredIndicatorStyles = null;
function $4a7ed1e0c62cc06b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("3Alw1", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $d0ede4c272661616$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $d0ede4c272661616$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3WlF6 = parcelRequire("3WlF6");

var $aOu3z = parcelRequire("aOu3z");

var $2SY35 = parcelRequire("2SY35");

var $fHpHg = parcelRequire("fHpHg");
const $d0ede4c272661616$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $d0ede4c272661616$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $d0ede4c272661616$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $d0ede4c272661616$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $d0ede4c272661616$var$baseIconStyles = null;
const $d0ede4c272661616$var$baseOptionStyles = null;
// eslint-disable-next-line @repo/internal/react/no-class-components
const $d0ede4c272661616$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $5uXOq.useState)(false);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $5uXOq.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $d0ede4c272661616$var$optionStyles.default,
            isFocused && $d0ede4c272661616$var$optionStyles.focused,
            isDisabled && $d0ede4c272661616$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $d0ede4c272661616$var$iconStyles.inherit : $d0ede4c272661616$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    label: "",
                    primaryColor: $d0ede4c272661616$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $d0ede4c272661616$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $d0ede4c272661616$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SY35.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $d0ede4c272661616$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SY35.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $d0ede4c272661616$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($d0ede4c272661616$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix, @atlaskit/platform/no-preconditioning
        (0, $fHpHg.fg)('platform-visual-refresh-icons') && (0, $fHpHg.fg)('platform-icon-control-migration') ? $d0ede4c272661616$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($3WlF6))),
        ...props
    });
const $d0ede4c272661616$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)($d0ede4c272661616$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix, @atlaskit/platform/no-preconditioning
        (0, $fHpHg.fg)('platform-visual-refresh-icons') && (0, $fHpHg.fg)('platform-icon-control-migration') ? $d0ede4c272661616$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($aOu3z))),
        ...props
    });

});
parcelRegister("3WlF6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2de7977aa9cb00bc$var$_react = $2de7977aa9cb00bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $2de7977aa9cb00bc$var$_checkboxChecked = $2de7977aa9cb00bc$var$_interopRequireDefault((parcelRequire("cZpzV")));
function $2de7977aa9cb00bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2de7977aa9cb00bc$var$CheckboxIcon = (props)=>/*#__PURE__*/ $2de7977aa9cb00bc$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $2de7977aa9cb00bc$var$_checkboxChecked.default
    }));
$2de7977aa9cb00bc$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $2de7977aa9cb00bc$var$_default = module.exports.default = $2de7977aa9cb00bc$var$CheckboxIcon;

});
parcelRegister("cZpzV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $974f05e630cecc25$var$_react = $974f05e630cecc25$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $974f05e630cecc25$var$_baseNew = $974f05e630cecc25$var$_interopRequireDefault((parcelRequire("enEmH")));
function $974f05e630cecc25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $974f05e630cecc25$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $974f05e630cecc25$var$_react.default.createElement($974f05e630cecc25$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$974f05e630cecc25$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $974f05e630cecc25$var$_default = module.exports.default = $974f05e630cecc25$var$CheckboxCheckedIcon;

});


parcelRegister("aOu3z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7df5e37c6b7a20c4$var$_react = $7df5e37c6b7a20c4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $7df5e37c6b7a20c4$var$_radioChecked = $7df5e37c6b7a20c4$var$_interopRequireDefault((parcelRequire("6Ozz1")));
function $7df5e37c6b7a20c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7df5e37c6b7a20c4$var$RadioIcon = (props)=>/*#__PURE__*/ $7df5e37c6b7a20c4$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $7df5e37c6b7a20c4$var$_radioChecked.default
    }));
$7df5e37c6b7a20c4$var$RadioIcon.displayName = 'RadioIcon';
var $7df5e37c6b7a20c4$var$_default = module.exports.default = $7df5e37c6b7a20c4$var$RadioIcon;

});
parcelRegister("6Ozz1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f37934c6709a990262261073c8d0052>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f62ffd3e1262340$var$_react = $4f62ffd3e1262340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4f62ffd3e1262340$var$_baseNew = $4f62ffd3e1262340$var$_interopRequireDefault((parcelRequire("enEmH")));
function $4f62ffd3e1262340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f62ffd3e1262340$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $4f62ffd3e1262340$var$_react.default.createElement($4f62ffd3e1262340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$4f62ffd3e1262340$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $4f62ffd3e1262340$var$_default = module.exports.default = $4f62ffd3e1262340$var$RadioCheckedIcon;

});



parcelRegister("4gxY5", function(module, exports) {

$parcel$export(module.exports, "ProductContext", () => $0e1df8106f47257b$export$e46bb22811a53085);
$parcel$export(module.exports, "useProducts", () => $0e1df8106f47257b$export$964e8498268f0fe3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kx8ta = parcelRequire("kx8ta");

var $gcIuM = parcelRequire("gcIuM");

var $7Nt5L = parcelRequire("7Nt5L");

var $daXvt = parcelRequire("daXvt");

var $hkLbH = parcelRequire("hkLbH");

var $6HEbe = parcelRequire("6HEbe");

var $lWbFO = parcelRequire("lWbFO");
const $0e1df8106f47257b$export$b1a2fdcd2fdbc1e5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $0e1df8106f47257b$export$bfcb57024ef3c3d = async (cloudId, resourceAri, analytics)=>{
    try {
        (0, $lWbFO.invitePeopleRendered).mark((0, $lWbFO.invitePeopleRenderedTimings).getInviteCapabilities.startMark);
        const response = await (0, $7Nt5L.defaultInviteApiClient).inviteCapabilities(cloudId);
        (0, $lWbFO.invitePeopleRendered).mark((0, $lWbFO.invitePeopleRenderedTimings).getInviteCapabilities.endMark);
        // Get unique capabilities.
        const resources = [
            // Create map (matching keys override) and get just the values
            ...new Map([
                ...response.directInvite,
                ...response.invitePendingApproval
            ].map((item)=>[
                    item.id,
                    item
                ])).values()
        ];
        analytics.getAvailableProductsSucceeded(resourceAri, resources.map(({ id: id })=>`ari:cloud:${id}::site/${cloudId}`));
        if (!resources?.length) return {
            productOptions: [],
            inviteCapabilities: {
                directInvite: [],
                invitePendingApproval: []
            }
        };
        const resourcesAsOptions = (0, $gcIuM.mapInviteProductsToProducts)(resources).filter((p)=>(0, $kx8ta.isProductIdWhiteListed)(p.id));
        return {
            productOptions: resourcesAsOptions,
            inviteCapabilities: response
        };
    } catch (err) {
        analytics.getAvailableProductsFailed(resourceAri);
        return {
            productOptions: [],
            inviteCapabilities: {
                directInvite: [],
                invitePendingApproval: []
            }
        };
    }
};
const $0e1df8106f47257b$export$e46bb22811a53085 = ({ resourceAri: resourceAri, children: children, productOptions: productOptions })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $hkLbH.ProductSelectAnalytics));
    const { cloudId: cloudId, jiraSubProduct: jiraSubProduct, productId: productId } = (0, $daXvt.useInvitePeopleContext)();
    const productOptionsFiltered = productOptions ? (0, $gcIuM.mapProductSelectOptionsToProducts)(productOptions).filter((p)=>(0, $kx8ta.isProductIdWhiteListed)(p.id)) : [];
    const getInitialSelectedProducts = (0, $5uXOq.useCallback)((productOptions)=>(0, $gcIuM.removeJiraCoreIfImplied)((0, $gcIuM.getDefaultSelectedProducts)((0, $gcIuM.mapProductsToProductSelectOptions)(productOptions), productId, jiraSubProduct).map((product)=>product.value)), [
        productId,
        jiraSubProduct
    ]);
    const [availableProducts, setAvailableProducts] = (0, $5uXOq.useState)(productOptionsFiltered);
    const [selectedProducts, setSelectedProducts] = (0, $5uXOq.useState)(getInitialSelectedProducts(productOptionsFiltered));
    const [inviteCapabilities, setInviteCapabilities] = (0, $5uXOq.useState)({
        directInvite: [],
        invitePendingApproval: []
    });
    const [isFetchProductsLoading, setIsFetchProductsLoading] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        const fetchProductData = async ()=>{
            if (productOptionsFiltered.length === 0 && isFetchProductsLoading) {
                const { productOptions: productOptions, inviteCapabilities: inviteCapabilities } = await $0e1df8106f47257b$export$bfcb57024ef3c3d(cloudId || '', resourceAri, analytics);
                setAvailableProducts(productOptions);
                setInviteCapabilities(inviteCapabilities);
                setSelectedProducts(getInitialSelectedProducts(productOptions));
            }
            setIsFetchProductsLoading(false);
        };
        fetchProductData();
    }, [
        cloudId,
        resourceAri,
        isFetchProductsLoading,
        productOptionsFiltered.length,
        analytics,
        getInitialSelectedProducts
    ]);
    const availableProductOptions = (0, $5uXOq.useMemo)(()=>(0, $gcIuM.mapProductsToProductSelectOptions)(availableProducts), [
        availableProducts
    ]);
    const hasPermissionToInviteOrRequestAccess = (0, $5uXOq.useMemo)(()=>{
        if (!productId || !cloudId || isFetchProductsLoading) return false;
        const { directInvite: directInvite, invitePendingApproval: invitePendingApproval } = inviteCapabilities;
        if (productId === 'platform') return directInvite.length > 0 || invitePendingApproval.length > 0;
        const currentProductId = jiraSubProduct || productId;
        const currentProductAri = (0, $kx8ta.makeAri)(currentProductId, cloudId);
        const hasRelatedProduct = (config)=>{
            if (productId === (0, $kx8ta.JiraProduct).id) {
                if (!jiraSubProduct || jiraSubProduct === 'unknown') return config.ari.indexOf((0, $kx8ta.JiraWorkManagementProduct).id) > 0 || config.ari.indexOf((0, $kx8ta.JiraServiceManagementProduct).id) > 0 || config.ari.indexOf((0, $kx8ta.JiraSoftwareProduct).id) > 0 || config.ari.indexOf((0, $kx8ta.JiraProductDiscovery).id) > 0;
                else if (jiraSubProduct === (0, $kx8ta.JiraWorkManagementProduct).id) return config.ari.indexOf((0, $kx8ta.JiraWorkManagementProduct).id) > 0 || config.ari.indexOf((0, $kx8ta.JiraSoftwareProduct).id) > 0;
            }
            return config.ari === currentProductAri;
        };
        return directInvite.some(hasRelatedProduct) || invitePendingApproval.some(hasRelatedProduct);
    }, [
        cloudId,
        jiraSubProduct,
        inviteCapabilities,
        isFetchProductsLoading,
        productId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($0e1df8106f47257b$export$b1a2fdcd2fdbc1e5.Provider, {
        value: {
            selectedProducts: selectedProducts,
            availableProducts: availableProducts,
            setAvailableProducts: setAvailableProducts,
            availableProductOptions: availableProductOptions,
            setSelectedProducts: setSelectedProducts,
            isFetchProductsLoading: isFetchProductsLoading,
            inviteCapabilities: inviteCapabilities,
            hasPermissionToInviteOrRequestAccess: hasPermissionToInviteOrRequestAccess
        },
        children: children
    });
};
const $0e1df8106f47257b$export$964e8498268f0fe3 = ()=>{
    const state = (0, $5uXOq.useContext)($0e1df8106f47257b$export$b1a2fdcd2fdbc1e5);
    if (state === undefined) throw new Error('useProducts must be used within a ProductsStateContextProvider');
    return state;
};

});
parcelRegister("gcIuM", function(module, exports) {

$parcel$export(module.exports, "mapProductSelectOptionsToProducts", () => $7e4417eacbb092fa$export$41e1984324a860ca);
$parcel$export(module.exports, "mapInviteProductsToProducts", () => $7e4417eacbb092fa$export$f4f954eb8b707ede);
$parcel$export(module.exports, "mapProductsToProductSelectOptions", () => $7e4417eacbb092fa$export$eff484b0acab3de5);
$parcel$export(module.exports, "mapProductIdsToProductSelectOptions", () => $7e4417eacbb092fa$export$e30dd649ce5911e1);
$parcel$export(module.exports, "getDefaultSelectedProducts", () => $7e4417eacbb092fa$export$877992b5aa6eda64);
$parcel$export(module.exports, "hasNonCoreJira", () => $7e4417eacbb092fa$export$3f18758b465dbbc9);
$parcel$export(module.exports, "removeJiraCoreIfImplied", () => $7e4417eacbb092fa$export$2ffa8edc2268aa15);

var $iItCF = parcelRequire("iItCF");

var $kx8ta = parcelRequire("kx8ta");
const $7e4417eacbb092fa$var$defaultProduct = (id, label)=>({
        id: id,
        label: label,
        landingPath: '',
        directAccessLocation: 'others.core-invites',
        icon: (0, $iItCF.AtlassianIcon)
    });
const $7e4417eacbb092fa$export$41e1984324a860ca = (options)=>{
    const hasBothJSWAndJWM = options.find((option)=>option.value === (0, $kx8ta.JiraWorkManagementProduct).id) && options.find((option)=>option.value === (0, $kx8ta.JiraSoftwareProduct).id);
    return options.map((option)=>{
        const product = (0, $kx8ta.getProductById)(option.value);
        // If has both JSW and JWM in selected products
        // then return the original JiraWorkManagementProduct that has Jira Work Management label and JWM Icon
        if (hasBothJSWAndJWM && option.value === (0, $kx8ta.JiraWorkManagementProduct).id) return 0, $kx8ta.JiraWorkManagementProduct;
        return product || $7e4417eacbb092fa$var$defaultProduct(option.value, option.label);
    });
};
const $7e4417eacbb092fa$export$f4f954eb8b707ede = (inviteProducts)=>{
    const hasBothJSWAndJWM = inviteProducts.find((product)=>product.id === (0, $kx8ta.JiraWorkManagementProduct).id) && inviteProducts.find((product)=>product.id === (0, $kx8ta.JiraSoftwareProduct).id);
    return inviteProducts.map((option)=>{
        const product = (0, $kx8ta.getProductById)(option.id);
        // If has both JSW and JWM in available products
        // then return the original JiraWorkManagementProduct that has Jira Work Management label and JWM Icon
        if (hasBothJSWAndJWM && option.id === (0, $kx8ta.JiraWorkManagementProduct).id) return 0, $kx8ta.JiraWorkManagementProduct;
        return product || $7e4417eacbb092fa$var$defaultProduct(option.id, option.name);
    });
};
const $7e4417eacbb092fa$export$eff484b0acab3de5 = (availableProducts)=>{
    return availableProducts.map((product)=>{
        return {
            value: product.id,
            label: product.label
        };
    });
};
const $7e4417eacbb092fa$export$e30dd649ce5911e1 = (ids)=>{
    return ids.map((id)=>({
            value: id,
            label: (0, $kx8ta.getProductTitle)(id) || id
        }));
};
const $7e4417eacbb092fa$export$877992b5aa6eda64 = (availableProductOptions, productId, jiraSubProduct)=>{
    if (jiraSubProduct) {
        const jiraSubProducts = availableProductOptions.filter((product)=>product.value === jiraSubProduct || product.value === (0, $kx8ta.JiraWorkManagementProduct).id);
        // handle case when the current product is JWM but JWM is not in the invite-capabilites response
        if (jiraSubProducts.length === 0) {
            const jiraSoftware = availableProductOptions.find((item)=>item.value === (0, $kx8ta.JiraSoftwareProduct).id);
            if (jiraSoftware) return [
                jiraSoftware
            ];
            const jiraServiceManagement = availableProductOptions.find((item)=>item.value === (0, $kx8ta.JiraServiceManagementProduct).id);
            if (jiraServiceManagement) return [
                jiraServiceManagement
            ];
        // fallthrough when there are no jira product capabilities
        } else return jiraSubProducts;
    }
    if (availableProductOptions.length === 1) // If there's exactly one product subscription, we should use it when sending
    // the invite
    return availableProductOptions;
    const currentProducts = availableProductOptions.filter((product)=>product.value.includes(productId));
    const fallbackProductList = productId !== 'platform' ? [
        {
            value: productId,
            label: (0, $kx8ta.getProductTitle)(productId)
        }
    ] : [];
    return currentProducts.length > 0 ? currentProducts : fallbackProductList;
};
const $7e4417eacbb092fa$var$isNotJiraCore = (product)=>product !== (0, $kx8ta.JiraWorkManagementProduct).id;
const $7e4417eacbb092fa$var$isAnyJira = (product)=>product.startsWith('jira');
const $7e4417eacbb092fa$var$isNonCoreJira = (product)=>$7e4417eacbb092fa$var$isAnyJira(product) && $7e4417eacbb092fa$var$isNotJiraCore(product);
const $7e4417eacbb092fa$export$3f18758b465dbbc9 = (products)=>products?.some($7e4417eacbb092fa$var$isNonCoreJira) || false;
const $7e4417eacbb092fa$export$2ffa8edc2268aa15 = (selectedProducts)=>$7e4417eacbb092fa$export$3f18758b465dbbc9(selectedProducts) ? selectedProducts.filter($7e4417eacbb092fa$var$isNotJiraCore) : selectedProducts;

});

parcelRegister("7Nt5L", function(module, exports) {

$parcel$export(module.exports, "defaultInviteApiClient", () => $536c5746c54cbde8$export$c993591f6996ca09);
$parcel$export(module.exports, "defaultPermsApiClient", () => $536c5746c54cbde8$export$c2fb70172d8b4300);
$parcel$export(module.exports, "defaultAccountInfoClient", () => $536c5746c54cbde8$export$a389cf813a8a5b61);
$parcel$export(module.exports, "defaultOpenInviteClient", () => $536c5746c54cbde8$export$4f6a946e6e09a73b);
$parcel$export(module.exports, "defaultInviteThirdPartyTeamsClient", () => $536c5746c54cbde8$export$cece732ae3647aa1);

var $Zeu50 = parcelRequire("Zeu50");

var $fs8mE = parcelRequire("fs8mE");

var $jAm3B = parcelRequire("jAm3B");

var $dgUIU = parcelRequire("dgUIU");

var $i92ym = parcelRequire("i92ym");

var $fIjji = parcelRequire("fIjji");

var $lCxIn = parcelRequire("lCxIn");
const $536c5746c54cbde8$export$d3e1efd45b274804 = new (0, $fIjji.PersonalizationClient)();
const $536c5746c54cbde8$export$c993591f6996ca09 = new (0, $Zeu50.InviteApiClientImpl)();
const $536c5746c54cbde8$export$c2fb70172d8b4300 = new (0, $fs8mE.PermsApiClient)();
const $536c5746c54cbde8$export$a389cf813a8a5b61 = new (0, $jAm3B.AccountInfoClient)();
const $536c5746c54cbde8$export$4f6a946e6e09a73b = new (0, $dgUIU.OpenInviteClient)();
const $536c5746c54cbde8$export$1c37f95483f1b2d0 = new (0, $i92ym.HaveISeenItClient)();
const $536c5746c54cbde8$export$cece732ae3647aa1 = new (0, $lCxIn.InviteThirdPartyTeamsClient)();

});
parcelRegister("fs8mE", function(module, exports) {

$parcel$export(module.exports, "PermsApiClient", () => $17f0ca68d2e86b89$export$87f10ac80394eda7);

var $z3rjp = parcelRequire("z3rjp");

var $evtmo = parcelRequire("evtmo");
class $17f0ca68d2e86b89$export$87f10ac80394eda7 {
    async isPermissionPermitted(request) {
        const path = `${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.PERMS_URL)}`;
        const { permissionId: permissionId, cloudId: cloudId } = request;
        const data = {
            permissionId: permissionId,
            resourceId: `ari:cloud:platform::site/${cloudId}`
        };
        return (0, $evtmo.postJson)(path, 'isPermissionPermitted', data);
    }
    async getUsersWithoutAccess(cloudId, products, accountIds) {
        const path = `${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.ELIGIBLE_USERS)}`;
        const request = {
            cloudId: cloudId,
            products: products,
            accountIds: accountIds
        };
        return (0, $evtmo.postJson)(path, 'get-eligible-users', request);
    }
    async getUserRole(cloudId) {
        try {
            const [{ permitted: isInviteUsersPermitted }, { permitted: isManagePermitted }] = await Promise.all([
                this.isPermissionPermitted({
                    permissionId: 'invite-users',
                    cloudId: cloudId
                }),
                this.isPermissionPermitted({
                    permissionId: 'manage',
                    cloudId: cloudId
                })
            ]);
            let role;
            if (isInviteUsersPermitted && isManagePermitted) role = 'admin';
            else if (isInviteUsersPermitted && !isManagePermitted) role = 'trusted';
            else role = 'basic';
            return {
                role: role,
                isInviteUsersPermitted: isInviteUsersPermitted,
                isManagePermitted: isManagePermitted
            };
        } catch (err) {
            //if something breaks while getting user role, fallback to 'basic'
            return {
                role: 'basic',
                errorMessage: `Error while getting user role: ${err instanceof Error ? err.message : String(err)}!`
            };
        }
    }
}
const $17f0ca68d2e86b89$export$c2fb70172d8b4300 = new $17f0ca68d2e86b89$export$87f10ac80394eda7();

});

parcelRegister("jAm3B", function(module, exports) {

$parcel$export(module.exports, "AccountInfoClient", () => $c9df56a36e58d54e$export$353491dc426ad77f);

var $z3rjp = parcelRequire("z3rjp");

var $evtmo = parcelRequire("evtmo");
class $c9df56a36e58d54e$export$353491dc426ad77f {
    async getAccountInfo() {
        const fetchUrl = `${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}/me`;
        const resp = await (0, $evtmo.fetchJson)(fetchUrl, 'getAccountInfo');
        return resp;
    }
}

});

parcelRegister("dgUIU", function(module, exports) {

$parcel$export(module.exports, "OpenInviteClient", () => $5e741355af4dde2a$export$db1a8fab85ca9503);

var $kx8ta = parcelRequire("kx8ta");

var $z3rjp = parcelRequire("z3rjp");

var $evtmo = parcelRequire("evtmo");
class $5e741355af4dde2a$export$db1a8fab85ca9503 {
    constructor(){
        this.clearCache = ()=>{
            this.openInviteCache.clear();
        };
        this.openInviteCache = new Map();
    }
    async getOpenInviteState(product, cloudId) {
        const resourceARI = `ari:cloud:${product}::site/${cloudId}`;
        const path = `${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.OPEN_INVITE_URL)}?resource=${resourceARI}`;
        const cacheValue = this.openInviteCache.get(resourceARI);
        if (cacheValue) return {
            response: cacheValue,
            cached: true
        };
        try {
            const resp = await (0, $evtmo.fetchJson)(path, 'getOpenInviteState');
            const openInviteInfo = {
                ...resp,
                getOpenInvite: true
            };
            (0, $kx8ta.tryCacheWithClear)(this.openInviteCache, resourceARI, openInviteInfo, 50);
            return {
                response: openInviteInfo,
                cached: false
            };
        } catch (err) {
            const openInviteInfo = {
                getOpenInvite: false,
                mode: 'REQUEST_ACCESS'
            };
            const { responseCode: responseCode } = (0, $kx8ta.resolveError)(err);
            if (responseCode && responseCode >= (0, $evtmo.RespCodes).BAD_REQUESTS && responseCode <= (0, $evtmo.RespCodes).CLIENT_CLOSED_REQUEST) (0, $kx8ta.tryCacheWithClear)(this.openInviteCache, resourceARI, openInviteInfo, 50);
            throw err;
        }
    }
    // Will only update to DIRECT_ACCESS for open invite settings.
    async enableOpenInvite(product, cloudId) {
        const resource = `ari:cloud:${product}::site/${cloudId}`;
        // only need to enable OPEN_INVITE (DIRECT_ACCESS) for our experiment
        const mode = 'DIRECT_ACCESS';
        const path = `${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.OPEN_INVITE_URL)}`;
        const request = {
            resource: resource,
            mode: mode
        };
        await (0, $evtmo.putJson)(path, 'enableOpenInvite', request);
        return {
            success: true,
            enableOpenInvite: true
        };
    }
    async getOpenInviteNote(orgId) {
        const url = (0, $z3rjp.getOpenInviteNoteUrl)((0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL), orgId);
        const response = await (0, $evtmo.fetchJson)(url, 'getOpenInviteNote');
        return response;
    }
}

});

parcelRegister("i92ym", function(module, exports) {

$parcel$export(module.exports, "createHISIDomainFlagKey", () => $a32c952034b0ace8$export$7d8a8798453c33f0);
$parcel$export(module.exports, "createHISIOpenInviteFlagKey", () => $a32c952034b0ace8$export$3e2b0be751a9f82e);
$parcel$export(module.exports, "HaveISeenItClient", () => $a32c952034b0ace8$export$7167d21e29807887);

var $z3rjp = parcelRequire("z3rjp");

var $kx8ta = parcelRequire("kx8ta");

var $evtmo = parcelRequire("evtmo");
const $a32c952034b0ace8$var$OPEN_INVITE_TYPE = 'open-invite';
const $a32c952034b0ace8$var$DOMAIN_TYPE = 'domain';
const $a32c952034b0ace8$export$fe791c4fa892e400 = 'viral-options-default-to-checked';
const $a32c952034b0ace8$export$7d8a8798453c33f0 = (product, cloudId, domain)=>{
    return `${cloudId}-${product}-${$a32c952034b0ace8$export$fe791c4fa892e400}-${$a32c952034b0ace8$var$DOMAIN_TYPE}-${domain}`;
};
const $a32c952034b0ace8$export$3e2b0be751a9f82e = (product, cloudId)=>{
    return `${cloudId}-${product}-${$a32c952034b0ace8$export$fe791c4fa892e400}-${$a32c952034b0ace8$var$OPEN_INVITE_TYPE}`;
};
class $a32c952034b0ace8$export$7167d21e29807887 {
    constructor(){
        this.clearCache = ()=>{
            this.flagsCache.clear();
        };
        this.flagsCache = new Map();
    }
    async getFlag(flagKey) {
        const cacheValue = this.flagsCache.get(flagKey);
        if (cacheValue) return {
            response: cacheValue,
            cached: true
        };
        const path = `${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.HAVE_I_SEEN_IT_URL)}?flagKey=${flagKey}`;
        const response = await (0, $evtmo.fetchJson)(path, 'getFlagHISI');
        (0, $kx8ta.tryCacheWithClear)(this.flagsCache, flagKey, response, 50);
        const returnValue = {
            response: response,
            cached: false
        };
        return returnValue;
    }
    async postFlag(flagKey) {
        const path = `${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.HAVE_I_SEEN_IT_URL)}`;
        await (0, $evtmo.postRequest)(path, 'postFlagHISI', {
            flagKey: flagKey
        });
        this.flagsCache.set(flagKey, {
            status: true,
            lastSeenDate: new Date().toISOString()
        });
    }
}

});

parcelRegister("fIjji", function(module, exports) {

$parcel$export(module.exports, "PersonalizationClient", () => $dbd16ead1a5ce949$export$c5b41f73d41fa593);

var $evtmo = parcelRequire("evtmo");

var $z3rjp = parcelRequire("z3rjp");
const $dbd16ead1a5ce949$export$4699366f3c37153b = (cloudId, userId)=>`${0, $z3rjp.PERSONALIZATION_URL}/site/${cloudId}/user/${userId}`;
const $dbd16ead1a5ce949$export$35bc6862a72d40bd = (cloudId)=>`${0, $z3rjp.PERSONALIZATION_URL}/site/${cloudId}`;
class $dbd16ead1a5ce949$export$c5b41f73d41fa593 {
    constructor(){
        this.getPersonalizationSiteTraits = (cloudId)=>(0, $evtmo.fetchJson)($dbd16ead1a5ce949$export$35bc6862a72d40bd(cloudId), 'getPeronalizationSiteTraits');
        this.getPersonalizationSiteUserTraits = (cloudId, userId)=>(0, $evtmo.fetchJson)($dbd16ead1a5ce949$export$4699366f3c37153b(cloudId, userId), 'getPersonalizationSiteUserTraits');
    }
}
const $dbd16ead1a5ce949$export$d3e1efd45b274804 = new $dbd16ead1a5ce949$export$c5b41f73d41fa593();

});

parcelRegister("lCxIn", function(module, exports) {

$parcel$export(module.exports, "InviteThirdPartyTeamsClient", () => $c4b77fd05e3493c5$export$a0b2bb3cf70cafd7);

var $z3rjp = parcelRequire("z3rjp");

var $evtmo = parcelRequire("evtmo");
class $c4b77fd05e3493c5$export$a0b2bb3cf70cafd7 {
    async listSlackChannels(workspaceId, cursor) {
        return (0, $evtmo.fetchJson)(`${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.ITPT_PATH)}${(0, $z3rjp.ITPT_SLACK_CHANNELS)}?workspaceId=${workspaceId}${cursor ? `&cursor=${cursor}` : ''}`, 'listSlackChannels');
    }
    async getSlackChannelMembers(workspaceId, channelId) {
        return (0, $evtmo.fetchJson)(`${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.ITPT_PATH)}${(0, $z3rjp.ITPT_SLACK_CHANNEL_MEMBERS)}?workspaceId=${workspaceId}&channelId=${channelId}`, 'getSlackChannelMembers');
    }
    async getSlackUserDetailsAndPerms(tenantId, workspaceId, product, users) {
        return await (0, $evtmo.postJson)(`${(0, $z3rjp.DEFAULT_STARGATE_SERVICE_URL)}${(0, $z3rjp.ITPT_PATH)}${(0, $z3rjp.ITPT_SLACK_USERS_DETAILS)}`, 'getSlackUserDetailsAndPerms', {
            tenantId: tenantId,
            workspaceId: workspaceId,
            product: product,
            users: users
        });
    }
}

});


parcelRegister("hkLbH", function(module, exports) {

$parcel$export(module.exports, "ProductSelectAnalytics", () => $ee96a792a5da4fcd$export$395cad012eb6716e);

var $lp06J = parcelRequire("lp06J");

var $hatDq = parcelRequire("hatDq");
class $ee96a792a5da4fcd$export$395cad012eb6716e extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    productSelectRendered(productOptions) {
        const { userRole: userRole, source: source } = this.commonAttributes;
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).DROPDOWN,
            actionSubjectId: 'customizedProductSelect',
            action: (0, $hatDq.AnalyticsAction).RENDERED,
            attributes: {
                integration: source,
                source: source,
                userRole: userRole,
                productOptions: productOptions
            }
        });
    }
    selectAllClicked(productsSelected) {
        const { productTitle: productTitle, source: source, userRole: userRole } = this.commonAttributes;
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).DROPDOWN_ITEM,
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            actionSubjectId: 'selectAll',
            attributes: {
                integration: source,
                source: source,
                product: productTitle.toLowerCase(),
                productsSelected: productsSelected,
                permissionLevel: userRole
            }
        });
    }
    getAvailableProductsSucceeded(resourceAri, availableResourcesAri) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INVITE_CAPABILITIES,
            actionSubjectId: resourceAri,
            action: (0, $hatDq.AnalyticsAction).SUCCEEDED,
            attributes: {
                availableResourcesAri: availableResourcesAri
            }
        });
    }
    getAvailableProductsFailed(resourceAri) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INVITE_CAPABILITIES,
            actionSubjectId: resourceAri,
            action: (0, $hatDq.AnalyticsAction).FAILED
        });
    }
}

});



parcelRegister("e3724", function(module, exports) {

$parcel$export(module.exports, "default", () => $9afb158e039dbf76$export$2e2bcd8739ae039);
/* InviteeList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $k5Wbc = parcelRequire("k5Wbc");
var $4EHpO = parcelRequire("4EHpO");
var $cUUCJ = parcelRequire("cUUCJ");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");


var $4kIK6 = parcelRequire("4kIK6");
var $grXIr = parcelRequire("grXIr");

var $cfWle = parcelRequire("cfWle");

var $84G45 = parcelRequire("84G45");
var $6HEbe = parcelRequire("6HEbe");

var $1TRcz = parcelRequire("1TRcz");
var $eddUJ = parcelRequire("eddUJ");
var $dCNWF = parcelRequire("dCNWF");

var $cyXdR = parcelRequire("cyXdR");

var $daXvt = parcelRequire("daXvt");

var $fn6W9 = parcelRequire("fn6W9");

var $fJpmn = parcelRequire("fJpmn");
var $hatDq = parcelRequire("hatDq");

var $kx8ta = parcelRequire("kx8ta");

var $86tbn = parcelRequire("86tbn");

var $7NZnV = parcelRequire("7NZnV");


var $8TQ2j = parcelRequire("8TQ2j");

var $hofb1 = parcelRequire("hofb1");

var $CZywg = parcelRequire("CZywg");

var $bcZLD = parcelRequire("bcZLD");

var $1SD2y = parcelRequire("1SD2y");

var $jN5wg = parcelRequire("jN5wg");

var $1CnPD = parcelRequire("1CnPD");

const $9afb158e039dbf76$var$LazySlackTeamsSpotlight = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("eA2RF")));
const $9afb158e039dbf76$var$styles = {
    fieldWrapper: "_kqswh2mm",
    label: "_11c816g6 _1e0c1ule _k48p1pd9 _syaz131l _19pkze3t _otyr1b66"
};
const $9afb158e039dbf76$var$UserPickerError = ({ validationList: validationList, isEmptyInput: isEmptyInput, maxEmails: maxEmails })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": "testId-invite-people-invitee-list-error-messages",
        children: [
            (0, $5uXOq.Children).toArray(validationList.map((validationState)=>validationState.validationState === 'error' && validationState.errorMessage && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k5Wbc.ErrorMessage), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...validationState.errorMessage,
                        values: {
                            maxEmails: maxEmails
                        }
                    })
                }))),
            isEmptyInput && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k5Wbc.ErrorMessage), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $fn6W9.messages).inviteeListPickerNote
                })
            })
        ]
    });
};
const $9afb158e039dbf76$var$InviteeList = ({ maxEmails: maxEmails = 10, onInviteeListChange: onInviteeListChange = ()=>{}, showEmptyError: showEmptyError = false, autoFocus: autoFocus = false })=>{
    const [inputValue, setInputValue] = (0, $5uXOq.useState)(undefined);
    const analytics = (0, $6HEbe.useAnalytics)((0, $jN5wg.InviteeListAnalytics));
    const { isCoreInvitesInJiraProjectEnabled: isCoreInvitesInJiraProjectEnabled } = (0, $cfWle.useCoreInvitesJiraProjectContext)();
    const { onSlackConnected: onSlackConnected } = (0, $86tbn.useInviteThirdPartyTeams)();
    const { allowEmail: allowEmail, selectedTeam: selectedTeam, setSelectedTeam: setSelectedTeam, setUserPickerOptions: setUserPickerOptions, userPickerOptions: userPickerOptions, experimental_userPickerByline: experimental_userPickerByline } = (0, $1CnPD.useInviteeListStateContext)();
    const { onInviteeListFocus: onInviteeListFocus } = (0, $hofb1.useViralSettingsContext)();
    const { queryThirdParty: queryThirdParty, querySlackChannels: querySlackChannels, integrations: integrations, updateIntegrations: updateIntegrations, isConnected: thirdPartyConnected } = (0, $dCNWF.useThirdPartyState)();
    const { cloudId: cloudId, invitePromptOnLinkV3Cohort: invitePromptOnLinkV3Cohort, inviteeProvider: inviteeProvider, loggedInEmailDomain: loggedInEmailDomain, productId: productId, userEmail: userEmail } = (0, $daXvt.useInvitePeopleContext)();
    const [spotlightHidden, setSpotlightHidden] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (onSlackConnected) setSpotlightHidden(false);
    }, [
        onSlackConnected
    ]);
    const [hasValidationError, validationList] = (0, $5uXOq.useMemo)(()=>{
        const { emails: emails, ids: ids } = (0, $1CnPD.getEmailAndIdArrays)(userPickerOptions);
        const validationList = (0, $1SD2y.determineValidationState)(emails, ids, maxEmails, userEmail, isCoreInvitesInJiraProjectEnabled);
        return [
            (0, $1SD2y.hasError)(validationList),
            validationList
        ];
    }, [
        maxEmails,
        userPickerOptions,
        userEmail,
        isCoreInvitesInJiraProjectEnabled
    ]);
    // This is used to make the "Enter up to 10 email addresses" an error if
    // the field is empty; EXCEPT it won't show until the form has been submitted
    const isEmptyInput = userPickerOptions.length === 0 && showEmptyError;
    const itpt = (0, $86tbn.useInviteThirdPartyTeams)();
    const onFocusEventWithAnalytics = (0, $5uXOq.useCallback)((pickerId)=>()=>{
            analytics.inviteeListFocused(pickerId);
            onInviteeListFocus();
        }, [
        analytics,
        onInviteeListFocus
    ]);
    const userPickerTypedDebounce = (0, $bcZLD.useDebounce)(2000);
    const getNewEmail = (prevEmails, emails)=>{
        const newEmails = emails.filter((email)=>!prevEmails.includes(email));
        return newEmails.shift() || '';
    };
    const onUserSelectionChange = (0, $5uXOq.useCallback)((value)=>{
        // picking a team
        if (itpt.isEnabled && Array.isArray(value) && value.length > 0) {
            const lastOption = value[value.length - 1];
            if (lastOption.type === (0, $d65afe1996371623$export$2fc7d0f2376458)) {
                setSelectedTeam(lastOption);
                analytics.slackChannelClicked(lastOption.id);
                return;
            }
        }
        let values = [];
        if (Array.isArray(value)) values = value;
        else if (value) values = [
            value
        ];
        for (const value of values){
            if ((0, $grXIr.isEmail)(value)) {
                value.name = (0, $kx8ta.removeZeroWidthCharacters)(value.name);
                value.id = (0, $kx8ta.removeZeroWidthCharacters)(value.id);
            }
            if ((0, $grXIr.isExternalUser)(value) && value.sources.includes('slack')) analytics.slackUserSelected();
        }
        const { emails: emails } = (0, $1CnPD.getEmailAndIdArrays)(values);
        setUserPickerOptions((prevEmails)=>{
            // Only fire analytics event if an email is added
            const { emails: previousEmailsStrings } = (0, $1CnPD.getEmailAndIdArrays)(prevEmails);
            prevEmails.length < values.length && analytics.inviteeListItemAdded((0, $84G45.USER_PICKER_ID), {
                domains: [
                    (0, $kx8ta.extractDomainFromEmail)(getNewEmail(previousEmailsStrings, emails)) || ''
                ]
            });
            return values;
        });
    }, [
        itpt.isEnabled,
        setUserPickerOptions,
        setSelectedTeam,
        analytics
    ]);
    // Validator and call onInviteeListChange
    (0, $5uXOq.useEffect)(()=>{
        const { emails: emails, ids: ids } = (0, $1CnPD.getEmailAndIdArrays)(userPickerOptions);
        if (emails.length === 0 && ids.length === 0) {
            onInviteeListChange([], []);
            return;
        }
        const selectOptions = [
            ...emails,
            ...ids
        ];
        // Finally, send back all entered email addresses to the parent component
        onInviteeListChange(selectOptions, // valid emails
        emails.filter((email)=>(0, $1SD2y.validateEmail)(email) === 'VALID'));
    }, [
        userPickerOptions,
        maxEmails,
        onInviteeListChange,
        userEmail
    ]);
    const loadOptionsBase = (0, $5uXOq.useCallback)(async (searchText)=>{
        if (!searchText || searchText.trim().length === 0) return [];
        const onInviteeLoadOptionsPromise = inviteeProvider?.onInviteeLoadOptions({
            searchText: searchText
        }) ?? Promise.resolve([]);
        const queryThirdPartyPromise = queryThirdParty(searchText);
        const [thirdPartySearch, inviteeLoadOptionsSearch] = await Promise.all([
            queryThirdPartyPromise,
            onInviteeLoadOptionsPromise
        ]);
        const providedAdditionalUsers = [];
        const groups = [];
        inviteeLoadOptionsSearch.forEach((item)=>{
            if (item.type === 'group') groups.push(item);
            else providedAdditionalUsers.push(item);
        });
        let mergedExternalUsers = thirdPartySearch;
        if (providedAdditionalUsers.length > 0) mergedExternalUsers = (0, $cyXdR.mergeAndSearchExternalUsers)({
            providedAdditionalUsers: providedAdditionalUsers,
            searchText: searchText,
            connectedThirdPartyUsers: thirdPartySearch
        });
        const options = [
            ...groups,
            ...mergedExternalUsers
        ];
        const { onInviteeResultsMerged: onInviteeResultsMerged } = inviteeProvider || {};
        if (onInviteeResultsMerged) return onInviteeResultsMerged(options);
        return options;
    }, [
        inviteeProvider,
        queryThirdParty
    ]);
    const withTypedEvent = (0, $5uXOq.useCallback)((loadOptions)=>async (searchText)=>{
            const options = await loadOptions(searchText);
            if (searchText !== undefined) userPickerTypedDebounce(()=>{
                analytics.userPickerTyped({
                    queryLength: searchText.length,
                    results: options.map((option)=>({
                            type: option.type ?? null,
                            // Note that sources from cache will only be added if option
                            // is loaded from org-people-picker
                            sources: option.sources
                        }))
                });
            });
            return options;
        }, [
        analytics,
        userPickerTypedDebounce
    ]);
    const loadOptions = (0, $5uXOq.useMemo)(()=>withTypedEvent(loadOptionsBase), [
        loadOptionsBase,
        withTypedEvent
    ]);
    const loadOptionsWithTeams = (0, $5uXOq.useMemo)(()=>withTypedEvent(async (searchText)=>{
            let teamsOrUsers;
            let slackChannelsSearch;
            const groups = [];
            if (!searchText || searchText.trim().length === 0) return [];
            let optionsSearch;
            [optionsSearch, slackChannelsSearch] = await Promise.all([
                loadOptionsBase(searchText),
                querySlackChannels(searchText)
            ]);
            const usersSearch = [];
            optionsSearch.forEach((option)=>{
                if (option.type === 'user' && option.sources) usersSearch.push(option);
                else if (option.type === 'group') groups.push(option);
            });
            teamsOrUsers = (0, $cyXdR.mergeAndSearchExternalTeamsOrUsers)(searchText, usersSearch, slackChannelsSearch);
            if (slackChannelsSearch.length > 0) {
                const teamIds = teamsOrUsers.reduce((ids, option)=>{
                    if (option.type === (0, $d65afe1996371623$export$2fc7d0f2376458)) ids.push(option.id);
                    return ids;
                }, []);
                analytics.teamOrUserPickerViewed({
                    teamIds: teamIds
                });
            }
            const { onInviteeResultsMerged: onInviteeResultsMerged } = inviteeProvider || {};
            if (onInviteeResultsMerged) return onInviteeResultsMerged([
                ...groups,
                ...teamsOrUsers
            ]);
            return [
                ...groups,
                ...teamsOrUsers
            ];
        }), [
        withTypedEvent,
        inviteeProvider,
        loadOptionsBase,
        querySlackChannels,
        analytics
    ]);
    const isStickyEmail = (0, $CZywg.useIsStickyExperimentEnabled)(allowEmail);
    const peuExperimentStickyStyles = (0, $CZywg.useStickyExperimentStyles)(userPickerOptions);
    const customStyles = (0, $5uXOq.useMemo)(()=>{
        return {
            control: (css, state)=>{
                const borderColor = hasValidationError || isEmptyInput ? `var(--ds-border-danger, ${0, $a7f8c6b391092279$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${0, $a7f8c6b391092279$export$ecfc1dff386a3e7a})` : `var(--ds-border, ${0, $a7f8c6b391092279$export$1ce2d1575d444ceb})`;
                return {
                    ...css,
                    borderColor: borderColor,
                    backgroundColor: state.isFocused ? `var(--ds-background-input-hovered, ${0, $a7f8c6b391092279$export$9fdfb749e33cdf97})` : `var(--ds-background-input, ${0, $a7f8c6b391092279$export$29a4f05edc054374})`,
                    ':hover': {
                        ...css[':hover'],
                        backgroundColor: `var(--ds-background-input-hovered, ${0, $a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                        borderColor: borderColor
                    }
                };
            },
            menuPortal: (provided)=>({
                    ...provided,
                    zIndex: (0, $hatDq.ZIndex).FLOATING
                }),
            ...isStickyEmail && peuExperimentStickyStyles
        };
    }, [
        isEmptyInput,
        hasValidationError,
        isStickyEmail,
        peuExperimentStickyStyles
    ]);
    const commonUserPickerProps = (0, $5uXOq.useMemo)(()=>{
        const onInputChange = (query)=>{
            const trimmedValue = query?.trimStart();
            setInputValue(trimmedValue);
        };
        const pickerThirdPartyTeamsPlaceholder = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $fn6W9.messages).inviteeListUserPickerEmailPlaceholderThirdPartyTeams
        });
        const pickerPlaceholder = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $fn6W9.messages).inviteeListUserPickerPlaceholder
        });
        const props = {
            ariaLive: 'polite',
            autoFocus: autoFocus,
            onChange: onUserSelectionChange,
            noOptionsMessage: ()=>null,
            placeholder: itpt.isEnabled && integrations.has((0, $8TQ2j.PLATFORM_SLACK_SERVICE)) ? pickerThirdPartyTeamsPlaceholder : pickerPlaceholder,
            width: '100%',
            value: userPickerOptions,
            isValidEmail: (0, $1SD2y.validateEmail),
            isClearable: true,
            isMulti: true,
            allowEmail: allowEmail,
            suggestEmailsForDomain: loggedInEmailDomain,
            styles: customStyles,
            menuPortalTarget: document.body,
            menuPosition: 'absolute',
            onInputChange: onInputChange,
            search: inputValue,
            required: true
        };
        return props;
    }, [
        allowEmail,
        autoFocus,
        customStyles,
        integrations,
        itpt.isEnabled,
        loggedInEmailDomain,
        onUserSelectionChange,
        userPickerOptions,
        inputValue
    ]);
    const shouldLoadOptions = !!inviteeProvider?.onInviteeLoadOptions || integrations.size > 0;
    const renderPicker = (0, $5uXOq.useCallback)((describedByFieldId)=>{
        if (itpt.isEnabled && cloudId) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Suspense), {
            fallback: null,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)($9afb158e039dbf76$var$LazySlackTeamsSpotlight, {
                    productId: productId,
                    spotlightHidden: spotlightHidden,
                    dismissSpotlight: ()=>setSpotlightHidden(true),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7NZnV.default), {
                        tenantId: cloudId,
                        product: productId,
                        fieldId: "invite-team-user-picker",
                        inputId: "invite-team-user-picker",
                        ariaLabelledBy: "invite-people-title",
                        "aria-describedby": describedByFieldId,
                        onFocus: onFocusEventWithAnalytics((0, $84G45.TEAM_OR_USER_PICKER_ID)),
                        loadOptions: shouldLoadOptions ? loadOptionsWithTeams : undefined,
                        selectedTeam: selectedTeam,
                        setSelectedTeam: setSelectedTeam,
                        // Calculated using the following measurements
                        //
                        // 6 (rows) *
                        // 28px (pill height (24px) + margin top (2px) + margin bottom (2px)) -
                        // 14px (half of the above value, since we want to show half of the top pill to indicate there's more pills to scroll through) +
                        // 6px (user picker bottom padding) +
                        // 28px (height of the "add more people..." placeholder (20px) + margin top (4px) + margin bottom (4px))
                        //
                        // This is done so that we can show 5 rows of pills + half a row of pills when there are too many pills in the user
                        // picker
                        maxPickerHeight: 188,
                        ...commonUserPickerProps
                    })
                }),
                !!invitePromptOnLinkV3Cohort && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                    as: "span",
                    size: "small",
                    color: "color.text.subtlest",
                    children: experimental_userPickerByline
                })
            ]
        });
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4kIK6.UserPicker), {
                    fieldId: "invite-user-picker",
                    inputId: "invite-user-picker",
                    ariaLabelledBy: "invite-people-title",
                    "aria-describedby": describedByFieldId,
                    onFocus: onFocusEventWithAnalytics((0, $84G45.USER_PICKER_ID)),
                    loadOptions: shouldLoadOptions ? loadOptions : undefined,
                    ...commonUserPickerProps
                }),
                !!invitePromptOnLinkV3Cohort && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                    as: "span",
                    size: "small",
                    color: "color.text.subtlest",
                    children: experimental_userPickerByline
                })
            ]
        });
    }, [
        itpt.isEnabled,
        cloudId,
        onFocusEventWithAnalytics,
        shouldLoadOptions,
        loadOptions,
        commonUserPickerProps,
        productId,
        spotlightHidden,
        loadOptionsWithTeams,
        selectedTeam,
        setSelectedTeam,
        invitePromptOnLinkV3Cohort,
        experimental_userPickerByline
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4EHpO.default), {
        name: "invite-people-invitee-list",
        children: (formProps)=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                testId: "testId-invite-people-invitee-list",
                xcss: $9afb158e039dbf76$var$styles.fieldWrapper,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                        as: "label",
                        htmlFor: itpt.isEnabled ? 'invite-team-user-picker' : 'invite-user-picker',
                        xcss: $9afb158e039dbf76$var$styles.label,
                        children: [
                            itpt.isEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $fn6W9.messages).inviteeListLabelThirdPartyTeams
                            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $fn6W9.messages).inviteeListLabelThirdParty
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cUUCJ.default), {})
                        ]
                    }),
                    renderPicker(`${formProps.fieldProps.id}-error`),
                    /*#__PURE__*/ (0, $2OMIu.jsx)($9afb158e039dbf76$var$UserPickerError, {
                        validationList: validationList,
                        isEmptyInput: isEmptyInput,
                        maxEmails: maxEmails
                    }),
                    thirdPartyConnected && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1TRcz.default), {}),
                    !!updateIntegrations.partialScope.size && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eddUJ.default), {
                        scope: (0, $fJpmn.ScopeState).PARTIAL_SCOPE
                    }),
                    thirdPartyConnected && !!updateIntegrations.noScope.size && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eddUJ.default), {
                        scope: (0, $fJpmn.ScopeState).NO_SCOPE
                    })
                ]
            })
    });
};
var $9afb158e039dbf76$export$2e2bcd8739ae039 = $9afb158e039dbf76$var$InviteeList;

});
parcelRegister("4EHpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4338501a4bebd545$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $jJsBW = parcelRequire("jJsBW");

var $bU9TL = parcelRequire("bU9TL");

var $7folp = parcelRequire("7folp");

var $cGltd = parcelRequire("cGltd");

var $cUUCJ = parcelRequire("cUUCJ");

var $6cAn5 = parcelRequire("6cAn5");
const $4338501a4bebd545$var$fieldWrapperStyles = null;
function $4338501a4bebd545$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $4338501a4bebd545$var$isFunction(x) {
    return typeof x === 'function';
}
function $4338501a4bebd545$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $4338501a4bebd545$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $4338501a4bebd545$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $7folp.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $7folp.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $4338501a4bebd545$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $4338501a4bebd545$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$4338501a4bebd545$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $4338501a4bebd545$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $4338501a4bebd545$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($4338501a4bebd545$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $jJsBW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cGltd.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cUUCJ.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("7folp", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $989b7d35312a49bd$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $989b7d35312a49bd$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $989b7d35312a49bd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $989b7d35312a49bd$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $989b7d35312a49bd$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $989b7d35312a49bd$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($989b7d35312a49bd$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($989b7d35312a49bd$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("cGltd", function(module, exports) {

$parcel$export(module.exports, "Label", () => $6da09f2418b6f13e$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $6da09f2418b6f13e$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6da09f2418b6f13e$var$fieldsetLabelStyles = null;
const $6da09f2418b6f13e$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $6da09f2418b6f13e$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});


parcelRegister("4kIK6", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $66beadc127696f3d$export$83e0c73b09b3a9cd);

var $2OMIu = parcelRequire("2OMIu");

var $3TR0I = parcelRequire("3TR0I");

var $8p2Od = parcelRequire("8p2Od");
var $lau8t = parcelRequire("lau8t");

var $e35GK = parcelRequire("e35GK");

var $5uXOq = parcelRequire("5uXOq");

var $8vKcg = parcelRequire("8vKcg");

var $lor1T = parcelRequire("lor1T");

var $cnoGa = parcelRequire("cnoGa");

var $5kiFd = parcelRequire("5kiFd");

var $gqIZX = parcelRequire("gqIZX");

var $l30aB = parcelRequire("l30aB");

var $b3Vox = parcelRequire("b3Vox");

var $dhLc4 = parcelRequire("dhLc4");

var $7Jxgt = parcelRequire("7Jxgt");

var $fHpHg = parcelRequire("fHpHg");
class $66beadc127696f3d$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $7Jxgt.v4)();
        const experienceForId = (0, $dhLc4.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $e35GK.UFOExperienceState).IN_PROGRESS.id,
            (0, $e35GK.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $dhLc4.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $e35GK.UFOExperienceState).IN_PROGRESS.id,
            (0, $e35GK.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $8p2Od.default) : (0, $lau8t.default);
        const creatableProps = suggestEmailsForDomain ? (0, $gqIZX.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $5kiFd.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dhLc4.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l30aB.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b3Vox.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8vKcg.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        width: width,
                        SelectComponent: SelectComponent,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        styles: (0, $lor1T.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, this.props.isInvalid, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
                        (0, $fHpHg.fg)('platform-component-visual-refresh') && (0, $fHpHg.fg)('visual-refresh-user-picker')),
                        components: (0, $cnoGa.getComponents)(isMulti, anchor),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
}
const $66beadc127696f3d$export$83e0c73b09b3a9cd = (0, $3TR0I.default)()($66beadc127696f3d$export$164f4d95e5d7e2f5);

});
parcelRegister("8p2Od", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f8ddcf2a6bdb8a$export$2e2bcd8739ae039);

var $793nn = parcelRequire("793nn");

var $7Qatx = parcelRequire("7Qatx");
const $e1f8ddcf2a6bdb8a$var$CreatableSelect = (0, $7Qatx.default)((0, $793nn.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e1f8ddcf2a6bdb8a$export$2e2bcd8739ae039 = $e1f8ddcf2a6bdb8a$var$CreatableSelect;

});
parcelRegister("793nn", function(module, exports) {

$parcel$export(module.exports, "default", () => $221e646eec2f5412$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("jtdsb")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $djBXi = parcelRequire("djBXi");

var $jtdsb = parcelRequire("jtdsb");

var $63z2N = parcelRequire("63z2N");
const $221e646eec2f5412$var$CreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const creatableProps = (0, $63z2N.default)(props);
    const selectProps = (0, $jtdsb.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $djBXi.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$221e646eec2f5412$export$2e2bcd8739ae039 = $221e646eec2f5412$var$CreatableSelect;

});
parcelRegister("jtdsb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4f1728a626c2897$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jwj8k = parcelRequire("jwj8k");

var $b0fMV = parcelRequire("b0fMV");
const $b4f1728a626c2897$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $b4f1728a626c2897$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$b4f1728a626c2897$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$b4f1728a626c2897$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $b4f1728a626c2897$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $b4f1728a626c2897$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $b4f1728a626c2897$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $b4f1728a626c2897$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $jwj8k.getOptionValue), getOptionLabel: getOptionLabel = (0, $jwj8k.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, $b0fMV.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $b0fMV.valueTernary)(isMulti, [
                    ...(0, $b0fMV.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("8vKcg", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $272ffc26a690b187$export$b4ff48c8d43b18c3);

var $2OMIu = parcelRequire("2OMIu");

var $3TR0I = parcelRequire("3TR0I");

var $e35GK = parcelRequire("e35GK");

var $lFKmC = parcelRequire("lFKmC");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fHpHg = parcelRequire("fHpHg");

var $7Jxgt = parcelRequire("7Jxgt");

var $fDHET = parcelRequire("fDHET");

var $f3Ls0 = parcelRequire("f3Ls0");

var $4NWOr = parcelRequire("4NWOr");

var $grXIr = parcelRequire("grXIr");

var $dhLc4 = parcelRequire("dhLc4");
const $272ffc26a690b187$var$loadingMessage = ()=>null;
const $272ffc26a690b187$var$classNamePrefix = 'fabric-user-picker';
class $272ffc26a690b187$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $4NWOr.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $grXIr.optionToSelectableOptions)(nextProps.value);
        else if ((0, $grXIr.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $grXIr.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $grXIr.callCallback)(onChange, (0, $grXIr.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $grXIr.callCallback)(onSelection, (0, $grXIr.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $fDHET.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $fDHET.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $grXIr.callCallback)(onClear);
                    this.fireEvent((0, $fDHET.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $fDHET.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $fDHET.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $f3Ls0.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $fDHET.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $grXIr.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $e35GK.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $grXIr.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $grXIr.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $grXIr.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleBlur = ()=>{
            (0, $grXIr.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $grXIr.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleOpen = ()=>{
            (0, $grXIr.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleClose = ()=>{
            this.resetInputState();
            (0, $grXIr.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $grXIr.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $fDHET.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $fDHET.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $fDHET.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptions = ()=>{
            const options = (0, $grXIr.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return filteredOptions.slice(0, maxOptions);
            }
            return options;
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $dhLc4.userPickerOptionsShownUfoExperience).getInstance((0, $7Jxgt.v4)());
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $fDHET.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $fDHET.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $e35GK.UFOExperienceState).STARTED.id,
            (0, $e35GK.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": (0, $fHpHg.fg)('pass-aria-describedby-to-baseuserpicker') ? ariaDescribedBy : undefined,
            "aria-label": ariaLabel,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $272ffc26a690b187$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $4NWOr.messages).placeholder
            }),
            addMoreMessage: addMoreMessage,
            classNamePrefix: $272ffc26a690b187$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $272ffc26a690b187$export$d099ade7b4f4d2a4 = (0, $3TR0I.default)()($272ffc26a690b187$export$b4ff48c8d43b18c3);

});
parcelRegister("fDHET", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $23708db1428e0cef$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $23708db1428e0cef$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $23708db1428e0cef$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $23708db1428e0cef$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $23708db1428e0cef$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $23708db1428e0cef$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $23708db1428e0cef$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $23708db1428e0cef$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $23708db1428e0cef$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $23708db1428e0cef$export$f541f04954b0c11e);

var $9Iej8 = parcelRequire("9Iej8");

var $7Jxgt = parcelRequire("7Jxgt");

var $grXIr = parcelRequire("grXIr");
const $23708db1428e0cef$var$packageName = "platform-pkg";
const $23708db1428e0cef$var$packageVersion = "0.0.0-use.local";
const $23708db1428e0cef$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $23708db1428e0cef$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $23708db1428e0cef$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $23708db1428e0cef$export$c0d84948cecf78d8 = ()=>({
        id: (0, $7Jxgt.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $23708db1428e0cef$export$53eef0dcd9611650 = (0, $9Iej8.default)('fabric-elements');
const $23708db1428e0cef$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $23708db1428e0cef$var$packageName,
            packageVersion: $23708db1428e0cef$var$packageVersion,
            ...attributes
        }
    });
const $23708db1428e0cef$var$checkValidId = (id)=>{
    return $23708db1428e0cef$var$UUID_REGEXP_NEW_AAID.test(id) || $23708db1428e0cef$var$UUID_REGEXP_OLD_AAID.test(id) || $23708db1428e0cef$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $23708db1428e0cef$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $23708db1428e0cef$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $grXIr.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $grXIr.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $23708db1428e0cef$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$23708db1428e0cef$var$optionData2Analytics(data));
    }
    return [];
};
const $23708db1428e0cef$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $23708db1428e0cef$var$sessionId(session),
        pickerType: $23708db1428e0cef$var$pickerType(props),
        journeyId: journeyId
    });
const $23708db1428e0cef$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$23708db1428e0cef$var$createEvent('ui', 'focused', 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $23708db1428e0cef$var$buildValueForAnalytics(state.value)
    });
const $23708db1428e0cef$export$7b5800e732182efb = (props, state, session, journeyId)=>$23708db1428e0cef$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $23708db1428e0cef$var$values(state)
    });
const $23708db1428e0cef$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$23708db1428e0cef$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $23708db1428e0cef$var$sessionId(session),
        journeyId: journeyId,
        value: $23708db1428e0cef$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $23708db1428e0cef$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$23708db1428e0cef$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $23708db1428e0cef$var$sessionDuration(session),
        queryLength: $23708db1428e0cef$var$queryLength(args[0]),
        spaceInQuery: $23708db1428e0cef$var$spaceInQuery(args[0]),
        upKeyCount: $23708db1428e0cef$var$upKeyCount(session),
        downKeyCount: $23708db1428e0cef$var$downKeyCount(session)
    });
const $23708db1428e0cef$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $23708db1428e0cef$var$createEvent('ui', $23708db1428e0cef$var$selectEventType(session), 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $23708db1428e0cef$var$sessionDuration(session),
        position: $23708db1428e0cef$var$position(state, args[0]),
        queryLength: $23708db1428e0cef$var$queryLength(state),
        spaceInQuery: $23708db1428e0cef$var$spaceInQuery(state),
        upKeyCount: $23708db1428e0cef$var$upKeyCount(session),
        downKeyCount: $23708db1428e0cef$var$downKeyCount(session),
        result: $23708db1428e0cef$var$result(args[0]),
        numberOfResults: $23708db1428e0cef$var$numberOfResults(state)
    });
};
const $23708db1428e0cef$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $23708db1428e0cef$var$results(state);
    return $23708db1428e0cef$var$createEvent('operational', 'searched', 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $23708db1428e0cef$var$sessionDuration(session),
        durationSinceInputChange: $23708db1428e0cef$var$durationSinceInputChange(session),
        queryLength: $23708db1428e0cef$var$queryLength(state),
        isLoading: $23708db1428e0cef$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $23708db1428e0cef$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$23708db1428e0cef$var$createEvent('operational', 'failed', 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $23708db1428e0cef$export$f541f04954b0c11e = (sources, accountId)=>$23708db1428e0cef$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $23708db1428e0cef$var$checkValidId(accountId) ? accountId : null
    });
function $23708db1428e0cef$var$queryLength(state) {
    return state.inputValue.length;
}
function $23708db1428e0cef$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $23708db1428e0cef$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $23708db1428e0cef$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $23708db1428e0cef$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $23708db1428e0cef$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $23708db1428e0cef$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $23708db1428e0cef$var$sessionId(session) {
    return session && session.id;
}
function $23708db1428e0cef$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $23708db1428e0cef$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $23708db1428e0cef$var$result(option) {
    return option ? $23708db1428e0cef$var$optionData2Analytics(option.data) : null;
}
function $23708db1428e0cef$var$results(state) {
    return (state.options || []).map($23708db1428e0cef$var$optionData2Analytics);
}
function $23708db1428e0cef$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $23708db1428e0cef$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$23708db1428e0cef$var$optionData2Analytics(option.data)) : [
        $23708db1428e0cef$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $23708db1428e0cef$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("grXIr", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $3d4e9c0ae8c2a010$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $3d4e9c0ae8c2a010$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $3d4e9c0ae8c2a010$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $3d4e9c0ae8c2a010$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $3d4e9c0ae8c2a010$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $3d4e9c0ae8c2a010$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $3d4e9c0ae8c2a010$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $3d4e9c0ae8c2a010$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $3d4e9c0ae8c2a010$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $3d4e9c0ae8c2a010$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $3d4e9c0ae8c2a010$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $3d4e9c0ae8c2a010$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $3d4e9c0ae8c2a010$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $3d4e9c0ae8c2a010$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $3d4e9c0ae8c2a010$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $3d4e9c0ae8c2a010$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $3d4e9c0ae8c2a010$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $3d4e9c0ae8c2a010$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $3d4e9c0ae8c2a010$export$5419897287f5f1c7);

var $8QpSo = parcelRequire("8QpSo");


var $1JbQI = parcelRequire("1JbQI");
const $3d4e9c0ae8c2a010$export$f6058dbcb5980cb = (option)=>option.type === (0, $ffa6e54f1b79ab69$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $3d4e9c0ae8c2a010$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $ffa6e54f1b79ab69$export$8436e53e45ffe15b);
const $3d4e9c0ae8c2a010$export$f8c4277cb588611f = (option)=>option.type === (0, $ffa6e54f1b79ab69$export$26bc40b960693765);
const $3d4e9c0ae8c2a010$export$d7976824e9f55785 = (option)=>option.type === (0, $ffa6e54f1b79ab69$export$d460f747b73abb10);
const $3d4e9c0ae8c2a010$export$7fbbfbca30081d0 = (option)=>option.type === (0, $ffa6e54f1b79ab69$export$6662b3461398ef8c);
const $3d4e9c0ae8c2a010$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $ffa6e54f1b79ab69$export$eafd0979afa5b224);
const $3d4e9c0ae8c2a010$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $3d4e9c0ae8c2a010$var$isOptionData = (option)=>option.name !== undefined;
const $3d4e9c0ae8c2a010$export$3f993c492bd6c728 = (option)=>{
    if ($3d4e9c0ae8c2a010$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $3d4e9c0ae8c2a010$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $3d4e9c0ae8c2a010$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
const $3d4e9c0ae8c2a010$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((options)=>options.map($3d4e9c0ae8c2a010$export$3f993c492bd6c728));
const $3d4e9c0ae8c2a010$export$e6fda14a194bcbcc = (0, $8QpSo.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($3d4e9c0ae8c2a010$export$3f993c492bd6c728);
    return $3d4e9c0ae8c2a010$export$3f993c492bd6c728(defaultValue);
});
const $3d4e9c0ae8c2a010$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $3d4e9c0ae8c2a010$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $3d4e9c0ae8c2a010$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $3d4e9c0ae8c2a010$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $3d4e9c0ae8c2a010$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $3d4e9c0ae8c2a010$export$b4f8f1f54acec99b = (optionData)=>{
    if ($3d4e9c0ae8c2a010$export$2e44165f1da65304(optionData) || $3d4e9c0ae8c2a010$export$f8c4277cb588611f(optionData) || $3d4e9c0ae8c2a010$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $3d4e9c0ae8c2a010$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $1JbQI.default);
const $3d4e9c0ae8c2a010$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $3d4e9c0ae8c2a010$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $ffa6e54f1b79ab69$export$8436e53e45ffe15b = 'user';
const $ffa6e54f1b79ab69$export$50042ec1d2e00e63 = 'external_user';
const $ffa6e54f1b79ab69$export$26bc40b960693765 = 'team';
const $ffa6e54f1b79ab69$export$d460f747b73abb10 = 'group';
const $ffa6e54f1b79ab69$export$6662b3461398ef8c = 'email';
const $ffa6e54f1b79ab69$export$eafd0979afa5b224 = 'custom';

parcelRegister("1JbQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce1428ca8599b707$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $ao4Ml = parcelRequire("ao4Ml");

var $cXw5N = parcelRequire("cXw5N");
var $dKwv2 = parcelRequire("dKwv2");
var $2HG8y = parcelRequire("2HG8y");

var $4wJSY = parcelRequire("4wJSY");

var $5a34e = parcelRequire("5a34e");

var $jJsBW = parcelRequire("jJsBW");

var $fHpHg = parcelRequire("fHpHg");

var $1BKyN = parcelRequire("1BKyN");


var $lau8t = parcelRequire("lau8t");

var $5IVHm = parcelRequire("5IVHm");

var $f2Cxi = parcelRequire("f2Cxi");

var $aztrV = parcelRequire("aztrV");
/**
 * Are we rendering on the client or server?
 */ const $ce1428ca8599b707$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $ce1428ca8599b707$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $ce1428ca8599b707$var$defaultPopperProps = {
    modifiers: $ce1428ca8599b707$var$modifiers,
    placement: 'bottom-start'
};
const $ce1428ca8599b707$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $ce1428ca8599b707$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$ce1428ca8599b707$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $f2Cxi.defaultComponents),
            ...props.components
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$ce1428ca8599b707$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cXw5N.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jJsBW.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2HG8y.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aztrV.NotifyOpenLayerObserver), {
                    isOpen: (0, $fHpHg.fg)('platform_dst_layer_observer_select') && this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $f2Cxi.defaultComponents),
            mergedPopperProps: $ce1428ca8599b707$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $ce1428ca8599b707$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $f2Cxi.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) // I might want to use a comma instead of a period here, when the feature flag is removed.
                    ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? `${optionName}, (${optionIndex + 1} of ${totalLength})` : `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? '' : ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $5IVHm.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $5IVHm.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $5IVHm.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    // Safari still does not announce the first option when menu is opened, so forcing a change to the input label
                    // will include the first option in the initial announcement.
                    if (!(0, $fHpHg.fg)('design_system_select-a11y-improvement') || (0, $5a34e.isSafari)() && (0, $fHpHg.fg)('design_system_select-a11y-improvement')) updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dKwv2.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $f2Cxi.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lau8t.default), {
                                    label: providedAriaLabel,
                                    // TODO: Popup Select does not work well with active-descendant
                                    "aria-live": (0, $5a34e.isAppleDevice)() && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                                    (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? 'assertive' // only needed on Apple products
                                     : undefined,
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                    styles: (0, $1BKyN.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId,
                                    ariaLiveMessages: {
                                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                                        onFocus: onReactSelectFocus,
                                        ...props.ariaLiveMessages // priority to use user handlers if provided
                                    }
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $7nsd3.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $fHpHg.fg)('platform_dst_layer_observer_select')) return;
            this.close();
        };
    }
}

});
parcelRegister("cXw5N", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $96f3e3a21854c201$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $96f3e3a21854c201$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $96f3e3a21854c201$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $96f3e3a21854c201$export$3dbd3405086fec7b = $5uXOq.createContext();
var $96f3e3a21854c201$export$cbabb21c2529b130 = $5uXOq.createContext();
function $96f3e3a21854c201$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($96f3e3a21854c201$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($96f3e3a21854c201$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("dKwv2", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $a028c7fdc314a3d7$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $cXw5N = parcelRequire("cXw5N");

var $9sasN = parcelRequire("9sasN");

var $1X8rn = parcelRequire("1X8rn");
var $a028c7fdc314a3d7$var$NOOP = function NOOP() {
    return void 0;
};
var $a028c7fdc314a3d7$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $a028c7fdc314a3d7$var$EMPTY_MODIFIERS = [];
function $a028c7fdc314a3d7$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $a028c7fdc314a3d7$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $cXw5N.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $9sasN.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $1X8rn.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $a028c7fdc314a3d7$var$NOOP,
            update: update || $a028c7fdc314a3d7$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $9sasN.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("9sasN", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $6e1ed863939d4e09$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $6e1ed863939d4e09$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $6e1ed863939d4e09$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $6e1ed863939d4e09$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $6e1ed863939d4e09$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $6e1ed863939d4e09$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $6e1ed863939d4e09$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $6e1ed863939d4e09$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $6e1ed863939d4e09$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $6e1ed863939d4e09$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $6e1ed863939d4e09$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("1X8rn", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $16c1d93cabd0d15c$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $7aL90 = parcelRequire("7aL90");

var $lHrkK = parcelRequire("lHrkK");

var $9sasN = parcelRequire("9sasN");
var $16c1d93cabd0d15c$var$EMPTY_MODIFIERS = [];
var $16c1d93cabd0d15c$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $16c1d93cabd0d15c$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $9sasN.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $9sasN.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $9sasN.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $9sasN.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $7aL90.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("7aL90", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $538e096cd49574d6$export$8f7491d57c8f97a9);

var $3xOUx = parcelRequire("3xOUx");

var $5d22G = parcelRequire("5d22G");

var $erJZ3 = parcelRequire("erJZ3");

var $8AiNL = parcelRequire("8AiNL");

var $bAjmm = parcelRequire("bAjmm");

var $lcFdJ = parcelRequire("lcFdJ");

var $7KqQI = parcelRequire("7KqQI");

var $7zSEz = parcelRequire("7zSEz");

var $ek5P6 = parcelRequire("ek5P6");

var $anqoe = parcelRequire("anqoe");


var $538e096cd49574d6$export$d34966752335dd47 = [
    (0, $5d22G.default),
    (0, $erJZ3.default),
    (0, $8AiNL.default),
    (0, $bAjmm.default),
    (0, $lcFdJ.default),
    (0, $7KqQI.default),
    (0, $7zSEz.default),
    (0, $ek5P6.default),
    (0, $anqoe.default)
];
var $538e096cd49574d6$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $3xOUx.popperGenerator)({
    defaultModifiers: $538e096cd49574d6$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("3xOUx", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $294bf2077fa79917$export$ed5e13716264f202);

var $hBSZx = parcelRequire("hBSZx");

var $h7lRj = parcelRequire("h7lRj");

var $82kk0 = parcelRequire("82kk0");

var $iMJep = parcelRequire("iMJep");

var $iEr9Q = parcelRequire("iEr9Q");

var $bKdOP = parcelRequire("bKdOP");

var $650fv = parcelRequire("650fv");


var $fJ6Ac = parcelRequire("fJ6Ac");
var $294bf2077fa79917$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $294bf2077fa79917$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $294bf2077fa79917$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $294bf2077fa79917$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $294bf2077fa79917$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $fJ6Ac.isElement)(reference) ? (0, $82kk0.default)(reference) : reference.contextElement ? (0, $82kk0.default)(reference.contextElement) : [],
                    popper: (0, $82kk0.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $iEr9Q.default)((0, $650fv.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$294bf2077fa79917$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $hBSZx.default)(reference, (0, $iMJep.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $h7lRj.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bKdOP.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$294bf2077fa79917$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $294bf2077fa79917$export$8f7491d57c8f97a9 = /*#__PURE__*/ $294bf2077fa79917$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("hBSZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd208c8e3dd9cb4f$export$2e2bcd8739ae039);

var $2aOS9 = parcelRequire("2aOS9");

var $6Kv1j = parcelRequire("6Kv1j");

var $3UmrH = parcelRequire("3UmrH");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $1lDxt = parcelRequire("1lDxt");

var $8WCqw = parcelRequire("8WCqw");

var $9YuAb = parcelRequire("9YuAb");

var $dNBRj = parcelRequire("dNBRj");
function $cd208c8e3dd9cb4f$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $dNBRj.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $dNBRj.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $cd208c8e3dd9cb4f$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fJ6Ac.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $fJ6Ac.isHTMLElement)(offsetParent) && $cd208c8e3dd9cb4f$var$isElementScaled(offsetParent);
    var documentElement = (0, $8WCqw.default)(offsetParent);
    var rect = (0, $2aOS9.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3UmrH.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9YuAb.default)(documentElement)) scroll = (0, $6Kv1j.default)(offsetParent);
        if ((0, $fJ6Ac.isHTMLElement)(offsetParent)) {
            offsets = (0, $2aOS9.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1lDxt.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("2aOS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1953fa21ac68a407$export$2e2bcd8739ae039);

var $fJ6Ac = parcelRequire("fJ6Ac");

var $dNBRj = parcelRequire("dNBRj");

var $iHejO = parcelRequire("iHejO");

var $duzhc = parcelRequire("duzhc");
function $1953fa21ac68a407$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fJ6Ac.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $dNBRj.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $dNBRj.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fJ6Ac.isElement)(element) ? (0, $iHejO.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $duzhc.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("fJ6Ac", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $b7302a2f8f3e16d5$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b7302a2f8f3e16d5$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $b7302a2f8f3e16d5$export$af51f0f06c0f328a);

var $iHejO = parcelRequire("iHejO");
function $b7302a2f8f3e16d5$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $iHejO.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b7302a2f8f3e16d5$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $iHejO.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b7302a2f8f3e16d5$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $iHejO.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("iHejO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c7598303229a8b$export$2e2bcd8739ae039);
function $d9c7598303229a8b$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("dNBRj", function(module, exports) {

$parcel$export(module.exports, "max", () => $a0bd37f1ec3b8c5c$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $a0bd37f1ec3b8c5c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $a0bd37f1ec3b8c5c$export$2077e0241d6afd3c);
var $a0bd37f1ec3b8c5c$export$8960430cfd85939f = Math.max;
var $a0bd37f1ec3b8c5c$export$96ec731ed4dcb222 = Math.min;
var $a0bd37f1ec3b8c5c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("duzhc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d2970d7bf044ee4$export$2e2bcd8739ae039);

var $eL5lS = parcelRequire("eL5lS");
function $9d2970d7bf044ee4$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $eL5lS.default)());
}

});
parcelRegister("eL5lS", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe99b418685a06a$export$2e2bcd8739ae039);
function $abe99b418685a06a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("6Kv1j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e9f19ecf6c383bb$export$2e2bcd8739ae039);

var $hNX0K = parcelRequire("hNX0K");

var $iHejO = parcelRequire("iHejO");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $d39KE = parcelRequire("d39KE");
function $4e9f19ecf6c383bb$export$2e2bcd8739ae039(node) {
    if (node === (0, $iHejO.default)(node) || !(0, $fJ6Ac.isHTMLElement)(node)) return (0, $hNX0K.default)(node);
    else return (0, $d39KE.default)(node);
}

});
parcelRegister("hNX0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf64c9a95bd91d41$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");
function $cf64c9a95bd91d41$export$2e2bcd8739ae039(node) {
    var win = (0, $iHejO.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("d39KE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0273a9c8aeed2a1a$export$2e2bcd8739ae039);
function $0273a9c8aeed2a1a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3UmrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d88034c5dd05ef3$export$2e2bcd8739ae039);
function $2d88034c5dd05ef3$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("1lDxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fb66c376a9887fc$export$2e2bcd8739ae039);

var $2aOS9 = parcelRequire("2aOS9");

var $8WCqw = parcelRequire("8WCqw");

var $hNX0K = parcelRequire("hNX0K");
function $0fb66c376a9887fc$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2aOS9.default)((0, $8WCqw.default)(element)).left + (0, $hNX0K.default)(element).scrollLeft;
}

});
parcelRegister("8WCqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $68318c45b50bb45b$export$2e2bcd8739ae039);

var $fJ6Ac = parcelRequire("fJ6Ac");
function $68318c45b50bb45b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fJ6Ac.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("9YuAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $743170baa6e13398$export$2e2bcd8739ae039);

var $326U9 = parcelRequire("326U9");
function $743170baa6e13398$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $326U9.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("326U9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2356ea197825164b$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");
function $2356ea197825164b$export$2e2bcd8739ae039(element) {
    return (0, $iHejO.default)(element).getComputedStyle(element);
}

});



parcelRegister("h7lRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7640bd28e53eae4$export$2e2bcd8739ae039);

var $2aOS9 = parcelRequire("2aOS9");
function $c7640bd28e53eae4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2aOS9.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("82kk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d9e461cb51b14a7$export$2e2bcd8739ae039);

var $91lyT = parcelRequire("91lyT");

var $lDDlB = parcelRequire("lDDlB");

var $iHejO = parcelRequire("iHejO");

var $9YuAb = parcelRequire("9YuAb");
function $5d9e461cb51b14a7$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $91lyT.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $iHejO.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9YuAb.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($5d9e461cb51b14a7$export$2e2bcd8739ae039((0, $lDDlB.default)(target)));
}

});
parcelRegister("91lyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6914eec2bc706a91$export$2e2bcd8739ae039);

var $lDDlB = parcelRequire("lDDlB");

var $9YuAb = parcelRequire("9YuAb");

var $3UmrH = parcelRequire("3UmrH");

var $fJ6Ac = parcelRequire("fJ6Ac");
function $6914eec2bc706a91$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3UmrH.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fJ6Ac.isHTMLElement)(node) && (0, $9YuAb.default)(node)) return node;
    return $6914eec2bc706a91$export$2e2bcd8739ae039((0, $lDDlB.default)(node));
}

});
parcelRegister("lDDlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc0bc31192c04a8d$export$2e2bcd8739ae039);

var $3UmrH = parcelRequire("3UmrH");

var $8WCqw = parcelRequire("8WCqw");

var $fJ6Ac = parcelRequire("fJ6Ac");
function $fc0bc31192c04a8d$export$2e2bcd8739ae039(element) {
    if ((0, $3UmrH.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fJ6Ac.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $8WCqw.default)(element) // fallback
    );
}

});



parcelRegister("iMJep", function(module, exports) {

$parcel$export(module.exports, "default", () => $dacfcbb55f910cab$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");

var $3UmrH = parcelRequire("3UmrH");

var $326U9 = parcelRequire("326U9");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $4hrjD = parcelRequire("4hrjD");

var $lDDlB = parcelRequire("lDDlB");

var $eL5lS = parcelRequire("eL5lS");
function $dacfcbb55f910cab$var$getTrueOffsetParent(element) {
    if (!(0, $fJ6Ac.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $326U9.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $dacfcbb55f910cab$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $eL5lS.default)());
    var isIE = /Trident/i.test((0, $eL5lS.default)());
    if (isIE && (0, $fJ6Ac.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $326U9.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $lDDlB.default)(element);
    if ((0, $fJ6Ac.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $fJ6Ac.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3UmrH.default)(currentNode)) < 0){
        var css = (0, $326U9.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $dacfcbb55f910cab$export$2e2bcd8739ae039(element) {
    var window = (0, $iHejO.default)(element);
    var offsetParent = $dacfcbb55f910cab$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $4hrjD.default)(offsetParent) && (0, $326U9.default)(offsetParent).position === 'static')offsetParent = $dacfcbb55f910cab$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3UmrH.default)(offsetParent) === 'html' || (0, $3UmrH.default)(offsetParent) === 'body' && (0, $326U9.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $dacfcbb55f910cab$var$getContainingBlock(element) || window;
}

});
parcelRegister("4hrjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ddf04ce957c4d3$export$2e2bcd8739ae039);

var $3UmrH = parcelRequire("3UmrH");
function $31ddf04ce957c4d3$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3UmrH.default)(element)) >= 0;
}

});


parcelRegister("iEr9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d941075e5e06e50f$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");
function $d941075e5e06e50f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $d941075e5e06e50f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $d941075e5e06e50f$var$order(modifiers); // order based on phase
    return (0, $iqJ7p.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("iqJ7p", function(module, exports) {

$parcel$export(module.exports, "top", () => $d6ada747b06c007d$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $d6ada747b06c007d$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $d6ada747b06c007d$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $d6ada747b06c007d$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $d6ada747b06c007d$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $d6ada747b06c007d$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $d6ada747b06c007d$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $d6ada747b06c007d$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $d6ada747b06c007d$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $d6ada747b06c007d$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $d6ada747b06c007d$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $d6ada747b06c007d$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $d6ada747b06c007d$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $d6ada747b06c007d$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $d6ada747b06c007d$export$d087d3878fdf71d5);
var $d6ada747b06c007d$export$1e95b668f3b82d = 'top';
var $d6ada747b06c007d$export$40e543e69a8b3fbb = 'bottom';
var $d6ada747b06c007d$export$79ffe56a765070d2 = 'right';
var $d6ada747b06c007d$export$eabcd2c8791e7bf4 = 'left';
var $d6ada747b06c007d$export$dfb5619354ba860 = 'auto';
var $d6ada747b06c007d$export$aec2ce47c367b8c3 = [
    $d6ada747b06c007d$export$1e95b668f3b82d,
    $d6ada747b06c007d$export$40e543e69a8b3fbb,
    $d6ada747b06c007d$export$79ffe56a765070d2,
    $d6ada747b06c007d$export$eabcd2c8791e7bf4
];
var $d6ada747b06c007d$export$b3571188c770cc5a = 'start';
var $d6ada747b06c007d$export$bd5df0f255a350f8 = 'end';
var $d6ada747b06c007d$export$390fd549c5303b4d = 'clippingParents';
var $d6ada747b06c007d$export$d7b7311ec04a3e8f = 'viewport';
var $d6ada747b06c007d$export$ae5ab1c730825774 = 'popper';
var $d6ada747b06c007d$export$ca50aac9f3ba507f = 'reference';
var $d6ada747b06c007d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $d6ada747b06c007d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $d6ada747b06c007d$export$b3571188c770cc5a,
        placement + "-" + $d6ada747b06c007d$export$bd5df0f255a350f8
    ]);
}, []);
var $d6ada747b06c007d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($d6ada747b06c007d$export$aec2ce47c367b8c3, [
    $d6ada747b06c007d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $d6ada747b06c007d$export$b3571188c770cc5a,
        placement + "-" + $d6ada747b06c007d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $d6ada747b06c007d$export$421679a7c3d56e = 'beforeRead';
var $d6ada747b06c007d$export$aafa59e2e03f2942 = 'read';
var $d6ada747b06c007d$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $d6ada747b06c007d$export$c65e99957a05207c = 'beforeMain';
var $d6ada747b06c007d$export$f22da7240b7add18 = 'main';
var $d6ada747b06c007d$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $d6ada747b06c007d$export$8d4d2d70e7d46032 = 'beforeWrite';
var $d6ada747b06c007d$export$68d8715fc104d294 = 'write';
var $d6ada747b06c007d$export$70a6e5159acce2e6 = 'afterWrite';
var $d6ada747b06c007d$export$d087d3878fdf71d5 = [
    $d6ada747b06c007d$export$421679a7c3d56e,
    $d6ada747b06c007d$export$aafa59e2e03f2942,
    $d6ada747b06c007d$export$6964f6c886723980,
    $d6ada747b06c007d$export$c65e99957a05207c,
    $d6ada747b06c007d$export$f22da7240b7add18,
    $d6ada747b06c007d$export$bab79516f2d662fe,
    $d6ada747b06c007d$export$8d4d2d70e7d46032,
    $d6ada747b06c007d$export$68d8715fc104d294,
    $d6ada747b06c007d$export$70a6e5159acce2e6
];

});


parcelRegister("bKdOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ceb5bd2b05c557$export$2e2bcd8739ae039);
function $88ceb5bd2b05c557$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("650fv", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d367282185b78e$export$2e2bcd8739ae039);
function $46d367282185b78e$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("5d22G", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cafc035423eb95a$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");
var $3cafc035423eb95a$var$passive = {
    passive: true
};
function $3cafc035423eb95a$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $iHejO.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3cafc035423eb95a$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3cafc035423eb95a$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3cafc035423eb95a$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3cafc035423eb95a$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3cafc035423eb95a$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3cafc035423eb95a$var$effect,
    data: {}
};

});

parcelRegister("erJZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a84741b446df23b4$export$2e2bcd8739ae039);

var $e8ZLL = parcelRequire("e8ZLL");
function $a84741b446df23b4$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $e8ZLL.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a84741b446df23b4$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $a84741b446df23b4$var$popperOffsets,
    data: {}
};

});
parcelRegister("e8ZLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c1ba21d03868aa$export$2e2bcd8739ae039);

var $lsJel = parcelRequire("lsJel");

var $jwYyR = parcelRequire("jwYyR");

var $ffRl6 = parcelRequire("ffRl6");

var $iqJ7p = parcelRequire("iqJ7p");
function $a4c1ba21d03868aa$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $lsJel.default)(placement) : null;
    var variation = placement ? (0, $jwYyR.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $iqJ7p.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $iqJ7p.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $iqJ7p.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $iqJ7p.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ffRl6.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $iqJ7p.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $iqJ7p.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("lsJel", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9ff4c508a576765$export$2e2bcd8739ae039);

function $f9ff4c508a576765$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("jwYyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37ffbaf78a48966$export$2e2bcd8739ae039);
function $e37ffbaf78a48966$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("ffRl6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b1a1cd84aec3a6$export$2e2bcd8739ae039);
function $b1b1a1cd84aec3a6$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("8AiNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6400452045d38e02$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $iMJep = parcelRequire("iMJep");

var $iHejO = parcelRequire("iHejO");

var $8WCqw = parcelRequire("8WCqw");

var $326U9 = parcelRequire("326U9");

var $lsJel = parcelRequire("lsJel");

var $jwYyR = parcelRequire("jwYyR");

var $dNBRj = parcelRequire("dNBRj");
var $6400452045d38e02$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6400452045d38e02$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $dNBRj.round)(x * dpr) / dpr || 0,
        y: (0, $dNBRj.round)(y * dpr) / dpr || 0
    };
}
function $6400452045d38e02$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $iqJ7p.left);
    var sideY = (0, $iqJ7p.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $iMJep.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $iHejO.default)(popper)) {
            offsetParent = (0, $8WCqw.default)(popper);
            if ((0, $326U9.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $iqJ7p.top) || (placement === (0, $iqJ7p.left) || placement === (0, $iqJ7p.right)) && variation === (0, $iqJ7p.end)) {
            sideY = (0, $iqJ7p.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $iqJ7p.left) || (placement === (0, $iqJ7p.top) || placement === (0, $iqJ7p.bottom)) && variation === (0, $iqJ7p.end)) {
            sideX = (0, $iqJ7p.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6400452045d38e02$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6400452045d38e02$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $iHejO.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6400452045d38e02$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $lsJel.default)(state.placement),
        variation: (0, $jwYyR.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6400452045d38e02$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6400452045d38e02$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6400452045d38e02$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6400452045d38e02$var$computeStyles,
    data: {}
};

});

parcelRegister("bAjmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $86f212e7a517fbb5$export$2e2bcd8739ae039);

var $3UmrH = parcelRequire("3UmrH");

var $fJ6Ac = parcelRequire("fJ6Ac");
// and applies them to the HTMLElements such as popper and arrow
function $86f212e7a517fbb5$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fJ6Ac.isHTMLElement)(element) || !(0, $3UmrH.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $86f212e7a517fbb5$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fJ6Ac.isHTMLElement)(element) || !(0, $3UmrH.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $86f212e7a517fbb5$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $86f212e7a517fbb5$var$applyStyles,
    effect: $86f212e7a517fbb5$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lcFdJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fab17b9f71b622$export$2e2bcd8739ae039);

var $lsJel = parcelRequire("lsJel");

var $iqJ7p = parcelRequire("iqJ7p");
function $f6fab17b9f71b622$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $lsJel.default)(placement);
    var invertDistance = [
        (0, $iqJ7p.left),
        (0, $iqJ7p.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $iqJ7p.left),
        (0, $iqJ7p.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f6fab17b9f71b622$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $iqJ7p.placements).reduce(function(acc, placement) {
        acc[placement] = $f6fab17b9f71b622$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f6fab17b9f71b622$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f6fab17b9f71b622$var$offset
};

});

parcelRegister("7KqQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a41a7ffd8eaaed3$export$2e2bcd8739ae039);

var $kQ8ZL = parcelRequire("kQ8ZL");

var $lsJel = parcelRequire("lsJel");

var $fyd1H = parcelRequire("fyd1H");

var $czpku = parcelRequire("czpku");

var $fW5QL = parcelRequire("fW5QL");

var $iqJ7p = parcelRequire("iqJ7p");

var $jwYyR = parcelRequire("jwYyR");
function $5a41a7ffd8eaaed3$var$getExpandedFallbackPlacements(placement) {
    if ((0, $lsJel.default)(placement) === (0, $iqJ7p.auto)) return [];
    var oppositePlacement = (0, $kQ8ZL.default)(placement);
    return [
        (0, $fyd1H.default)(placement),
        oppositePlacement,
        (0, $fyd1H.default)(oppositePlacement)
    ];
}
function $5a41a7ffd8eaaed3$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $lsJel.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $kQ8ZL.default)(preferredPlacement)
    ] : $5a41a7ffd8eaaed3$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $lsJel.default)(placement) === (0, $iqJ7p.auto) ? (0, $fW5QL.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $lsJel.default)(placement);
        var isStartVariation = (0, $jwYyR.default)(placement) === (0, $iqJ7p.start);
        var isVertical = [
            (0, $iqJ7p.top),
            (0, $iqJ7p.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $czpku.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $iqJ7p.right) : (0, $iqJ7p.left) : isStartVariation ? (0, $iqJ7p.bottom) : (0, $iqJ7p.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $kQ8ZL.default)(mainVariationSide);
        var altVariationSide = (0, $kQ8ZL.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $5a41a7ffd8eaaed3$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $5a41a7ffd8eaaed3$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("kQ8ZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2bfa43e7acf7a1f$export$2e2bcd8739ae039);
var $f2bfa43e7acf7a1f$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $f2bfa43e7acf7a1f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $f2bfa43e7acf7a1f$var$hash[matched];
    });
}

});

parcelRegister("fyd1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $b52422c6016bd931$export$2e2bcd8739ae039);
var $b52422c6016bd931$var$hash = {
    start: 'end',
    end: 'start'
};
function $b52422c6016bd931$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b52422c6016bd931$var$hash[matched];
    });
}

});

parcelRegister("czpku", function(module, exports) {

$parcel$export(module.exports, "default", () => $926c66d41a194a34$export$2e2bcd8739ae039);

var $c62Z3 = parcelRequire("c62Z3");

var $8WCqw = parcelRequire("8WCqw");

var $2aOS9 = parcelRequire("2aOS9");

var $e8ZLL = parcelRequire("e8ZLL");

var $4SDYu = parcelRequire("4SDYu");

var $iqJ7p = parcelRequire("iqJ7p");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $dmhsV = parcelRequire("dmhsV");

var $3qyWh = parcelRequire("3qyWh");
function $926c66d41a194a34$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $iqJ7p.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $iqJ7p.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $iqJ7p.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $dmhsV.default)(typeof padding !== 'number' ? padding : (0, $3qyWh.default)(padding, (0, $iqJ7p.basePlacements)));
    var altContext = elementContext === (0, $iqJ7p.popper) ? (0, $iqJ7p.reference) : (0, $iqJ7p.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $c62Z3.default)((0, $fJ6Ac.isElement)(element) ? element : element.contextElement || (0, $8WCqw.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2aOS9.default)(state.elements.reference);
    var popperOffsets = (0, $e8ZLL.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $4SDYu.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $iqJ7p.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $iqJ7p.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $iqJ7p.right),
                (0, $iqJ7p.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $iqJ7p.top),
                (0, $iqJ7p.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("c62Z3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ce85c1418d21935$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $5AoPY = parcelRequire("5AoPY");

var $5d4pe = parcelRequire("5d4pe");

var $82kk0 = parcelRequire("82kk0");

var $iMJep = parcelRequire("iMJep");

var $8WCqw = parcelRequire("8WCqw");

var $326U9 = parcelRequire("326U9");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $2aOS9 = parcelRequire("2aOS9");

var $lDDlB = parcelRequire("lDDlB");

var $3M1PW = parcelRequire("3M1PW");

var $3UmrH = parcelRequire("3UmrH");

var $4SDYu = parcelRequire("4SDYu");

var $dNBRj = parcelRequire("dNBRj");
function $8ce85c1418d21935$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2aOS9.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $8ce85c1418d21935$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $iqJ7p.viewport) ? (0, $4SDYu.default)((0, $5AoPY.default)(element, strategy)) : (0, $fJ6Ac.isElement)(clippingParent) ? $8ce85c1418d21935$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $4SDYu.default)((0, $5d4pe.default)((0, $8WCqw.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $8ce85c1418d21935$var$getClippingParents(element) {
    var clippingParents = (0, $82kk0.default)((0, $lDDlB.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $326U9.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fJ6Ac.isHTMLElement)(element) ? (0, $iMJep.default)(element) : element;
    if (!(0, $fJ6Ac.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fJ6Ac.isElement)(clippingParent) && (0, $3M1PW.default)(clippingParent, clipperElement) && (0, $3UmrH.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $8ce85c1418d21935$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $8ce85c1418d21935$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $8ce85c1418d21935$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $dNBRj.max)(rect.top, accRect.top);
        accRect.right = (0, $dNBRj.min)(rect.right, accRect.right);
        accRect.bottom = (0, $dNBRj.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $dNBRj.max)(rect.left, accRect.left);
        return accRect;
    }, $8ce85c1418d21935$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("5AoPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $411394afa2383299$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");

var $8WCqw = parcelRequire("8WCqw");

var $1lDxt = parcelRequire("1lDxt");

var $duzhc = parcelRequire("duzhc");
function $411394afa2383299$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $iHejO.default)(element);
    var html = (0, $8WCqw.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $duzhc.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1lDxt.default)(element),
        y: y
    };
}

});

parcelRegister("5d4pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cb195955e9900e4$export$2e2bcd8739ae039);

var $8WCqw = parcelRequire("8WCqw");

var $326U9 = parcelRequire("326U9");

var $1lDxt = parcelRequire("1lDxt");

var $hNX0K = parcelRequire("hNX0K");

var $dNBRj = parcelRequire("dNBRj");
function $3cb195955e9900e4$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $8WCqw.default)(element);
    var winScroll = (0, $hNX0K.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $dNBRj.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $dNBRj.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1lDxt.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $326U9.default)(body || html).direction === 'rtl') x += (0, $dNBRj.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("3M1PW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf7478da67e8745$export$2e2bcd8739ae039);

var $fJ6Ac = parcelRequire("fJ6Ac");
function $2bf7478da67e8745$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fJ6Ac.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("4SDYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $38db36b96d02eccc$export$2e2bcd8739ae039);
function $38db36b96d02eccc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("dmhsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b9ae0b6550b6f37$export$2e2bcd8739ae039);

var $yT6R3 = parcelRequire("yT6R3");
function $9b9ae0b6550b6f37$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $yT6R3.default)(), paddingObject);
}

});
parcelRegister("yT6R3", function(module, exports) {

$parcel$export(module.exports, "default", () => $068decb3807e55f3$export$2e2bcd8739ae039);
function $068decb3807e55f3$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("3qyWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $27eee6fc63c552c6$export$2e2bcd8739ae039);
function $27eee6fc63c552c6$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("fW5QL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a0cf81f1fbb0d2$export$2e2bcd8739ae039);

var $jwYyR = parcelRequire("jwYyR");

var $iqJ7p = parcelRequire("iqJ7p");

var $czpku = parcelRequire("czpku");

var $lsJel = parcelRequire("lsJel");
function $b9a0cf81f1fbb0d2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $iqJ7p.placements) : _options$allowedAutoP;
    var variation = (0, $jwYyR.default)(placement);
    var placements = variation ? flipVariations ? (0, $iqJ7p.variationPlacements) : (0, $iqJ7p.variationPlacements).filter(function(placement) {
        return (0, $jwYyR.default)(placement) === variation;
    }) : (0, $iqJ7p.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $czpku.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $lsJel.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("7zSEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5846324917bf1014$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $lsJel = parcelRequire("lsJel");

var $ffRl6 = parcelRequire("ffRl6");

var $kZNfy = parcelRequire("kZNfy");

var $cEkqa = parcelRequire("cEkqa");

var $h7lRj = parcelRequire("h7lRj");

var $iMJep = parcelRequire("iMJep");

var $czpku = parcelRequire("czpku");

var $jwYyR = parcelRequire("jwYyR");

var $yT6R3 = parcelRequire("yT6R3");

var $dNBRj = parcelRequire("dNBRj");
function $5846324917bf1014$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $czpku.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $lsJel.default)(state.placement);
    var variation = (0, $jwYyR.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ffRl6.default)(basePlacement);
    var altAxis = (0, $kZNfy.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $iqJ7p.top) : (0, $iqJ7p.left);
        var altSide = mainAxis === 'y' ? (0, $iqJ7p.bottom) : (0, $iqJ7p.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $iqJ7p.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $iqJ7p.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $h7lRj.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $yT6R3.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cEkqa.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $iMJep.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cEkqa.within)(tether ? (0, $dNBRj.min)(min, tetherMin) : min, offset, tether ? (0, $dNBRj.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $iqJ7p.top) : (0, $iqJ7p.left);
        var _altSide = mainAxis === 'x' ? (0, $iqJ7p.bottom) : (0, $iqJ7p.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $iqJ7p.top),
            (0, $iqJ7p.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cEkqa.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cEkqa.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5846324917bf1014$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $5846324917bf1014$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("kZNfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48fb5228a571c9a$export$2e2bcd8739ae039);
function $f48fb5228a571c9a$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cEkqa", function(module, exports) {

$parcel$export(module.exports, "within", () => $93590faa2f1f82c6$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $93590faa2f1f82c6$export$86c8af6d3ef0b4a);

var $dNBRj = parcelRequire("dNBRj");
function $93590faa2f1f82c6$export$f28d906d67a997f3(min, value, max) {
    return (0, $dNBRj.max)(min, (0, $dNBRj.min)(value, max));
}
function $93590faa2f1f82c6$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $93590faa2f1f82c6$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("ek5P6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6d7735846c13c0b$export$2e2bcd8739ae039);

var $lsJel = parcelRequire("lsJel");

var $h7lRj = parcelRequire("h7lRj");

var $3M1PW = parcelRequire("3M1PW");

var $iMJep = parcelRequire("iMJep");

var $ffRl6 = parcelRequire("ffRl6");

var $cEkqa = parcelRequire("cEkqa");

var $dmhsV = parcelRequire("dmhsV");

var $3qyWh = parcelRequire("3qyWh");

var $iqJ7p = parcelRequire("iqJ7p");
var $a6d7735846c13c0b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $dmhsV.default)(typeof padding !== 'number' ? padding : (0, $3qyWh.default)(padding, (0, $iqJ7p.basePlacements)));
};
function $a6d7735846c13c0b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $lsJel.default)(state.placement);
    var axis = (0, $ffRl6.default)(basePlacement);
    var isVertical = [
        (0, $iqJ7p.left),
        (0, $iqJ7p.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $a6d7735846c13c0b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $h7lRj.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $iqJ7p.top) : (0, $iqJ7p.left);
    var maxProp = axis === 'y' ? (0, $iqJ7p.bottom) : (0, $iqJ7p.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $iMJep.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cEkqa.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $a6d7735846c13c0b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $3M1PW.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $a6d7735846c13c0b$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $a6d7735846c13c0b$var$arrow,
    effect: $a6d7735846c13c0b$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("anqoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e085d14bcc9886$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $czpku = parcelRequire("czpku");
function $78e085d14bcc9886$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $78e085d14bcc9886$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $iqJ7p.top),
        (0, $iqJ7p.right),
        (0, $iqJ7p.bottom),
        (0, $iqJ7p.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $78e085d14bcc9886$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $czpku.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $czpku.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $78e085d14bcc9886$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $78e085d14bcc9886$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $78e085d14bcc9886$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $78e085d14bcc9886$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $78e085d14bcc9886$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $78e085d14bcc9886$var$hide
};

});




parcelRegister("2HG8y", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $1f8048740832c02d$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $cXw5N = parcelRequire("cXw5N");

var $9sasN = parcelRequire("9sasN");
function $1f8048740832c02d$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $cXw5N.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $9sasN.setRef)(innerRef, node);
        (0, $9sasN.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $9sasN.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $9sasN.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("4wJSY", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $34bdbe885d924a05$export$3e67810a3f0e9f1c);
function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
    return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("f2Cxi", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $73214f191156d056$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $73214f191156d056$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $73214f191156d056$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7kQOw = parcelRequire("7kQOw");

var $b1kcy = parcelRequire("b1kcy");

var $cBCgC = parcelRequire("cBCgC");
const $73214f191156d056$var$menuDialogStyles = null;
const $73214f191156d056$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $73214f191156d056$var$dropdownStyles = null;
const $73214f191156d056$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kQOw))), {
            color: "currentColor",
            label: ""
        })
    });
const $73214f191156d056$var$controlStyles = null;
const $73214f191156d056$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $73214f191156d056$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $73214f191156d056$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $73214f191156d056$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).ClearIndicator, {
        ...props
    });
const $73214f191156d056$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).MultiValueRemove, {
        ...props
    });
const $73214f191156d056$export$71abc632aa29e6fe = {
    Control: $73214f191156d056$var$Control,
    DropdownIndicator: $73214f191156d056$var$DropdownIndicator,
    Menu: $73214f191156d056$var$Menu,
    ClearIndicator: $73214f191156d056$var$ClearIndicator,
    MultiValueRemove: $73214f191156d056$var$MultiValueRemove
};

});
parcelRegister("7kQOw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd994b90fa78030d2d1c292998636115>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55735e66b3bc3e4b$var$_react = $55735e66b3bc3e4b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $55735e66b3bc3e4b$var$_search = $55735e66b3bc3e4b$var$_interopRequireDefault((parcelRequire("aWy0H")));

var $55735e66b3bc3e4b$var$_search2 = $55735e66b3bc3e4b$var$_interopRequireDefault((parcelRequire("Ltnm7")));
function $55735e66b3bc3e4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $55735e66b3bc3e4b$var$SearchIcon = (props)=>/*#__PURE__*/ $55735e66b3bc3e4b$var$_react.default.createElement($55735e66b3bc3e4b$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $55735e66b3bc3e4b$var$_search2.default
    }, props));
$55735e66b3bc3e4b$var$SearchIcon.Name = 'SearchIconMigration';
var $55735e66b3bc3e4b$var$_default = module.exports.default = $55735e66b3bc3e4b$var$SearchIcon;

});
parcelRegister("Ltnm7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08eb2d4df89f92f3$var$_react = $08eb2d4df89f92f3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $08eb2d4df89f92f3$var$_search = $08eb2d4df89f92f3$var$_interopRequireDefault((parcelRequire("aWy0H")));
function $08eb2d4df89f92f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $08eb2d4df89f92f3$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $08eb2d4df89f92f3$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $08eb2d4df89f92f3$var$_search.default
    }));
$08eb2d4df89f92f3$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $08eb2d4df89f92f3$var$_default = module.exports.default = $08eb2d4df89f92f3$var$EditorSearchIcon;

});



parcelRegister("aztrV", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $eda715fe218ca2e5$export$17baa7c95b6ba1b8);

var $8Oct0 = parcelRequire("8Oct0");
function $eda715fe218ca2e5$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    (0, $8Oct0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});




parcelRegister("f3Ls0", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $81fcd896751fe1de$export$da86c38211c1c0a8);
function $81fcd896751fe1de$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("4NWOr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e6014f1bd11e07e5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e6014f1bd11e07e5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("dhLc4", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $c4652decfc9c5e44$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $c4652decfc9c5e44$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $c4652decfc9c5e44$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $766ff = parcelRequire("766ff");
var $2DPlK = parcelRequire("2DPlK");
var $e35GK = parcelRequire("e35GK");
const $c4652decfc9c5e44$export$b49757166e1acfc2 = new (0, $766ff.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $2DPlK.ExperienceTypes).Load,
    performanceType: (0, $2DPlK.ExperiencePerformanceTypes).PageSegmentLoad
});
const $c4652decfc9c5e44$export$135a264e0da507ae = new (0, $766ff.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $2DPlK.ExperienceTypes).Operation,
    performanceType: (0, $2DPlK.ExperiencePerformanceTypes).InlineResult
});
class $c4652decfc9c5e44$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        const instance = $c4652decfc9c5e44$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $e35GK.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("766ff", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $da9c8b3012314011$export$ac1cddfee07ba6ac);

var $2wNBQ = parcelRequire("2wNBQ");

var $88I8J = parcelRequire("88I8J");
class $da9c8b3012314011$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $88I8J.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $2wNBQ.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});



parcelRegister("lor1T", function(module, exports) {

$parcel$export(module.exports, "BORDER_PADDING", () => $5137687be2312326$export$59c188914e58c94b);
$parcel$export(module.exports, "getStyles", () => $5137687be2312326$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $5137687be2312326$export$4e983f376ad8a3af);


var $8QpSo = parcelRequire("8QpSo");

var $1BKyN = parcelRequire("1BKyN");
const $5137687be2312326$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $5137687be2312326$export$53937c04f7dfc2ae = 6;
const $5137687be2312326$export$2c62ba763e976c54 = 39;
const $5137687be2312326$export$ffd58b7f6f099a57 = (0, $8QpSo.default)((width, isMulti, isCompact, overrideStyles, isInvalid, isVisualRefresh, isPopupStyles)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: isInvalid ? `var(--ds-border-danger, ${0, $a7f8c6b391092279$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $a7f8c6b391092279$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $a7f8c6b391092279$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $a7f8c6b391092279$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $a7f8c6b391092279$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $a7f8c6b391092279$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $a7f8c6b391092279$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $a7f8c6b391092279$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $a7f8c6b391092279$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $a7f8c6b391092279$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $a7f8c6b391092279$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $5137687be2312326$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $5137687be2312326$export$59c188914e58c94b,
                paddingLeft: isMulti ? $5137687be2312326$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$5137687be2312326$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $5137687be2312326$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $5137687be2312326$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $1BKyN.mergeStyles)(styles, overrideStyles) : styles;
});
const $5137687be2312326$export$4e983f376ad8a3af = (0, $8QpSo.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$5137687be2312326$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, false, isVisualRefresh, true)
    }));

});

parcelRegister("cnoGa", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $9e80c7fb0ec6ec7b$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $9e80c7fb0ec6ec7b$export$19205fd341a6bb08);

var $8QpSo = parcelRequire("8QpSo");

var $4YoV5 = parcelRequire("4YoV5");

var $dtNVh = parcelRequire("dtNVh");

var $6CXdK = parcelRequire("6CXdK");

var $gWmUf = parcelRequire("gWmUf");

var $7EN2Y = parcelRequire("7EN2Y");

var $jUKmL = parcelRequire("jUKmL");

var $fAFbI = parcelRequire("fAFbI");

var $aK2hz = parcelRequire("aK2hz");

var $4grkH = parcelRequire("4grkH");

var $6tZmh = parcelRequire("6tZmh");
const $9e80c7fb0ec6ec7b$export$4e811121b221213b = (0, $8QpSo.default)((multi, anchor)=>{
    if (anchor) return {
        Control: anchor,
        Option: $gWmUf.Option
    };
    else return {
        MultiValue: $dtNVh.MultiValue,
        DropdownIndicator: null,
        SingleValue: $7EN2Y.SingleValue,
        ClearIndicator: multi ? null : (0, $4YoV5.ClearIndicator),
        Option: $gWmUf.Option,
        ValueContainer: multi ? (0, $6CXdK.MultiValueContainer) : (0, $fAFbI.SingleValueContainer),
        Input: $jUKmL.Input,
        Menu: $6tZmh.Menu
    };
});
const $9e80c7fb0ec6ec7b$export$19205fd341a6bb08 = (0, $8QpSo.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $7EN2Y.SingleValue,
        ClearIndicator: $4YoV5.ClearIndicator,
        Option: $gWmUf.Option,
        ValueContainer: (0, $fAFbI.SingleValueContainer),
        Input: (0, $aK2hz.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $4grkH.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("4YoV5", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $df76864cb02026d8$export$ecf9cf59142dd54a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b1kcy = parcelRequire("b1kcy");

const $df76864cb02026d8$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("4tQB9")).then((module)=>{
        return {
            default: module.default
        };
    }));
class $df76864cb02026d8$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            }
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($df76864cb02026d8$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("4tQB9", function(module, exports) {

let $3432abc7e67820eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3432abc7e67820eb$var$load("95awv").then(()=>parcelRequire('gGV5g'));

});


parcelRegister("dtNVh", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $94ec0dcd8f0d6d4c$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $b1kcy = parcelRequire("b1kcy");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2i4X3 = parcelRequire("2i4X3");

var $9tC62 = parcelRequire("9tC62");

var $grXIr = parcelRequire("grXIr");

var $IoPSi = parcelRequire("IoPSi");

var $5uGNN = parcelRequire("5uGNN");

var $fHpHg = parcelRequire("fHpHg");
function $94ec0dcd8f0d6d4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $94ec0dcd8f0d6d4c$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $94ec0dcd8f0d6d4c$var$groupTagContainer = (0, $2s57o.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $94ec0dcd8f0d6d4c$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $94ec0dcd8f0d6d4c$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $grXIr.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2i4X3.AddOptionAvatar), {
                isLozenge: true
            });
            if ((0, $grXIr.isGroup)(data)) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
                xcss: $94ec0dcd8f0d6d4c$var$groupTagContainer
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($IoPSi))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9tC62.SizeableAvatar), {
                appearance: "multi",
                src: (0, $grXIr.getAvatarUrl)(data),
                type: (0, $grXIr.isTeam)(data) && (0, $fHpHg.fg)('verified-team-in-user-picker') ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $grXIr.isTeam)(data) && data.verified && (0, $fHpHg.fg)('verified-team-in-user-picker')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uGNN.VerifiedTeamIcon), null);
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $94ec0dcd8f0d6d4c$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b1kcy.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Eqc8.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $94ec0dcd8f0d6d4c$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}

});
parcelRegister("2i4X3", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $e95c724b1c8bbd59$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bEcs6 = parcelRequire("bEcs6");


var $f8Sb3 = parcelRequire("f8Sb3");
parcelRequire("5uXOq");
const $e95c724b1c8bbd59$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding,
        backgroundColor: `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $e95c724b1c8bbd59$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $e95c724b1c8bbd59$var$getEmailAvatarWrapperStyle(isLozenge)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bEcs6))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`
    })));
};

});
parcelRegister("bEcs6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2014ecb862bd114df9c4eca3bb7d0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87ad16e679cb17a1$var$_react = $87ad16e679cb17a1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87ad16e679cb17a1$var$_email = $87ad16e679cb17a1$var$_interopRequireDefault((parcelRequire("dvv9E")));

var $87ad16e679cb17a1$var$_email2 = $87ad16e679cb17a1$var$_interopRequireDefault((parcelRequire("dTO85")));
function $87ad16e679cb17a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87ad16e679cb17a1$var$EmailIcon = (props)=>/*#__PURE__*/ $87ad16e679cb17a1$var$_react.default.createElement($87ad16e679cb17a1$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $87ad16e679cb17a1$var$_email2.default
    }, props));
$87ad16e679cb17a1$var$EmailIcon.Name = 'EmailIconMigration';
var $87ad16e679cb17a1$var$_default = module.exports.default = $87ad16e679cb17a1$var$EmailIcon;

});
parcelRegister("dvv9E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d565642138875e6$var$_react = $9d565642138875e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9d565642138875e6$var$_baseNew = $9d565642138875e6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $9d565642138875e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d565642138875e6$var$EmailIcon = (props)=>/*#__PURE__*/ $9d565642138875e6$var$_react.default.createElement($9d565642138875e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$9d565642138875e6$var$EmailIcon.displayName = 'EmailIcon';
var $9d565642138875e6$var$_default = module.exports.default = $9d565642138875e6$var$EmailIcon;

});

parcelRegister("dTO85", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1e74c1782477aa6$var$_react = $a1e74c1782477aa6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $a1e74c1782477aa6$var$_email = $a1e74c1782477aa6$var$_interopRequireDefault((parcelRequire("dvv9E")));
function $a1e74c1782477aa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a1e74c1782477aa6$var$EmailIcon = (props)=>/*#__PURE__*/ $a1e74c1782477aa6$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $a1e74c1782477aa6$var$_email.default
    }));
$a1e74c1782477aa6$var$EmailIcon.displayName = 'EmailIcon';
var $a1e74c1782477aa6$var$_default = module.exports.default = $a1e74c1782477aa6$var$EmailIcon;

});



parcelRegister("9tC62", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $4489f08f8425adec$export$44d81a88129649da);

var $2OMIu = parcelRequire("2OMIu");

var $ew55A = parcelRequire("ew55A");

var $cFwjb = parcelRequire("cFwjb");

var $5uXOq = parcelRequire("5uXOq");

var $grXIr = parcelRequire("grXIr");
class $4489f08f8425adec$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $grXIr.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFwjb.default), {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
            ...props
        });
    }
}

});

parcelRegister("IoPSi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff23a711b4b109cded01cd0a5945034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08576006ad7cfbb6$var$_react = $08576006ad7cfbb6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $08576006ad7cfbb6$var$_peopleGroup = $08576006ad7cfbb6$var$_interopRequireDefault((parcelRequire("gfxSS")));

var $08576006ad7cfbb6$var$_people = $08576006ad7cfbb6$var$_interopRequireDefault((parcelRequire("GLupd")));
function $08576006ad7cfbb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08576006ad7cfbb6$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $08576006ad7cfbb6$var$_react.default.createElement($08576006ad7cfbb6$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $08576006ad7cfbb6$var$_people.default
    }, props));
$08576006ad7cfbb6$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $08576006ad7cfbb6$var$_default = module.exports.default = $08576006ad7cfbb6$var$PeopleGroupIcon;

});

parcelRegister("5uGNN", function(module, exports) {

$parcel$export(module.exports, "VerifiedTeamIcon", () => $62ccb659a0f5c058$export$d7949f68d31e5edd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $jGBbV = parcelRequire("jGBbV");

var $8PSX5 = parcelRequire("8PSX5");

var $5KCCi = parcelRequire("5KCCi");

var $cJFyP = parcelRequire("cJFyP");
const $62ccb659a0f5c058$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $cJFyP.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "aria-hidden": "true",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jGBbV))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    LEGACY_size: "medium",
                    label: tooltipContent,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $8PSX5.default)
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jGBbV))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: label,
        LEGACY_fallbackIcon: (0, $8PSX5.default)
    });
};

});
parcelRegister("jGBbV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08303db08bddd05336395b40b61b967a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e54eca00b611caa6$var$_react = $e54eca00b611caa6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e54eca00b611caa6$var$_baseNew = $e54eca00b611caa6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $e54eca00b611caa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e54eca00b611caa6$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $e54eca00b611caa6$var$_react.default.createElement($e54eca00b611caa6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.15.444a1.713 1.713 0 0 0-2.3 0L5.7 1.486a.2.2 0 0 1-.15.055L4 1.481a1.713 1.713 0 0 0-1.763 1.48l-.21 1.536a.2.2 0 0 1-.08.139l-1.225.95c-.697.54-.87 1.52-.4 2.266l.827 1.312c.03.047.04.104.027.159l-.328 1.515A1.713 1.713 0 0 0 2 12.831l1.477.474a.2.2 0 0 1 .123.103l.723 1.372c.41.78 1.346 1.12 2.162.787l1.436-.586a.2.2 0 0 1 .16 0l1.436.586a1.713 1.713 0 0 0 2.162-.787l.723-1.372a.2.2 0 0 1 .123-.103l1.477-.474a1.713 1.713 0 0 0 1.15-1.993l-.328-1.515a.2.2 0 0 1 .028-.159l.827-1.312a1.71 1.71 0 0 0-.4-2.266l-1.225-.95a.2.2 0 0 1-.08-.14l-.21-1.536A1.713 1.713 0 0 0 12 1.481l-1.55.06a.2.2 0 0 1-.15-.055zm3.176 5.036-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$e54eca00b611caa6$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $e54eca00b611caa6$var$_default = module.exports.default = $e54eca00b611caa6$var$StatusVerifiedIcon;

});

parcelRegister("8PSX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a04c34dba77105$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $49a04c34dba77105$var$VerifiedIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        })
    });
/**
 * __VerifiedIcon__
 */ const $49a04c34dba77105$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $49a04c34dba77105$var$VerifiedIconGlyph
    });
var $49a04c34dba77105$export$2e2bcd8739ae039 = $49a04c34dba77105$var$VerifiedIcon;

});

parcelRegister("cJFyP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5fbb80e95a063e02$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5fbb80e95a063e02$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("6CXdK", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $3bdf0218ead7cc96$export$cf9cf2a30a59265c);

var $2OMIu = parcelRequire("2OMIu");

var $b1kcy = parcelRequire("b1kcy");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $ousew = parcelRequire("ousew");

var $4NWOr = parcelRequire("4NWOr");

var $grXIr = parcelRequire("grXIr");

var $h34oI = parcelRequire("h34oI");
class $3bdf0218ead7cc96$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(this.props.children, (child)=>(0, $grXIr.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $4NWOr.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h34oI.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).ValueContainer, {
                ...props,
                children: this.renderChildren()
            })
        });
    }
}

});
parcelRegister("h34oI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f04b52c8ea4f6d06$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $f04b52c8ea4f6d06$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $f04b52c8ea4f6d06$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $f04b52c8ea4f6d06$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f04b52c8ea4f6d06$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $f04b52c8ea4f6d06$export$2e2bcd8739ae039 = $f04b52c8ea4f6d06$var$ValueContainerWrapper;

});


parcelRegister("gWmUf", function(module, exports) {

$parcel$export(module.exports, "Option", () => $5ba8751fc07b7c62$export$36d18380658d5d20);

var $2OMIu = parcelRequire("2OMIu");

var $0yZbT = parcelRequire("0yZbT");

var $b1kcy = parcelRequire("b1kcy");

var $5KCCi = parcelRequire("5KCCi");

var $5uXOq = parcelRequire("5uXOq");

var $2PHGY = parcelRequire("2PHGY");

var $YPzRV = parcelRequire("YPzRV");

var $awtJw = parcelRequire("awtJw");

var $2n5eM = parcelRequire("2n5eM");

var $kCULJ = parcelRequire("kCULJ");

var $6cP61 = parcelRequire("6cP61");

var $grXIr = parcelRequire("grXIr");

var $104WL = parcelRequire("104WL");
const $5ba8751fc07b7c62$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PHGY.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $5ba8751fc07b7c62$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $grXIr.isExternalUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $YPzRV.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $grXIr.isUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PHGY.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $grXIr.isEmail)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kCULJ.default), {
        email: data,
        emailValidity: (0, $104WL.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $grXIr.isTeam)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $awtJw.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $grXIr.isGroup)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2n5eM.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $grXIr.isCustom)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6cP61.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $5ba8751fc07b7c62$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                ...tooltipProps,
                children: $5ba8751fc07b7c62$var$dataOption(props)
            })
    });
    return $5ba8751fc07b7c62$var$dataOption(props);
};
const $5ba8751fc07b7c62$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: $5ba8751fc07b7c62$var$defaultOption(props),
            children: $5ba8751fc07b7c62$var$dataOptionWithTooltip(props)
        })
    });

});
parcelRegister("2PHGY", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $0e4a443eeb5a4e0a$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $fbX4N = parcelRequire("fbX4N");

var $5qCda = parcelRequire("5qCda");

var $9tC62 = parcelRequire("9tC62");

var $grXIr = parcelRequire("grXIr");

var $fHpHg = parcelRequire("fHpHg");
class $0e4a443eeb5a4e0a$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fbX4N.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $fbX4N.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $a7f8c6b391092279$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5qCda.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $grXIr.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $fbX4N.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5qCda.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $fbX4N.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9tC62.SizeableAvatar), {
                appearance: // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
                (0, $fHpHg.fg)('platform-component-visual-refresh') && (0, $fHpHg.fg)('visual-refresh-user-picker') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("fbX4N", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $2e72275a504ff5d5$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $2e72275a504ff5d5$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eOat1 = parcelRequire("eOat1");

var $grXIr = parcelRequire("grXIr");
function $2e72275a504ff5d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $2e72275a504ff5d5$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("4tQB9")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $2e72275a504ff5d5$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $2e72275a504ff5d5$var$optionWrapper = {
    name: "yyrqoa",
    styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $2e72275a504ff5d5$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $2e72275a504ff5d5$var$additionalInfo = {
    name: "tjo4qw",
    styles: "float:right"
};
const $2e72275a504ff5d5$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $2e72275a504ff5d5$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $grXIr.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                fallback: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eOat1.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($2e72275a504ff5d5$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eOat1.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eOat1.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $2e72275a504ff5d5$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2e72275a504ff5d5$var$optionWrapper
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2e72275a504ff5d5$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2e72275a504ff5d5$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2e72275a504ff5d5$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("5qCda", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $c3ed5a07c45b5b38$export$bb02e7bc6e1a7119);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $c3ed5a07c45b5b38$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}

});


parcelRegister("YPzRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a870202364343035$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $a870202364343035$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("e0p5Z")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $a870202364343035$export$2e2bcd8739ae039 = $a870202364343035$var$AsyncExternalUserOption;

});
parcelRegister("e0p5Z", function(module, exports) {

let $a3248839f5f9b5fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a3248839f5f9b5fc$var$load("h2MrD"),
    $a3248839f5f9b5fc$var$load("bYT2S"),
    $a3248839f5f9b5fc$var$load("9h9RB")
]).then(()=>parcelRequire('ktIzm'));

});


parcelRegister("awtJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba679b69dd7ccb6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $7ba679b69dd7ccb6$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("1j0Lr")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $7ba679b69dd7ccb6$export$2e2bcd8739ae039 = $7ba679b69dd7ccb6$var$AsyncTeamOption;

});
parcelRegister("1j0Lr", function(module, exports) {

let $0f3828901b52ab32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f3828901b52ab32$var$load("fC988").then(()=>parcelRequire('lsQoH'));

});


parcelRegister("2n5eM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fbc1bb80d7a3170$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $6fbc1bb80d7a3170$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("fFM41")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $6fbc1bb80d7a3170$export$2e2bcd8739ae039 = $6fbc1bb80d7a3170$var$AsyncGroupOption;

});
parcelRegister("fFM41", function(module, exports) {

let $b68ff7cf7e321fee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b68ff7cf7e321fee$var$load("9KU3A").then(()=>parcelRequire('j7bRg'));

});


parcelRegister("kCULJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9d80be6c5e0939$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $4d9d80be6c5e0939$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("caJxV")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $4d9d80be6c5e0939$export$2e2bcd8739ae039 = $4d9d80be6c5e0939$var$AsyncEmailOption;

});
parcelRegister("caJxV", function(module, exports) {

let $8dc9bfbc0f78aa34$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8dc9bfbc0f78aa34$var$load("1GZuZ").then(()=>parcelRequire('jqML9'));

});


parcelRegister("6cP61", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b38ebfc92215d7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $00b38ebfc92215d7$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("dKtsE")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $00b38ebfc92215d7$export$2e2bcd8739ae039 = $00b38ebfc92215d7$var$AsyncCustomOption;

});
parcelRegister("dKtsE", function(module, exports) {

let $a0266c966245cb62$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0266c966245cb62$var$load("k0Mrq").then(()=>parcelRequire('1d4Fe'));

});


parcelRegister("104WL", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $609db301c001dbf3$export$371e338370561054);
const $609db301c001dbf3$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $609db301c001dbf3$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $609db301c001dbf3$export$371e338370561054 = (inputText)=>{
    if (inputText.match($609db301c001dbf3$var$validRegex)) return 'VALID';
    if (inputText.match($609db301c001dbf3$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("7EN2Y", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $3ac61185f8cc9790$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b1kcy = parcelRequire("b1kcy");

var $9tC62 = parcelRequire("9tC62");

var $grXIr = parcelRequire("grXIr");

var $5uGNN = parcelRequire("5uGNN");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $AX5oF = parcelRequire("AX5oF");
var $5sLH0 = parcelRequire("5sLH0");
const $3ac61185f8cc9790$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syaz1fxt _1reo15vq _1bto1l2s _o5721q9c"
};
const $3ac61185f8cc9790$var$ElementAfter = (props)=>{
    const { data: { data: data } } = props;
    if ((0, $grXIr.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uGNN.VerifiedTeamIcon), {});
    return null;
};
const $3ac61185f8cc9790$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $AX5oF.default), {
            xcss: $3ac61185f8cc9790$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9tC62.SizeableAvatar), {
                    src: (0, $grXIr.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $grXIr.isTeam)(data) && (0, $fHpHg.fg)('verified-team-in-user-picker') ? 'team' : 'person'
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $3ac61185f8cc9790$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $3ac61185f8cc9790$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $3ac61185f8cc9790$var$styles.avatarItemText,
                            children: (0, $fHpHg.fg)('verified-team-in-user-picker') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)($3ac61185f8cc9790$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            }) : label
                        })
                    })
                })
            ]
        })
    }) : null;
};

});

parcelRegister("jUKmL", function(module, exports) {

$parcel$export(module.exports, "Input", () => $615c88cdee68cd15$export$f5b8910cec6cf069);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b1kcy = parcelRequire("b1kcy");
class $615c88cdee68cd15$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
	 * Overrides the default behaviour of react-select lib
	 *
	 * The getter is a workaround for original behaviour of the react-select lib.
	 * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
	 * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
	 * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
	 */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("fAFbI", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $34d702fe6d808611$export$afa5f855316c6a48);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $b1kcy = parcelRequire("b1kcy");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $9tC62 = parcelRequire("9tC62");

var $lor1T = parcelRequire("lor1T");

var $h34oI = parcelRequire("h34oI");
function $34d702fe6d808611$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $34d702fe6d808611$var$placeholderIconContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: (0, $lor1T.BORDER_PADDING),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    gridArea: '1/1/2/2'
});
const $34d702fe6d808611$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
var $34d702fe6d808611$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
class $34d702fe6d808611$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $h34oI.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b1kcy.components).ValueContainer, valueContainerProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $34d702fe6d808611$var$placeholderIconContainer
        }, this.renderAvatar()), children));
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9tC62.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $34d702fe6d808611$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: $34d702fe6d808611$var$_ref,
                onMouseDown: this.onValueContainerClick
            }, children) : children;
        };
    }
}

});

parcelRegister("aK2hz", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $ffb63a5983a8f220$export$d8edbfd510a7db82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jUKmL = parcelRequire("jUKmL");
class $ffb63a5983a8f220$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jUKmL.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("4grkH", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $d2f2a3eee86fa9b3$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $b1kcy = parcelRequire("b1kcy");

var $f8Sb3 = parcelRequire("f8Sb3");

const $d2f2a3eee86fa9b3$var$controlWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $d2f2a3eee86fa9b3$var$labelStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $d2f2a3eee86fa9b3$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $d2f2a3eee86fa9b3$var$controlWrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $d2f2a3eee86fa9b3$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b1kcy.components).Control, this.props));
    }
}

});

parcelRegister("6tZmh", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $7272f57eddeb7040$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $b1kcy = parcelRequire("b1kcy");

var $f8Sb3 = parcelRequire("f8Sb3");
const $7272f57eddeb7040$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $7272f57eddeb7040$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b1kcy.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $7272f57eddeb7040$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("5kiFd", function(module, exports) {

$parcel$export(module.exports, "getCreatableProps", () => $234e99affad67fe2$export$36f97d8afa97203d);

var $8QpSo = parcelRequire("8QpSo");


var $104WL = parcelRequire("104WL");

var $grXIr = parcelRequire("grXIr");
const $234e99affad67fe2$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $234e99affad67fe2$var$isValidNewOption = (isValidEmail = (0, $104WL.isValidEmail))=>(inputValue)=>inputValue && $234e99affad67fe2$var$validOption.includes(isValidEmail(inputValue));
const $234e99affad67fe2$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $ffa6e54f1b79ab69$export$6662b3461398ef8c)
        }
    });
const $234e99affad67fe2$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $234e99affad67fe2$var$isOptionDisabled = (isValidEmail = (0, $104WL.isValidEmail))=>(option)=>{
        if ((0, $grXIr.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $234e99affad67fe2$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $234e99affad67fe2$var$isValidNewOption(isValidEmail),
        getNewOptionData: $234e99affad67fe2$var$getNewOptionData,
        formatCreateLabel: $234e99affad67fe2$var$formatCreateLabel,
        isOptionDisabled: $234e99affad67fe2$var$isOptionDisabled(isValidEmail)
    };
}
const $234e99affad67fe2$export$36f97d8afa97203d = (0, $8QpSo.default)($234e99affad67fe2$var$creatableProps);

});

parcelRegister("gqIZX", function(module, exports) {

$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $a192baba05155357$export$34b9dd2dd6a225e5);

var $8QpSo = parcelRequire("8QpSo");


var $104WL = parcelRequire("104WL");

var $grXIr = parcelRequire("grXIr");
const $a192baba05155357$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $a192baba05155357$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $a192baba05155357$var$getNewOptionData = (isValidEmail = (0, $104WL.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $a192baba05155357$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $ffa6e54f1b79ab69$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $a192baba05155357$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $a192baba05155357$var$isOptionDisabled = (isValidEmail = (0, $104WL.isValidEmail))=>(option)=>{
        if ((0, $grXIr.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $a192baba05155357$export$34b9dd2dd6a225e5 = (0, $8QpSo.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $a192baba05155357$var$isValidNewOption,
        getNewOptionData: $a192baba05155357$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $a192baba05155357$var$formatCreateLabel,
        isOptionDisabled: $a192baba05155357$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("l30aB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f47fc17bfe16330e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $aaKGj = parcelRequire("aaKGj");
const $f47fc17bfe16330e$var$EMPTY = {};
const $f47fc17bfe16330e$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($f47fc17bfe16330e$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($f47fc17bfe16330e$var$EMPTY);
        (0, $aaKGj.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f47fc17bfe16330e$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $koVbs.default)();
    const { children: children } = props;
    const messages = $f47fc17bfe16330e$var$useI18n(intl.locale);
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $f47fc17bfe16330e$export$2e2bcd8739ae039 = $f47fc17bfe16330e$var$MessagesIntlProvider;

});
parcelRegister("aaKGj", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $de09ea5c7692d192$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $de09ea5c7692d192$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("6AQOU")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("eUiCu")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("2NCg1")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("49YmD")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("cGSEg")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("eFhXH")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("8D5o7")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("1lVVO")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("flXH0")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("btj7K")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("kTZKK")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("3pSlv")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("51GbE")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("1ccrr")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("7DMvA")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("3pcGH")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("g5n49")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("ke65r")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("bLkBA")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("huLPG")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("3Lkhu")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("daq5Q")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("88rUw")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("gT7Js")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("g0Now")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("b8vRV")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("3Hjct")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6KDhu")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("fxDDv")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("l5iCB")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $de09ea5c7692d192$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("49YmD")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("6AQOU", function(module, exports) {

let $4ccf13d6cd18bf96$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ccf13d6cd18bf96$var$load("g5Cqr").then(()=>parcelRequire('bOZZh'));

});

parcelRegister("eUiCu", function(module, exports) {

let $ada4bd2a8dbcf542$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ada4bd2a8dbcf542$var$load("3nPyl").then(()=>parcelRequire('1XhGw'));

});

parcelRegister("2NCg1", function(module, exports) {

let $209dd580dc4672d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $209dd580dc4672d5$var$load("jzKXZ").then(()=>parcelRequire('hvRes'));

});

parcelRegister("49YmD", function(module, exports) {

let $3076d3b9a57003e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3076d3b9a57003e4$var$load("6qBuq").then(()=>parcelRequire('5v8Tc'));

});

parcelRegister("cGSEg", function(module, exports) {

let $93d3cc52160351f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $93d3cc52160351f5$var$load("bghJB").then(()=>parcelRequire('iOrq6'));

});

parcelRegister("eFhXH", function(module, exports) {

let $aad2d3df09c04dcd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aad2d3df09c04dcd$var$load("cVHxt").then(()=>parcelRequire('4J30H'));

});

parcelRegister("8D5o7", function(module, exports) {

let $648625314e90ad42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $648625314e90ad42$var$load("aD0sx").then(()=>parcelRequire('fB17y'));

});

parcelRegister("1lVVO", function(module, exports) {

let $0fc4b09c86c598be$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0fc4b09c86c598be$var$load("1HNA9").then(()=>parcelRequire('akYEc'));

});

parcelRegister("flXH0", function(module, exports) {

let $b2d71ee1f142e642$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b2d71ee1f142e642$var$load("15G7H").then(()=>parcelRequire('81pCG'));

});

parcelRegister("btj7K", function(module, exports) {

let $85a13cbd58375cfb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $85a13cbd58375cfb$var$load("6k2ZI").then(()=>parcelRequire('fECc8'));

});

parcelRegister("kTZKK", function(module, exports) {

let $f378d895efe76ed2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f378d895efe76ed2$var$load("hwB1b").then(()=>parcelRequire('d88YX'));

});

parcelRegister("3pSlv", function(module, exports) {

let $27cddcd88332d06f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27cddcd88332d06f$var$load("lO82O").then(()=>parcelRequire('lOXhp'));

});

parcelRegister("51GbE", function(module, exports) {

let $3a8dc52dcb6171be$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a8dc52dcb6171be$var$load("2kasq").then(()=>parcelRequire('w9M1e'));

});

parcelRegister("1ccrr", function(module, exports) {

let $0df0900e3c1d7535$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0df0900e3c1d7535$var$load("7Q86P").then(()=>parcelRequire('1Aw1f'));

});

parcelRegister("7DMvA", function(module, exports) {

let $5901cdb744a5fb8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5901cdb744a5fb8f$var$load("bsLaU").then(()=>parcelRequire('6OvxG'));

});

parcelRegister("3pcGH", function(module, exports) {

let $27ad8c64a09eb1b6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27ad8c64a09eb1b6$var$load("iTamo").then(()=>parcelRequire('6bd5D'));

});

parcelRegister("g5n49", function(module, exports) {

let $bb5f0160afe6072a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb5f0160afe6072a$var$load("4A2F7").then(()=>parcelRequire('85aXb'));

});

parcelRegister("ke65r", function(module, exports) {

let $eb99d62511d6b6c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb99d62511d6b6c0$var$load("koIFB").then(()=>parcelRequire('2LXP4'));

});

parcelRegister("bLkBA", function(module, exports) {

let $890411499316919e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $890411499316919e$var$load("kft0l").then(()=>parcelRequire('6LTAU'));

});

parcelRegister("huLPG", function(module, exports) {

let $cbca57981e34ac83$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cbca57981e34ac83$var$load("jmn8B").then(()=>parcelRequire('jrhuf'));

});

parcelRegister("3Lkhu", function(module, exports) {

let $2bd57e49a0f4c3a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2bd57e49a0f4c3a1$var$load("7gIwy").then(()=>parcelRequire('gZXKe'));

});

parcelRegister("daq5Q", function(module, exports) {

let $9960731a5a8c162f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9960731a5a8c162f$var$load("iMbmg").then(()=>parcelRequire('hNdNI'));

});

parcelRegister("88rUw", function(module, exports) {

let $5ec4b89236647103$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5ec4b89236647103$var$load("fva9M").then(()=>parcelRequire('honk4'));

});

parcelRegister("gT7Js", function(module, exports) {

let $c4b7c7d965a08e49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c4b7c7d965a08e49$var$load("1YAwp").then(()=>parcelRequire('3ZrPs'));

});

parcelRegister("g0Now", function(module, exports) {

let $ba82f6294e5ffe77$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba82f6294e5ffe77$var$load("g3Naz").then(()=>parcelRequire('5fZdl'));

});

parcelRegister("b8vRV", function(module, exports) {

let $81b9298ea947624d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81b9298ea947624d$var$load("igYET").then(()=>parcelRequire('k6ghn'));

});

parcelRegister("3Hjct", function(module, exports) {

let $2b144801333164fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2b144801333164fb$var$load("80bvY").then(()=>parcelRequire('iq7kq'));

});

parcelRegister("6KDhu", function(module, exports) {

let $4ea5825eabe1707f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ea5825eabe1707f$var$load("jwQtv").then(()=>parcelRequire('bW6Sb'));

});

parcelRegister("fxDDv", function(module, exports) {

let $b508af079c5cd080$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b508af079c5cd080$var$load("4APEf").then(()=>parcelRequire('i1po0'));

});

parcelRegister("l5iCB", function(module, exports) {

let $f59882729b9ff5f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f59882729b9ff5f3$var$load("ggFhf").then(()=>parcelRequire('9kjay'));

});



parcelRegister("b3Vox", function(module, exports) {

$parcel$export(module.exports, "ExusUserSourceProvider", () => $331e080864f7862a$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $331e080864f7862a$export$c6c0c1a2bac363f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $331e080864f7862a$var$ExusUserSourceContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
const $331e080864f7862a$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($331e080864f7862a$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $331e080864f7862a$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $5uXOq.useContext)($331e080864f7862a$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $5uXOq.useState)([]);
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const abortController = (0, $5uXOq.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("cfWle", function(module, exports) {

$parcel$export(module.exports, "CoreInvitesJiraProjectContext", () => $09b41a5d57cfc58a$export$b9157093d5c4e7cd);
$parcel$export(module.exports, "useCoreInvitesJiraProjectContext", () => $09b41a5d57cfc58a$export$2a48237687fafe42);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $j1rgu = parcelRequire("j1rgu");

var $444qv = parcelRequire("444qv");
const $09b41a5d57cfc58a$export$f3c297c96e0df944 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $09b41a5d57cfc58a$export$3eb662c848c7349f = 'core-invites';
const $09b41a5d57cfc58a$export$b9157093d5c4e7cd = ({ children: children })=>{
    const { coreInvitesInJiraProjects: coreInvitesInJiraProjectsCohort } = (0, $444qv.useExperimentalFeatures)();
    const isCoreInvitesInJiraProjectEnabled = coreInvitesInJiraProjectsCohort === (0, $j1rgu.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY || coreInvitesInJiraProjectsCohort === (0, $j1rgu.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($09b41a5d57cfc58a$export$f3c297c96e0df944.Provider, {
        value: {
            isCoreInvitesInJiraProjectEnabled: isCoreInvitesInJiraProjectEnabled
        },
        children: children
    });
};
const $09b41a5d57cfc58a$export$2a48237687fafe42 = ()=>{
    const state = (0, $5uXOq.useContext)($09b41a5d57cfc58a$export$f3c297c96e0df944);
    if (state === undefined) throw new Error('useCoreInvitesJiraProjectContext must be used within a CoreInvitesJiraProjectStateContextProvider');
    return state;
};

});
parcelRegister("j1rgu", function(module, exports) {

$parcel$export(module.exports, "CORE_INVITES_IN_JIRA_PROJECTS", () => $067d0647ed6261b9$export$3496ae3c3008d7e5);
var $067d0647ed6261b9$export$3496ae3c3008d7e5 = /*#__PURE__*/ function(CORE_INVITES_IN_JIRA_PROJECTS) {
    CORE_INVITES_IN_JIRA_PROJECTS["CONTROL"] = "control";
    CORE_INVITES_IN_JIRA_PROJECTS["NOT_ENROLLED"] = "not-enrolled";
    CORE_INVITES_IN_JIRA_PROJECTS["INVITE_ONLY"] = "invite-only-variation";
    CORE_INVITES_IN_JIRA_PROJECTS["INVITE_ONLY_NOT_ENROLLED"] = "invite-only-not-enrolled";
    CORE_INVITES_IN_JIRA_PROJECTS["INVITE_RA"] = "invite-ra-variation";
    CORE_INVITES_IN_JIRA_PROJECTS["INVITE_RA_NOT_ENROLLED"] = "invite-ra-variation";
    return CORE_INVITES_IN_JIRA_PROJECTS;
}({});

});


parcelRegister("1TRcz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a1f7e436abd2034$export$2e2bcd8739ae039);
/* ThirdPartyConnectedTo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $6tzHJ = parcelRequire("6tzHJ");

var $5KCCi = parcelRequire("5KCCi");


var $cgJ4s = parcelRequire("cgJ4s");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $k9nuy = parcelRequire("k9nuy");

var $gHU1R = parcelRequire("gHU1R");

var $dnGcR = parcelRequire("dnGcR");

var $inni2 = parcelRequire("inni2");

var $6HEbe = parcelRequire("6HEbe");

var $fn6W9 = parcelRequire("fn6W9");

var $daXvt = parcelRequire("daXvt");

var $8TQ2j = parcelRequire("8TQ2j");

var $52kUs = parcelRequire("52kUs");

var $dCNWF = parcelRequire("dCNWF");

var $iTzFN = parcelRequire("iTzFN");
const $4a1f7e436abd2034$var$MAX_INTEGRATIONS_WITH_LABEL = 3;
const $4a1f7e436abd2034$var$styles = {
    wrapper: "_19pku2gc",
    fieldSet: "_1e0c1bgi",
    connectedIntegrationWrapper: "_2rkogqwt _11c8qk37 _4bfu18uv _1hmsglyw _ajmmnqa1 _1mou1b66 _195g12x7 _4t3i7vkz _1e0c1txw _2lx2vrvc _1bah1h6o _syaz131l _bfhkvuon _9oik18uv _1bnxglyw _jf4cnqa1 _irr31yvi",
    connectedPlatformSlackServiceWrapper: "_irr315ej",
    connectedIntegrationText: "_195g1b66 _syaz1fxt"
};
const $4a1f7e436abd2034$var$ConnectedIntegration = ({ integration: integration, shouldShowLabel: shouldShowLabel = true })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $iTzFN.ThirdPartyAnalytics));
    const { onDisconnectProvider: onDisconnectProvider } = (0, $dCNWF.useThirdPartyState)();
    const { orgId: orgId } = (0, $daXvt.useInvitePeopleContext)();
    const [hover, setHover] = (0, $5uXOq.useState)(false);
    let { icon: icon } = (0, $52kUs.useIntegrationComponents)(integration);
    const { connectButtonText: connectButtonText, toolTip: toolTip } = (0, $52kUs.useIntegrationComponents)(integration);
    if (hover) icon = integration === (0, $8TQ2j.PLATFORM_SLACK_SERVICE) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dnGcR))), {
        color: `var(--ds-icon, ${(0, $a7f8c6b391092279$export$ad0bacf983b7ddaa)})`,
        LEGACY_size: 'small',
        label: 'settings'
    }, integration) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cgJ4s))), {
        color: `var(--ds-icon, ${(0, $a7f8c6b391092279$export$ad0bacf983b7ddaa)})`,
        LEGACY_size: 'small',
        label: 'unlink'
    }, integration);
    const onMouseOver = (0, $5uXOq.useCallback)(()=>{
        if (!hover) setHover(true);
    }, [
        hover
    ]);
    const onMouseOut = (0, $5uXOq.useCallback)(()=>{
        if (hover) setHover(false);
    }, [
        hover
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        analytics.integrationSettingsButtonClicked(integration, orgId);
        onDisconnectProvider(integration);
    }, [
        integration,
        analytics,
        onDisconnectProvider,
        orgId
    ]);
    const integrationComponent = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gHU1R.default), {
        testId: `testId-invite-people-third-party-${integration}`,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onClick: onClick,
        href: "#",
        xcss: (0, $6tzHJ.cx)($4a1f7e436abd2034$var$styles.connectedIntegrationWrapper, integration === (0, $8TQ2j.PLATFORM_SLACK_SERVICE) && $4a1f7e436abd2034$var$styles.connectedPlatformSlackServiceWrapper),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                position: "bottom",
                content: toolTip,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    children: icon
                })
            }),
            shouldShowLabel && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $4a1f7e436abd2034$var$styles.connectedIntegrationText
                ]),
                children: connectButtonText
            })
        ]
    });
    return integrationComponent;
};
const $4a1f7e436abd2034$var$ThirdPartyConnectedTo = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { integrations: integrations, updateIntegrations: updateIntegrations } = (0, $dCNWF.useThirdPartyState)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $inni2.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
            alignBlock: "center",
            alignInline: "start",
            xcss: $4a1f7e436abd2034$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("fieldset", {
                className: (0, $bwpsq.default)([
                    $4a1f7e436abd2034$var$styles.fieldSet
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        as: "legend",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            size: "small",
                            weight: "regular",
                            children: formatMessage((0, $fn6W9.messages).thirdPartyConnectedTo)
                        })
                    }),
                    [
                        ...integrations
                    ].map((integration)=>{
                        if (updateIntegrations.noScope.has(integration)) return null;
                        return /*#__PURE__*/ (0, $2OMIu.jsx)($4a1f7e436abd2034$var$ConnectedIntegration, {
                            integration: integration,
                            shouldShowLabel: integrations.size <= $4a1f7e436abd2034$var$MAX_INTEGRATIONS_WITH_LABEL
                        }, integration);
                    })
                ]
            })
        })
    });
};
var $4a1f7e436abd2034$export$2e2bcd8739ae039 = $4a1f7e436abd2034$var$ThirdPartyConnectedTo;

});
parcelRegister("cgJ4s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f974263d6792e563f31a788c1da2025e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ee9f0cd3216dc71$var$_react = $8ee9f0cd3216dc71$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8ee9f0cd3216dc71$var$_linkBroken = $8ee9f0cd3216dc71$var$_interopRequireDefault((parcelRequire("lYlcK")));

var $8ee9f0cd3216dc71$var$_unlink = $8ee9f0cd3216dc71$var$_interopRequireDefault((parcelRequire("i1Qu4")));
function $8ee9f0cd3216dc71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkBrokenIcon.
 * This component is LinkBrokenIcon, with `UNSAFE_fallbackIcon` set to "UnlinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ee9f0cd3216dc71$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $8ee9f0cd3216dc71$var$_react.default.createElement($8ee9f0cd3216dc71$var$_linkBroken.default, Object.assign({
        LEGACY_fallbackIcon: $8ee9f0cd3216dc71$var$_unlink.default
    }, props));
$8ee9f0cd3216dc71$var$LinkBrokenIcon.Name = 'LinkBrokenIconMigration';
var $8ee9f0cd3216dc71$var$_default = module.exports.default = $8ee9f0cd3216dc71$var$LinkBrokenIcon;

});
parcelRegister("lYlcK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d32cfb464fc797f765cf705a7186f08e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ffefa659e876a95d$var$_react = $ffefa659e876a95d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ffefa659e876a95d$var$_baseNew = $ffefa659e876a95d$var$_interopRequireDefault((parcelRequire("enEmH")));
function $ffefa659e876a95d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ffefa659e876a95d$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $ffefa659e876a95d$var$_react.default.createElement($ffefa659e876a95d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$ffefa659e876a95d$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $ffefa659e876a95d$var$_default = module.exports.default = $ffefa659e876a95d$var$LinkBrokenIcon;

});

parcelRegister("i1Qu4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d20108388a5127be$var$_react = $d20108388a5127be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $d20108388a5127be$var$_linkBroken = $d20108388a5127be$var$_interopRequireDefault((parcelRequire("lYlcK")));
function $d20108388a5127be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d20108388a5127be$var$UnlinkIcon = (props)=>/*#__PURE__*/ $d20108388a5127be$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.72 14.43a.97.97 0 0 0-1.37 0l-2.09 2.06a1.93 1.93 0 0 1-1.37.57c-.59 0-1.13-.26-1.52-.74-.63-.78-.5-1.93.2-2.64l1.32-1.32.69-.69a.97.97 0 0 0 0-1.38.97.97 0 0 0-1.37 0l-2.07 2.07a3.89 3.89 0 0 0 0 5.5l.01.01A3.87 3.87 0 0 0 8.89 19a3.87 3.87 0 0 0 2.75-1.14l2.08-2.08a.95.95 0 0 0 0-1.34m-3.44-4.87a.97.97 0 0 0 1.37 0l2.09-2.06c.37-.37.85-.57 1.37-.57.59 0 1.14.26 1.53.74.63.78.51 1.93-.2 2.64l-1.32 1.32-.69.69a.97.97 0 0 0 0 1.38c.38.38 1 .38 1.38 0l2.07-2.07a3.89 3.89 0 0 0 0-5.5l-.01-.01A3.87 3.87 0 0 0 15.11 5a3.87 3.87 0 0 0-2.75 1.14l-2.08 2.09a.95.95 0 0 0 0 1.35M8.92 4.62l.4.97a1 1 0 1 1-1.85.77l-.4-.97a1 1 0 1 1 1.85-.76M5.38 7.08l.97.4a1 1 0 0 1-.77 1.85l-.97-.4a1 1 0 0 1 .77-1.85m9.94 10.41a1 1 0 0 0-.54 1.31l.4.97a1 1 0 1 0 1.84-.77l-.4-.97a1 1 0 0 0-1.31-.54m2.18-2.17a1 1 0 0 0 .54 1.31l.97.4a1 1 0 0 0 .77-1.85l-.97-.4a1 1 0 0 0-1.31.54"/></svg>`
    }, props, {
        newIcon: $d20108388a5127be$var$_linkBroken.default
    }));
$d20108388a5127be$var$UnlinkIcon.displayName = 'UnlinkIcon';
var $d20108388a5127be$var$_default = module.exports.default = $d20108388a5127be$var$UnlinkIcon;

});



parcelRegister("eddUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $89bd4fd77982ff6a$export$2e2bcd8739ae039);
/* UpdateConnection.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cNW3X = parcelRequire("cNW3X");

var $vCqQa = parcelRequire("vCqQa");

var $b4a3S = parcelRequire("b4a3S");


var $5E93O = parcelRequire("5E93O");

var $85eFT = parcelRequire("85eFT");

var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $fJpmn = parcelRequire("fJpmn");

var $gZC93 = parcelRequire("gZC93");

var $6HEbe = parcelRequire("6HEbe");

var $fn6W9 = parcelRequire("fn6W9");

var $8TQ2j = parcelRequire("8TQ2j");

var $dCNWF = parcelRequire("dCNWF");

var $iTzFN = parcelRequire("iTzFN");

var $daXvt = parcelRequire("daXvt");
const $89bd4fd77982ff6a$var$styles = {
    wrapper: "_11c81oud _19pku2gc",
    popupWrapper: "_11c81oud _1moupxbi _195gpxbi _kqswh2mm _1bsbp2n4",
    popupBody: "_1mouu2gc",
    popupButtonWrapper: "_2rkogqwt _80omtlke",
    buttonTitle: "_18zr1b66 _1e0c116y _y3gn1e5h _o5724jg8"
};
const $89bd4fd77982ff6a$var$UpdateIntegration = ({ integration: integration, scopeState: scopeState })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $iTzFN.ThirdPartyAnalytics));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { orgId: orgId } = (0, $daXvt.useInvitePeopleContext)();
    const { onConnectProvider: onConnectProvider, onDisconnectProvider: onDisconnectProvider } = (0, $dCNWF.useThirdPartyState)();
    const [showPopup, setShowPopup] = (0, $5uXOq.useState)(false);
    const [hover, setHover] = (0, $5uXOq.useState)(false);
    let product = null;
    let popupTitle = null;
    let popupBody = null;
    let buttonTitle = null;
    let space = null;
    const iconColor = {
        error: {
            color: `var(--ds-icon-danger, ${$a7f8c6b391092279$export$2010d0fb4295b346})`,
            accent: `var(--ds-icon-danger, ${$a7f8c6b391092279$export$4a7404f376229999})`
        },
        warning: {
            color: `var(--ds-icon-danger, ${$a7f8c6b391092279$export$c6930421db9fa514})`,
            accent: `var(--ds-icon-danger, ${$a7f8c6b391092279$export$5aae31392d72caaa})`
        }
    };
    switch(integration){
        case 0, $8TQ2j.PLATFORM_SLACK_SERVICE:
            product = formatMessage((0, $fn6W9.messages).slackThirdPartyButton);
            break;
        case 0, $8TQ2j.GOOGLE_SERVICE:
            product = formatMessage((0, $fn6W9.messages).googleThirdPartyButton);
            space = formatMessage((0, $fn6W9.messages).googleSpace);
            break;
        case 0, $8TQ2j.MICROSOFT_SERVICE:
            product = formatMessage((0, $fn6W9.messages).microsoftThirdPartyButton);
            break;
    }
    // No scope messaging more general, will replace detailed partial scope messaging
    if (scopeState === (0, $fJpmn.ScopeState).NO_SCOPE) {
        if (integration === (0, $8TQ2j.PLATFORM_SLACK_SERVICE)) {
            popupTitle = formatMessage((0, $fn6W9.messages).reviewConnectionTitle, {
                integration: product
            });
            popupBody = formatMessage((0, $fn6W9.messages).reviewConnectionDescription, {
                integration: product
            });
            buttonTitle = formatMessage((0, $fn6W9.messages).reviewConnection, {
                integration: product
            });
        } else {
            popupTitle = formatMessage((0, $fn6W9.messages).reviewAccessNoScopeTitle);
            popupBody = formatMessage((0, $fn6W9.messages).reviewAccessNoScopeDescription, {
                integration: product
            });
            buttonTitle = formatMessage((0, $fn6W9.messages).reviewAccessNoScope, {
                integration: product
            });
        }
    }
    if (scopeState === (0, $fJpmn.ScopeState).PARTIAL_SCOPE) {
        popupTitle = formatMessage((0, $fn6W9.messages).reviewAccessPartialAccessTitle, {
            integration: product,
            space: space
        });
        popupBody = formatMessage((0, $fn6W9.messages).reviewAccessPartialAccessDescription, {
            integration: product,
            space: space
        });
        buttonTitle = formatMessage((0, $fn6W9.messages).reviewAccessPartialScope, {
            integration: product
        });
    }
    const toggleHover = (0, $5uXOq.useCallback)(()=>setHover(!hover), [
        hover
    ]);
    const closePopup = (0, $5uXOq.useCallback)(()=>setShowPopup(false), []);
    const onUpdateClick = (0, $5uXOq.useCallback)(()=>{
        analytics.updateWarningClicked(integration, orgId || null, scopeState);
        setShowPopup(!showPopup);
    }, [
        integration,
        orgId,
        analytics,
        showPopup,
        scopeState
    ]);
    const onDisconnectClick = (0, $5uXOq.useCallback)(()=>{
        onDisconnectProvider(integration);
    }, [
        integration,
        onDisconnectProvider
    ]);
    (0, $5uXOq.useEffect)(()=>{
        analytics.updateConnectionShown(integration, scopeState);
    }, [
        integration,
        scopeState,
        analytics
    ]);
    const handleContinueButton = (0, $5uXOq.useCallback)(()=>{
        if (onConnectProvider) {
            analytics.scopeUpdateButtonClicked(integration, scopeState);
            onConnectProvider({
                serviceKey: integration
            });
        }
    }, [
        onConnectProvider,
        integration,
        scopeState,
        analytics
    ]);
    const continueButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        appearance: "link",
        spacing: "none",
        onClick: handleContinueButton,
        children: formatMessage((0, $fn6W9.messages).reviewAccessContinue)
    });
    const disconnectButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gZC93.default), {
        actionSubjectId: "disconnectUpdate",
        analyticsAttributes: {
            integration: integration,
            orgId: orgId,
            fromMenu: false
        },
        appearance: "link",
        spacing: "none",
        onClick: onDisconnectClick,
        children: formatMessage((0, $fn6W9.messages).reviewAccessDisconnect)
    });
    const notNowButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gZC93.default), {
        actionSubjectId: "notNowUpdate",
        analyticsAttributes: {
            integration: integration
        },
        appearance: "link",
        spacing: "none",
        onClick: closePopup,
        children: formatMessage((0, $fn6W9.messages).reviewAccessNotNow)
    });
    const PopupContent = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
            xcss: $89bd4fd77982ff6a$var$styles.popupWrapper,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                    weight: "bold",
                    children: popupTitle
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                    xcss: $89bd4fd77982ff6a$var$styles.popupBody,
                    children: popupBody
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                    alignBlock: "start",
                    xcss: $89bd4fd77982ff6a$var$styles.popupButtonWrapper,
                    space: "space.050",
                    children: [
                        continueButton,
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            as: "span",
                            children: "\u2022"
                        }),
                        scopeState === (0, $fJpmn.ScopeState).NO_SCOPE ? disconnectButton : notNowButton
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
        onClose: closePopup,
        isOpen: showPopup,
        content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)(PopupContent, {}),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                ...triggerProps,
                appearance: "subtle-link",
                spacing: "none",
                onClick: onUpdateClick,
                onMouseEnter: toggleHover,
                onMouseLeave: toggleHover,
                iconBefore: scopeState === (0, $fJpmn.ScopeState).NO_SCOPE ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                    label: 'error',
                    color: showPopup || hover ? iconColor.error.accent : iconColor.error.color,
                    spacing: "spacious"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
                    label: 'warning',
                    color: showPopup || hover ? iconColor.warning.accent : iconColor.warning.color,
                    spacing: "spacious"
                }),
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    alignItems: 'center',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    fontWeight: "var(--ds-font-weight-regular, 400)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    alignSelf: 'flex-start'
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                    as: "span",
                    xcss: $89bd4fd77982ff6a$var$styles.buttonTitle,
                    children: buttonTitle
                })
            }),
        offset: [
            0,
            4
        ],
        zIndex: (0, $b4a3S.layers).flag(),
        placement: "bottom-start"
    });
};
const $89bd4fd77982ff6a$var$UpdateConnection = ({ scope: scope })=>{
    const { updateIntegrations: updateIntegrations } = (0, $dCNWF.useThirdPartyState)();
    const updatableIntegrations = (0, $5uXOq.useMemo)(()=>{
        switch(scope){
            case (0, $fJpmn.ScopeState).NO_SCOPE:
                return updateIntegrations.noScope;
            case (0, $fJpmn.ScopeState).PARTIAL_SCOPE:
                return updateIntegrations.partialScope;
            default:
                return null;
        }
    }, [
        scope,
        updateIntegrations
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
        xcss: $89bd4fd77982ff6a$var$styles.wrapper,
        children: updatableIntegrations && [
            ...updatableIntegrations
        ].map((integration)=>/*#__PURE__*/ (0, $2OMIu.jsx)($89bd4fd77982ff6a$var$UpdateIntegration, {
                integration: integration,
                scopeState: scope
            }, integration))
    });
};
var $89bd4fd77982ff6a$export$2e2bcd8739ae039 = $89bd4fd77982ff6a$var$UpdateConnection;

});

parcelRegister("7NZnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c38c6251827c798$export$2e2bcd8739ae039);
/* TeamOrUserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $vCqQa = parcelRequire("vCqQa");

var $5sRpy = parcelRequire("5sRpy");

var $b4a3S = parcelRequire("b4a3S");

var $4kIK6 = parcelRequire("4kIK6");

var $5CAoG = parcelRequire("5CAoG");
const $8c38c6251827c798$var$styles = {
    dummyPicker: "_1bsb1j8x _4t3i1ady"
};
const $8c38c6251827c798$var$TeamOrUserPicker = (props)=>{
    const clearTeamSelection = ()=>props.setSelectedTeam(undefined);
    const team = props.selectedTeam;
    return !team ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": "team-or-user-picker-wrapper",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4kIK6.UserPicker), {
            ...props,
            open: true
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
                onClose: clearTeamSelection,
                isOpen: true,
                content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5CAoG.default), {
                        tenantId: props.tenantId,
                        product: props.product,
                        team: team,
                        clearTeamSelection: clearTeamSelection
                    }),
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...triggerProps
                    }),
                offset: [
                    0,
                    4
                ],
                zIndex: (0, $b4a3S.layers).modal() + 1,
                placement: "bottom-start"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $8c38c6251827c798$var$styles.dummyPicker
            })
        ]
    });
};
var $8c38c6251827c798$export$2e2bcd8739ae039 = $8c38c6251827c798$var$TeamOrUserPicker;

});
parcelRegister("5CAoG", function(module, exports) {

$parcel$export(module.exports, "default", () => $85b36c7a56b3e649$export$2e2bcd8739ae039);
/* TeamMemberPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $cNW3X = parcelRequire("cNW3X");

var $aveRr = parcelRequire("aveRr");

var $jsLTH = parcelRequire("jsLTH");

var $85eFT = parcelRequire("85eFT");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $k9nuy = parcelRequire("k9nuy");

var $5KCCi = parcelRequire("5KCCi");

var $1CnPD = parcelRequire("1CnPD");

var $7Nt5L = parcelRequire("7Nt5L");

var $fISW3 = parcelRequire("fISW3");

var $fn6W9 = parcelRequire("fn6W9");

var $5AIMu = parcelRequire("5AIMu");

var $8TQ2j = parcelRequire("8TQ2j");

var $kx8ta = parcelRequire("kx8ta");

var $dCNWF = parcelRequire("dCNWF");

var $gkQTU = parcelRequire("gkQTU");

var $6HEbe = parcelRequire("6HEbe");

var $cLDgJ = parcelRequire("cLDgJ");

var $evtmo = parcelRequire("evtmo");

var $cfWle = parcelRequire("cfWle");
const $85b36c7a56b3e649$var$styles = {
    wrapper: "_1bsb1j8x",
    header: "_1h6dmuej _1dqonqa1 _189ee4h9 _4t3i8vuz _1s1giti9 _5fbciti9",
    backButtonWrapper: "_16jlidpf _1o9zidpf _i0dl1wug _18u0utpp",
    continueButtonWrapper: "_18u01wug _2hwxutpp",
    logoWrapper: "_1bsbzwfg _4t3izwfg",
    teamNameWrapper: "_195g12x7 _1ul9idpf",
    selectAllButtonWrapper: "_4t3ickbl",
    teamMembers: "_1reo1wug _18m91wug _18zrutpp _1h6dmuej _1dqonqa1 _85i5utpp _uwhkidpf _1doce4h9 _tml8e4h9 _1yxniti9 _1einiti9 _c71leo28 _sao8x0bf _18p3p3fh",
    pickItem: "_195g1b66 _4t3ickbl _1eq11h6o"
};
const $85b36c7a56b3e649$var$TeamMemberPicker = (props)=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $cLDgJ.TeamMemberPickerAnalytics));
    const { selectedSlackWorkspace: selectedSlackWorkspace, getUserByThirdPartyId: getUserByThirdPartyId, cacheUserByThirdPartyId: cacheUserByThirdPartyId } = (0, $dCNWF.useThirdPartyState)();
    const { isCoreInvitesInJiraProjectEnabled: isCoreInvitesInJiraProjectEnabled } = (0, $cfWle.useCoreInvitesJiraProjectContext)();
    const { setSelectedTeam: setSelectedTeam, userPickerOptions: userPickerOptions, selectUsersFromSlackTeam: selectUsersFromSlackTeam } = (0, $1CnPD.useInviteeListStateContext)();
    const originalUserPickerSelectedIds = new Set(userPickerOptions.map((user)=>user.id));
    const [userPickerSelectedIds, setUserPickerSelectedIds] = (0, $5uXOq.useState)(originalUserPickerSelectedIds);
    const [teamMembers, setTeamMembers] = (0, $5uXOq.useState)([]);
    const [isTeamMemberLoading, setIsTeamMemberLoading] = (0, $5uXOq.useState)(true);
    const [hasMoreMembersThan, setMoreMembersThan] = (0, $5uXOq.useState)(0);
    const teamMembersSelected = teamMembers.filter((member)=>userPickerSelectedIds.has(member.id));
    (0, $5uXOq.useEffect)(()=>{
        const workspaceId = selectedSlackWorkspace?.id;
        const getChannelMembers = async (workspaceId, channelId)=>{
            try {
                setIsTeamMemberLoading(true);
                const slackChannelMembersResponse = await (0, $7Nt5L.defaultInviteThirdPartyTeamsClient).getSlackChannelMembers(workspaceId, channelId);
                const slackChannelMembers = slackChannelMembersResponse.members.map((id)=>({
                        id: id,
                        cachedData: getUserByThirdPartyId((0, $8TQ2j.SLACK_SOURCE), id)
                    }));
                const slackUserDetailsAndPermsResponse = await (0, $7Nt5L.defaultInviteThirdPartyTeamsClient).getSlackUserDetailsAndPerms(props.tenantId, workspaceId, props.product, slackChannelMembers.filter((user)=>user.cachedData !== null).map((user)=>({
                        id: user.id,
                        // Note that experiment-api won't make the Slack request for users that have emails defined, this is how we
                        // are able to reduce the number of users being fetched using the cache
                        //
                        // https://bitbucket.org/atlassian/experiment-api/src/b01f7e2cdba0020ebcd2d3da6464b39075353e4e/src/experiments/invite-3rd-party-teams/getSlackUserDetailsAndPerms.ts#lines-18
                        email: user.cachedData?.email
                    })));
                const invalidUserIds = new Set(slackChannelMembers.filter((user)=>!user.cachedData?.email).map((user)=>user.id));
                const slackUserDetailsAndPermsMap = new Map();
                for (const userDetails of slackUserDetailsAndPermsResponse.userDetailsAndPerms){
                    slackUserDetailsAndPermsMap.set(userDetails.id, {
                        hasProductAccess: userDetails.hasProductAccess,
                        details: userDetails.details
                    });
                    invalidUserIds.delete(userDetails.id);
                    if (userDetails.details) cacheUserByThirdPartyId((0, $8TQ2j.SLACK_SOURCE), userDetails.id, // The type: 'directMessage' is purely for type purposes, since the interface SlackUser has a field type: 'directMessage', so
                    // it needs to be set here to satisfy the types. slackToExternalUser() doesn't actually uses slackUser.type so it won’t cause any problems
                    //
                    // https://bitbucket.org/atlassian/atlassian-frontend/src/dabb025dcab4f47f956f61985cd57195a8d8a9d2/packages/growth/integrations/src/share-to-slack/common/types.ts#lines-129
                    (0, $kx8ta.slackToExternalUser)({
                        ...userDetails.details,
                        type: 'directMessage'
                    }));
                }
                for (const userId of invalidUserIds)cacheUserByThirdPartyId((0, $8TQ2j.SLACK_SOURCE), userId, null);
                const teamMembers = slackChannelMembers.filter((user)=>!invalidUserIds.has(user.id)).map(({ id: id, cachedData: cachedData })=>{
                    const userDetails = slackUserDetailsAndPermsMap.get(id);
                    const teamMember = {
                        id: id,
                        email: cachedData?.email ?? userDetails?.details?.email,
                        avatarUrl: cachedData?.avatarUrl ?? userDetails?.details?.avatarUrl,
                        // Using empty string as a last resort to satisfy the type of `name`, which is strictly `string`. Though it should never be used since `userDetails` should contain the details
                        // in case the cache doesn't have it
                        name: cachedData?.name ?? userDetails?.details?.realName ?? '',
                        hasProductAccess: userDetails?.hasProductAccess,
                        sources: [
                            'slack'
                        ]
                    };
                    return teamMember;
                });
                analytics.teamMemberPickerViewed({
                    teamId: channelId,
                    members: teamMembers.length,
                    membersWithAccess: teamMembers.filter((member)=>member.hasProductAccess).length,
                    membersCapped: slackChannelMembersResponse.hasMoreMembers
                });
                setTeamMembers(teamMembers);
                setMoreMembersThan(slackChannelMembersResponse.hasMoreMembers ? teamMembers.length : 0);
            } catch (err) {
                const { code: code, message: message, status: status } = (0, $evtmo.getErrorDetails)(err);
                analytics.viewSlackTeamMembersFailed(code, message, status);
            } finally{
                setIsTeamMemberLoading(false);
            }
        };
        if (workspaceId) getChannelMembers(workspaceId, props.team.id);
    }, [
        analytics,
        cacheUserByThirdPartyId,
        getUserByThirdPartyId,
        props.product,
        props.team,
        props.tenantId,
        selectedSlackWorkspace
    ]);
    const isNotPreSelected = (member)=>!originalUserPickerSelectedIds.has(member.id);
    const isSelectedMembersChanged = originalUserPickerSelectedIds.size !== userPickerSelectedIds.size || teamMembersSelected.some(isNotPreSelected);
    const selectableTeamMembers = teamMembers.filter((teamMember)=>// team member is always selectable when `core invites in jira project` is enabled, regardless of its product access
        isCoreInvitesInJiraProjectEnabled || !teamMember.hasProductAccess);
    const selectAllInTeam = (0, $5uXOq.useCallback)(()=>setUserPickerSelectedIds(new Set(selectableTeamMembers.map((teamMember)=>teamMember.id))), [
        selectableTeamMembers
    ]);
    const deselectAllInTeam = (0, $5uXOq.useCallback)(()=>setUserPickerSelectedIds(new Set()), []);
    const onChange = (0, $5uXOq.useCallback)((event)=>{
        if (event.target.checked) {
            if (!userPickerSelectedIds.has(event.target.value)) setUserPickerSelectedIds(new Set(userPickerSelectedIds.add(event.target.value)));
        } else if (userPickerSelectedIds.has(event.target.value)) {
            userPickerSelectedIds.delete(event.target.value);
            setUserPickerSelectedIds(new Set(userPickerSelectedIds));
        }
    }, [
        userPickerSelectedIds
    ]);
    const onContinue = (0, $5uXOq.useCallback)(()=>{
        analytics.teamMemberPickerContinueClicked({
            teamId: props.team.id,
            members: teamMembers.length,
            membersWithAccess: teamMembers.filter((member)=>member.hasProductAccess).length,
            selectedMembers: userPickerSelectedIds.size,
            membersCapped: hasMoreMembersThan > 0
        });
        selectUsersFromSlackTeam(teamMembersSelected, teamMembers);
        setSelectedTeam(undefined);
    }, [
        analytics,
        props.team.id,
        teamMembers,
        userPickerSelectedIds.size,
        hasMoreMembersThan,
        selectUsersFromSlackTeam,
        setSelectedTeam,
        teamMembersSelected
    ]);
    const isTeamMemberDisabled = (0, $5uXOq.useCallback)((member)=>// team member is always selectable when `core invites in jira project` is enabled, regardless of its product access
        isCoreInvitesInJiraProjectEnabled ? false : !!member.hasProductAccess, [
        isCoreInvitesInJiraProjectEnabled
    ]);
    const isTeamMemberChecked = (0, $5uXOq.useCallback)((member)=>// team member is always checkable when `core invites in jira project` is enabled, regardless of its product access
        isCoreInvitesInJiraProjectEnabled ? userPickerSelectedIds.has(member.id) : userPickerSelectedIds.has(member.id) || member.hasProductAccess, [
        isCoreInvitesInJiraProjectEnabled,
        userPickerSelectedIds
    ]);
    const showTeamMemberSubText = (0, $5uXOq.useCallback)((member)=>// team member should never show sub text when `core invites in jira project` is enabled, regardless of its product access
        isCoreInvitesInJiraProjectEnabled ? false : !member.hasProductAccess, [
        isCoreInvitesInJiraProjectEnabled
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
        testId: "team-member-picker-wrapper",
        backgroundColor: "color.background.input",
        xcss: $85b36c7a56b3e649$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                alignBlock: "center",
                spread: "space-between",
                xcss: $85b36c7a56b3e649$var$styles.header,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: $85b36c7a56b3e649$var$styles.backButtonWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                            appearance: "subtle",
                            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jsLTH))), {
                                color: "currentColor",
                                spacing: "spacious",
                                label: formatMessage((0, $fn6W9.messages).inviteeListLabelThirdPartyTeamMemberPickerBackButton)
                            }),
                            onClick: props.clearTeamSelection
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: $85b36c7a56b3e649$var$styles.logoWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fISW3.SlackLogo), {})
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                        xcss: $85b36c7a56b3e649$var$styles.teamNameWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                            content: props.team?.name,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                maxLines: 1,
                                children: props.team?.name
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: $85b36c7a56b3e649$var$styles.continueButtonWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                            appearance: "primary",
                            isDisabled: isTeamMemberLoading || !isSelectedMembersChanged,
                            onClick: onContinue,
                            testId: "team-member-picker-continue-button",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $fn6W9.messages).inviteeListLabelThirdPartyTeamMemberPickerContinueButton
                            })
                        })
                    })
                ]
            }),
            isTeamMemberLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5AIMu.default), {}) : teamMembers && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                testId: "team-members",
                xcss: $85b36c7a56b3e649$var$styles.teamMembers,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                        alignBlock: "center",
                        xcss: $85b36c7a56b3e649$var$styles.selectAllButtonWrapper,
                        children: [
                            teamMembersSelected.length ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                                testId: "team-member-picker-deselect-all",
                                appearance: "link",
                                onClick: deselectAllInTeam,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...(0, $fn6W9.messages).thirdPartyTeamDeselectAllLabel,
                                    values: {
                                        numSelected: teamMembersSelected.length
                                    }
                                })
                            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                                testId: "team-member-picker-select-all",
                                appearance: "link",
                                onClick: selectAllInTeam,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...(0, $fn6W9.messages).thirdPartyTeamSelectAllLabel,
                                    values: {
                                        numSelectable: selectableTeamMembers.length
                                    }
                                })
                            }),
                            hasMoreMembersThan > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                                content: formatMessage((0, $fn6W9.messages).thirdPartyTeamHasMoreMembersWarningText, {
                                    memberCount: hasMoreMembersThan
                                }),
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                                    testId: "max-members-warning",
                                    appearance: "link",
                                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
                                        color: "currentColor",
                                        spacing: "spacious",
                                        label: formatMessage((0, $fn6W9.messages).thirdPartyTeamHasMoreMembersWarningLabel)
                                    })
                                })
                            })
                        ]
                    }),
                    teamMembers.map((member)=>{
                        const isDisabled = isTeamMemberDisabled(member);
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                            alignBlock: "center",
                            xcss: $85b36c7a56b3e649$var$styles.pickItem,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aveRr.default), {
                                isDisabled: isDisabled,
                                onChange: onChange,
                                isChecked: isTeamMemberChecked(member),
                                value: member.id,
                                label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gkQTU.default), {
                                    isDisabled: isDisabled,
                                    member: member,
                                    showSubText: showTeamMemberSubText(member)
                                }),
                                testId: `team-member-${member.id}`
                            })
                        }, member.id);
                    })
                ]
            })
        ]
    });
};
var $85b36c7a56b3e649$export$2e2bcd8739ae039 = $85b36c7a56b3e649$var$TeamMemberPicker;

});
parcelRegister("aveRr", function(module, exports) {

$parcel$export(module.exports, "default", () => $46f4f8a83dbe8ecb$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $cD7p8 = parcelRequire("cD7p8");

var $eDdzl = parcelRequire("eDdzl");
var $7NMn5 = parcelRequire("7NMn5");
var $7ULfK = parcelRequire("7ULfK");
var $5Z7Nu = parcelRequire("5Z7Nu");
const $46f4f8a83dbe8ecb$var$checkboxStyles = null; /**
                              * __Checkbox__
                              *
                              * A checkbox an input control that allows a user to select one or more options from a number of choices.
                              *
                              * - [Examples](https://atlassian.design/components/checkbox/examples)
                              * - [Code](https://atlassian.design/components/checkbox/code)
                              * - [Usage](https://atlassian.design/components/checkbox/usage)
                              */ 
const $46f4f8a83dbe8ecb$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $cD7p8.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7NMn5.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt",
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eDdzl.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7ULfK.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Z7Nu.default), {})
                ]
            })
        ]
    });
}));
$46f4f8a83dbe8ecb$var$Checkbox.displayName = 'Checkbox';
var $46f4f8a83dbe8ecb$export$2e2bcd8739ae039 = $46f4f8a83dbe8ecb$var$Checkbox;

});
parcelRegister("eDdzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a75fbddbadb7cd2$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2SY35 = parcelRequire("2SY35");

var $fHpHg = parcelRequire("fHpHg");
function $9a75fbddbadb7cd2$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $fHpHg.fg)('platform-visual-refresh-icons') && (0, $fHpHg.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $fHpHg.fg)('platform-visual-refresh-icons') && (0, $fHpHg.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $9a75fbddbadb7cd2$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$9a75fbddbadb7cd2$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SY35.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
                (0, $fHpHg.fg)('platform-visual-refresh-icons') && (0, $fHpHg.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $9a75fbddbadb7cd2$export$2e2bcd8739ae039 = $9a75fbddbadb7cd2$var$CheckboxIcon;

});

parcelRegister("7NMn5", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc95de6f20af911c$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $cc95de6f20af911c$var$baseStyles = null;
const $cc95de6f20af911c$var$textLabelLayoutStyles = null;
const $cc95de6f20af911c$var$disabledStyles = null;
const $cc95de6f20af911c$var$labelStyles = null;
function $cc95de6f20af911c$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("7ULfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $36497d3ff4b8b4c3$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $36497d3ff4b8b4c3$var$labelTextStyles = null;
function $36497d3ff4b8b4c3$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("5Z7Nu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d39f3d5b30b8495$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $8d39f3d5b30b8495$var$requiredIndicatorStyles = null;
function $8d39f3d5b30b8495$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("jsLTH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::707984c4bf43fbcb724a560e605082a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2b5c93f02a4f670$var$_react = $e2b5c93f02a4f670$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2b5c93f02a4f670$var$_arrowLeft = $e2b5c93f02a4f670$var$_interopRequireDefault((parcelRequire("kmtfL")));

var $e2b5c93f02a4f670$var$_arrowLeft2 = $e2b5c93f02a4f670$var$_interopRequireDefault((parcelRequire("gpI4P")));
function $e2b5c93f02a4f670$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2b5c93f02a4f670$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $e2b5c93f02a4f670$var$_react.default.createElement($e2b5c93f02a4f670$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $e2b5c93f02a4f670$var$_arrowLeft2.default
    }, props));
$e2b5c93f02a4f670$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $e2b5c93f02a4f670$var$_default = module.exports.default = $e2b5c93f02a4f670$var$ArrowLeftIcon;

});
parcelRegister("kmtfL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed2c8dd1c17ad869$var$_react = $ed2c8dd1c17ad869$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ed2c8dd1c17ad869$var$_baseNew = $ed2c8dd1c17ad869$var$_interopRequireDefault((parcelRequire("enEmH")));
function $ed2c8dd1c17ad869$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed2c8dd1c17ad869$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $ed2c8dd1c17ad869$var$_react.default.createElement($ed2c8dd1c17ad869$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$ed2c8dd1c17ad869$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $ed2c8dd1c17ad869$var$_default = module.exports.default = $ed2c8dd1c17ad869$var$ArrowLeftIcon;

});

parcelRegister("gpI4P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf312be5ba437a9c$var$_react = $bf312be5ba437a9c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $bf312be5ba437a9c$var$_arrowLeft = $bf312be5ba437a9c$var$_interopRequireDefault((parcelRequire("kmtfL")));
function $bf312be5ba437a9c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bf312be5ba437a9c$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $bf312be5ba437a9c$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $bf312be5ba437a9c$var$_arrowLeft.default
    }));
$bf312be5ba437a9c$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $bf312be5ba437a9c$var$_default = module.exports.default = $bf312be5ba437a9c$var$ArrowLeftIcon;

});


parcelRegister("1CnPD", function(module, exports) {

$parcel$export(module.exports, "getEmailAndIdArrays", () => $65f07a916ee1e1e2$export$15763c41b3a95990);
$parcel$export(module.exports, "InviteeListContext", () => $65f07a916ee1e1e2$export$6dbd1016efd8086d);
$parcel$export(module.exports, "useInviteeListStateContext", () => $65f07a916ee1e1e2$export$ec7b6d9ecf7a2aed);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hatDq = parcelRequire("hatDq");

var $grXIr = parcelRequire("grXIr");

var $jN5wg = parcelRequire("jN5wg");

var $6HEbe = parcelRequire("6HEbe");
const $65f07a916ee1e1e2$export$9b360043fbff7382 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $65f07a916ee1e1e2$export$72f281f17133b74f = (options, includeGroupsInIds)=>options.filter((option)=>includeGroupsInIds || option.type !== 'group').map((option)=>{
        if ((0, $grXIr.isEmail)(option)) {
            const nameOrId = option.name || option.id;
            return {
                email: nameOrId
            };
        }
        if ((0, $grXIr.isUser)(option)) {
            if (option.email) return {
                email: option.email
            };
            else {
                const id = option.id;
                return {
                    id: id
                };
            }
        }
        // Use the id if option is not of type USER or EMAIL
        const id = option.id;
        return {
            id: id
        };
    });
const $65f07a916ee1e1e2$export$ac13055eb7c14776 = (options)=>options.filter((option)=>option.type === 'group').map(({ id: id })=>({
            id: id
        }));
const $65f07a916ee1e1e2$export$15763c41b3a95990 = (options)=>{
    const emailsAndIds = $65f07a916ee1e1e2$export$72f281f17133b74f(options, true);
    return {
        emails: emailsAndIds.flatMap((item)=>(0, $hatDq.isUserWithEmail)(item) && item.email ? [
                item.email
            ] : []),
        // only get ID if email does not exist and ID exists.
        ids: emailsAndIds.flatMap((item)=>item.id && !(0, $hatDq.isUserWithEmail)(item) ? [
                item.id
            ] : [])
    };
};
const $65f07a916ee1e1e2$export$a6210aced9c88789 = (options, invitedUser)=>{
    const user = options.find((option)=>{
        if ((0, $grXIr.isExternalUser)(option)) return option.email === invitedUser.email || option.id === invitedUser.id;
        return false;
    });
    return user ? user.externalUserType : undefined;
};
const $65f07a916ee1e1e2$export$6dbd1016efd8086d = ({ allowEmail: allowEmail, children: children, initialInvitees: initialInvitees, experimental_userPickerByline: experimental_userPickerByline })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $jN5wg.InviteeListAnalytics));
    const [userPickerOptions, setUserPickerOptions] = (0, $5uXOq.useState)(()=>initialInvitees ?? []);
    const [trailingText, setTrailingText] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState('');
    const [selectedTeam, setSelectedTeam] = (0, $5uXOq.useState)();
    const [selectedSlackTeamUserEmails, setSelectedSlackTeamUserEmails] = (0, $5uXOq.useState)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        setSelectedSlackTeamUserEmails((selectedSlackTeamUserEmails)=>new Set(userPickerOptions.filter((user)=>selectedSlackTeamUserEmails.has(user.email)).map((user)=>user.email)));
    }, [
        userPickerOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (initialInvitees && initialInvitees.length > 0) analytics.inviteeListPrefilled(initialInvitees.length);
    }, [
        initialInvitees,
        analytics
    ]);
    // emails ands ids that are in the user picker. This array will be used when inviting.
    const users = $65f07a916ee1e1e2$export$72f281f17133b74f(userPickerOptions, false);
    const groups = $65f07a916ee1e1e2$export$ac13055eb7c14776(userPickerOptions);
    // emails and ids as string arrays.
    const { emails: emails, ids: ids } = $65f07a916ee1e1e2$export$15763c41b3a95990(userPickerOptions);
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const selectUsersFromSlackTeam = (selectedTeamUsers, allTeamUsers)=>{
            const selectedTeamEmails = selectedTeamUsers.map((user)=>user.email);
            const selected = new Set(selectedTeamEmails);
            const unselected = new Set(allTeamUsers.filter((user)=>!selected.has(user.email)).map((user)=>user.email));
            setSelectedSlackTeamUserEmails(new Set([
                ...[
                    ...selectedSlackTeamUserEmails
                ].filter((email)=>!unselected.has(email)),
                ...selectedTeamEmails
            ]));
            const existingEmails = new Set(userPickerOptions.map((user)=>user.email));
            setUserPickerOptions([
                ...userPickerOptions.filter((user)=>!unselected.has(user.email)),
                ...selectedTeamUsers.filter((user)=>!existingEmails.has(user.email))
            ]);
        };
        const getName = (id)=>{
            return userPickerOptions.find((item)=>item.id === id)?.name || id;
        };
        const getUser = (id)=>userPickerOptions.find((user)=>user.id === id);
        const getExternalUserType = (user)=>$65f07a916ee1e1e2$export$a6210aced9c88789(userPickerOptions, user);
        return {
            // NOTE: default value of `allowEmail` is `true` given backwards compatibility,
            //       since UserPicker's `allowEmail` was always `true` before the Invite People `allowEmail` prop
            allowEmail: allowEmail ?? true,
            userPickerOptions: userPickerOptions,
            setUserPickerOptions: setUserPickerOptions,
            selectedTeam: selectedTeam,
            setSelectedTeam: setSelectedTeam,
            trailingText: trailingText,
            setTrailingText: setTrailingText,
            users: users,
            groups: groups,
            emails: emails,
            ids: ids,
            getName: getName,
            getUser: getUser,
            getExternalUserType: getExternalUserType,
            selectedSlackTeamUserEmails: selectedSlackTeamUserEmails,
            selectUsersFromSlackTeam: selectUsersFromSlackTeam,
            experimental_userPickerByline: experimental_userPickerByline
        };
    }, [
        allowEmail,
        emails,
        groups,
        ids,
        selectedSlackTeamUserEmails,
        selectedTeam,
        trailingText,
        userPickerOptions,
        users,
        experimental_userPickerByline
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($65f07a916ee1e1e2$export$9b360043fbff7382.Provider, {
        value: contextValue,
        children: children
    });
};
const $65f07a916ee1e1e2$export$ec7b6d9ecf7a2aed = ()=>{
    const state = (0, $5uXOq.useContext)($65f07a916ee1e1e2$export$9b360043fbff7382);
    if (state === undefined) throw new Error('useInviteeListStateContext must be used within a InviteeListStateContextProvider');
    return state;
};

});
parcelRegister("jN5wg", function(module, exports) {

$parcel$export(module.exports, "InviteeListAnalytics", () => $405dd0bcc9e4b8be$export$be0471201c1b7dbc);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $405dd0bcc9e4b8be$export$be0471201c1b7dbc extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    inviteeListItemAdded(id, attributes) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INVITEE_LIST_ITEM,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubject).INVITEE_LIST_ITEM + id,
            action: (0, $hatDq.AnalyticsAction).ADDED,
            attributes: {
                ...attributes
            }
        });
    }
    inviteeListFocused(id) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INVITEE_LIST,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubject).INVITEE_LIST + id,
            action: (0, $hatDq.AnalyticsAction).CLICKED
        });
    }
    inviteeListPrefilled(numUsersPrefilled) {
        const { source: source } = this.commonAttributes;
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INVITEE_LIST,
            action: (0, $hatDq.AnalyticsAction).PREFILLED,
            attributes: {
                numUsersPrefilled: numUsersPrefilled,
                source: source
            }
        });
    }
    teamOrUserPickerViewed(attributes) {
        this.fireScreen({
            name: (0, $hatDq.AnalyticsActionSubject).TEAM_OR_USER_PICKER,
            attributes: attributes
        });
    }
    slackChannelClicked(teamId) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubject).INVITEE_LIST_ITEM_USER_PICKER,
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            attributes: {
                source: (0, $hatDq.AnalyticsActionSubject).TEAM_OR_USER_PICKER,
                teamId: teamId
            }
        });
    }
    slackUserSelected() {
        this.fireTrack({
            action: (0, $hatDq.AnalyticsAction).SELECTED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).SLACK_USER
        });
    }
    userPickerTyped(attributes) {
        this.fireTrack({
            action: (0, $hatDq.AnalyticsAction).TYPED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).USER_PICKER,
            attributes: {
                context: 'invite-user-picker',
                pickerType: 'multi',
                numberOfResults: attributes.results.length,
                ...attributes
            }
        });
    }
    userPickerAutoOpened(attributes) {
        this.fireUI({
            action: (0, $hatDq.AnalyticsAction).AUTO_OPENED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).USER_PICKER,
            attributes: {
                context: 'invite-user-picker',
                pickerType: 'multi',
                ...attributes
            }
        });
    }
}

});


parcelRegister("fISW3", function(module, exports) {

$parcel$export(module.exports, "SlackLogo", () => $67fd0a46101d003b$export$741d0a87d063b83b);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $67fd0a46101d003b$export$741d0a87d063b83b(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "15.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.7748 18.3522C10.7748 19.391 9.92619 20.2396 8.88739 20.2396C7.8486 20.2396 7 19.391 7 18.3522C7 17.3134 7.8486 16.4648 8.88739 16.4648H10.7748V18.3522Z",
                fill: "#E01E5A"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.7249 18.3527C11.7249 17.3139 12.5734 16.4653 13.6122 16.4653C14.651 16.4653 15.4996 17.3139 15.4996 18.3527V23.0785C15.4996 24.1173 14.651 24.9659 13.6122 24.9659C12.5734 24.9659 11.7249 24.1173 11.7249 23.0785V18.3527Z",
                fill: "#E01E5A"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M13.6122 10.7748C12.5734 10.7748 11.7249 9.92618 11.7249 8.88739C11.7249 7.84859 12.5734 7 13.6122 7C14.651 7 15.4996 7.84859 15.4996 8.88739V10.7748H13.6122Z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M13.6132 11.7256C14.652 11.7256 15.5006 12.5742 15.5006 13.613C15.5006 14.6518 14.652 15.5004 13.6132 15.5004H8.88739C7.8486 15.5004 7 14.6518 7 13.613C7 12.5742 7.8486 11.7256 8.88739 11.7256H13.6132Z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M21.1915 13.613C21.1915 12.5742 22.0401 11.7256 23.0789 11.7256C24.1177 11.7256 24.9663 12.5742 24.9663 13.613C24.9663 14.6518 24.1177 15.5004 23.0789 15.5004H21.1915V13.613Z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M20.2389 13.6132C20.2389 14.652 19.3903 15.5006 18.3515 15.5006C17.3127 15.5006 16.4641 14.652 16.4641 13.6132V8.88739C16.4641 7.84859 17.3127 7 18.3515 7C19.3903 7 20.2389 7.84859 20.2389 8.88739V13.6132Z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.3527 21.1914C19.3915 21.1914 20.2401 22.04 20.2401 23.0788C20.2401 24.1176 19.3915 24.9662 18.3527 24.9662C17.3139 24.9662 16.4653 24.1176 16.4653 23.0788V21.1914H18.3527Z",
                fill: "#ECB22E"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M18.3524 20.2396C17.3136 20.2396 16.465 19.391 16.465 18.3522C16.465 17.3134 17.3136 16.4648 18.3524 16.4648H23.0782C24.117 16.4648 24.9656 17.3134 24.9656 18.3522C24.9656 19.391 24.117 20.2396 23.0782 20.2396H18.3524Z",
                fill: "#ECB22E"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "15.5",
                stroke: "#DFE1E6"
            })
        ]
    });
}

});

parcelRegister("5AIMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05e45642503879c$export$2e2bcd8739ae039);
/* TeamMembersSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCE62 = parcelRequire("eCE62");

var $5sRpy = parcelRequire("5sRpy");
const $c05e45642503879c$var$styles = {
    wrapper: "_1reo15vq _18m915vq _1h6dmuej _1dqonqa1 _189ee4h9 _4t3ieo28 _1h0yze3t _iemi1b66 _2juhckbl _v798ckbl"
};
const $c05e45642503879c$var$TeamMembersSkeleton = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
        testId: "testId-team-member-picker-skeleton",
        xcss: $c05e45642503879c$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {
                isShimmering: true,
                width: "50%",
                testId: "select-all-skeleton"
            }),
            [
                ...Array(6)
            ].map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {
                    hasAvatar: true,
                    isShimmering: true,
                    testId: "team-member-skeleton"
                }, index))
        ]
    });
};
var $c05e45642503879c$export$2e2bcd8739ae039 = $c05e45642503879c$var$TeamMembersSkeleton;

});

parcelRegister("gkQTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab0d4e4b5d7e8f16$export$2e2bcd8739ae039);
/* TeamMember.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $ew55A = parcelRequire("ew55A");

var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $fn6W9 = parcelRequire("fn6W9");
const $ab0d4e4b5d7e8f16$var$styles = {
    description: "_18u01b66 _syaz1fxt",
    name: "_syaz1fxt",
    disabledName: "_syaz1lh4"
};
const $ab0d4e4b5d7e8f16$var$TeamMember = ({ isDisabled: isDisabled, member: member, showSubText: showSubText })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
        as: "span",
        alignBlock: "center",
        testId: "team-member",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                as: "span",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
                    src: member.avatarUrl,
                    size: "small",
                    borderColor: "transparent",
                    isDisabled: isDisabled
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                as: "span",
                xcss: $ab0d4e4b5d7e8f16$var$styles.description,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        className: (0, $bwpsq.default)([
                            $ab0d4e4b5d7e8f16$var$styles.name,
                            isDisabled && $ab0d4e4b5d7e8f16$var$styles.disabledName
                        ]),
                        children: member.name
                    }),
                    showSubText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        as: "span",
                        color: "color.text.subtlest",
                        testId: `team-member-byline-${member.id}`,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $fn6W9.messages).inviteeListLabelThirdPartyTeamMemberByline
                        })
                    })
                ]
            })
        ]
    });
var $ab0d4e4b5d7e8f16$export$2e2bcd8739ae039 = $ab0d4e4b5d7e8f16$var$TeamMember;

});

parcelRegister("cLDgJ", function(module, exports) {

$parcel$export(module.exports, "TeamMemberPickerAnalytics", () => $b7821bc7d1c71cee$export$e83b8a15f3703af3);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $b7821bc7d1c71cee$export$e83b8a15f3703af3 extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    teamMemberPickerViewed(attributes) {
        this.fireScreen({
            name: (0, $hatDq.AnalyticsActionSubject).TEAM_MEMBER_PICKER,
            attributes: attributes
        });
    }
    teamMemberPickerContinueClicked(attributes) {
        this.fireUI({
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: 'teamMemberContinue',
            attributes: {
                source: 'teamMemberPicker',
                ...attributes
            }
        });
    }
    viewSlackTeamMembersFailed(code, message, status) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).VIEW_SLACK_TEAM_MEMBERS,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                code: code,
                message: message,
                status: status
            }
        });
    }
}

});



parcelRegister("hofb1", function(module, exports) {

$parcel$export(module.exports, "ViralSettingsContext", () => $494f4004503d26dd$export$565fe958259f8ed8);
$parcel$export(module.exports, "useViralSettingsContext", () => $494f4004503d26dd$export$5ab4720aaf50c15c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jHCFV = parcelRequire("jHCFV");

var $4gxY5 = parcelRequire("4gxY5");

var $daXvt = parcelRequire("daXvt");

var $1CnPD = parcelRequire("1CnPD");
const $494f4004503d26dd$var$ViralSettingsStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $494f4004503d26dd$export$565fe958259f8ed8 = ({ children: children, disableViralSettings: disableViralSettings, onInviteeListFocus: onInviteeListFocusProp })=>{
    const [uniqueEmailDomains, setUniqueEmailDomains] = (0, $5uXOq.useState)([]);
    const [selectHasBeenFocused, setSelectHasBeenFocused] = (0, $5uXOq.useState)(false);
    const onInviteeListFocus = (0, $5uXOq.useCallback)(()=>{
        setSelectHasBeenFocused(true);
        onInviteeListFocusProp?.();
    }, [
        setSelectHasBeenFocused,
        onInviteeListFocusProp
    ]);
    const { emails: emails } = (0, $1CnPD.useInviteeListStateContext)();
    const { cloudId: cloudId, userRole: userRole } = (0, $daXvt.useInvitePeopleContext)();
    const { selectedProducts: selectedProducts } = (0, $4gxY5.useProducts)();
    const { viralSettingsByDomain: viralSettingsByDomain, eligibleDomains: eligibleDomains, viralSettingsDESEligibleStates: viralSettingsDESEligibleStates, showOpenInvite: showOpenInvite, handleViralSettingsByDomainCheckbox: handleViralSettingsByDomainCheckbox, enableOpenInvite: enableOpenInvite, setEnableOpenInvite: setEnableOpenInvite, isViralSettingsEnabled: isViralSettingsEnabled } = (0, $jHCFV.useViralSettings)({
        domains: uniqueEmailDomains,
        cloudId: cloudId || '',
        products: selectedProducts,
        role: userRole,
        selectHasBeenFocused: selectHasBeenFocused,
        emails: emails,
        disableViralSettings: disableViralSettings
    });
    const onOpenInviteChange = (0, $5uXOq.useCallback)((event)=>{
        setEnableOpenInvite(event?.target.checked);
    }, [
        setEnableOpenInvite
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            viralSettingsByDomain: viralSettingsByDomain,
            eligibleDomains: eligibleDomains,
            viralSettingsDESEligibleStates: viralSettingsDESEligibleStates,
            showOpenInvite: showOpenInvite,
            handleViralSettingsByDomainCheckbox: handleViralSettingsByDomainCheckbox,
            openInviteEnabled: enableOpenInvite,
            onOpenInviteChange: onOpenInviteChange,
            setEnableOpenInvite: setEnableOpenInvite,
            isViralSettingsEnabled: isViralSettingsEnabled,
            uniqueEmailDomains: uniqueEmailDomains,
            setUniqueEmailDomains: setUniqueEmailDomains,
            selectHasBeenFocused: selectHasBeenFocused,
            onInviteeListFocus: onInviteeListFocus
        };
    }, [
        viralSettingsByDomain,
        eligibleDomains,
        viralSettingsDESEligibleStates,
        showOpenInvite,
        handleViralSettingsByDomainCheckbox,
        enableOpenInvite,
        onOpenInviteChange,
        setEnableOpenInvite,
        isViralSettingsEnabled,
        uniqueEmailDomains,
        setUniqueEmailDomains,
        selectHasBeenFocused,
        onInviteeListFocus
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($494f4004503d26dd$var$ViralSettingsStateContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $494f4004503d26dd$export$5ab4720aaf50c15c = ()=>{
    const state = (0, $5uXOq.useContext)($494f4004503d26dd$var$ViralSettingsStateContext);
    if (state === undefined) throw new Error('useViralSettingsContext must be used within a ViralSettingsContext provider');
    return state;
};

});
parcelRegister("jHCFV", function(module, exports) {

$parcel$export(module.exports, "useViralSettings", () => $30724c7e775e7d48$export$72e5b7b8f170d556);

var $5uXOq = parcelRequire("5uXOq");

var $84G45 = parcelRequire("84G45");
var $6HEbe = parcelRequire("6HEbe");

var $kx8ta = parcelRequire("kx8ta");

var $i92ym = parcelRequire("i92ym");
var $7Nt5L = parcelRequire("7Nt5L");

var $ld9Ow = parcelRequire("ld9Ow");

var $3m2BQ = parcelRequire("3m2BQ");

var $9RrMz = parcelRequire("9RrMz");
const $30724c7e775e7d48$var$EMPTY_DOMAINS = {};
const $30724c7e775e7d48$export$72e5b7b8f170d556 = (props)=>{
    const { domains: domains, cloudId: cloudId, products: products, role: role, selectHasBeenFocused: selectHasBeenFocused, emails: emails, disableViralSettings: disableViralSettings } = props;
    const analytics = (0, $6HEbe.useAnalytics)((0, $9RrMz.ViralSettingsAnalytics));
    const [enableOpenInvite, setEnableOpenInvite] = (0, $5uXOq.useState)(false);
    const [showOpenInvite, setShowOpenInvite] = (0, $5uXOq.useState)(false);
    const [viralSettingsByDomain, setViralSettingsByDomain] = (0, $5uXOq.useState)({});
    const [viralSettingsDESEligibleStates, setViralSettingsDESEligibleStates] = (0, $5uXOq.useState)({
        checked: [],
        unchecked: []
    });
    const product = products && products[0];
    const isViralSettingsEnabled = (0, $5uXOq.useMemo)(()=>{
        return !disableViralSettings && (0, $84G45.qualifiesForViralSettings)(role) && products && products.length === 1 && (selectHasBeenFocused || emails.filter((v)=>v).length > 0);
    }, [
        products,
        selectHasBeenFocused,
        emails,
        role,
        disableViralSettings
    ]);
    const eligibleDomains = (0, $5uXOq.useMemo)(()=>{
        return Object.keys(viralSettingsByDomain).filter((domain)=>viralSettingsByDomain[domain].desPromotionEligible);
    }, [
        viralSettingsByDomain
    ]);
    //Clear cache on render.
    (0, $5uXOq.useEffect)(()=>{
        (0, $7Nt5L.defaultInviteApiClient).clearDESCache();
        (0, $7Nt5L.defaultOpenInviteClient).clearCache();
        (0, $3m2BQ.defaultViralSettingsHisiClient).clearCache();
    }, []);
    const getUserInvitesSetting = (0, $5uXOq.useCallback)(async (product, cloudId)=>{
        const ari = (0, $kx8ta.makeAri)(product, cloudId);
        try {
            const { response: response, cached: cached } = await (0, $7Nt5L.defaultOpenInviteClient).getOpenInviteState(product, cloudId);
            if (!cached) analytics.getUserInvitesSettingsSucceededSLO(ari);
            return response;
        } catch (err) {
            const { errorMessage: errorMessage, responseCode: responseCode } = (0, $kx8ta.resolveError)(err);
            analytics.getUserInvitesSettingsFailure({
                ari: ari,
                errorMessage: errorMessage,
                responseCode: responseCode
            });
            // in the case of the response being Forbidden, neither an SLO success or error should be fired
            if (!(0, $kx8ta.isForbidden)(responseCode)) {
                if ((0, $kx8ta.isAcceptableFailure)(errorMessage, responseCode)) analytics.getUserInvitesSettingsSucceededSLO(ari);
                else analytics.getUserInvitesSettingsFailureSLO({
                    ari: ari,
                    errorMessage: errorMessage,
                    responseCode: responseCode
                });
            }
        }
    }, [
        analytics
    ]);
    const getDirectAccessEligibility = (0, $5uXOq.useCallback)(async (request)=>{
        try {
            const response = await (0, $7Nt5L.defaultInviteApiClient).getDirectAccessSetting(request);
            const { response: fetchedResponse, cached: cached } = response;
            if (!cached) analytics.getDirectAccessSettingSucceededSLO(request);
            return {
                ...fetchedResponse,
                desPromotionEligible: 'desPromotionEligible' in fetchedResponse && fetchedResponse?.desPromotionEligible ? fetchedResponse.desPromotionEligible : false
            };
        } catch (err) {
            const { responseCode: responseCode, errorMessage: errorMessage } = (0, $kx8ta.resolveError)(err);
            const attributes = {
                domain: request.domain,
                responseCode: responseCode,
                errorMessage: errorMessage
            };
            analytics.getDirectAccessSettingFailure(request, attributes);
            const isSuccess = (0, $kx8ta.isAcceptableFailureForDirectAccess)(errorMessage, responseCode) || (0, $kx8ta.isAcceptableFailure)(errorMessage, responseCode);
            // in the case of the response being Forbidden, neither an SLO success or error should be fired
            if (!(0, $kx8ta.isForbidden)(responseCode)) {
                if (isSuccess) analytics.getDirectAccessSettingSucceededSLO(request);
                else analytics.getDirectAccessSettingFailureSLO(request, attributes);
            }
            return {
                domain: request.domain,
                errorMessage: errorMessage
            };
        }
    }, [
        analytics
    ]);
    // Fetches all domain settings in parallel and return the resolved responses
    const getDomainViralSettings = (0, $5uXOq.useCallback)((product, cloudId)=>(0, $kx8ta.waitForAllPromises)([
            ...domains.map((domain)=>{
                const request = {
                    domain: domain,
                    productAri: (0, $kx8ta.makeAri)(product, cloudId),
                    setting: 'DIRECT_ACCESS'
                };
                return getDirectAccessEligibility(request);
            })
        ]), [
        domains,
        getDirectAccessEligibility
    ]);
    // Gets the default value for the open invite checkbox. Uses HISI and fallbacks to true
    const userInviteDefaultValue = (0, $5uXOq.useCallback)(async (product, cloudId, shouldShowOpenInvite)=>{
        // if the invite checkbox isnt being shown it should default to false
        if (!shouldShowOpenInvite) return false;
        return (0, $3m2BQ.defaultViralSettingsHisiClient).getFlagWithAnalytics({
            flagKey: (0, $i92ym.createHISIOpenInviteFlagKey)(product, cloudId),
            product: product
        }, analytics).then((wasExposed)=>{
            // Default value is true if this is their first exposure, and false if we know they have been previously exposed.
            return !wasExposed;
        }, (_)=>{
            // Will default to checked in the case that HISI fails
            return true;
        });
    }, [
        analytics
    ]);
    // Get the default value for a domain using HISI, fallbacks to isChecked true if elligible for promotion
    const getDesDefaultValue = (0, $5uXOq.useCallback)(async (product, cloudId, domainResponse)=>{
        const domain = (0, $ld9Ow.getDomainFromResults)(domainResponse);
        // in the case that the domain is eligible for promotion
        if (domainResponse.status === 'fulfilled' && domain && domainResponse.value.desPromotionEligible) {
            const desPromotionEligible = domainResponse.value.desPromotionEligible;
            return (0, $3m2BQ.defaultViralSettingsHisiClient).getFlagWithAnalytics({
                flagKey: (0, $i92ym.createHISIDomainFlagKey)(product, cloudId, domain),
                product: product,
                domain: domain
            }, analytics).then((wasExposed)=>{
                // Default value is true if this is their first exposure, and false if we know they have been previously exposed.
                return (0, $ld9Ow.createViralSettingsByDomainValueObject)(domain, !wasExposed, desPromotionEligible);
            }, (_)=>{
                // If HISI unavailable assume this is their first exposure and return isCheck = true
                return (0, $ld9Ow.createViralSettingsByDomainValueObject)(domain, true, desPromotionEligible);
            });
        } else // is not eligible for promotion, do not show checkbox (desPromotion = false) and set is checked to false for safety
        return (0, $ld9Ow.createViralSettingsByDomainValueObject)(domain, false, false);
    }, [
        analytics
    ]);
    // Gets all the HISI settings (open invite and domain) in parallel and returns in an array
    const getHISIDomainSettings = (0, $5uXOq.useCallback)((domainResponses)=>(0, $kx8ta.waitForAllPromises)([
            ...domainResponses.map((domainResponse)=>{
                return getDesDefaultValue(product, cloudId, domainResponse);
            })
        ]), [
        cloudId,
        product,
        getDesDefaultValue
    ]);
    const handleShouldShowOpenInvite = (0, $5uXOq.useCallback)(async ()=>{
        const [openInviteState, error] = await (0, $ld9Ow.handlePromise)(getUserInvitesSetting(product, cloudId));
        const shouldShowOpenInvite = openInviteState && openInviteState.getOpenInvite && openInviteState.mode === 'REQUEST_ACCESS' && !error;
        setShowOpenInvite(shouldShowOpenInvite);
    }, [
        product,
        cloudId,
        getUserInvitesSetting
    ]);
    const handleDomains = (0, $5uXOq.useCallback)(async ()=>{
        const domainResults = await getDomainViralSettings(product, cloudId);
        const domainResultsWithDefaultValue = await getHISIDomainSettings(domainResults);
        const viralSettingsByDomainValueObjectFromResponse = (0, $ld9Ow.getViralSettingsByDomainValueObjectFromResponse)(domainResultsWithDefaultValue);
        setViralSettingsByDomain((previousViralSettingMap)=>{
            // Create a map using the completed domain object with defaultValues
            const viralSettingsMap = (0, $ld9Ow.createViralSettingsMapWithDefaultValues)(previousViralSettingMap, viralSettingsByDomainValueObjectFromResponse);
            setViralSettingsDESEligibleStates((0, $ld9Ow.getDESEligibleDomainsStates)(viralSettingsMap));
            return viralSettingsMap;
        });
    }, [
        cloudId,
        getHISIDomainSettings,
        getDomainViralSettings,
        product
    ]);
    const handleViralSettingsByDomainCheckbox = (newDomainState)=>{
        setViralSettingsByDomain(newDomainState);
        setViralSettingsDESEligibleStates((0, $ld9Ow.getDESEligibleDomainsStates)(newDomainState));
    };
    // useEffect to determine whether or not viral settings section should be displayed
    // triggers fetch calls to HISI if it should be displayed
    (0, $5uXOq.useEffect)(()=>{
        // reset value to false on change
        if (!isViralSettingsEnabled) {
            setEnableOpenInvite(false);
            setViralSettingsByDomain($30724c7e775e7d48$var$EMPTY_DOMAINS);
        }
        if (isViralSettingsEnabled) {
            handleShouldShowOpenInvite();
            handleDomains();
        }
    }, [
        isViralSettingsEnabled,
        handleShouldShowOpenInvite,
        handleDomains
    ]);
    // Determine initial state of open invite checkbox when showOpenInvite is updated.
    (0, $5uXOq.useEffect)(()=>{
        const handleDefaultOpenInvite = async ()=>{
            // Does not need error handled as userInviteDefaultValue catches the error
            const openInviteDefaultValue = await userInviteDefaultValue(product, cloudId, showOpenInvite);
            // will be default to undefined if shouldShowOpenInvite is false
            setEnableOpenInvite(openInviteDefaultValue);
        };
        handleDefaultOpenInvite();
    }, [
        showOpenInvite,
        product,
        cloudId,
        userInviteDefaultValue
    ]);
    const responseObject = {
        viralSettingsByDomain: viralSettingsByDomain,
        eligibleDomains: eligibleDomains,
        viralSettingsDESEligibleStates: viralSettingsDESEligibleStates,
        handleViralSettingsByDomainCheckbox: handleViralSettingsByDomainCheckbox,
        setEnableOpenInvite: setEnableOpenInvite,
        isViralSettingsEnabled: isViralSettingsEnabled,
        showOpenInvite: showOpenInvite,
        enableOpenInvite: enableOpenInvite
    };
    return responseObject;
};

});
parcelRegister("ld9Ow", function(module, exports) {

$parcel$export(module.exports, "createViralSettingsMapWithDefaultValues", () => $9600628e4a9f29a2$export$1260260645448a22);
$parcel$export(module.exports, "getDESEligibleDomainsStates", () => $9600628e4a9f29a2$export$f84202e4f11078fa);
$parcel$export(module.exports, "getViralSettingsByDomainValueObjectFromResponse", () => $9600628e4a9f29a2$export$24931e58402304dd);
$parcel$export(module.exports, "getDomainFromResults", () => $9600628e4a9f29a2$export$bea1fc390abe3bc5);
$parcel$export(module.exports, "handlePromise", () => $9600628e4a9f29a2$export$8080b7556d9d6445);
$parcel$export(module.exports, "createViralSettingsByDomainValueObject", () => $9600628e4a9f29a2$export$f433b2fa9a26fb63);
const $9600628e4a9f29a2$export$1260260645448a22 = (previousViralSettingMap, domainResults)=>{
    const viralSettingsMap = {};
    domainResults.forEach((result)=>{
        const domain = result.key;
        viralSettingsMap[domain] = {
            ...result.value,
            isChecked: previousViralSettingMap[domain] ? previousViralSettingMap[domain].isChecked : result.value.isChecked
        };
    });
    return viralSettingsMap;
};
const $9600628e4a9f29a2$export$f84202e4f11078fa = (viralSettingsMap)=>{
    const unchecked = [];
    const checked = [];
    const viralSettingsDomains = Object.keys(viralSettingsMap);
    viralSettingsDomains.filter((domain)=>viralSettingsMap[domain].desPromotionEligible).forEach((domain)=>{
        const viralSetting = viralSettingsMap[domain];
        if (viralSetting.isChecked) checked.push(domain);
        else unchecked.push(domain);
    });
    return {
        checked: checked,
        unchecked: unchecked
    };
};
const $9600628e4a9f29a2$export$24931e58402304dd = (domainResults)=>{
    return domainResults.filter((result)=>result.status === 'fulfilled').map((item)=>item.value);
};
const $9600628e4a9f29a2$export$bea1fc390abe3bc5 = (result)=>{
    const successDomain = result.status === 'fulfilled' && result.value ? result.value.domain : '';
    const errorDomain = result.status === 'failed' && result.errorDetails ? result.errorDetails.domain : '';
    // '' is falsy.
    return successDomain || errorDomain;
};
const $9600628e4a9f29a2$export$8080b7556d9d6445 = (promise)=>{
    return promise.then((result)=>Promise.resolve([
            result,
            undefined
        ])).catch((error)=>Promise.resolve([
            undefined,
            error
        ]));
};
const $9600628e4a9f29a2$export$f433b2fa9a26fb63 = (domain, isChecked, desPromotionEligible)=>{
    return {
        key: domain,
        value: {
            isChecked: isChecked,
            desPromotionEligible: desPromotionEligible
        }
    };
};

});

parcelRegister("3m2BQ", function(module, exports) {

$parcel$export(module.exports, "defaultViralSettingsHisiClient", () => $aeb8eb9111ed43ce$export$57cae7afb40bd58f);

var $i92ym = parcelRequire("i92ym");
class $aeb8eb9111ed43ce$export$98add1c97bc6ec46 extends (0, $i92ym.HaveISeenItClient) {
    constructor(){
        super();
    }
    // A wrapper for getFlag that includes Viral Settings analytics
    async getFlagWithAnalytics(props, analytics) {
        const { flagKey: flagKey, product: product, domain: domain } = props;
        try {
            const { response: response, cached: cached } = await this.getFlag(flagKey);
            if (!cached) analytics.fetchHISIFlagSucceeded({
                flagKey: flagKey,
                product: product,
                domain: domain,
                value: response.status
            });
            return response.status;
        } catch (error) {
            analytics.fetchHISIFlagFailed({
                flagKey: flagKey,
                product: product,
                domain: domain
            });
            return Promise.reject(error);
        }
    }
    // A wrapper for postFlag that includes Viral Settings analytics
    async postFlagWithAnalytics(props, analytics) {
        const { flagKey: flagKey, product: product, domain: domain } = props;
        try {
            await this.postFlag(flagKey);
            analytics.createHISIFlagSucceeded({
                flagKey: flagKey,
                product: product,
                domain: domain
            });
        } catch  {
            analytics.createHisiFlagFailed({
                flagKey: flagKey,
                product: product,
                domain: domain
            });
        }
    }
}
const $aeb8eb9111ed43ce$export$57cae7afb40bd58f = new $aeb8eb9111ed43ce$export$98add1c97bc6ec46();

});

parcelRegister("9RrMz", function(module, exports) {

$parcel$export(module.exports, "ViralSettingsAnalytics", () => $6f23a91cb3f218ec$export$79c486b6beac7a88);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");

var $i7Upr = parcelRequire("i7Upr");
const $6f23a91cb3f218ec$export$fda1575ee29e8f5 = {
    DIRECT_ACCESS_CHECKBOX: 'directAccessCheckbox',
    USER_INVITES_CHECKBOX: 'userInvitesCheckbox'
};
class $6f23a91cb3f218ec$export$79c486b6beac7a88 extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    userInvitesCheckboxRendered(attributes) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).CHECKBOX,
            actionSubjectId: $6f23a91cb3f218ec$export$fda1575ee29e8f5.USER_INVITES_CHECKBOX,
            action: (0, $hatDq.AnalyticsAction).RENDERED,
            attributes: {
                ...attributes,
                flow: (0, $i7Upr.FLOW_CORE_INVITES)
            }
        });
    }
    userInvitesCheckboxClicked(attributes) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).CHECKBOX,
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            // To match naming of checkbox clicked event from admin hub
            actionSubjectId: $6f23a91cb3f218ec$export$fda1575ee29e8f5.USER_INVITES_CHECKBOX,
            attributes: {
                ...attributes,
                flow: (0, $i7Upr.FLOW_CORE_INVITES)
            }
        });
    }
    directAccessCheckboxRendered(attributes) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).CHECKBOX,
            actionSubjectId: $6f23a91cb3f218ec$export$fda1575ee29e8f5.DIRECT_ACCESS_CHECKBOX,
            action: (0, $hatDq.AnalyticsAction).RENDERED,
            attributes: {
                ...attributes,
                flow: (0, $i7Upr.FLOW_CORE_INVITES)
            }
        });
    }
    directAccessCheckboxClicked(attributes) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).CHECKBOX,
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            actionSubjectId: $6f23a91cb3f218ec$export$fda1575ee29e8f5.DIRECT_ACCESS_CHECKBOX,
            attributes: {
                ...attributes,
                flow: (0, $i7Upr.FLOW_CORE_INVITES)
            }
        });
    }
    createHisiFlagFailed(attributes) {
        const { cloudId: cloudId } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).USER_INVITE_SETTINGS_HISI,
            action: (0, $hatDq.AnalyticsAction).CREATE_FAILED,
            attributes: {
                ...attributes,
                cloudId: cloudId
            }
        });
    }
    createHISIFlagSucceeded(attributes) {
        const { cloudId: cloudId } = this.commonAttributes;
        this.fireTrack({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).USER_INVITE_SETTINGS_HISI,
            action: (0, $hatDq.AnalyticsAction).CREATED,
            attributes: {
                ...attributes,
                cloudId: cloudId
            }
        });
    }
    fetchHISIFlagFailed(attributes) {
        const { cloudId: cloudId } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).USER_INVITE_SETTINGS_HISI,
            action: (0, $hatDq.AnalyticsAction).FETCH_FAILED,
            attributes: {
                ...attributes,
                cloudId: cloudId
            }
        });
    }
    fetchHISIFlagSucceeded(attributes) {
        const { cloudId: cloudId } = this.commonAttributes;
        this.fireTrack({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).USER_INVITE_SETTINGS_HISI,
            action: (0, $hatDq.AnalyticsAction).FETCHED,
            attributes: {
                ...attributes,
                cloudId: cloudId
            }
        });
    }
    getUserInvitesSettingsSucceededSLO(ari) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).GET_USER_INVITES_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).SUCCEEDED,
            attributes: {
                ari: ari
            }
        });
    }
    getUserInvitesSettingsFailureSLO(attributes) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).SLO_GET_USER_INVITES_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: attributes
        });
    }
    getDirectAccessSettingSucceededSLO(request) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).GET_DIRECT_ACCESS_SETTING,
            action: (0, $hatDq.AnalyticsAction).SUCCEEDED,
            attributes: {
                ...request
            }
        });
    }
    getDirectAccessSettingFailureSLO(request, attributes) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).SLO_GET_DIRECT_ACCESS_SETTING,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                ...request,
                ...attributes
            }
        });
    }
    getUserInvitesSettingsFailure(attributes) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).GET_USER_INVITES_SETTINGS,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: attributes
        });
    }
    getDirectAccessSettingFailure(request, attributes) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).GET_DIRECT_ACCESS_SETTING,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                ...request,
                ...attributes
            }
        });
    }
}

});
parcelRegister("i7Upr", function(module, exports) {

$parcel$export(module.exports, "FLOW_CORE_INVITES", () => $029602c9d76fffe3$export$3eb662c848c7349f);
$parcel$export(module.exports, "InvitePeopleContext", () => $029602c9d76fffe3$export$1c4ce4f476bc0521);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kx8ta = parcelRequire("kx8ta");

var $7Nt5L = parcelRequire("7Nt5L");

var $lWbFO = parcelRequire("lWbFO");


var $6HEbe = parcelRequire("6HEbe");
var $gOE0R = parcelRequire("gOE0R");

var $5Iax1 = parcelRequire("5Iax1");

var $daXvt = parcelRequire("daXvt");

var $444qv = parcelRequire("444qv");
const $029602c9d76fffe3$var$DEFAULT_SOURCE = 'unknown';
const $029602c9d76fffe3$var$DEFAULT_VIEW_AS = 'unknown';
const $029602c9d76fffe3$export$3eb662c848c7349f = 'core-invites';
const $029602c9d76fffe3$export$1c4ce4f476bc0521 = ({ children: children, inviteeProvider: inviteeProvider, plugins: plugins, resourceAri: resourceAri, source: source = $029602c9d76fffe3$var$DEFAULT_SOURCE, subProduct: subProduct, userEmail: userEmailProp, accountId: accountIdProp, userRole: userRoleProp, viewAs: viewAs = $029602c9d76fffe3$var$DEFAULT_VIEW_AS, orgId: orgId, disableNoInviteError: disableNoInviteError = false, experimental_inviteLink: experimental_inviteLink, experimental_turnOnInviteLinkModalDismissed: experimental_turnOnInviteLinkModalDismissed })=>{
    const [userEmail, setUserEmail] = (0, $5uXOq.useState)(userEmailProp);
    const [accountId, setAccountId] = (0, $5uXOq.useState)(accountIdProp);
    const needToFetchUserEmail = !userEmailProp || !accountIdProp;
    const [isUserEmailLoading, setIsUserEmailLoading] = (0, $5uXOq.useState)(needToFetchUserEmail);
    const [userRole, setUserRole] = (0, $5uXOq.useState)(userRoleProp || 'basic'); // TODO shouldn't this default to undefined while we load it?
    const needToFetchUserRole = !userRoleProp;
    const [isUserRoleLoading, setIsUserRoleLoading] = (0, $5uXOq.useState)(needToFetchUserRole);
    const isLoading = isUserEmailLoading || isUserRoleLoading;
    const { inviteFromAssignModal: inviteFromAssignModalCohort, isEligibleForInviteAndAssignFromBoard: isEligibleForInviteAndAssignFromBoard, invitePromptOnLinkV3: invitePromptOnLinkV3Cohort, isConfluenceInviteLinkFeatureEnabled: isConfluenceInviteLinkFeatureEnabled } = (0, $444qv.useExperimentalFeatures)();
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const productId = (0, $kx8ta.getProductIdFromResource)(resourceAri) || '';
        const [, loggedInEmailDomain] = userEmail?.split('@') ?? [];
        return {
            flow: $029602c9d76fffe3$export$3eb662c848c7349f,
            growthInitiative: (0, $d65afe1996371623$export$da46cb6a7468a9c2),
            cloudId: (0, $kx8ta.getCloudIdFromResource)(resourceAri),
            inviteeProvider: inviteeProvider,
            plugins: plugins,
            productId: productId,
            productTitle: (0, $kx8ta.getProductTitleFromAri)(resourceAri),
            jiraSubProduct: productId === 'jira' && subProduct && subProduct !== 'unknown' ? (0, $kx8ta.normalizeJiraSubProduct)(subProduct) : subProduct,
            source: source,
            subProduct: subProduct,
            userRole: userRole,
            viewAs: viewAs,
            inviteFromAssignModalCohort: inviteFromAssignModalCohort,
            invitePromptOnLinkV3Cohort: invitePromptOnLinkV3Cohort,
            isEligibleForInviteAndAssignFromBoard: isEligibleForInviteAndAssignFromBoard,
            orgId: orgId,
            isLoading: isLoading,
            loggedInEmailDomain: loggedInEmailDomain,
            userEmail: userEmail,
            accountId: accountId,
            disableNoInviteError: disableNoInviteError,
            experimental_inviteLink: experimental_inviteLink,
            isConfluenceInviteLinkFeatureEnabled: isConfluenceInviteLinkFeatureEnabled,
            experimental_turnOnInviteLinkModalDismissed: experimental_turnOnInviteLinkModalDismissed
        };
    }, [
        disableNoInviteError,
        isEligibleForInviteAndAssignFromBoard,
        inviteFromAssignModalCohort,
        invitePromptOnLinkV3Cohort,
        inviteeProvider,
        isLoading,
        orgId,
        plugins,
        resourceAri,
        source,
        subProduct,
        userEmail,
        accountId,
        userRole,
        viewAs,
        experimental_inviteLink,
        isConfluenceInviteLinkFeatureEnabled,
        experimental_turnOnInviteLinkModalDismissed
    ]);
    const analytics = (0, $6HEbe.useAnalyticsWithAttributes)((0, $5Iax1.InvitePeopleAnalytics), (0, $gOE0R.useCommonAttributesFrom)(contextValue));
    (0, $5uXOq.useEffect)(()=>{
        const fetchUserEmail = async ()=>{
            try {
                (0, $lWbFO.invitePeopleRendered).mark((0, $lWbFO.invitePeopleRenderedTimings).getAccountInfo.startMark);
                const accountInfo = await (0, $7Nt5L.defaultAccountInfoClient).getAccountInfo();
                (0, $lWbFO.invitePeopleRendered).mark((0, $lWbFO.invitePeopleRenderedTimings).getAccountInfo.endMark);
                setUserEmail(accountInfo.email);
                setAccountId(accountInfo.account_id);
            } catch (err) {
                analytics.accountInfoFailed(String(err));
            } finally{
                setIsUserEmailLoading(false);
            }
        };
        if (needToFetchUserEmail) fetchUserEmail();
    }, [
        analytics,
        needToFetchUserEmail
    ]);
    const cloudId = contextValue.cloudId;
    (0, $5uXOq.useEffect)(()=>{
        async function fetchUserRole() {
            try {
                setIsUserRoleLoading(true);
                (0, $lWbFO.invitePeopleRendered).mark((0, $lWbFO.invitePeopleRenderedTimings).getUserPermission.startMark);
                const perms = await (0, $7Nt5L.defaultPermsApiClient).getUserRole(cloudId);
                (0, $lWbFO.invitePeopleRendered).mark((0, $lWbFO.invitePeopleRenderedTimings).getUserPermission.endMark);
                if (perms.errorMessage) analytics.getPermsFailed(`ari:cloud:platform::site/${cloudId}`, perms.errorMessage);
                else analytics.getPermsSucceeded(`ari:cloud:platform::site/${cloudId}`, perms.isInviteUsersPermitted, perms.isManagePermitted);
                setUserRole(perms.role);
            } finally{
                setIsUserRoleLoading(false);
            }
        }
        if (needToFetchUserRole) fetchUserRole();
    }, [
        cloudId,
        resourceAri,
        analytics,
        userRoleProp,
        needToFetchUserRole
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daXvt.InvitePeopleStateContext).Provider, {
        value: contextValue,
        children: children
    });
};

});




parcelRegister("CZywg", function(module, exports) {

$parcel$export(module.exports, "useStickyExperimentStyles", () => $c532850c6d63fed2$export$7bf51680f2197a2f);
$parcel$export(module.exports, "useIsStickyExperimentEnabled", () => $c532850c6d63fed2$export$36ca36c9a1851eaa);

var $5uXOq = parcelRequire("5uXOq");

var $grXIr = parcelRequire("grXIr");
var $104WL = parcelRequire("104WL");


var $84Nhj = parcelRequire("84Nhj");

var $hatDq = parcelRequire("hatDq");
const $c532850c6d63fed2$var$getIds = (userPickerOptions)=>{
    return userPickerOptions.map((opt)=>{
        return opt.id;
    });
};
const $c532850c6d63fed2$var$getIsMultiValue = (state, userPickerOptions)=>{
    const ids = new Set($c532850c6d63fed2$var$getIds(userPickerOptions));
    return state?.options?.filter((val)=>!ids.has(val?.data?.id))?.length > 1;
};
const $c532850c6d63fed2$var$getIsEmailVisible = (state, userPickerOptions)=>{
    const email = state?.options?.filter((option)=>(0, $grXIr.isEmail)(option.data))?.at(0);
    if (!email) return false;
    const ids = new Set($c532850c6d63fed2$var$getIds(userPickerOptions));
    return !ids.has(email.data?.id);
};
const $c532850c6d63fed2$export$7bf51680f2197a2f = (userPickerOptions)=>{
    const isExperimentEnabled = $c532850c6d63fed2$var$getIsExperimentEnabled();
    return (0, $5uXOq.useMemo)(()=>{
        if (!isExperimentEnabled) return {};
        return {
            option: (css, state)=>{
                const optionData = state?.data?.data;
                const isSticky = optionData && (0, $grXIr.isEmail)(optionData);
                const isDisabled = (0, $104WL.isValidEmail)(optionData?.id) === 'INVALID';
                const isMultiValue = $c532850c6d63fed2$var$getIsMultiValue(state, userPickerOptions);
                const colorAndShadowOptions = {
                    boxShadow: css['boxShadow'],
                    backgroundColor: css['backgroundColor']
                };
                const multiValueStyle = {
                    backgroundColor: `var(--ds-surface-overlay, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
                    borderTop: `${"var(--ds-space-025, 2px)"} solid ${`var(--ds-border, ${(0, $a7f8c6b391092279$export$7090862dc3038a9f)})`}`,
                    padding: `${"var(--ds-space-100, 8px)"} 0`,
                    marginTop: "var(--ds-space-100, 8px)",
                    borderRadius: `0 0 ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`,
                    boxShadow: 'None',
                    '> span:first-child': {
                        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
                        opacity: isDisabled && "var(--ds-opacity-disabled, 0.4)",
                        ...colorAndShadowOptions
                    }
                };
                const disabledStyle = {
                    '> *:first-child': {
                        opacity: "var(--ds-opacity-disabled, 0.4)"
                    }
                };
                const stickyOptions = {
                    position: 'sticky',
                    bottom: 0,
                    ...isDisabled && disabledStyle,
                    ...isMultiValue && multiValueStyle
                };
                return {
                    ...css,
                    overflow: 'hidden',
                    ...isSticky && stickyOptions
                };
            },
            menuList: (css, state)=>{
                const isEmailVisible = $c532850c6d63fed2$var$getIsEmailVisible(state, userPickerOptions);
                const multiValueStyle = {
                    paddingBottom: 0
                };
                const isMultiValue = $c532850c6d63fed2$var$getIsMultiValue(state, userPickerOptions);
                return {
                    ...css,
                    zIndex: '400',
                    ...isMultiValue && isEmailVisible && multiValueStyle
                };
            }
        };
    }, [
        userPickerOptions,
        isExperimentEnabled
    ]);
};
const $c532850c6d63fed2$var$getIsExperimentEnabled = ()=>(0, $84Nhj.getExperimentValue)((0, $hatDq.ExperimentKeys).STICKY_EMAIL_INVITE, 'control') === 'experiment';
const $c532850c6d63fed2$export$36ca36c9a1851eaa = (override)=>$c532850c6d63fed2$var$getIsExperimentEnabled() && override;

});

parcelRegister("bcZLD", function(module, exports) {

$parcel$export(module.exports, "useDebounce", () => $df806655a682a783$export$21805fee57372823);

var $5uXOq = parcelRequire("5uXOq");
const $df806655a682a783$export$21805fee57372823 = (delay)=>{
    const timeout = (0, $5uXOq.useRef)();
    const debounce = (0, $5uXOq.useMemo)(()=>{
        const debounce = (callback)=>{
            clearTimeout(timeout.current);
            timeout.current = window.setTimeout(callback, delay);
        };
        return debounce;
    }, [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>()=>clearTimeout(timeout.current), []);
    return debounce;
};

});

parcelRegister("1SD2y", function(module, exports) {

$parcel$export(module.exports, "validateEmail", () => $043ff1902de9f761$export$18148d12c805c5b0);
$parcel$export(module.exports, "hasError", () => $043ff1902de9f761$export$5e63894f961a3223);
$parcel$export(module.exports, "determineValidationState", () => $043ff1902de9f761$export$4a1e16a3f293dded);

var $fn6W9 = parcelRequire("fn6W9");
const $043ff1902de9f761$export$fd7e7522f281d3fd = {
    validationState: 'error',
    reason: 'overflow',
    errorMessage: (0, $fn6W9.messages).tooManyEmailAddresses
};
const $043ff1902de9f761$export$50c8bce072597428 = {
    validationState: 'error',
    reason: 'overflow',
    errorMessage: (0, $fn6W9.messages).tooManyEmailAddressesInProject
};
const $043ff1902de9f761$export$89d3193818991094 = {
    validationState: 'error',
    reason: 'invalid-email',
    errorMessage: (0, $fn6W9.messages).invalidMultipleEmailMessage
};
const $043ff1902de9f761$export$46acf7cabfde1718 = [
    {
        validationState: 'default'
    }
];
const $043ff1902de9f761$export$2c8433e5dc4daaba = {
    validationState: 'error',
    reason: 'inviting-self',
    errorMessage: (0, $fn6W9.messages).inviteSelfMessage
};
// Email Validations
// Extends default validation found in /packages/elements/user-picker/src/components/emailValidation.ts
// by checking that the domain does not end in a symbol
const $043ff1902de9f761$var$validRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
const $043ff1902de9f761$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $043ff1902de9f761$export$18148d12c805c5b0 = (inputText)=>{
    // Email will display as an option in the user picker and willbe selectable
    if (inputText.match($043ff1902de9f761$var$validRegex)) return 'VALID';
    // Potential emails will not be domain auto completed by the user picker (validation check is still completed on these emails)
    if (inputText.match($043ff1902de9f761$var$potentialRegex)) return 'POTENTIAL';
    // Invalid emails will have the domain auto complete option from the user picker
    return 'INVALID';
};
const $043ff1902de9f761$export$5e63894f961a3223 = (validationList, reason)=>validationList.reduce((error, validationItem)=>error || !!reason && validationItem.reason === reason && validationItem.validationState === 'error' || validationItem.validationState === 'error', false);
const $043ff1902de9f761$export$4a1e16a3f293dded = (emails, ids, maxEmails, userEmail, coreInvitesInJiraProjectEnabled)=>{
    const isOverflowing = emails.concat(ids).length > maxEmails;
    const hasInvalidEmail = emails.some((v)=>$043ff1902de9f761$export$18148d12c805c5b0(v) === 'INVALID');
    const isInvitingSelf = userEmail && emails.includes(userEmail);
    const validationList = [];
    if (isOverflowing) validationList.push(coreInvitesInJiraProjectEnabled ? $043ff1902de9f761$export$50c8bce072597428 : $043ff1902de9f761$export$fd7e7522f281d3fd);
    if (hasInvalidEmail) validationList.push($043ff1902de9f761$export$89d3193818991094);
    if (!coreInvitesInJiraProjectEnabled && isInvitingSelf) validationList.push($043ff1902de9f761$export$2c8433e5dc4daaba);
    if (validationList.length > 0) return validationList;
    return $043ff1902de9f761$export$46acf7cabfde1718;
};

});

parcelRegister("eA2RF", function(module, exports) {

let $a9d6a659bddccb95$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a9d6a659bddccb95$var$load("h2MrD"),
    $a9d6a659bddccb95$var$load("bYT2S"),
    $a9d6a659bddccb95$var$load("fMGlS")
]).then(()=>parcelRequire('6YlNK'));

});


parcelRegister("hLdbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe1123c25fc27e4c$export$2e2bcd8739ae039);
/* ThirdPartyConnect.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $7rJgC = parcelRequire("7rJgC");
var $k9nuy = parcelRequire("k9nuy");

var $fJpmn = parcelRequire("fJpmn");

var $6HEbe = parcelRequire("6HEbe");

var $fn6W9 = parcelRequire("fn6W9");

var $8TQ2j = parcelRequire("8TQ2j");

var $fLNVv = parcelRequire("fLNVv");

var $STeDz = parcelRequire("STeDz");

var $g7ZGR = parcelRequire("g7ZGR");

var $dCNWF = parcelRequire("dCNWF");

var $eddUJ = parcelRequire("eddUJ");

var $iTzFN = parcelRequire("iTzFN");

var $86tbn = parcelRequire("86tbn");

var $c7bcW = parcelRequire("c7bcW");

var $9aJ9a = parcelRequire("9aJ9a");

var $cQ8dn = parcelRequire("cQ8dn");
const $fe1123c25fc27e4c$var$ICON_SIZE = {
    height: 16,
    width: 16
};
const $fe1123c25fc27e4c$var$styles = {
    wrapper: "_11c81oud _syaz1wmz",
    header: "_11c816g6 _18zrze3t _k48p1pd9 _otyr1b66",
    buttonGroup: "_195g1i6y",
    buttonIcon: "_1mouu2gc _2hwxu2gc",
    connectButton: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2rko1sit _1mou1b66 _195gv77o _1h6dmuej _1dqonqa1 _189ee4h9 _1e0c1txw _4t3i1ylp _4cvr1h6o _1bah1h6o _bfhk1j9a _1lhce4h9 _4cvxmuej _irr31d5g _1wjne4h9 _q4ztmuej _1di6ip91"
};
const $fe1123c25fc27e4c$var$ThirdPartyConnect = ()=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $iTzFN.ThirdPartyAnalytics));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { enabledIntegrations: enabledIntegrations, onConnectProvider: onConnectProvider, updateIntegrations: updateIntegrations } = (0, $dCNWF.useThirdPartyState)();
    const { isEnabled: isInfiSpotlightEnabled } = (0, $cQ8dn.useInfiSpotlight)();
    const { setOnSlackConnected: setOnSlackConnected } = (0, $86tbn.useInviteThirdPartyTeams)();
    const handleClick = (0, $5uXOq.useCallback)((serviceKey)=>()=>{
            if (onConnectProvider) {
                analytics.connectButtonClicked(serviceKey);
                onConnectProvider({
                    serviceKey: serviceKey
                });
                if (serviceKey === (0, $8TQ2j.PLATFORM_SLACK_SERVICE)) setOnSlackConnected(true);
            }
        }, [
        analytics,
        onConnectProvider,
        setOnSlackConnected
    ]);
    const [spotlightHidden, setSpotlightHidden] = (0, $5uXOq.useState)(!!(0, $c7bcW.getIsInfiSpotlightSeen)());
    (0, $5uXOq.useEffect)(()=>{
        if (isInfiSpotlightEnabled && spotlightHidden) (0, $c7bcW.setIsInfiSpotlightSeen)(true);
    }, [
        isInfiSpotlightEnabled,
        spotlightHidden
    ]);
    const dismissSpotlight = (0, $5uXOq.useCallback)(()=>{
        if (isInfiSpotlightEnabled) setSpotlightHidden(true);
    }, [
        isInfiSpotlightEnabled
    ]);
    const wrapWithNudgeToInvite = (slackButton)=>slackButton;
    const buttonGroup = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
        shouldWrap: true,
        spread: "space-between",
        xcss: $fe1123c25fc27e4c$var$styles.buttonGroup,
        children: [
            enabledIntegrations.has((0, $8TQ2j.GOOGLE_SERVICE)) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                onClick: handleClick((0, $8TQ2j.GOOGLE_SERVICE)),
                testId: "testId-invite-people-connect-google",
                xcss: $fe1123c25fc27e4c$var$styles.connectButton,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                    as: "span",
                    alignBlock: "center",
                    alignInline: "center",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNVv.GoogleIcon), {
                            ...$fe1123c25fc27e4c$var$ICON_SIZE,
                            className: (0, $bwpsq.default)([
                                $fe1123c25fc27e4c$var$styles.buttonIcon
                            ])
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            color: "color.text",
                            size: "medium",
                            weight: "medium",
                            children: formatMessage((0, $fn6W9.messages).googleThirdPartyButton)
                        })
                    ]
                })
            }),
            enabledIntegrations.has((0, $8TQ2j.PLATFORM_SLACK_SERVICE)) && wrapWithNudgeToInvite(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                onClick: handleClick((0, $8TQ2j.PLATFORM_SLACK_SERVICE)),
                testId: `testId-invite-people-connect-slack`,
                xcss: $fe1123c25fc27e4c$var$styles.connectButton,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                    as: "span",
                    alignBlock: "center",
                    alignInline: "center",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g7ZGR.SlackIcon), {
                            ...$fe1123c25fc27e4c$var$ICON_SIZE,
                            className: (0, $bwpsq.default)([
                                $fe1123c25fc27e4c$var$styles.buttonIcon
                            ])
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            color: "color.text",
                            size: "medium",
                            weight: "medium",
                            children: formatMessage((0, $fn6W9.messages).slackThirdPartyButton)
                        })
                    ]
                })
            })),
            enabledIntegrations.has((0, $8TQ2j.MICROSOFT_SERVICE)) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                onClick: handleClick((0, $8TQ2j.MICROSOFT_SERVICE)),
                testId: "testId-invite-people-connect-microsoft",
                xcss: $fe1123c25fc27e4c$var$styles.connectButton,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                    as: "span",
                    alignBlock: "center",
                    alignInline: "center",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $STeDz.MicrosoftIcon), {
                            ...$fe1123c25fc27e4c$var$ICON_SIZE,
                            className: (0, $bwpsq.default)([
                                $fe1123c25fc27e4c$var$styles.buttonIcon
                            ])
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            color: "color.text",
                            size: "medium",
                            weight: "medium",
                            children: formatMessage((0, $fn6W9.messages).microsoftThirdPartyButton)
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("fieldset", {
        className: (0, $bwpsq.default)([
            $fe1123c25fc27e4c$var$styles.wrapper
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                as: "legend",
                xcss: $fe1123c25fc27e4c$var$styles.header,
                children: formatMessage((0, $fn6W9.messages).thirdPartyConnect)
            }),
            isInfiSpotlightEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9aJ9a.default), {
                spotlightHidden: spotlightHidden,
                dismissSpotlight: dismissSpotlight,
                children: buttonGroup
            }) : buttonGroup,
            !!updateIntegrations.noScope.size && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eddUJ.default), {
                scope: (0, $fJpmn.ScopeState).NO_SCOPE
            })
        ]
    });
};
var $fe1123c25fc27e4c$export$2e2bcd8739ae039 = $fe1123c25fc27e4c$var$ThirdPartyConnect;

});
parcelRegister("c7bcW", function(module, exports) {

$parcel$export(module.exports, "getIsInfiSpotlightSeen", () => $6a539bcbef4bea10$export$e5692b7aaa5c63e4);
$parcel$export(module.exports, "setIsInfiSpotlightSeen", () => $6a539bcbef4bea10$export$4e9307cba9aec850);

var $kx8ta = parcelRequire("kx8ta");
const $6a539bcbef4bea10$export$8671d8ac2bda7bc8 = 'is-infi-spotlight-seen';
const $6a539bcbef4bea10$export$e5692b7aaa5c63e4 = ()=>(0, $kx8ta.getBooleanLocalStorageKey)($6a539bcbef4bea10$export$8671d8ac2bda7bc8);
const $6a539bcbef4bea10$export$4e9307cba9aec850 = (isInfiSpotlightSeen)=>(0, $kx8ta.updateLocalStorageKey)($6a539bcbef4bea10$export$8671d8ac2bda7bc8, isInfiSpotlightSeen.toString());

});

parcelRegister("9aJ9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36009b4c5e0fe51$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $bkS4F = parcelRequire("bkS4F");
var $inni2 = parcelRequire("inni2");
var $Pxnvj = parcelRequire("Pxnvj");
var $98UVV = parcelRequire("98UVV");

var $fn6W9 = parcelRequire("fn6W9");

var $b4a3S = parcelRequire("b4a3S");

var $6HEbe = parcelRequire("6HEbe");

var $d8UBh = parcelRequire("d8UBh");
const $c36009b4c5e0fe51$var$SpotlightWithScreenEvent = ({ dismissSpotlight: dismissSpotlight })=>{
    const intl = (0, $koVbs.default)();
    const analytics = (0, $6HEbe.useAnalytics)((0, $d8UBh.InfiSpotlightAnalytics));
    (0, $5uXOq.useEffect)(()=>{
        analytics.spotlightViewed();
    }, [
        analytics
    ]);
    const handleDismissButtonClick = (0, $5uXOq.useCallback)(()=>{
        analytics.spotlightDismissed();
        dismissSpotlight();
    }, [
        analytics,
        dismissSpotlight
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bkS4F.default), {
        testId: "testId-invite-people-infi-spotlight",
        dialogPlacement: 'bottom center',
        dialogWidth: 44.25 * (0, $b4a3S.gridSize)(),
        actions: [
            {
                onClick: handleDismissButtonClick,
                text: intl.formatMessage((0, $fn6W9.messages).infiSpotlightAction)
            }
        ],
        heading: intl.formatMessage((0, $fn6W9.messages).infiSpotlightTitle),
        target: "coreInvitesThirdPartyConnectSpotlight",
        targetRadius: 3,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $fn6W9.messages).infiSpotlightDescription
        })
    }, "coreInvitesThirdPartyConnectSpotlight");
};
const $c36009b4c5e0fe51$var$InfiSpotlight = ({ children: children, spotlightHidden: spotlightHidden, dismissSpotlight: dismissSpotlight })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $inni2.default), {
        blanketIsTinted: false,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Pxnvj.default), {
                name: "coreInvitesThirdPartyConnectSpotlight",
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $98UVV.default), {
                children: !spotlightHidden && /*#__PURE__*/ (0, $2OMIu.jsx)($c36009b4c5e0fe51$var$SpotlightWithScreenEvent, {
                    dismissSpotlight: dismissSpotlight
                })
            })
        ]
    });
var $c36009b4c5e0fe51$export$2e2bcd8739ae039 = $c36009b4c5e0fe51$var$InfiSpotlight;

});
parcelRegister("d8UBh", function(module, exports) {

$parcel$export(module.exports, "InfiSpotlightAnalytics", () => $55b8aeb0d5f1f046$export$60a9f789989731cd);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $55b8aeb0d5f1f046$export$60a9f789989731cd extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    spotlightViewed() {
        this.fireScreen({
            name: (0, $hatDq.AnalyticsActionSubject).INFI_SPOTLIGHT
        });
    }
    spotlightDismissed() {
        this.fireTrack({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INFI_SPOTLIGHT,
            action: (0, $hatDq.AnalyticsAction).CLOSED
        });
    }
}

});


parcelRegister("cQ8dn", function(module, exports) {

$parcel$export(module.exports, "useInfiSpotlight", () => $0aafdff87878f39c$export$cc46799898138921);

var $dCNWF = parcelRequire("dCNWF");
const $0aafdff87878f39c$export$cc46799898138921 = ()=>(0, $dCNWF.useThirdPartyState)().infiSpotlight;

});


parcelRegister("jmZyU", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b7b03643028af6$export$2e2bcd8739ae039);
/* ViralSettings.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");

var $dVJUv = parcelRequire("dVJUv");

var $fn6W9 = parcelRequire("fn6W9");

var $hofb1 = parcelRequire("hofb1");

var $axtEf = parcelRequire("axtEf");

var $gqMIn = parcelRequire("gqMIn");

var $kx8ta = parcelRequire("kx8ta");
const $80b7b03643028af6$var$styles = {
    heading: "_11c816g6 _syaz131l",
    formSection: "_otyrpxbi"
};
const $80b7b03643028af6$export$e42106b9b5ecbfaf = ({ product: product })=>{
    const { viralSettingsByDomain: viralSettingsByDomain, eligibleDomains: eligibleDomains, showOpenInvite: showOpenInvite, onOpenInviteChange: onOpenInviteChange, handleViralSettingsByDomainCheckbox: handleViralSettingsByDomainCheckbox, openInviteEnabled: openInviteEnabled } = (0, $hofb1.useViralSettingsContext)();
    const productTitle = (0, $kx8ta.getProductTitle)(product);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dVJUv.SlideAnimationWrapper), {
        shouldTriggerAnimation: showOpenInvite || eligibleDomains.length > 0,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
            testId: "testId-invite-people-viral-settings",
            xcss: $80b7b03643028af6$var$styles.formSection,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        "data-test-id": "testId-invite-people-viral-settings-title",
                        className: (0, $bwpsq.default)([
                            $80b7b03643028af6$var$styles.heading
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $fn6W9.messages).viralSettingsHeading,
                            values: {
                                product: productTitle
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $axtEf.default), {
                    show: showOpenInvite,
                    isChecked: openInviteEnabled,
                    onChange: onOpenInviteChange
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gqMIn.default), {
                    viralSettingsByDomain: viralSettingsByDomain,
                    onChange: handleViralSettingsByDomainCheckbox
                })
            ]
        })
    });
};
var $80b7b03643028af6$export$2e2bcd8739ae039 = $80b7b03643028af6$export$e42106b9b5ecbfaf;

});
parcelRegister("dVJUv", function(module, exports) {

$parcel$export(module.exports, "SlideAnimationWrapper", () => $2f9fa483ffacd108$export$ceb13420774e5c3b);
/* SlideAnimationWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7xhdA = parcelRequire("7xhdA");
var $3aB43 = parcelRequire("3aB43");

var $5sRpy = parcelRequire("5sRpy");
const $2f9fa483ffacd108$var$styles = {
    wrapper: "_1reo15vq _18m915vq"
};
const $2f9fa483ffacd108$export$ceb13420774e5c3b = ({ children: children, shouldTriggerAnimation: shouldTriggerAnimation })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xhdA.default), {
        children: shouldTriggerAnimation && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
            xcss: $2f9fa483ffacd108$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3aB43.default), {
                enterFrom: "top",
                fade: "inout",
                children: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...props,
                        children: children
                    })
            })
        })
    });

});

parcelRegister("axtEf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d894e0b249c776$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $aveRr = parcelRequire("aveRr");

var $geBdj = parcelRequire("geBdj");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");

var $fn6W9 = parcelRequire("fn6W9");

var $6HEbe = parcelRequire("6HEbe");

var $9RrMz = parcelRequire("9RrMz");
const $d4d894e0b249c776$export$11078a062caad4af = (props)=>{
    const { show: show, onChange: onChange, checkboxTheme: checkboxTheme = 'DEFAULT', isChecked: isChecked } = props;
    const analytics = (0, $6HEbe.useAnalytics)((0, $9RrMz.ViralSettingsAnalytics));
    (0, $5uXOq.useEffect)(()=>{
        show && analytics.userInvitesCheckboxRendered({
            container: checkboxTheme,
            value: isChecked
        });
    }, [
        show,
        checkboxTheme,
        isChecked,
        analytics
    ]);
    const onChangeWrapper = (event)=>{
        const value = event.target.checked;
        analytics.userInvitesCheckboxClicked({
            value: value,
            container: checkboxTheme
        });
        onChange(event);
    };
    if (!show) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $geBdj.default), {
        entranceDirection: "top",
        children: (animationProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                paddingBlockStart: checkboxTheme === 'MODAL' ? 'space.150' : 'space.050',
                ...animationProps,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aveRr.default), {
                    testId: "testId-invite-people-viral-settings-open-invite",
                    onChange: onChangeWrapper,
                    isChecked: isChecked,
                    label: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                color: "color.text",
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...(0, $fn6W9.messages).openInviteDescription
                                })
                            }),
                            checkboxTheme === 'MODAL' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                color: "color.text.subtlest",
                                size: "small",
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...(0, $fn6W9.messages).openInviteExtendedDescription
                                })
                            })
                        ]
                    })
                })
            })
    });
};
var $d4d894e0b249c776$export$2e2bcd8739ae039 = $d4d894e0b249c776$export$11078a062caad4af;

});

parcelRegister("gqMIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $14f47eac8e559133$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $aveRr = parcelRequire("aveRr");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");

var $geBdj = parcelRequire("geBdj");

var $fn6W9 = parcelRequire("fn6W9");

var $6HEbe = parcelRequire("6HEbe");

var $9RrMz = parcelRequire("9RrMz");
const $14f47eac8e559133$var$CheckboxWithAnalytics = ({ children: children, domain: domain, value: value, container: container })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $9RrMz.ViralSettingsAnalytics));
    (0, $5uXOq.useEffect)(()=>{
        analytics.directAccessCheckboxRendered({
            domain: domain,
            container: container,
            value: value
        });
    }, [
        domain,
        container,
        value,
        analytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children
    });
};
const $14f47eac8e559133$export$2ecf71c9432abb54 = (props)=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $9RrMz.ViralSettingsAnalytics));
    const { viralSettingsByDomain: viralSettingsByDomain, checkboxTheme: checkboxTheme = 'DEFAULT', onChange: onChange } = props;
    const onChangeWrapper = (updatedViralSettingsByDomain, domain)=>{
        analytics.directAccessCheckboxClicked({
            value: updatedViralSettingsByDomain[domain].isChecked,
            domain: domain,
            container: checkboxTheme
        });
        onChange(updatedViralSettingsByDomain);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: Object.keys(viralSettingsByDomain).filter((domain)=>viralSettingsByDomain[domain].desPromotionEligible).map((domain)=>{
            const value = !!viralSettingsByDomain?.[domain].isChecked;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $geBdj.default), {
                entranceDirection: "top",
                children: (animationProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)($14f47eac8e559133$var$CheckboxWithAnalytics, {
                        domain: domain,
                        value: value,
                        container: checkboxTheme,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            paddingBlockStart: checkboxTheme === 'MODAL' ? 'space.150' : 'space.050',
                            ...animationProps,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aveRr.default), {
                                testId: `testId-invite-people-viral-settings-direct-access-${domain}`,
                                isChecked: value,
                                onChange: (e)=>{
                                    onChangeWrapper({
                                        ...viralSettingsByDomain,
                                        [domain]: {
                                            ...viralSettingsByDomain[domain],
                                            isChecked: e.target.checked
                                        }
                                    }, domain);
                                },
                                label: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                            color: "color.text",
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                ...(0, $fn6W9.messages).directAccessDescription,
                                                values: {
                                                    domainWithStyling: /*#__PURE__*/ (0, $2OMIu.jsxs)("b", {
                                                        children: [
                                                            "<@",
                                                            domain,
                                                            ">"
                                                        ]
                                                    })
                                                }
                                            })
                                        }),
                                        checkboxTheme === 'MODAL' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                            color: "color.text.subtlest",
                                            size: "small",
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                ...(0, $fn6W9.messages).directAccessExtendedDescription
                                            })
                                        })
                                    ]
                                })
                            }, `viral-settings-direct-access-checkbox-${domain}`)
                        })
                    })
            }, `viral-settings-direct-access-checkbox-fade-in${domain}`);
        })
    });
};
var $14f47eac8e559133$export$2e2bcd8739ae039 = $14f47eac8e559133$export$2ecf71c9432abb54;

});


parcelRegister("3nIQz", function(module, exports) {

$parcel$export(module.exports, "LineDivider", () => $4faae30c8e2005d1$export$b5f2c46c0231ba4e);
/* LineDivider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
const $4faae30c8e2005d1$var$styles = {
    wrapper: "_11c81vlj _syaz1be1 _otyrpxbi",
    line: "_1h6d1val _1dqonqa1 _189ee4h9 _1bsb1osq"
};
const $4faae30c8e2005d1$export$b5f2c46c0231ba4e = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $4faae30c8e2005d1$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
            as: "span",
            xcss: $4faae30c8e2005d1$var$styles.line
        })
    });
};

});

parcelRegister("4zFDR", function(module, exports) {

$parcel$export(module.exports, "Recaptcha", () => $8a8c703b02ff41f5$export$537aeeb398c07c0a);
/* Recaptcha.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1w0pe = parcelRequire("1w0pe");
var $kIcfN = parcelRequire("kIcfN");

var $5sRpy = parcelRequire("5sRpy");

var $hatDq = parcelRequire("hatDq");

var $kx8ta = parcelRequire("kx8ta");


var $lWbFO = parcelRequire("lWbFO");

var $daXvt = parcelRequire("daXvt");
const $8a8c703b02ff41f5$var$styles = {
    wrapper: "_11c81vlj _syaz131l"
};
const $8a8c703b02ff41f5$export$537aeeb398c07c0a = ({ isLoading: isLoading, onChange: onChange })=>{
    const { source: source } = (0, $daXvt.useInvitePeopleContext)();
    const { isRecaptchaLoaded: isRecaptchaLoaded, getRecaptchaToken: getRecaptchaToken, recaptchaLoadErrorReason: recaptchaLoadErrorReason } = (0, $kIcfN.useInvisibleRecaptcha)({
        siteKey: (0, $kx8ta.getRecaptchaSiteKey)(),
        displayBadge: false,
        analyticsChannel: (0, $241a88bae7861acc$export$85183a312807388d),
        analyticsSource: `${(0, $hatDq.AnalyticsActionSubject).CORE_INVITE_COMPONENT}_${source}`
    });
    const isInitialLoad = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (isInitialLoad.current) {
            (0, $lWbFO.recaptchaLoaded).start();
            isInitialLoad.current = false;
        }
        if (isRecaptchaLoaded) (0, $lWbFO.recaptchaLoaded).success();
        if (recaptchaLoadErrorReason) (0, $lWbFO.recaptchaLoaded).failure();
        onChange({
            isRecaptchaLoaded: isRecaptchaLoaded,
            getRecaptchaToken: getRecaptchaToken,
            recaptchaLoadErrorReason: recaptchaLoadErrorReason
        });
    }, [
        onChange,
        isRecaptchaLoaded,
        getRecaptchaToken,
        recaptchaLoadErrorReason
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: "recaptcha-footer",
        "data-loading": isLoading,
        xcss: $8a8c703b02ff41f5$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1w0pe.default), {})
    });
};

});
parcelRegister("1w0pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5750e0d5300e7bb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8zIDr = parcelRequire("8zIDr");

var $f4Jo1 = parcelRequire("f4Jo1");

var $gdIB2 = parcelRequire("gdIB2");
const $e5750e0d5300e7bb$var$RecaptchaTermsAndPolicy = ({ tagName: tagName = 'span' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4Jo1.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $gdIB2.default).termsAndPolicy,
            tagName: tagName,
            values: {
                privacyPolicy: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8zIDr.default), {
                    href: "https://policies.google.com/privacy",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $gdIB2.default).privacyPolicy
                    })
                }),
                termsOfService: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8zIDr.default), {
                    href: "https://policies.google.com/terms",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $gdIB2.default).termsOfService
                    })
                })
            }
        })
    });
var $e5750e0d5300e7bb$export$2e2bcd8739ae039 = $e5750e0d5300e7bb$var$RecaptchaTermsAndPolicy;

});
parcelRegister("f4Jo1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe1f25c8f5caaff5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $2RH5p = parcelRequire("2RH5p");
const $fe1f25c8f5caaff5$var$IntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $koVbs.default)();
    const { messages: messages } = (0, $2RH5p.useFetchMessagesByLocale)(locale);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        messages: messages,
        locale: locale,
        children: children
    }, locale);
};
var $fe1f25c8f5caaff5$export$2e2bcd8739ae039 = $fe1f25c8f5caaff5$var$IntlProvider;

});
parcelRegister("2RH5p", function(module, exports) {

$parcel$export(module.exports, "useFetchMessagesByLocale", () => $45948b94ca76836d$export$5ac26fa9b941854e);
/* eslint-disable import/dynamic-import-chunkname */ 
var $5uXOq = parcelRequire("5uXOq");

























function $45948b94ca76836d$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("eb2qc"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("eNM9y"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("8cyn2"));
        case 'en-GB':
            return (parcelRequire("6ihC8"));
        case 'en-US':
        case 'en':
            return (parcelRequire("k0Q3p"));
        case 'en-ZZ':
            return (parcelRequire("2KHCw"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("6bVGQ"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("6y5xJ"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("68u1x"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("c9r07"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("fw9XG"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("idIXs"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("iUAy9"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("jynKC"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("8qmcC"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("44Kdu"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("91tks"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("9rW6B"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("IgpJl"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("kFOTe"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("eobxU"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("ftKwW"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("fakJJ"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("lA9CX"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("bzXC4"));
    }
    return Promise.resolve({
        default: {}
    });
}
function $45948b94ca76836d$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $5uXOq.useState)({});
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                const module = await $45948b94ca76836d$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                if (isMounted) setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            }
        }
        startToFetchMessagesByLocale();
        return ()=>{
            isMounted = false;
        };
    }, [
        locale
    ]);
    return {
        messages: messages
    };
}

});
parcelRegister("eb2qc", function(module, exports) {

let $a523f8aab95945c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a523f8aab95945c5$var$load("jYnvm").then(()=>parcelRequire('faSYD'));

});

parcelRegister("eNM9y", function(module, exports) {

let $ac6afe78417e5495$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac6afe78417e5495$var$load("4MvLG").then(()=>parcelRequire('9qnNs'));

});

parcelRegister("8cyn2", function(module, exports) {

let $5f8a1b0407d5a47d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f8a1b0407d5a47d$var$load("3hbva").then(()=>parcelRequire('9YR8M'));

});

parcelRegister("6ihC8", function(module, exports) {

let $49521654418e8d0e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49521654418e8d0e$var$load("3rtfT").then(()=>parcelRequire('c5LJI'));

});

parcelRegister("k0Q3p", function(module, exports) {

let $e91c2f96e57553c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e91c2f96e57553c7$var$load("9MxKn").then(()=>parcelRequire('dn30F'));

});

parcelRegister("2KHCw", function(module, exports) {

let $2011b6bafcfe5889$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2011b6bafcfe5889$var$load("bKV2M").then(()=>parcelRequire('626CG'));

});

parcelRegister("6bVGQ", function(module, exports) {

let $4820852cc43ab663$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4820852cc43ab663$var$load("bx5md").then(()=>parcelRequire('8NKu1'));

});

parcelRegister("6y5xJ", function(module, exports) {

let $4c4a37caae511741$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c4a37caae511741$var$load("flujA").then(()=>parcelRequire('11DQh'));

});

parcelRegister("68u1x", function(module, exports) {

let $477ac785c768075e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $477ac785c768075e$var$load("9R3Ww").then(()=>parcelRequire('5mbGr'));

});

parcelRegister("c9r07", function(module, exports) {

let $024870995dcb8755$var$load = (parcelRequire("28QjX"))(4);
module.exports = $024870995dcb8755$var$load("g7Lmu").then(()=>parcelRequire('54qAt'));

});

parcelRegister("fw9XG", function(module, exports) {

let $b4c19252f4939f2a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4c19252f4939f2a$var$load("iNh3z").then(()=>parcelRequire('2oqB3'));

});

parcelRegister("idIXs", function(module, exports) {

let $d43c50a0be4148c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d43c50a0be4148c7$var$load("8w3tW").then(()=>parcelRequire('2F04t'));

});

parcelRegister("iUAy9", function(module, exports) {

let $dc49cefed6872fc0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dc49cefed6872fc0$var$load("hNpH2").then(()=>parcelRequire('jOHnb'));

});

parcelRegister("jynKC", function(module, exports) {

let $e3c39dbbeb52dc37$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3c39dbbeb52dc37$var$load("diVkb").then(()=>parcelRequire('fyJ0C'));

});

parcelRegister("8qmcC", function(module, exports) {

let $6221f96834e9ff75$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6221f96834e9ff75$var$load("deQ2I").then(()=>parcelRequire('v5uKD'));

});

parcelRegister("44Kdu", function(module, exports) {

let $2f7b62cac7900e0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f7b62cac7900e0f$var$load("7lU3Y").then(()=>parcelRequire('ie6Ec'));

});

parcelRegister("91tks", function(module, exports) {

let $691af52d96fa3e03$var$load = (parcelRequire("28QjX"))(4);
module.exports = $691af52d96fa3e03$var$load("ewLFk").then(()=>parcelRequire('3e4ZT'));

});

parcelRegister("9rW6B", function(module, exports) {

let $6e13b53afdeb0e0d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e13b53afdeb0e0d$var$load("hQ20i").then(()=>parcelRequire('h7JqD'));

});

parcelRegister("IgpJl", function(module, exports) {

let $0850d7a79f905ab1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0850d7a79f905ab1$var$load("blElc").then(()=>parcelRequire('iKFEa'));

});

parcelRegister("kFOTe", function(module, exports) {

let $f0cf1caa52a65682$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f0cf1caa52a65682$var$load("77BC6").then(()=>parcelRequire('dmaeZ'));

});

parcelRegister("eobxU", function(module, exports) {

let $a79c435715a62eed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a79c435715a62eed$var$load("3Soyj").then(()=>parcelRequire('71zoy'));

});

parcelRegister("ftKwW", function(module, exports) {

let $b44da8622593de74$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b44da8622593de74$var$load("9IimT").then(()=>parcelRequire('fUbLC'));

});

parcelRegister("fakJJ", function(module, exports) {

let $b0a7e00f778547c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0a7e00f778547c1$var$load("9o5Js").then(()=>parcelRequire('bo4yT'));

});

parcelRegister("lA9CX", function(module, exports) {

let $fb646d931f50ec5b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fb646d931f50ec5b$var$load("7yM1X").then(()=>parcelRequire('6AOzH'));

});

parcelRegister("bzXC4", function(module, exports) {

let $86e1348407fbe329$var$load = (parcelRequire("28QjX"))(4);
module.exports = $86e1348407fbe329$var$load("dzTo5").then(()=>parcelRequire('ckkdR'));

});



parcelRegister("gdIB2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2ec6d6e51615515$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a2ec6d6e51615515$var$messages = (0, $7VHMR.defineMessages)({
    termsAndPolicy: {
        id: 'growth.google-recaptcha.terms-and-policy.text',
        description: 'Text substitute for reCAPTCHA branding when badge is visibly hidden',
        defaultMessage: 'This site is protected by reCAPTCHA and the Google {privacyPolicy} and {termsOfService} apply.'
    },
    privacyPolicy: {
        id: 'growth.google-recaptcha.terms-and-policy.privacy-policy',
        description: 'Privacy Policy link text',
        defaultMessage: 'Privacy Policy'
    },
    termsOfService: {
        id: 'growth.google-recaptcha.terms-and-policy.terms-of-service',
        description: 'Terms of Service link text',
        defaultMessage: 'Terms of Service'
    }
});
var $a2ec6d6e51615515$export$2e2bcd8739ae039 = $a2ec6d6e51615515$var$messages;

});


parcelRegister("kIcfN", function(module, exports) {

$parcel$export(module.exports, "useInvisibleRecaptcha", () => $983b4db9f78e6557$export$9a22eec761fce66);

var $5uXOq = parcelRequire("5uXOq");

var $W05rd = parcelRequire("W05rd");

var $eQ63C = parcelRequire("eQ63C");
const $983b4db9f78e6557$export$9a22eec761fce66 = ({ siteKey: siteKey, displayBadge: displayBadge = true, analyticsChannel: analyticsChannel, analyticsSource: analyticsSource })=>{
    const triggerEvent = (0, $W05rd.useAnalytics)(analyticsChannel, analyticsSource);
    const [isRecaptchaLoaded, setIsRecaptchaLoaded] = (0, $5uXOq.useState)(false);
    const [recaptchaLoadErrorReason, setRecaptchaLoadErrorReason] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        const initRecaptcha = async ()=>{
            try {
                await (0, $eQ63C.loadRecaptcha)(siteKey);
                if (!displayBadge) (0, $eQ63C.hideRecaptchaBadge)(siteKey);
                triggerEvent((0, $W05rd.recaptchaLoaded));
                if (isMounted) {
                    setIsRecaptchaLoaded(true);
                    setRecaptchaLoadErrorReason(undefined);
                }
            } catch (err) {
                const errorMessage = String(err);
                triggerEvent((0, $W05rd.recaptchaLoadFailed), errorMessage);
                if (isMounted) setRecaptchaLoadErrorReason(errorMessage);
            }
        };
        initRecaptcha();
        return ()=>{
            (0, $eQ63C.unloadRecaptcha)(siteKey);
            setRecaptchaLoadErrorReason(undefined);
            isMounted = false;
        };
    }, [
        displayBadge,
        siteKey,
        triggerEvent
    ]);
    const getRecaptchaToken = (0, $5uXOq.useCallback)(async (action)=>{
        try {
            if (!isRecaptchaLoaded || !window?.grecaptcha?.enterprise?.execute) throw new (0, $eQ63C.RecaptchaError)('Execute function not ready');
            return await window.grecaptcha.enterprise.execute(siteKey, {
                action: action
            });
        } catch (err) {
            triggerEvent((0, $W05rd.recaptchaExecuteFailed), String(err));
            throw err;
        }
    }, [
        isRecaptchaLoaded,
        siteKey,
        triggerEvent
    ]);
    return {
        isRecaptchaLoaded: isRecaptchaLoaded,
        getRecaptchaToken: getRecaptchaToken,
        recaptchaLoadErrorReason: recaptchaLoadErrorReason
    };
};

});
parcelRegister("W05rd", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $5a031dfad876e5cb$export$e955abb82869dc84);
$parcel$export(module.exports, "recaptchaLoaded", () => $5a031dfad876e5cb$export$b97b16bc7fe47920);
$parcel$export(module.exports, "recaptchaLoadFailed", () => $5a031dfad876e5cb$export$3a46331396e3fda);
$parcel$export(module.exports, "recaptchaExecuteFailed", () => $5a031dfad876e5cb$export$ea782407790eb26c);

var $5uXOq = parcelRequire("5uXOq");


var $9Iej8 = parcelRequire("9Iej8");
var $bngFq = parcelRequire("bngFq");
const $5a031dfad876e5cb$var$ACTION_SUBJECT = 'recaptcha';
const $5a031dfad876e5cb$export$e955abb82869dc84 = (channel, source)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const triggerEvent = (0, $5uXOq.useCallback)((eventFactory, ...args)=>{
        const analyticsEvent = {
            source: source,
            ...eventFactory(...args)
        };
        (0, $9Iej8.default)(channel)(analyticsEvent)(createAnalyticsEvent);
    }, [
        source,
        channel,
        createAnalyticsEvent
    ]);
    return triggerEvent;
};
const $5a031dfad876e5cb$export$b97b16bc7fe47920 = ()=>({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: $5a031dfad876e5cb$var$ACTION_SUBJECT,
        action: 'loaded'
    });
const $5a031dfad876e5cb$export$3a46331396e3fda = (errorMessage)=>({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: $5a031dfad876e5cb$var$ACTION_SUBJECT,
        actionSubjectId: 'load',
        action: 'failed',
        attributes: {
            error: errorMessage
        }
    });
const $5a031dfad876e5cb$export$ea782407790eb26c = (errorMessage)=>({
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        actionSubject: $5a031dfad876e5cb$var$ACTION_SUBJECT,
        actionSubjectId: 'execute',
        action: 'failed',
        attributes: {
            error: errorMessage
        }
    });

});

parcelRegister("eQ63C", function(module, exports) {

$parcel$export(module.exports, "loadRecaptcha", () => $bf16b49a0815f816$export$29933d84054794ee);
$parcel$export(module.exports, "unloadRecaptcha", () => $bf16b49a0815f816$export$cfad80fecff3cb16);
$parcel$export(module.exports, "hideRecaptchaBadge", () => $bf16b49a0815f816$export$924e44702e93d253);
$parcel$export(module.exports, "RecaptchaError", () => $bf16b49a0815f816$export$e037dc82f45cc746);
const $bf16b49a0815f816$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE = 'Failed to load grecaptcha enterprise';
const $bf16b49a0815f816$export$b8e8ecca99719d00 = 'https://www.recaptcha.net/recaptcha/enterprise.js';
const $bf16b49a0815f816$var$RECAPTCHA_BADGE_SELECTOR = '.grecaptcha-badge';
const $bf16b49a0815f816$export$29933d84054794ee = (siteKey)=>new Promise((resolve, reject)=>{
        if ($bf16b49a0815f816$var$isRecaptchaLoaded(siteKey)) {
            resolve();
            return;
        }
        const scriptElement = document.createElement('script');
        scriptElement.src = `${$bf16b49a0815f816$export$b8e8ecca99719d00}?render=${siteKey}`;
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.id = siteKey;
        scriptElement.onload = ()=>{
            if (!window?.grecaptcha?.enterprise) reject($bf16b49a0815f816$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
            else window.grecaptcha.enterprise.ready(resolve);
        };
        scriptElement.onerror = (error)=>{
            reject(typeof error === 'string' ? error : error.message ?? $bf16b49a0815f816$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
        };
        document.body.appendChild(scriptElement);
    });
const $bf16b49a0815f816$var$isRecaptchaLoaded = (siteKey)=>Boolean(document.getElementById(siteKey));
const $bf16b49a0815f816$export$cfad80fecff3cb16 = (siteKey)=>{
    $bf16b49a0815f816$var$removeRecaptchaScriptElement(siteKey);
    $bf16b49a0815f816$var$removeRecaptchaBadgeStyleElement(siteKey);
    $bf16b49a0815f816$var$removeRecaptchaBadge();
};
const $bf16b49a0815f816$export$924e44702e93d253 = (siteKey)=>{
    const id = `${siteKey}-styles`;
    if (document.getElementById(id)) return;
    const styleElement = document.createElement('style');
    styleElement.id = `${siteKey}-styles`;
    styleElement.innerText = `${$bf16b49a0815f816$var$RECAPTCHA_BADGE_SELECTOR} { visibility: hidden; }`;
    document.head.appendChild(styleElement);
};
const $bf16b49a0815f816$var$removeRecaptchaScriptElement = (siteKey)=>{
    const scriptElement = document.getElementById(siteKey);
    if (scriptElement) scriptElement.remove();
};
const $bf16b49a0815f816$var$removeRecaptchaBadgeStyleElement = (siteKey)=>{
    const styleElement = document.getElementById(`${siteKey}-styles`);
    if (styleElement) styleElement.remove();
};
const $bf16b49a0815f816$var$removeRecaptchaBadge = ()=>{
    const badgeElements = document.querySelectorAll($bf16b49a0815f816$var$RECAPTCHA_BADGE_SELECTOR);
    // @ts-ignore "TS2488: Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator." occurs within Jira due to missing DOM.Iterable. We've dropped IE support so we shouldn't need it.
    for (const el of badgeElements)el.remove();
};
class $bf16b49a0815f816$export$e037dc82f45cc746 extends Error {
    constructor(message){
        super(message);
        // fixing the `instanceof` operators, see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $bf16b49a0815f816$export$e037dc82f45cc746.prototype);
    }
}

});



parcelRegister("1PtjI", function(module, exports) {

$parcel$export(module.exports, "PluginRenderer", () => $54de57ba7e98e15e$export$8a533d10ba2da272);
/* PluginRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");

var $78lfI = parcelRequire("78lfI");
const $54de57ba7e98e15e$var$styles = {
    formSection: "_otyrpxbi"
};
const $54de57ba7e98e15e$export$8a533d10ba2da272 = /*#__PURE__*/ (0, $5uXOq.memo)(({ plugins: plugins, location: location })=>{
    const invitePeopleData = (0, $78lfI.useInvitePeopleData)();
    const plugin = plugins?.[location];
    if (!plugin) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $54de57ba7e98e15e$var$styles.formSection,
        children: plugin.render(invitePeopleData)
    }, `plugin-${location}`);
});

});
parcelRegister("78lfI", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleData", () => $f2d8a8ab29b9d318$export$458bac823ccb0e85);

var $5uXOq = parcelRequire("5uXOq");

var $4gxY5 = parcelRequire("4gxY5");

var $1CnPD = parcelRequire("1CnPD");
const $f2d8a8ab29b9d318$export$458bac823ccb0e85 = ()=>{
    const { groups: groups, users: users } = (0, $1CnPD.useInviteeListStateContext)();
    const { selectedProducts: selectedProducts, inviteCapabilities: inviteCapabilities } = (0, $4gxY5.useProducts)();
    const { userPickerOptions: inviteeListOptions } = (0, $1CnPD.useInviteeListStateContext)();
    return (0, $5uXOq.useMemo)(()=>({
            groups: groups,
            inviteCapabilities: inviteCapabilities,
            inviteeListOptions: inviteeListOptions,
            selectedProducts: selectedProducts,
            users: users
        }), [
        groups,
        inviteCapabilities,
        inviteeListOptions,
        selectedProducts,
        users
    ]);
};

});



parcelRegister("tkxOk", function(module, exports) {

$parcel$export(module.exports, "InvitePeoplePluginsAnalytics", () => $61f7599e4c4b6270$export$84804bd348f3aafb);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $61f7599e4c4b6270$export$84804bd348f3aafb extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    pluginsValidationFailed({ error: error }) {
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).VALIDATION,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubjectId).PLUGINS,
            action: (0, $hatDq.AnalyticsAction).FAILED,
            attributes: {
                error: error
            }
        });
    }
}

});

parcelRegister("kKKsG", function(module, exports) {

$parcel$export(module.exports, "onValidate", () => $94fae4a0ad745463$export$d0b1421dbb7d2df3);
const $94fae4a0ad745463$export$d0b1421dbb7d2df3 = async ({ analytics: analytics, invitePeopleData: invitePeopleData, plugins: plugins })=>{
    const pluginValidationSuccessfulResult = {
        isValid: true
    };
    if (!plugins) return pluginValidationSuccessfulResult;
    try {
        const onValidatePromises = Object.keys(plugins).map((location)=>plugins[location]?.onValidate?.(invitePeopleData) ?? Promise.resolve(pluginValidationSuccessfulResult));
        const onValidateResults = await Promise.all(onValidatePromises);
        return {
            isValid: onValidateResults.every(({ isValid: isValid })=>isValid)
        };
    } catch (error) {
        analytics.pluginsValidationFailed({
            error: String(error)
        });
        return {
            isValid: false
        };
    }
};

});

parcelRegister("daR2j", function(module, exports) {

$parcel$export(module.exports, "ShareableLinkComponent", () => $33700097d45f2e9e$export$c0aa13db94cca49e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7Nt5L = parcelRequire("7Nt5L");

var $aRodw = parcelRequire("aRodw");

var $9ObVy = parcelRequire("9ObVy");

var $6HEbe = parcelRequire("6HEbe");

var $7VCSG = parcelRequire("7VCSG");
const $33700097d45f2e9e$export$c0aa13db94cca49e = ({ inviteLink: inviteLink, cloudId: cloudId, orgId: orgId, onCloseTurnOnInviteLinkModal: onCloseTurnOnInviteLinkModal, turnOnInviteLinkModalDismissed: turnOnInviteLinkModalDismissed })=>{
    const [isInviteLinkCopied, setInviteLinkCopied] = (0, $5uXOq.useState)(false);
    const [activeInviteLink, setActiveInviteLink] = (0, $5uXOq.useState)(inviteLink);
    const [shouldShowTurnOnInvite, setShouldShowTurnOnInvite] = (0, $5uXOq.useState)(!activeInviteLink && !turnOnInviteLinkModalDismissed);
    const analytics = (0, $6HEbe.useAnalytics)((0, $7VCSG.ShareableLinkAnalytics));
    (0, $5uXOq.useEffect)(()=>{
        setActiveInviteLink(inviteLink);
    }, [
        inviteLink
    ]);
    const handleCopyLink = ()=>{
        activeInviteLink && navigator.clipboard.writeText(activeInviteLink).then(()=>{
            setInviteLinkCopied(true);
            setTimeout(()=>setInviteLinkCopied(false), 2000);
        });
        analytics.copyInviteLinkButtonClicked();
    };
    const handleAllowLink = async ()=>{
        try {
            const resourceId = `ari:cloud:confluence::site/${cloudId}`;
            const response = await (0, $7Nt5L.defaultInviteApiClient).enableInviteLink(resourceId);
            if (typeof response === 'object' && response !== null && 'url' in response) {
                setShouldShowTurnOnInvite(false);
                setActiveInviteLink(response.url);
            }
            analytics.enableInviteLinkToggleClicked();
        } catch (err) {}
    };
    const handleCloseTurnOnInviteLink = ()=>{
        onCloseTurnOnInviteLinkModal?.();
        analytics.enableInviteLinkCloseButtonClicked();
        setShouldShowTurnOnInvite(false);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            shouldShowTurnOnInvite && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRodw.TurnOnInviteLink), {
                handleAllowLink: handleAllowLink,
                handleCloseTurnOnInviteLink: handleCloseTurnOnInviteLink,
                orgId: orgId
            }),
            activeInviteLink && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9ObVy.CopyInviteLink), {
                handleCopyLink: handleCopyLink,
                activeInviteLink: activeInviteLink,
                isInviteLinkCopied: isInviteLinkCopied
            })
        ]
    });
};

});
parcelRegister("aRodw", function(module, exports) {

$parcel$export(module.exports, "TurnOnInviteLink", () => $46b7171647692e83$export$e7492402fe8f9fd4);
/* TurnOnInviteLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $1Seuh = parcelRequire("1Seuh");

var $gANiX = parcelRequire("gANiX");

var $3YyrB = parcelRequire("3YyrB");
var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $fHMtf = parcelRequire("fHMtf");

var $kx8ta = parcelRequire("kx8ta");

var $fn6W9 = parcelRequire("fn6W9");
const $46b7171647692e83$var$styles = {
    headingWrapper: "_11c81doa",
    heading: "_syaz1gjq _k48p1wq8",
    toggle: "_ahbq196n",
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1",
    wrapper: "_2rko1sit _1rjcpxbi _18zrpxbi _1pfhpxbi _bfhk1nvp"
};
const $46b7171647692e83$export$e7492402fe8f9fd4 = ({ handleAllowLink: handleAllowLink, orgId: orgId, handleCloseTurnOnInviteLink: handleCloseTurnOnInviteLink })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
        xcss: $46b7171647692e83$var$styles.wrapper,
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                grow: "fill",
                alignBlock: "stretch",
                spread: "space-between",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        as: "span",
                        xcss: $46b7171647692e83$var$styles.headingWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            as: "span",
                            xcss: $46b7171647692e83$var$styles.heading,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $fn6W9.messages).turnOnShareableLinkTitle
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                        appearance: "subtle",
                        label: "Close modal",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gANiX))),
                        spacing: "compact",
                        onClick: handleCloseTurnOnInviteLink,
                        testId: "testId-shareablelink-turn-on-invite-dismiss"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                color: "color.text.subtle",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $fn6W9.messages).turnOnShareableLinkHelpText,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3YyrB.default), {
                                xcss: $46b7171647692e83$var$styles.anchor,
                                href: orgId ? (0, $kx8ta.adminManageUserInviteLinkHref)(orgId) : '',
                                target: "_blank",
                                children: chunks
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                alignBlock: "center",
                xcss: $46b7171647692e83$var$styles.toggle,
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fHMtf.default), {
                        id: "toggle-allow-link",
                        label: "allowShareableLink",
                        onChange: handleAllowLink,
                        testId: "testId-shareablelink-turn-on-invite-toggle"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        size: "medium",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $fn6W9.messages).turnOnShareableLinkToggleLabel
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("fHMtf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8dd5ff816ae367$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $jJsBW = parcelRequire("jJsBW");

var $aWYDr = parcelRequire("aWYDr");

var $9ojbB = parcelRequire("9ojbB");

var $fHpHg = parcelRequire("fHpHg");

var $8nOMf = parcelRequire("8nOMf");
const $1d8dd5ff816ae367$var$basicStyles = null;
const $1d8dd5ff816ae367$var$borderStyles = null;
const $1d8dd5ff816ae367$var$iconStyles = null;
const $1d8dd5ff816ae367$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $1d8dd5ff816ae367$var$noop = (0, $bKnKN.default);
const $1d8dd5ff816ae367$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $1d8dd5ff816ae367$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $1d8dd5ff816ae367$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $1d8dd5ff816ae367$var$noop, onChange: providedChange = $1d8dd5ff816ae367$var$noop, onFocus: providedFocus = $1d8dd5ff816ae367$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$1d8dd5ff816ae367$var$analyticsAttributes
    });
    const handleFocus = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$1d8dd5ff816ae367$var$analyticsAttributes
    });
    const handleChange = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$1d8dd5ff816ae367$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $1d8dd5ff816ae367$var$iconSizeMap[size];
    const labelId = (0, $jJsBW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $fHpHg.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $1d8dd5ff816ae367$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8nOMf.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aWYDr))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8nOMf.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9ojbB))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$1d8dd5ff816ae367$var$Toggle.displayName = 'Toggle';
var $1d8dd5ff816ae367$export$2e2bcd8739ae039 = $1d8dd5ff816ae367$var$Toggle;

});
parcelRegister("aWYDr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f8e5b0cf2a75074$var$_react = $7f8e5b0cf2a75074$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7f8e5b0cf2a75074$var$_checkMark = $7f8e5b0cf2a75074$var$_interopRequireDefault((parcelRequire("aiSXl")));

var $7f8e5b0cf2a75074$var$_done = $7f8e5b0cf2a75074$var$_interopRequireDefault((parcelRequire("4UpSr")));
function $7f8e5b0cf2a75074$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f8e5b0cf2a75074$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $7f8e5b0cf2a75074$var$_react.default.createElement($7f8e5b0cf2a75074$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $7f8e5b0cf2a75074$var$_done.default
    }, props));
$7f8e5b0cf2a75074$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $7f8e5b0cf2a75074$var$_default = module.exports.default = $7f8e5b0cf2a75074$var$CheckMarkIcon;

});
parcelRegister("aiSXl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $780636fcbb2cccd4$var$_react = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $780636fcbb2cccd4$var$_baseNew = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("enEmH")));
function $780636fcbb2cccd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $780636fcbb2cccd4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $780636fcbb2cccd4$var$_react.default.createElement($780636fcbb2cccd4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$780636fcbb2cccd4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $780636fcbb2cccd4$var$_default = module.exports.default = $780636fcbb2cccd4$var$CheckMarkIcon;

});

parcelRegister("4UpSr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3930770d7c775047$var$_react = $3930770d7c775047$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $3930770d7c775047$var$_checkMark = $3930770d7c775047$var$_interopRequireDefault((parcelRequire("dVU8x")));
function $3930770d7c775047$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3930770d7c775047$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $3930770d7c775047$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $3930770d7c775047$var$_checkMark.default
    }));
$3930770d7c775047$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $3930770d7c775047$var$_default = module.exports.default = $3930770d7c775047$var$EditorDoneIcon;

});
parcelRegister("dVU8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a24c24cfbaad63c1$var$_react = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a24c24cfbaad63c1$var$_baseNew = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a24c24cfbaad63c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a24c24cfbaad63c1$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a24c24cfbaad63c1$var$_react.default.createElement($a24c24cfbaad63c1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$a24c24cfbaad63c1$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $a24c24cfbaad63c1$var$_default = module.exports.default = $a24c24cfbaad63c1$var$CheckMarkIcon;

});



parcelRegister("9ojbB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c13696afcc546e8bf0fe91a6c236c8d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d653cee5ee628ba$var$_react = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6d653cee5ee628ba$var$_cross = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("gANiX")));

var $6d653cee5ee628ba$var$_close = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("gKTT6")));
function $6d653cee5ee628ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d653cee5ee628ba$var$CrossIcon = (props)=>/*#__PURE__*/ $6d653cee5ee628ba$var$_react.default.createElement($6d653cee5ee628ba$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $6d653cee5ee628ba$var$_close.default
    }, props));
$6d653cee5ee628ba$var$CrossIcon.Name = 'CrossIconMigration';
var $6d653cee5ee628ba$var$_default = module.exports.default = $6d653cee5ee628ba$var$CrossIcon;

});
parcelRegister("gKTT6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c32c4b58a13c4296$var$_react = $c32c4b58a13c4296$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $c32c4b58a13c4296$var$_close = $c32c4b58a13c4296$var$_interopRequireDefault((parcelRequire("eh9vz")));
function $c32c4b58a13c4296$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c32c4b58a13c4296$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $c32c4b58a13c4296$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $c32c4b58a13c4296$var$_close.default
    }));
$c32c4b58a13c4296$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $c32c4b58a13c4296$var$_default = module.exports.default = $c32c4b58a13c4296$var$EditorCloseIcon;

});


parcelRegister("8nOMf", function(module, exports) {

$parcel$export(module.exports, "default", () => $300b858f6a112f45$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
const $300b858f6a112f45$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $300b858f6a112f45$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "span",
        xcss: (0, $6tzHJ.cx)($300b858f6a112f45$var$styles.iconContainer, isHidden && (0, $fHpHg.fg)('platform-visual-refresh-icons') && $300b858f6a112f45$var$styles.hidden, size === 'regular' && $300b858f6a112f45$var$styles.iconContainerRegular, size === 'large' && $300b858f6a112f45$var$styles.iconContainerLarge, position === 'left' && $300b858f6a112f45$var$styles.left, position === 'right' && $300b858f6a112f45$var$styles.right),
        children: children
    });
};
var $300b858f6a112f45$export$2e2bcd8739ae039 = $300b858f6a112f45$var$IconContainer;

});



parcelRegister("9ObVy", function(module, exports) {

$parcel$export(module.exports, "CopyInviteLink", () => $1c28bea267d0b451$export$799ff52807b27ed1);
/* CopyInviteLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $c95g7 = parcelRequire("c95g7");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $cGltd = parcelRequire("cGltd");

var $9r7BT = parcelRequire("9r7BT");

var $55tuP = parcelRequire("55tuP");

var $bMdrA = parcelRequire("bMdrA");

var $6QlEX = parcelRequire("6QlEX");

var $fn6W9 = parcelRequire("fn6W9");
const $1c28bea267d0b451$var$styles = {
    wrapper: "_1pfhpxbi"
};
const $1c28bea267d0b451$export$799ff52807b27ed1 = ({ handleCopyLink: handleCopyLink, activeInviteLink: activeInviteLink, isInviteLinkCopied: isInviteLinkCopied })=>{
    const popupContent = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
                label: "",
                color: "var(--ds-icon-success, #22A06B)",
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $fn6W9.messages).copyInviteButtonCopiedLabel
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
        xcss: $1c28bea267d0b451$var$styles.wrapper,
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cGltd.Label), {
                htmlFor: "copyLink",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $fn6W9.messages).inviteLinkLabel
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9r7BT.default), {
                        id: "copyLink",
                        isReadOnly: true,
                        value: activeInviteLink,
                        isDisabled: !activeInviteLink,
                        testId: "testId-shareablelink-link-textfield"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $55tuP.default), {
                            content: popupContent,
                            isOpen: isInviteLinkCopied,
                            placement: "bottom",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6QlEX.default), {
                                onClick: handleCopyLink,
                                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c95g7))), {
                                    color: "currentColor",
                                    label: "",
                                    LEGACY_size: "medium",
                                    spacing: "spacious"
                                }),
                                style: {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                                    backgroundColor: "var(--ds-background-neutral, #091E420F)",
                                    padding: `0 ${"var(--ds-space-150, 12px)"} 0 ${"var(--ds-space-100, 8px)"}`
                                },
                                actionSubjectId: "copyInviteLinkButton",
                                testId: "testId-shareablelink-copy-button",
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...(0, $fn6W9.messages).copyInviteButtonLabel
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                color: "color.text.subtlest",
                size: "small",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $fn6W9.messages).shareableLinkSubMessageLabel
                })
            })
        ]
    });
};

});
parcelRegister("c95g7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d7a67a528197b47$var$_react = $8d7a67a528197b47$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8d7a67a528197b47$var$_link = $8d7a67a528197b47$var$_interopRequireDefault((parcelRequire("bDHz4")));

var $8d7a67a528197b47$var$_link2 = $8d7a67a528197b47$var$_interopRequireDefault((parcelRequire("5gmaZ")));
function $8d7a67a528197b47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d7a67a528197b47$var$LinkIcon = (props)=>/*#__PURE__*/ $8d7a67a528197b47$var$_react.default.createElement($8d7a67a528197b47$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $8d7a67a528197b47$var$_link2.default
    }, props));
$8d7a67a528197b47$var$LinkIcon.Name = 'LinkIconMigration';
var $8d7a67a528197b47$var$_default = module.exports.default = $8d7a67a528197b47$var$LinkIcon;

});
parcelRegister("bDHz4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8795214424a53a62$var$_react = $8795214424a53a62$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8795214424a53a62$var$_baseNew = $8795214424a53a62$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8795214424a53a62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8795214424a53a62$var$LinkIcon = (props)=>/*#__PURE__*/ $8795214424a53a62$var$_react.default.createElement($8795214424a53a62$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$8795214424a53a62$var$LinkIcon.displayName = 'LinkIcon';
var $8795214424a53a62$var$_default = module.exports.default = $8795214424a53a62$var$LinkIcon;

});

parcelRegister("5gmaZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d4fa62011caab87$var$_react = $3d4fa62011caab87$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $3d4fa62011caab87$var$_link = $3d4fa62011caab87$var$_interopRequireDefault((parcelRequire("bDHz4")));
function $3d4fa62011caab87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3d4fa62011caab87$var$LinkIcon = (props)=>/*#__PURE__*/ $3d4fa62011caab87$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $3d4fa62011caab87$var$_link.default
    }));
$3d4fa62011caab87$var$LinkIcon.displayName = 'LinkIcon';
var $3d4fa62011caab87$var$_default = module.exports.default = $3d4fa62011caab87$var$LinkIcon;

});


parcelRegister("9r7BT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7747ff173c91dd60$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $fHpHg = parcelRequire("fHpHg");
const $7747ff173c91dd60$var$containerMedia = {
    invalid: "_srjtgir2",
    disabled: "_6up518qt"
};
const $7747ff173c91dd60$var$inputMediaDisabled = null;
const $7747ff173c91dd60$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $7747ff173c91dd60$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $7747ff173c91dd60$var$invalidStyle = null;
const $7747ff173c91dd60$var$focusWithinStyle = {
    standard: "_ochr1p6i _195er01l _bqhtq049",
    subtle: "_ochr1p6i _195er01l _bqhtq049",
    none: "_ochr3acm _195e18uv _bqhtnruj"
};
const $7747ff173c91dd60$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $7747ff173c91dd60$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _srjtgir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _srjtgir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _srjtgir2"
};
const $7747ff173c91dd60$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $7747ff173c91dd60$var$getMaxWidth = (width)=>!width ? `100%` : width in $7747ff173c91dd60$var$widthMap ? `${$7747ff173c91dd60$var$widthMap[width]}px` : `${+width}px`;
const $7747ff173c91dd60$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $7747ff173c91dd60$var$containerStyles = null;
const $7747ff173c91dd60$var$inputDisabledStyle = null;
const $7747ff173c91dd60$var$inputCompactStyleWithFg = null;
const $7747ff173c91dd60$var$inputCompactStyle = null;
const $7747ff173c91dd60$var$inputMonospacedStyle = null;
const $7747ff173c91dd60$var$inputFontStyleWithFG = null;
const $7747ff173c91dd60$var$inputStyleMonospacedWithFg = null;
const $7747ff173c91dd60$var$inputStyleNotDataCompactWithFG = null;
const $7747ff173c91dd60$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $7747ff173c91dd60$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$7747ff173c91dd60$var$analyticsParams
    });
    const handleOnBlur = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$7747ff173c91dd60$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$7747ff173c91dd60$var$getMaxWidth(width)}`
        },
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $7747ff173c91dd60$var$getContainerTextBgAndBorderColor[appearance],
            $7747ff173c91dd60$var$containerStyleAppearance[appearance],
            !isDisabled && $7747ff173c91dd60$var$focusWithinStyle[appearance],
            !isDisabled && $7747ff173c91dd60$var$hoverStyle[appearance],
            isDisabled && $7747ff173c91dd60$var$containerMedia.disabled,
            isDisabled && $7747ff173c91dd60$var$disabledStyle[appearance],
            isInvalid && $7747ff173c91dd60$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _10j7r01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $7747ff173c91dd60$export$2e2bcd8739ae039 = $7747ff173c91dd60$var$Textfield;

});


parcelRegister("7VCSG", function(module, exports) {

$parcel$export(module.exports, "ShareableLinkAnalytics", () => $1892ba0acbcd450b$export$16b82861c03c14a);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $1892ba0acbcd450b$export$16b82861c03c14a extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    copyInviteLinkButtonClicked() {
        this.fireUI({
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubjectId).COPY_INVITE_LINK_BUTTON
        });
    }
    enableInviteLinkCloseButtonClicked() {
        this.fireUI({
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubjectId).ENABLE_INVITE_LINK_CLOSE
        });
    }
    enableInviteLinkToggleClicked() {
        this.fireUI({
            action: (0, $hatDq.AnalyticsAction).CLICKED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).BUTTON,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubjectId).ENABLE_INVITE_LINK_TOGGLE
        });
    }
}

});



parcelRegister("a3CEJ", function(module, exports) {

$parcel$export(module.exports, "useViralSettingsFlags", () => $b44c810f9f0f83da$export$19902b66d8fa0a2c);

var $koVbs = parcelRequire("koVbs");

var $kx8ta = parcelRequire("kx8ta");

var $jDNEN = parcelRequire("jDNEN");

var $hofb1 = parcelRequire("hofb1");

var $daXvt = parcelRequire("daXvt");

var $4gxY5 = parcelRequire("4gxY5");
const $b44c810f9f0f83da$export$19902b66d8fa0a2c = ()=>{
    const { viralSettingsDESEligibleStates: { checked: domains } } = (0, $hofb1.useViralSettingsContext)();
    const { cloudId: cloudId } = (0, $daXvt.useInvitePeopleContext)();
    const { selectedProducts: selectedProducts } = (0, $4gxY5.useProducts)();
    const intl = (0, $koVbs.default)();
    return (openInviteEnabled, directAccessAllDomainsEnabled)=>(0, $jDNEN.getViralSettingsFlags)(openInviteEnabled, directAccessAllDomainsEnabled, domains, cloudId || '', (0, $kx8ta.getProductTitle)(selectedProducts[0]), intl);
};

});
parcelRegister("jDNEN", function(module, exports) {

$parcel$export(module.exports, "getViralSettingsFlags", () => $a05e869f957fbf7c$export$f8472417a92ca559);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $bMdrA = parcelRequire("bMdrA");


var $kx8ta = parcelRequire("kx8ta");

var $fn6W9 = parcelRequire("fn6W9");
const $a05e869f957fbf7c$var$getOpenInviteSuccessFlag = (cloudId, product, intl)=>{
    return {
        appearance: 'success',
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
            label: "success",
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$exports).G400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
        }),
        title: intl.formatMessage((0, $fn6W9.messages).openInviteSuccessFlagTitle, {
            product: product
        }),
        description: intl.formatMessage((0, $fn6W9.messages).openInviteSuccessFlagDescription),
        actions: [
            {
                content: intl.formatMessage((0, $fn6W9.messages).viralSettingsSuccessFlagActionLabel),
                href: `${(0, $kx8ta.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
                target: '_blank'
            }
        ]
    };
};
const $a05e869f957fbf7c$var$getDirectAccessSuccessFlag = (domains, cloudId, product, intl)=>{
    return {
        appearance: 'success',
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
            label: "success",
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$exports).G400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
        }),
        title: intl.formatMessage((0, $fn6W9.messages).directAccessSuccessFlagTitle, {
            product: product
        }),
        description: intl.formatMessage((0, $fn6W9.messages).directAccessSuccessFlagDescription, {
            domains: domains.map((domain)=>`@${domain}`).join(', ')
        }),
        actions: [
            {
                content: intl.formatMessage((0, $fn6W9.messages).viralSettingsSuccessFlagActionLabel),
                href: `${(0, $kx8ta.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
                target: '_blank'
            }
        ]
    };
};
const $a05e869f957fbf7c$var$getViralSettingsSuccessFlag = (domains, cloudId, product, intl)=>{
    return {
        appearance: 'success',
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
            label: "success",
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$exports).G400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
        }),
        title: intl.formatMessage((0, $fn6W9.messages).viralSettingsSuccessFlagTitle, {
            product: product
        }),
        description: intl.formatMessage((0, $fn6W9.messages).viralSettingsSuccessFlagDescription, {
            domains: domains.map((domain)=>`@${domain}`).join(', ')
        }),
        actions: [
            {
                content: intl.formatMessage((0, $fn6W9.messages).viralSettingsSuccessFlagActionLabel),
                href: `${(0, $kx8ta.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
                target: '_blank'
            }
        ]
    };
};
const $a05e869f957fbf7c$var$getOpenInviteFailureFlag = (cloudId, product, intl)=>{
    return {
        appearance: 'error',
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
            label: "error",
            spacing: "spacious",
            color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$exports).R400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
        }),
        title: intl.formatMessage((0, $fn6W9.messages).openInviteFailureFlagTitle),
        description: intl.formatMessage((0, $fn6W9.messages).openInviteFailureFlagDescription, {
            product: product
        }),
        actions: [
            {
                content: intl.formatMessage((0, $fn6W9.messages).viralSettingsFailureFlagActionLabel),
                href: `${(0, $kx8ta.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
                target: '_blank'
            }
        ]
    };
};
const $a05e869f957fbf7c$var$getDirectAccessFailureFlag = (domain, cloudId, product, intl)=>{
    return {
        appearance: 'error',
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
            label: "error",
            spacing: "spacious",
            color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$exports).R400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
        }),
        title: intl.formatMessage((0, $fn6W9.messages).directAccessFailureFlagTitle),
        description: intl.formatMessage((0, $fn6W9.messages).directAccessFailureFlagDescription, {
            domain: `@${domain}`,
            product: product
        }),
        actions: [
            {
                content: intl.formatMessage((0, $fn6W9.messages).viralSettingsFailureFlagActionLabel),
                href: `${(0, $kx8ta.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
                target: '_blank'
            }
        ]
    };
};
const $a05e869f957fbf7c$export$f8472417a92ca559 = (openInviteEnabled, directAccessAllDomainsEnabled, domains, cloudId, product, intl)=>{
    let flags = [];
    if (openInviteEnabled && directAccessAllDomainsEnabled) return [
        $a05e869f957fbf7c$var$getViralSettingsSuccessFlag(domains, cloudId, product, intl)
    ];
    if (openInviteEnabled) flags.push($a05e869f957fbf7c$var$getOpenInviteSuccessFlag(cloudId, product, intl));
    else if (openInviteEnabled === false) flags.push($a05e869f957fbf7c$var$getOpenInviteFailureFlag(cloudId, product, intl));
    if (directAccessAllDomainsEnabled) flags.push($a05e869f957fbf7c$var$getDirectAccessSuccessFlag(domains, cloudId, product, intl));
    else if (directAccessAllDomainsEnabled === false) domains.forEach((domain)=>flags.push($a05e869f957fbf7c$var$getDirectAccessFailureFlag(domain, cloudId, product, intl)));
    return flags;
};

});


parcelRegister("5mSkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $568c367b0d699dd1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $jBZuc = parcelRequire("jBZuc");

var $6HEbe = parcelRequire("6HEbe");

var $aqemk = parcelRequire("aqemk");
const $568c367b0d699dd1$var$InvitePeopleIntlProvider = ({ children: children })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $aqemk.IntlProviderAnalytics));
    const { locale: locale } = (0, $koVbs.default)();
    const { messages: messages } = (0, $jBZuc.useFetchMessagesByLocale)(locale);
    const onErrorHandler = (0, $5uXOq.useCallback)((error)=>{
        analytics.translationMessageError({
            error: {
                locale: locale,
                errorMessage: error.message.trim()
            }
        });
    }, [
        analytics,
        locale
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        messages: messages,
        locale: locale,
        onError: onErrorHandler,
        children: children
    }, locale);
};
var $568c367b0d699dd1$export$2e2bcd8739ae039 = $568c367b0d699dd1$var$InvitePeopleIntlProvider;

});
parcelRegister("jBZuc", function(module, exports) {

$parcel$export(module.exports, "useFetchMessagesByLocale", () => $0270247c206a6219$export$5ac26fa9b941854e);
/* eslint-disable import/dynamic-import-chunkname */ 
var $5uXOq = parcelRequire("5uXOq");
const $0270247c206a6219$export$94d2d72df36bbb16 = [
    'en-GB',
    'en-US',
    'en-ZZ',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'es-ES',
    'et-EE',
    'fi-FI',
    'fr-FR',
    'hu-HU',
    'is-IS',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NB',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'th-TH',
    'uk-UK',
    'vi-VI',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];






























function $0270247c206a6219$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("gWDBY"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("hTK3A"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("glgNI"));
        case 'en-GB':
            return (parcelRequire("agzBe"));
        case 'en-US':
        case 'en':
            return (parcelRequire("41Gmo"));
        case 'en-ZZ':
            return (parcelRequire("b8T7n"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("huXIK"));
        case 'et-EE':
        case 'et':
            return (parcelRequire("ie0SU"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("1Y1SN"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("cTF0J"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("2PZhI"));
        case 'is-IS':
        case 'is':
            return (parcelRequire("gIi4E"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("cWVCL"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("a9fZP"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("63eMM"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("jTvIs"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("4UwYZ"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("05958"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("6PrDJ"));
        case 'pt-PT':
            return (parcelRequire("9wL7P"));
        case 'ro-RO':
        case 'ro':
            return (parcelRequire("7uaZE"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("7aC8R"));
        case 'sk-SK':
        case 'sk':
            return (parcelRequire("8Sdhb"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("0eH3J"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("92Hb0"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("3LLCr"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("a4OVs"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("lveIG"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("4FS4k"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("aSPd3"));
    }
    return Promise.resolve({
        default: {}
    });
}
function $0270247c206a6219$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $5uXOq.useState)({});
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                setIsLoading(true);
                const module = await $0270247c206a6219$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}

});
parcelRegister("gWDBY", function(module, exports) {

let $c560ca28c39adfbd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c560ca28c39adfbd$var$load("iev78").then(()=>parcelRequire('gRQrJ'));

});

parcelRegister("hTK3A", function(module, exports) {

let $d07b4ca8e57ca661$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d07b4ca8e57ca661$var$load("hOtz5").then(()=>parcelRequire('cUy6F'));

});

parcelRegister("glgNI", function(module, exports) {

let $be5ba3cdd9bed0d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be5ba3cdd9bed0d7$var$load("1bQae").then(()=>parcelRequire('3oe7z'));

});

parcelRegister("agzBe", function(module, exports) {

let $779703550a94de68$var$load = (parcelRequire("28QjX"))(4);
module.exports = $779703550a94de68$var$load("eAQHs").then(()=>parcelRequire('2PU1R'));

});

parcelRegister("41Gmo", function(module, exports) {

let $2ee81d485be24504$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2ee81d485be24504$var$load("gjY1R").then(()=>parcelRequire('10BKN'));

});

parcelRegister("b8T7n", function(module, exports) {

let $81cb325e635841cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81cb325e635841cd$var$load("7rMXw").then(()=>parcelRequire('dIBtT'));

});

parcelRegister("huXIK", function(module, exports) {

let $cbd3904afcf1eb14$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cbd3904afcf1eb14$var$load("imsAj").then(()=>parcelRequire('jdPpY'));

});

parcelRegister("ie0SU", function(module, exports) {

let $d44a3874ac43db4a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d44a3874ac43db4a$var$load("1qOPx").then(()=>parcelRequire('duSU8'));

});

parcelRegister("1Y1SN", function(module, exports) {

let $16ecdae71cd5af21$var$load = (parcelRequire("28QjX"))(4);
module.exports = $16ecdae71cd5af21$var$load("lDYS4").then(()=>parcelRequire('cre93'));

});

parcelRegister("cTF0J", function(module, exports) {

let $963a6f011d87779f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $963a6f011d87779f$var$load("agjXs").then(()=>parcelRequire('aEV1Q'));

});

parcelRegister("2PZhI", function(module, exports) {

let $210fe20d1f9726e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $210fe20d1f9726e0$var$load("oCABF").then(()=>parcelRequire('e3f9S'));

});

parcelRegister("gIi4E", function(module, exports) {

let $c2aec68186c953e5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c2aec68186c953e5$var$load("dVXbd").then(()=>parcelRequire('lVvPe'));

});

parcelRegister("cWVCL", function(module, exports) {

let $96d799c8e899d953$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96d799c8e899d953$var$load("4Ts2T").then(()=>parcelRequire('5pcKz'));

});

parcelRegister("a9fZP", function(module, exports) {

let $7637272ca2292106$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7637272ca2292106$var$load("fySWh").then(()=>parcelRequire('cHVW5'));

});

parcelRegister("63eMM", function(module, exports) {

let $467e7e041e4ab8ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $467e7e041e4ab8ce$var$load("lHlAt").then(()=>parcelRequire('g9HXg'));

});

parcelRegister("jTvIs", function(module, exports) {

let $e7bbc18b408c2846$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e7bbc18b408c2846$var$load("dd17F").then(()=>parcelRequire('9Goyd'));

});

parcelRegister("4UwYZ", function(module, exports) {

let $3935fa12cd792c07$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3935fa12cd792c07$var$load("dJGIV").then(()=>parcelRequire('l4Jlt'));

});

parcelRegister("05958", function(module, exports) {

let $00f783382d596f51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00f783382d596f51$var$load("5ejSL").then(()=>parcelRequire('gXDCE'));

});

parcelRegister("6PrDJ", function(module, exports) {

let $4f8cf22dc8f8fc48$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f8cf22dc8f8fc48$var$load("ceocz").then(()=>parcelRequire('bF5KC'));

});

parcelRegister("9wL7P", function(module, exports) {

let $6efba84eca8a0c85$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6efba84eca8a0c85$var$load("02ora").then(()=>parcelRequire('bU19U'));

});

parcelRegister("7uaZE", function(module, exports) {

let $5733dcce088a6bbf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5733dcce088a6bbf$var$load("8vmOG").then(()=>parcelRequire('8p4lX'));

});

parcelRegister("7aC8R", function(module, exports) {

let $53870dc70b27a30a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $53870dc70b27a30a$var$load("2OK0z").then(()=>parcelRequire('i6sUS'));

});

parcelRegister("8Sdhb", function(module, exports) {

let $675daa3dfb6d82e1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $675daa3dfb6d82e1$var$load("leL2S").then(()=>parcelRequire('ibFDt'));

});

parcelRegister("0eH3J", function(module, exports) {

let $000b660689ddfb26$var$load = (parcelRequire("28QjX"))(4);
module.exports = $000b660689ddfb26$var$load("4uQLu").then(()=>parcelRequire('31PzS'));

});

parcelRegister("92Hb0", function(module, exports) {

let $6955caec5db10ffb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6955caec5db10ffb$var$load("92ZqJ").then(()=>parcelRequire('dd3Pl'));

});

parcelRegister("3LLCr", function(module, exports) {

let $2beab30a95866d65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2beab30a95866d65$var$load("fko2T").then(()=>parcelRequire('kZC4a'));

});

parcelRegister("a4OVs", function(module, exports) {

let $7561c7eb28868a67$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7561c7eb28868a67$var$load("jvqmI").then(()=>parcelRequire('gIIpH'));

});

parcelRegister("lveIG", function(module, exports) {

let $fa77e941d79ef239$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa77e941d79ef239$var$load("kV9FT").then(()=>parcelRequire('af7DQ'));

});

parcelRegister("4FS4k", function(module, exports) {

let $3674eeb6b5aea599$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3674eeb6b5aea599$var$load("cocqi").then(()=>parcelRequire('5PFnk'));

});

parcelRegister("aSPd3", function(module, exports) {

let $7ec6abab41f994f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ec6abab41f994f4$var$load("gJFE8").then(()=>parcelRequire('50YSg'));

});


parcelRegister("aqemk", function(module, exports) {

$parcel$export(module.exports, "IntlProviderAnalytics", () => $361f57987d1ac71c$export$35b5385dadcb5bc3);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $361f57987d1ac71c$export$35b5385dadcb5bc3 extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    translationMessageError(attributes) {
        this.fireOperational({
            action: (0, $hatDq.AnalyticsAction).FAILED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).TRANSLATION_MESSAGE,
            attributes: attributes
        });
    }
}

});


parcelRegister("fkAmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bea42fea1a1cb121$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6HEbe = parcelRequire("6HEbe");

var $bACLO = parcelRequire("bACLO");

var $h2ncp = parcelRequire("h2ncp");

var $jZmOr = parcelRequire("jZmOr");
const $bea42fea1a1cb121$export$e926676385687eaf = (props)=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $h2ncp.ErrorBoundaryAnalytics));
    const { children: children, errorCallback: errorCallback } = props;
    const onError = (error, info)=>{
        analytics.errorBoundaryRendered({
            error: {
                message: error.message,
                stack: info?.componentStack || error.stack
            }
        });
        analytics.inviteFormFailedToLoad({
            message: error.message,
            stack: info?.componentStack || error.stack
        });
        errorCallback && errorCallback();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jZmOr.BaseErrorBoundary), {
        ErrorComponent: (0, $bACLO.ErrorScreen),
        onError: onError,
        children: children
    });
};
var $bea42fea1a1cb121$export$2e2bcd8739ae039 = $bea42fea1a1cb121$export$e926676385687eaf;

});
parcelRegister("bACLO", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $3e4a561b27030ee7$export$42f84e610f279c31);
/* ErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bWfiu = parcelRequire("bWfiu");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $7VOyo = parcelRequire("7VOyo");

var $fn6W9 = parcelRequire("fn6W9");
const $3e4a561b27030ee7$var$styles = {
    wrapper: "_1rjcoahv _18zroahv",
    contentWrapper: "_y3gn1h6o",
    imageWrapper: "_4t3iuuw1 _otyrxy5q",
    headingWrapper: "_p12fp3fh _otyr1ejb",
    messageWrapper: "_p12fp3fh"
};
const $3e4a561b27030ee7$export$42f84e610f279c31 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $3e4a561b27030ee7$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $3e4a561b27030ee7$var$styles.contentWrapper,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                    xcss: $3e4a561b27030ee7$var$styles.imageWrapper,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                        width: "100%",
                        height: "100%",
                        src: (0, $7VOyo.default),
                        alt: formatMessage((0, $fn6W9.messages).errorImageAltText)
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                    xcss: $3e4a561b27030ee7$var$styles.headingWrapper,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                        as: "h3",
                        size: "medium",
                        children: formatMessage((0, $fn6W9.messages).errorHeading)
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                    xcss: $3e4a561b27030ee7$var$styles.messageWrapper,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        as: "p",
                        children: formatMessage((0, $fn6W9.messages).errorText)
                    })
                })
            ]
        })
    });
};
var $3e4a561b27030ee7$export$2e2bcd8739ae039 = $3e4a561b27030ee7$export$42f84e610f279c31;

});
parcelRegister("7VOyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f6cc89b0f1a729$export$2e2bcd8739ae039);
var $48f6cc89b0f1a729$export$2e2bcd8739ae039 = `data:image/png;base64,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`;

});


parcelRegister("h2ncp", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryAnalytics", () => $9e388135309f0426$export$627f773fbbb39e);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $9e388135309f0426$export$627f773fbbb39e extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    errorBoundaryRendered(attributes) {
        const { productTitle: productTitle, source: source, subProduct: subProduct } = this.commonAttributes;
        this.fireOperational({
            action: (0, $hatDq.AnalyticsAction).RENDERED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).ERROR_BOUNDARY,
            attributes: {
                product: productTitle,
                source: source,
                subProduct: subProduct,
                ...attributes
            }
        });
    }
    inviteFormFailedToLoad(error) {
        const { source: source } = this.commonAttributes;
        this.fireOperational({
            action: (0, $hatDq.AnalyticsAction).FAILED,
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INVITE_FORM,
            attributes: {
                error: error,
                integration: source
            }
        });
    }
}

});

parcelRegister("jZmOr", function(module, exports) {

$parcel$export(module.exports, "BaseErrorBoundary", () => $deb983c1253006d0$export$688779ac61ee945f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $deb983c1253006d0$export$688779ac61ee945f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, info) {
        this.props.onError?.(error, info);
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError) return ErrorComponent ? /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorComponent, {}) : null;
        return children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}

});


parcelRegister("kPhww", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $1251c1e3f11e9d3f$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $1251c1e3f11e9d3f$export$37c25be427bec097);
const $1251c1e3f11e9d3f$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $1251c1e3f11e9d3f$var$hasPerformanceAPIAvailable = $1251c1e3f11e9d3f$var$isPerformanceAPIAvailable();
const $1251c1e3f11e9d3f$var$measureMap = new Map();
function $1251c1e3f11e9d3f$export$b62aa2130c86b59b(measureName) {
    if (!$1251c1e3f11e9d3f$var$hasPerformanceAPIAvailable) return;
    performance.mark(`${measureName}::start`);
    $1251c1e3f11e9d3f$var$measureMap.set(measureName, performance.now());
}
function $1251c1e3f11e9d3f$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!$1251c1e3f11e9d3f$var$hasPerformanceAPIAvailable) return;
    // `startMeasure` is not called with `measureName` before.
    if (!$1251c1e3f11e9d3f$var$measureMap.get(measureName)) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $1251c1e3f11e9d3f$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $1251c1e3f11e9d3f$export$6f766653554dac02(measureName);
    }
}
function $1251c1e3f11e9d3f$export$6f766653554dac02(measureName) {
    if (!$1251c1e3f11e9d3f$var$hasPerformanceAPIAvailable) return;
    $1251c1e3f11e9d3f$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});

parcelRegister("94SGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $204a6d56209442d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i92ym = parcelRequire("i92ym");
var $7Nt5L = parcelRequire("7Nt5L");

var $aKXjP = parcelRequire("aKXjP");

var $hatDq = parcelRequire("hatDq");

var $kx8ta = parcelRequire("kx8ta");

var $6HEbe = parcelRequire("6HEbe");

var $lWbFO = parcelRequire("lWbFO");

var $5Iax1 = parcelRequire("5Iax1");

var $daXvt = parcelRequire("daXvt");
const $204a6d56209442d5$var$SKIPPED_RESPONSE = {
    responseStatus: (0, $hatDq.InviteProcessingResponseStatus).SKIPPED,
    flags: []
};
const $204a6d56209442d5$var$isAcceptable = (errorMessage, statusCode)=>{
    return (0, $kx8ta.isAcceptableFailureForDirectAccess)(errorMessage, statusCode) || (0, $kx8ta.isAcceptableFailure)(errorMessage, statusCode);
};
const $204a6d56209442d5$var$useDirectAccessSettings = ({ selectedProducts: selectedProducts, viralSettingsDESEligibleStates: viralSettingsDESEligibleStates, isViralSettingsEnabled: isViralSettingsEnabled })=>{
    const { productId: productId, ...invitePeopleData } = (0, $daXvt.useInvitePeopleContext)();
    const cloudId = invitePeopleData.cloudId ?? '';
    const analytics = (0, $6HEbe.useAnalytics)((0, $5Iax1.InvitePeopleAnalytics));
    const { setViralSettingsHaveISeenIt: setViralSettingsHaveISeenIt } = (0, $aKXjP.default)();
    const processDirectAccessSettings = (0, $5uXOq.useCallback)(async ()=>{
        // Adding empty flag array in preparation for flags to be refactored from getViralSettingsFlags in near future
        if (!isViralSettingsEnabled || selectedProducts.length !== 1 || !cloudId) return $204a6d56209442d5$var$SKIPPED_RESPONSE;
        const product = selectedProducts[0];
        const { checked: domains, unchecked: uncheckedDomains } = viralSettingsDESEligibleStates;
        uncheckedDomains.forEach((domain)=>{
            const domainKey = (0, $i92ym.createHISIDomainFlagKey)(product, cloudId, domain);
            setViralSettingsHaveISeenIt(domainKey, product, domain);
        });
        // Only add request if there are domains to update
        if (domains.length === 0) return $204a6d56209442d5$var$SKIPPED_RESPONSE;
        const location = (0, $kx8ta.getDirectAccessLocation)(productId);
        try {
            (0, $lWbFO.domainsSettingsUpdated).start();
            (0, $lWbFO.inviteFormSubmitted).mark((0, $lWbFO.inviteFormSubmittedTimings).updateDirectAccessSettings.startMark);
            const response = await (0, $7Nt5L.defaultInviteApiClient).updateDirectAccessSettings({
                cloudId: cloudId,
                product: product,
                domains: domains,
                location: location
            });
            analytics.approvedDomainsSettingsSucceededSLO({
                addedDomains: domains
            });
            (0, $lWbFO.domainsSettingsUpdated).success();
            return {
                responseStatus: (0, $hatDq.InviteProcessingResponseStatus).SUCCESS,
                response: response,
                flags: []
            };
        } catch (err) {
            const { responseCode: responseCode, errorMessage: errorMessage, error: error } = (0, $kx8ta.resolveError)(err);
            analytics.approvedDomainsSettingsFailed({
                proposedDomains: domains,
                responseCode: responseCode,
                errorMessage: errorMessage
            });
            const isSuccess = $204a6d56209442d5$var$isAcceptable(errorMessage, responseCode);
            if (isSuccess) {
                // no domains were added so we will send an empty value for the addedDomains attribute
                analytics.approvedDomainsSettingsSucceededSLO({
                    addedDomains: []
                });
                (0, $lWbFO.domainsSettingsUpdated).success();
            } else {
                analytics.approvedDomainsSettingsFailedSLO({
                    proposedDomains: domains,
                    responseCode: responseCode,
                    errorMessage: errorMessage
                });
                (0, $lWbFO.domainsSettingsUpdated).failure();
            }
            return {
                responseStatus: (0, $hatDq.InviteProcessingResponseStatus).ERROR,
                error: error,
                flags: []
            };
        } finally{
            (0, $lWbFO.inviteFormSubmitted).mark((0, $lWbFO.inviteFormSubmittedTimings).updateDirectAccessSettings.endMark);
        }
    }, [
        analytics,
        cloudId,
        isViralSettingsEnabled,
        productId,
        selectedProducts,
        setViralSettingsHaveISeenIt,
        viralSettingsDESEligibleStates
    ]);
    return {
        processDirectAccessSettings: processDirectAccessSettings
    };
};
var $204a6d56209442d5$export$2e2bcd8739ae039 = $204a6d56209442d5$var$useDirectAccessSettings;

});
parcelRegister("aKXjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $047d16d4285d6ce7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3m2BQ = parcelRequire("3m2BQ");

var $9RrMz = parcelRequire("9RrMz");

var $6HEbe = parcelRequire("6HEbe");
const $047d16d4285d6ce7$var$useViralSettingsHaveISeenIt = ()=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $9RrMz.ViralSettingsAnalytics));
    const setViralSettingsHaveISeenIt = (0, $5uXOq.useCallback)((flagKey, product, domain)=>{
        return (0, $3m2BQ.defaultViralSettingsHisiClient).postFlagWithAnalytics({
            flagKey: flagKey,
            product: product,
            domain: domain
        }, analytics);
    }, [
        analytics
    ]);
    return {
        setViralSettingsHaveISeenIt: setViralSettingsHaveISeenIt
    };
};
var $047d16d4285d6ce7$export$2e2bcd8739ae039 = $047d16d4285d6ce7$var$useViralSettingsHaveISeenIt;

});


parcelRegister("a0kJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7beab37f61e945$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i92ym = parcelRequire("i92ym");
var $7Nt5L = parcelRequire("7Nt5L");

var $aKXjP = parcelRequire("aKXjP");

var $hatDq = parcelRequire("hatDq");

var $kx8ta = parcelRequire("kx8ta");

var $6HEbe = parcelRequire("6HEbe");

var $lWbFO = parcelRequire("lWbFO");

var $5Iax1 = parcelRequire("5Iax1");

var $daXvt = parcelRequire("daXvt");
const $6f7beab37f61e945$var$SKIPPED_RESPONSE = {
    responseStatus: (0, $hatDq.InviteProcessingResponseStatus).SKIPPED,
    flags: []
};
const $6f7beab37f61e945$var$useOpenInvite = ({ showOpenInvite: showOpenInvite, enableOpenInvite: enableOpenInvite, selectedProducts: selectedProducts, isViralSettingsEnabled: isViralSettingsEnabled })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $5Iax1.InvitePeopleAnalytics));
    const invitePeopleData = (0, $daXvt.useInvitePeopleContext)();
    const cloudId = invitePeopleData.cloudId ?? '';
    const { setViralSettingsHaveISeenIt: setViralSettingsHaveISeenIt } = (0, $aKXjP.default)();
    const processOpenInviteSettings = (0, $5uXOq.useCallback)(async ()=>{
        // Adding empty flag array in preparation for flags to be refactored from getViralSettingsFlags in near future
        if (!isViralSettingsEnabled || selectedProducts.length !== 1 || !cloudId) return $6f7beab37f61e945$var$SKIPPED_RESPONSE;
        const product = selectedProducts[0];
        if (!enableOpenInvite && showOpenInvite) {
            // If unchecked and open invite is shown
            const openInviteKey = (0, $i92ym.createHISIOpenInviteFlagKey)(product, cloudId);
            setViralSettingsHaveISeenIt(openInviteKey, product);
            return $6f7beab37f61e945$var$SKIPPED_RESPONSE;
        }
        if (!enableOpenInvite) return $6f7beab37f61e945$var$SKIPPED_RESPONSE;
        const productAri = (0, $kx8ta.makeAri)(product, cloudId);
        try {
            (0, $lWbFO.inviteSettingsUpdated).start();
            (0, $lWbFO.inviteFormSubmitted).mark((0, $lWbFO.inviteFormSubmittedTimings).updateOpenInviteSettings.startMark);
            const response = await (0, $7Nt5L.defaultOpenInviteClient).enableOpenInvite(product, cloudId);
            analytics.userInviteSettingsSucceededSLO({
                newState: 'enabled',
                productAri: productAri
            });
            (0, $lWbFO.inviteSettingsUpdated).success();
            return {
                responseStatus: (0, $hatDq.InviteProcessingResponseStatus).SUCCESS,
                response: response,
                flags: []
            };
        } catch (err) {
            const { responseCode: responseCode, errorMessage: errorMessage, error: error } = (0, $kx8ta.resolveError)(err);
            analytics.userInviteSettingsFailed({
                proposedNewState: 'enabled',
                productAri: productAri,
                responseCode: responseCode,
                errorMessage: errorMessage
            });
            if ((0, $kx8ta.isAcceptableFailure)(errorMessage, responseCode)) {
                // user invite setting state was not changed so we will send null as the newState attribute
                analytics.userInviteSettingsSucceededSLO({
                    newState: null,
                    productAri: productAri
                });
                (0, $lWbFO.inviteSettingsUpdated).success();
            } else {
                analytics.userInviteSettingsFailedSLO({
                    proposedNewState: 'enabled',
                    productAri: productAri,
                    responseCode: responseCode,
                    errorMessage: errorMessage
                });
                (0, $lWbFO.inviteSettingsUpdated).failure();
            }
            return {
                responseStatus: (0, $hatDq.InviteProcessingResponseStatus).ERROR,
                error: error,
                flags: []
            };
        } finally{
            (0, $lWbFO.inviteFormSubmitted).mark((0, $lWbFO.inviteFormSubmittedTimings).updateOpenInviteSettings.endMark);
        }
    }, [
        isViralSettingsEnabled,
        selectedProducts,
        cloudId,
        enableOpenInvite,
        showOpenInvite,
        setViralSettingsHaveISeenIt,
        analytics
    ]);
    return {
        processOpenInviteSettings: processOpenInviteSettings
    };
};
var $6f7beab37f61e945$export$2e2bcd8739ae039 = $6f7beab37f61e945$var$useOpenInvite;

});

parcelRegister("io72P", function(module, exports) {

$parcel$export(module.exports, "default", () => $565bf6c4e7d2cfd7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2VHHh = parcelRequire("2VHHh");

var $kx8ta = parcelRequire("kx8ta");

var $hatDq = parcelRequire("hatDq");

var $7Nt5L = parcelRequire("7Nt5L");
var $Zeu50 = parcelRequire("Zeu50");

var $lWbFO = parcelRequire("lWbFO");

var $lVAw3 = parcelRequire("lVAw3");

var $daXvt = parcelRequire("daXvt");

var $1CnPD = parcelRequire("1CnPD");

var $4gxY5 = parcelRequire("4gxY5");

var $86tbn = parcelRequire("86tbn");

var $evtmo = parcelRequire("evtmo");

var $6HEbe = parcelRequire("6HEbe");

var $5Iax1 = parcelRequire("5Iax1");

var $444qv = parcelRequire("444qv");
const $565bf6c4e7d2cfd7$var$useInviteUsers = ({ continueUrl: continueUrl, onInviteCompletedHandler: onInviteCompletedHandler, onReopenHandler: onReopenHandler })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $5Iax1.InvitePeopleAnalytics));
    const { cloudId: cloudId, productId: productId, source: source } = (0, $daXvt.useInvitePeopleContext)();
    const { selectedProducts: selectedProducts } = (0, $4gxY5.useProducts)();
    const { users: users, getExternalUserType: getExternalUserType, selectedSlackTeamUserEmails: selectedSlackTeamUserEmails, userPickerOptions: userPickerOptions } = (0, $1CnPD.useInviteeListStateContext)();
    const instanceUrl = (0, $kx8ta.getInstanceUrl)();
    const inviteUsersFlags = (0, $lVAw3.useInvitePeopleFlags)(onReopenHandler);
    const { confluenceXflowOnboarding: confluenceXflowOnboarding, invitePromptOnLinkV3: invitePromptOnLinkV3 } = (0, $444qv.useExperimentalFeatures)();
    const itpt = (0, $86tbn.useInviteThirdPartyTeams)();
    const fireInviteSuccessAnalytics = (0, $5uXOq.useCallback)(({ result: result, origin: origin, userPickerOptions: userPickerOptions, inviteFromSuccessModal: inviteFromSuccessModal })=>{
        const originAttributes = origin.toAnalyticsAttributes({
            hasGeneratedId: true
        });
        const { invited: invited, accessRequested: accessRequested } = result;
        const getExternalUserSubtype = (user)=>selectedSlackTeamUserEmails.has(user.email) ? 'slackChannel' : undefined;
        const getOption = (user)=>userPickerOptions?.find((option)=>(option.type === 'user' || option.type === 'external_user') && option.email === user.email && option.isExternal);
        invited.forEach((user)=>{
            const option = getOption(user);
            analytics.userInvited({
                originAttributes: originAttributes,
                userId: user.id,
                products: selectedProducts,
                inviteResult: user.results,
                externalUserType: getExternalUserType(user),
                externalUserSubtype: getExternalUserSubtype(user),
                isUserEmailVisible: (0, $hatDq.isUserWithEmail)(user),
                isAioliv3Enabled: invitePromptOnLinkV3,
                inviteFromSuccessModal: inviteFromSuccessModal,
                ...option ? {
                    sources: option.sources
                } : {}
            });
        });
        accessRequested.forEach((user)=>{
            const option = getOption(user);
            analytics.userAccessRequested({
                originAttributes: originAttributes,
                userId: user.id,
                products: selectedProducts,
                inviteResult: user.results,
                externalUserType: getExternalUserType(user),
                externalUserSubtype: getExternalUserSubtype(user),
                isUserEmailVisible: (0, $hatDq.isUserWithEmail)(user),
                isAioliv3Enabled: invitePromptOnLinkV3,
                ...option ? {
                    sources: option.sources
                } : {}
            });
        });
    }, [
        selectedSlackTeamUserEmails,
        selectedProducts,
        getExternalUserType,
        analytics,
        invitePromptOnLinkV3
    ]);
    const handleInviteFailureResponse = (0, $5uXOq.useCallback)(({ result: result, flags: flags })=>{
        const { failure: failure } = result;
        const { message: message, code: code, status: status } = failure;
        const inviteFormSubmittedConfig = {
            metadata: {
                inviteeCount: users.length,
                productCount: selectedProducts.length
            }
        };
        // There should not be a failure SLO event if the error is a user network failure error
        if (!(0, $kx8ta.isAcceptableFailureForUserInvite)(failure)) {
            if ((0, $kx8ta.shouldReportFailedInvite)(failure)) {
                (0, $lWbFO.inviteFormSubmitted).failure(inviteFormSubmittedConfig);
                analytics.inviteFailedSLO(itpt.isEnabled, invitePromptOnLinkV3, code, message, status);
                if (itpt.isEnabled || invitePromptOnLinkV3) (0, $lWbFO.parallelInviteRequestSubmitted).failure();
            } else {
                (0, $lWbFO.inviteFormSubmitted).success(inviteFormSubmittedConfig);
                analytics.inviteSucceededSLO(itpt.isEnabled, invitePromptOnLinkV3);
                if (itpt.isEnabled || invitePromptOnLinkV3) (0, $lWbFO.parallelInviteRequestSubmitted).success();
            }
        }
        const failureFlag = inviteUsersFlags.failure(result);
        onInviteCompletedHandler?.(result);
        if (failureFlag) flags.push(failureFlag);
    }, [
        users.length,
        selectedProducts.length,
        inviteUsersFlags,
        onInviteCompletedHandler,
        analytics,
        itpt.isEnabled,
        invitePromptOnLinkV3
    ]);
    const handleInviteSuccessResponse = (0, $5uXOq.useCallback)(({ result: result, origin: origin, flags: flags, userPickerOptions: userPickerOptions, inviteFromSuccessModal: inviteFromSuccessModal })=>{
        onInviteCompletedHandler?.(result);
        analytics.inviteSucceededSLO(itpt.isEnabled, invitePromptOnLinkV3);
        (0, $lWbFO.inviteFormSubmitted).success({
            metadata: {
                inviteeCount: result.invited.length + result.accessRequested.length,
                productCount: selectedProducts.length
            }
        });
        if (itpt.isEnabled || invitePromptOnLinkV3) (0, $lWbFO.parallelInviteRequestSubmitted).success();
        fireInviteSuccessAnalytics({
            result: result,
            origin: origin,
            userPickerOptions: userPickerOptions,
            inviteFromSuccessModal: inviteFromSuccessModal
        });
        const successFlag = inviteUsersFlags.success(result);
        if (successFlag) flags.push(successFlag);
        const errorFlag = inviteUsersFlags.error(result);
        if (errorFlag) flags.push(errorFlag);
    }, [
        onInviteCompletedHandler,
        analytics,
        itpt.isEnabled,
        selectedProducts.length,
        fireInviteSuccessAnalytics,
        inviteUsersFlags,
        invitePromptOnLinkV3
    ]);
    const inviteUsers = (0, $5uXOq.useCallback)(async (getRecaptchaToken, inviteFromSuccessModal)=>{
        let productContinueUrl = continueUrl;
        if (!productContinueUrl) productContinueUrl = selectedProducts.length === 1 ? `${instanceUrl}${(0, $kx8ta.getLandingPathByProduct)(selectedProducts[0])}` : instanceUrl;
        // Also try to find urls that forward newly invited users to jira setting pages and redirect them to a product landing page instead.
        // We should do this so newly invited users are not seeing a permission denied screen when accessing restricted pages.
        if (productContinueUrl.match(/.*\/jira.*\/settings/gim)) productContinueUrl = selectedProducts.length === 1 ? `${instanceUrl}${(0, $kx8ta.getLandingPathByProduct)(selectedProducts[0])}` : instanceUrl;
        const origin = new (0, $2VHHh.default)({
            product: productId
        });
        const productContinueUrlWithOrigin = origin.addToUrl(productContinueUrl);
        const inviteContinueUrl = `${productContinueUrlWithOrigin}&source=${source}`;
        const resources = selectedProducts.map((selectedProduct)=>`ari:cloud:${selectedProduct}::site/${cloudId}`);
        const inviteRequest = async (usersToInvite)=>{
            (0, $lWbFO.inviteFormSubmitted).mark((0, $lWbFO.inviteFormSubmittedTimings).getRecaptchaToken.startMark);
            const recaptchaToken = await getRecaptchaToken?.('v1_invitations_invite').catch(// If token generation fails we want to just continue with the
            // request without a recaptcha token (the lib will fire an event)
            ()=>undefined);
            (0, $lWbFO.inviteFormSubmitted).mark((0, $lWbFO.inviteFormSubmittedTimings).getRecaptchaToken.endMark);
            const recaptchaAction = `${productId}-${source}`;
            const recaptchaOptions = {
                recaptchaToken: recaptchaToken,
                recaptchaAction: recaptchaAction
            };
            try {
                let result;
                if (confluenceXflowOnboarding) result = await (0, $7Nt5L.defaultInviteApiClient).inviteUsersV3({
                    users: usersToInvite,
                    continueUrl: inviteContinueUrl,
                    resources: resources,
                    suppressInviteEmail: false
                }, recaptchaOptions);
                else result = await (0, $7Nt5L.defaultInviteApiClient).inviteUsers({
                    users: usersToInvite,
                    continueUrl: inviteContinueUrl,
                    resources: resources,
                    suppressInviteEmail: false
                }, recaptchaOptions);
                if ('failure' in result) {
                    const { message: message, code: code, status: status } = result.failure;
                    analytics.inviteRequestFailed(selectedProducts, !!recaptchaToken, code, message, status, inviteFromSuccessModal);
                } else {
                    const { invited: invited, accessRequested: accessRequested, error: error } = result;
                    analytics.inviteRequestSucceeded(selectedProducts, {
                        invited: invited.map((u)=>u.id),
                        accessRequested: accessRequested.map((u)=>u.id),
                        error: error.map(({ error: error })=>error)
                    }, !!recaptchaToken, inviteFromSuccessModal);
                }
                return result;
            } catch (err) {
                const { code: code, message: message, status: status } = (0, $evtmo.getErrorDetails)(err);
                analytics.inviteRequestFailed(selectedProducts, !!recaptchaToken, code, message, status, inviteFromSuccessModal);
                throw err;
            }
        };
        const inviteRequestParallel = async ()=>{
            const result = {
                invited: [],
                accessRequested: [],
                error: []
            };
            const userBatches = (0, $kx8ta.chunk)(users, (0, $Zeu50.INVITE_API_MAX_USERS));
            const responses = await Promise.allSettled(userBatches.map(async (userBatch)=>{
                try {
                    const response = await inviteRequest(userBatch);
                    if ('failure' in response) for (const user of userBatch)result.error.push({
                        ...user,
                        error: response.failure
                    });
                    else {
                        result.invited.push(...response.invited);
                        result.accessRequested.push(...response.accessRequested);
                        result.error.push(...response.error);
                    }
                    return response;
                } catch (err) {
                    for (const user of userBatch)result.error.push({
                        ...user,
                        error: {
                            code: err.code,
                            message: err.message || String(err)
                        }
                    });
                    throw err;
                }
            }));
            const rejectedResponse = responses.find((response)=>response.status === 'rejected');
            const successResponse = responses.find((response)=>response.status === 'fulfilled' && !('failure' in response.value));
            const failureResponse = responses.find((response)=>response.status === 'fulfilled' && 'failure' in response.value);
            if (rejectedResponse && !successResponse && !failureResponse) throw rejectedResponse.reason;
            if (!successResponse && failureResponse) return failureResponse.value;
            return result;
        };
        try {
            (0, $lWbFO.inviteFormSubmitted).mark((0, $lWbFO.inviteFormSubmittedTimings).inviteUsersPromise.startMark);
            if (itpt.isEnabled || invitePromptOnLinkV3) (0, $lWbFO.parallelInviteRequestSubmitted).start();
            const result = itpt.isEnabled || invitePromptOnLinkV3 ? await inviteRequestParallel() : await inviteRequest(users);
            (0, $lWbFO.inviteFormSubmitted).mark((0, $lWbFO.inviteFormSubmittedTimings).inviteUsersPromise.endMark);
            const flags = [];
            if ('failure' in result) handleInviteFailureResponse({
                result: result,
                flags: flags
            });
            else handleInviteSuccessResponse({
                result: result,
                origin: origin,
                flags: flags,
                userPickerOptions: userPickerOptions,
                inviteFromSuccessModal: inviteFromSuccessModal
            });
            return {
                responseStatus: (0, $hatDq.InviteProcessingResponseStatus).SUCCESS,
                response: result,
                flags: flags
            };
        } catch (err) {
            (0, $lWbFO.inviteFormSubmitted).mark((0, $lWbFO.inviteFormSubmittedTimings).inviteUsersPromise.endMark);
            const { code: code, message: message, status: status } = (0, $evtmo.getErrorDetails)(err);
            if (!(0, $kx8ta.isAcceptableFailure)(message, status)) analytics.inviteFailedSLO(itpt.isEnabled, invitePromptOnLinkV3, code, message, status);
            // TODO: add metadata indicating failure, migrate off custom SLO event to using UFO only
            (0, $lWbFO.inviteFormSubmitted).failure({
                metadata: {
                    inviteeCount: users.length,
                    productCount: selectedProducts.length
                }
            });
            if (itpt.isEnabled || invitePromptOnLinkV3) (0, $lWbFO.parallelInviteRequestSubmitted).failure();
            return {
                responseStatus: (0, $hatDq.InviteProcessingResponseStatus).ERROR,
                error: err,
                flags: [
                    inviteUsersFlags.genericError()
                ]
            };
        }
    }, [
        continueUrl,
        productId,
        selectedProducts,
        instanceUrl,
        cloudId,
        analytics,
        users,
        itpt.isEnabled,
        handleInviteFailureResponse,
        handleInviteSuccessResponse,
        inviteUsersFlags,
        confluenceXflowOnboarding,
        userPickerOptions,
        invitePromptOnLinkV3,
        source
    ]);
    return {
        inviteUsers: inviteUsers
    };
};
var $565bf6c4e7d2cfd7$export$2e2bcd8739ae039 = $565bf6c4e7d2cfd7$var$useInviteUsers;

});
parcelRegister("lVAw3", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleFlags", () => $5768fed0ed79d801$export$ab5fb7206b83c9ad);

var $koVbs = parcelRequire("koVbs");

var $daXvt = parcelRequire("daXvt");

var $1CnPD = parcelRequire("1CnPD");

var $4gxY5 = parcelRequire("4gxY5");

var $dVrjr = parcelRequire("dVrjr");
const $5768fed0ed79d801$export$ab5fb7206b83c9ad = (onReopenHandler)=>{
    const { cloudId: cloudId, userRole: userRole } = (0, $daXvt.useInvitePeopleContext)();
    const { selectedProducts: selectedProducts } = (0, $4gxY5.useProducts)();
    const { users: users, getName: getName } = (0, $1CnPD.useInviteeListStateContext)();
    const intl = (0, $koVbs.default)();
    return {
        failure: (result)=>(0, $dVrjr.getFailureFlag)(result, cloudId, userRole, users, selectedProducts, intl),
        error: (result)=>(0, $dVrjr.getErrorFlag)(result, userRole, getName, intl),
        genericError: ()=>(0, $dVrjr.getGenericErrorFlag)(userRole, intl),
        success: (result)=>(0, $dVrjr.getSuccessFlag)(result, selectedProducts, getName, intl, onReopenHandler)
    };
};

});
parcelRegister("dVrjr", function(module, exports) {

$parcel$export(module.exports, "getSuccessFlag", () => $9bc3e2892c6f2d23$export$dbe4723f1df81b00);
$parcel$export(module.exports, "getErrorFlag", () => $9bc3e2892c6f2d23$export$7a23a73c35436772);
$parcel$export(module.exports, "getGenericErrorFlag", () => $9bc3e2892c6f2d23$export$cb537c6a6762d3e3);
$parcel$export(module.exports, "getFailureFlag", () => $9bc3e2892c6f2d23$export$facdb825a1c5a8e0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bMdrA = parcelRequire("bMdrA");

var $5E93O = parcelRequire("5E93O");

var $IoPSi = parcelRequire("IoPSi");

var $k9nuy = parcelRequire("k9nuy");


var $hatDq = parcelRequire("hatDq");

var $kx8ta = parcelRequire("kx8ta");

var $fn6W9 = parcelRequire("fn6W9");
const $9bc3e2892c6f2d23$export$86072b504af31b29 = (responseArray, getName)=>{
    if (!responseArray.length) return '';
    return (0, $hatDq.isUserWithEmail)(responseArray[0]) ? responseArray[0].email : getName(responseArray[0].id);
};
const $9bc3e2892c6f2d23$export$dbe4723f1df81b00 = (result, products, getName, intl, onReopenHandler)=>{
    const { invited: invited = [], accessRequested: accessRequested = [] } = result;
    let successTitle = (0, $fn6W9.messages).genericSuccessFlagTitle;
    if (invited.length || accessRequested.length) {
        let descriptionMessage = (0, $fn6W9.messages).hybridSuccessFlagDescription;
        const isInviteOnly = invited.length && !accessRequested.length;
        const isAccessRequestOnly = !invited.length && accessRequested.length;
        if (isInviteOnly) {
            if (products.length === 1) descriptionMessage = (0, $fn6W9.messages).inviteSuccessFlagDescriptionSingleProductEmail;
            else descriptionMessage = (0, $fn6W9.messages).inviteSuccessFlagDescriptionMultiProductEmail;
        } else if (isAccessRequestOnly) {
            descriptionMessage = (0, $fn6W9.messages).requestAccessSuccessFlagDescription;
            successTitle = (0, $fn6W9.messages).requestAccessSuccessFlagTitle;
        } else if (invited.length === 1 && accessRequested.length === 1) {
            descriptionMessage = (0, $fn6W9.messages).hybridSuccessFlagDescriptionOneEach;
            successTitle = (0, $fn6W9.messages).hybridSuccessFlagTitle;
        }
        const formattedMessageValues = {
            inviteCount: invited.length,
            requestAccessCount: accessRequested.length,
            emailInvited: $9bc3e2892c6f2d23$export$86072b504af31b29(invited, getName),
            emailRequestedAccess: $9bc3e2892c6f2d23$export$86072b504af31b29(accessRequested, getName),
            product: products.length > 1 ? null : (0, $kx8ta.getProductTitle)(products[0]),
            productCount: products.length,
            b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                    as: "strong",
                    children: chunks
                }),
            p: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                    as: "p",
                    children: chunks
                })
        };
        return {
            appearance: 'success',
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
                label: "success",
                spacing: "spacious",
                color: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$exports).G400})`,
                LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
            }),
            title: intl.formatMessage(successTitle),
            description: intl.formatMessage(descriptionMessage, {
                ...formattedMessageValues,
                invitedHybridPluralCoreInvitesOptimisation: intl.formatMessage((0, $fn6W9.messages).invitedHybridPlural, formattedMessageValues),
                requestAccessHybridPluralCoreInvitesOptimisation: intl.formatMessage((0, $fn6W9.messages).requestAccessHybridPlural, formattedMessageValues)
            }),
            actions: onReopenHandler ? [
                {
                    content: intl.formatMessage((0, $fn6W9.messages).addMorePeopleActionLabel),
                    onClick: onReopenHandler
                }
            ] : []
        };
    }
    return null;
};
const $9bc3e2892c6f2d23$export$7a23a73c35436772 = (result, userRole, getName, intl)=>{
    const { error: error } = result;
    const isAdmin = userRole === 'admin';
    if (error && error.length) return {
        appearance: 'error',
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
            label: "error",
            spacing: "spacious",
            color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$exports).R400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
        }),
        title: intl.formatMessage((0, $fn6W9.messages).inviteFailedFlagTitle, {
            isAdmin: isAdmin,
            failedInviteCount: error.length
        }),
        description: intl.formatMessage((0, $fn6W9.messages).inviteFailedFlagDescription, {
            isAdmin: isAdmin,
            emailFailedToInvite: $9bc3e2892c6f2d23$export$86072b504af31b29(error, getName),
            failedInviteCount: error.length,
            b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                    as: "strong",
                    children: chunks
                })
        }),
        actions: isAdmin ? [
            {
                content: intl.formatMessage((0, $fn6W9.messages).contactSupportActionLabel),
                href: 'https://support.atlassian.com/contact/',
                target: '_blank'
            }
        ] : []
    };
    return null;
};
const $9bc3e2892c6f2d23$export$cb537c6a6762d3e3 = (userRole, intl)=>{
    const isAdmin = userRole === 'admin';
    return {
        appearance: 'error',
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
            label: "error",
            spacing: "spacious",
            color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$exports).R400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
        }),
        title: intl.formatMessage((0, $fn6W9.messages).genericFailedFlagTitle),
        description: intl.formatMessage((0, $fn6W9.messages).genericFailedFlagDescription, {
            isAdmin: isAdmin
        }),
        actions: isAdmin ? [
            {
                content: intl.formatMessage((0, $fn6W9.messages).contactSupportActionLabel),
                href: 'https://support.atlassian.com/contact/',
                target: '_blank'
            }
        ] : []
    };
};
const $9bc3e2892c6f2d23$export$facdb825a1c5a8e0 = (result, cloudId, userRole, failedUsers, products, intl)=>{
    const { failure: failure } = result;
    if (!failure) return null;
    if (failure.code !== 'licence-exceeded') return $9bc3e2892c6f2d23$export$cb537c6a6762d3e3(userRole, intl);
    const billingUrl = (0, $kx8ta.getBillingUrl)(products, cloudId);
    return {
        appearance: 'warning',
        icon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($IoPSi))), {
            label: failure.code,
            color: `var(--ds-icon-warning, ${(0, $a7f8c6b391092279$exports).Y300})`,
            LEGACY_secondaryColor: `var(--ds-icon-warning-inverse, ${(0, $a7f8c6b391092279$exports).N0})`
        }),
        title: intl.formatMessage((0, $fn6W9.messages).licenceExceededFlagTitle, {
            failedInviteCount: failedUsers.length
        }),
        description: intl.formatMessage((0, $fn6W9.messages).licenceExceededFlagDescription, {
            failedInviteCount: failedUsers.length,
            userRole: userRole
        }),
        actions: userRole === 'admin' ? [
            {
                content: intl.formatMessage((0, $fn6W9.messages).upgradePlanActionLabel),
                href: billingUrl,
                target: '_blank'
            },
            {
                content: intl.formatMessage((0, $fn6W9.messages).viewUsersActionLabel),
                href: `${(0, $kx8ta.CLOUD_ADMIN_URL)}/s/${cloudId}/users`,
                target: '_blank'
            }
        ] : []
    };
};

});



parcelRegister("h23hB", function(module, exports) {

$parcel$export(module.exports, "CoreInvitesDriveMultiProductInvitesContext", () => $e4c91a8c3bdffb44$export$adf29e99a652dd15);
$parcel$export(module.exports, "useCoreInvitesDriveMultiProductInvitesContext", () => $e4c91a8c3bdffb44$export$31955ec55e0414bf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3pEK0 = parcelRequire("3pEK0");

var $6HEbe = parcelRequire("6HEbe");

var $hQIJN = parcelRequire("hQIJN");

var $daXvt = parcelRequire("daXvt");

var $7Nt5L = parcelRequire("7Nt5L");

var $444qv = parcelRequire("444qv");

var $4gxY5 = parcelRequire("4gxY5");

var $hatDq = parcelRequire("hatDq");

var $1CnPD = parcelRequire("1CnPD");

var $gnr0Q = parcelRequire("gnr0Q");

var $koVbs = parcelRequire("koVbs");

var $kx8ta = parcelRequire("kx8ta");
const $e4c91a8c3bdffb44$var$EligibleProducts = [
    'jira',
    'jira-software',
    'confluence',
    'jira-product-discovery'
];
const $e4c91a8c3bdffb44$export$74ed2505e2fae856 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $e4c91a8c3bdffb44$export$adf29e99a652dd15 = ({ children: children })=>{
    const { coreInvitesDriveMultiProductInvites: coreInvitesDriveMultiProductInvites } = (0, $444qv.useExperimentalFeatures)();
    const analytics = (0, $6HEbe.useAnalytics)((0, $hQIJN.Analytics));
    const { inviteCapabilities: inviteCapabilities, isFetchProductsLoading: isFetchProductsLoading } = (0, $4gxY5.useProducts)();
    const { getName: getName, getUser: getUser } = (0, $1CnPD.useInviteeListStateContext)();
    const { cloudId: cloudId, productId: productId } = (0, $daXvt.useInvitePeopleContext)();
    const [isCoreInvitesDriveMultiProductInvitesEnabled, setIsCoreInvitesDriveMultiProductInvitesEnabled] = (0, $5uXOq.useState)(false);
    const { locale: locale } = (0, $koVbs.default)();
    const cohort = (0, $3pEK0.getExperimentCohort)({
        fireExposure: false
    });
    const isEnrolled = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $kx8ta.isEnglishLocale)(locale)) return false;
        if (coreInvitesDriveMultiProductInvites && !isFetchProductsLoading) {
            if (inviteCapabilities?.directInvite.length === 0) {
                analytics.eligibilityChecked('NO_INVITE_PERMISSIONS');
                return false;
            }
            if (!$e4c91a8c3bdffb44$var$EligibleProducts.includes(productId)) {
                analytics.eligibilityChecked('PRODUCT_NOT_ELIGIBLE');
                return false;
            }
            return coreInvitesDriveMultiProductInvites && (cohort === (0, $3pEK0.VARIATION) || cohort === (0, $3pEK0.CONTROL));
        }
        return false;
    }, [
        analytics,
        inviteCapabilities?.directInvite.length,
        coreInvitesDriveMultiProductInvites,
        isFetchProductsLoading,
        productId,
        cohort,
        locale
    ]);
    const getEligibleUsersAndProducts = (0, $5uXOq.useCallback)(async (invitedUsers, invitedProducts)=>{
        if (cloudId) {
            const userIds = invitedUsers.flatMap((user)=>user.id ? user.id : []);
            const filteredEligibleProducts = inviteCapabilities.directInvite.map((product)=>product.id).filter((x)=>!invitedProducts.includes(x) && $e4c91a8c3bdffb44$var$EligibleProducts.includes(x));
            if (filteredEligibleProducts.length === 0) {
                analytics.eligibilityChecked('NO_ELIGIBLE_PRODUCTS');
                return {
                    products: [],
                    users: []
                };
            }
            const productsAndUsers = await (0, $7Nt5L.defaultPermsApiClient).getUsersWithoutAccess(cloudId, filteredEligibleProducts, userIds);
            const { users: users, products: products } = (0, $gnr0Q.filterUsersAndProductsForDisplay)(productsAndUsers);
            const usersWithEmail = invitedUsers.filter((user)=>users.includes(user?.id || '')).map((user)=>{
                const nameOrEmail = (0, $hatDq.isUserWithEmail)(user) ? user.email : getName(user.id);
                const userPickerOption = getUser(user.id);
                return userPickerOption || {
                    id: user.id,
                    email: nameOrEmail,
                    name: nameOrEmail
                };
            });
            const formattedUsersAndProducts = {
                products: products,
                users: usersWithEmail
            };
            if (users.length === 0) {
                analytics.eligibilityChecked('NO_ELIGIBLE_USERS');
                return formattedUsersAndProducts;
            }
            if (products.length === 0) {
                analytics.eligibilityChecked('NO_ELIGIBLE_PRODUCTS');
                return formattedUsersAndProducts;
            }
            analytics.eligibilityChecked('ELIGIBLE');
            (0, $3pEK0.fireStatsigFeatureExposedEvent)();
            analytics.featureExposed();
            if (cohort === (0, $3pEK0.VARIATION)) setIsCoreInvitesDriveMultiProductInvitesEnabled(true);
            return formattedUsersAndProducts;
        }
        return {
            products: [],
            users: []
        };
    }, [
        analytics,
        cloudId,
        cohort,
        getName,
        getUser,
        inviteCapabilities.directInvite
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e4c91a8c3bdffb44$export$74ed2505e2fae856.Provider, {
        value: {
            isCoreInvitesDriveMultiProductInvitesEnabled: isCoreInvitesDriveMultiProductInvitesEnabled,
            cohort: cohort,
            getEligibleUsersAndProducts: getEligibleUsersAndProducts,
            isEnrolled: isEnrolled
        },
        children: children
    });
};
const $e4c91a8c3bdffb44$export$31955ec55e0414bf = ()=>{
    const state = (0, $5uXOq.useContext)($e4c91a8c3bdffb44$export$74ed2505e2fae856);
    if (state === undefined) throw new Error('useCoreInvitesDriveMultiProductInvitesContext must be used within a CoreInvitesDriveMultiProductInvitesProvider');
    return state;
};

});
parcelRegister("3pEK0", function(module, exports) {

$parcel$export(module.exports, "CORE_INVITES_DRIVE_MULTI_PRODUCT_INVITES", () => $bf72c6175499039d$export$9e93d4abae182337);
$parcel$export(module.exports, "CONTROL", () => $bf72c6175499039d$export$43f367b3e957f219);
$parcel$export(module.exports, "VARIATION", () => $bf72c6175499039d$export$fa04ad826acc90da);
$parcel$export(module.exports, "fireStatsigFeatureExposedEvent", () => $bf72c6175499039d$export$182cbf21e9131eab);
$parcel$export(module.exports, "getExperimentCohort", () => $bf72c6175499039d$export$d297da143e393306);

var $96Irh = parcelRequire("96Irh");
const $bf72c6175499039d$export$9e93d4abae182337 = 'core_invites_drive_multi_product_invites';
const $bf72c6175499039d$export$5b7423264d48ab04 = 'not-enrolled';
const $bf72c6175499039d$export$43f367b3e957f219 = 'control';
const $bf72c6175499039d$export$fa04ad826acc90da = 'variation';
const $bf72c6175499039d$export$182cbf21e9131eab = ()=>{
    (0, $96Irh.default).manuallyLogExperimentExposure($bf72c6175499039d$export$9e93d4abae182337);
};
const $bf72c6175499039d$export$d297da143e393306 = ({ fireExposure: fireExposure } = {
    fireExposure: false
})=>{
    if ((0, $96Irh.default).initializeCalled()) return (0, $96Irh.default).getExperimentValue($bf72c6175499039d$export$9e93d4abae182337, 'cohort', $bf72c6175499039d$export$5b7423264d48ab04, {
        fireExperimentExposure: fireExposure
    });
    return $bf72c6175499039d$export$5b7423264d48ab04;
};
const $bf72c6175499039d$export$336b018592dc9972 = ()=>$bf72c6175499039d$export$d297da143e393306({
        fireExposure: false
    }) === $bf72c6175499039d$export$fa04ad826acc90da;

});

parcelRegister("hQIJN", function(module, exports) {

$parcel$export(module.exports, "Analytics", () => $9cb362e9dbc888d1$export$2b3af6baec22bd98);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");

var $3pEK0 = parcelRequire("3pEK0");
class $9cb362e9dbc888d1$export$2b3af6baec22bd98 extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    eligibilityChecked(ineligibilityReason) {
        this.fireTrack({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).ELIGIBILITY,
            action: (0, $hatDq.AnalyticsAction).CHECKED,
            attributes: {
                flagKey: (0, $3pEK0.CORE_INVITES_DRIVE_MULTI_PRODUCT_INVITES),
                ineligibilityReason: ineligibilityReason
            }
        });
    }
    featureExposed() {
        this.fireTrack({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).INVITE_PEOPLE_FEATURE,
            action: (0, $hatDq.AnalyticsAction).EXPOSED,
            attributes: {
                flagKey: (0, $3pEK0.CORE_INVITES_DRIVE_MULTI_PRODUCT_INVITES),
                cohort: (0, $3pEK0.getExperimentCohort)({
                    fireExposure: true
                })
            }
        });
    }
}

});

parcelRegister("gnr0Q", function(module, exports) {

$parcel$export(module.exports, "filterUsersAndProductsForDisplay", () => $d37f985f6214c14c$export$2f1d2627f841f7b4);
// Order of this array is important, as it determine priority of products
const $d37f985f6214c14c$var$EligibleProducts = [
    'jira',
    'jira-software',
    'confluence',
    'jira-product-discovery'
];
const $d37f985f6214c14c$export$2f1d2627f841f7b4 = (productsAndUsers)=>{
    const users = [
        ...new Set(Object.values(productsAndUsers).flat())
    ];
    const products = Object.keys(productsAndUsers).filter((product)=>users.every((user)=>productsAndUsers[product].includes(user)));
    if (products.length === 0) for (const product of $d37f985f6214c14c$var$EligibleProducts){
        if (productsAndUsers[product]?.length > 0) return {
            products: [
                product
            ],
            users: productsAndUsers[product]
        };
    }
    return {
        products: products,
        users: users
    };
};

});


const $c2b60d1cbe5ffbe3$export$a0c5ea4233e1cf17 = 30;

parcelRegister("14Qmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab7fa39a258339ac$export$2e2bcd8739ae039);
/* NoInvitePermission.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bWfiu = parcelRequire("bWfiu");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $k9nuy = parcelRequire("k9nuy");

var $clxo5 = parcelRequire("clxo5");

var $6QlEX = parcelRequire("6QlEX");

var $6HEbe = parcelRequire("6HEbe");

var $lWbFO = parcelRequire("lWbFO");

var $kx8ta = parcelRequire("kx8ta");

var $daXvt = parcelRequire("daXvt");

var $fn6W9 = parcelRequire("fn6W9");

var $7J4VB = parcelRequire("7J4VB");

var $1bkVf = parcelRequire("1bkVf");

var $bnY52 = parcelRequire("bnY52");
const $ab7fa39a258339ac$var$styles = {
    formWrapper: "_195g1wug _kqswh2mm _p12f1j8x",
    descriptionWrapper: "_1moupxbi",
    buttonWrapper: "_2lx21sbv _1n261q9c _otyrpxbi",
    spinnerWrapper: "_1mouxncg _195gxncg _18m91wug",
    headingWrapper: "_1q511ejb _85i5v77o",
    footer: "_otyr1ejb"
};
const $ab7fa39a258339ac$var$NoInvitePermission = ({ onAcknowledgeButtonClick: onAcknowledgeButtonClick })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $7J4VB.NoInvitePermissionAnalytics));
    const { jiraSubProduct: jiraSubProduct, orgId: orgId, productId: productId, userRole: userRole } = (0, $daXvt.useInvitePeopleContext)();
    const { failedGetOpenInviteNote: failedGetOpenInviteNote, isLoading: isFetchingOpenInviteNote, openInviteNote: openInviteNote } = (0, $bnY52.default)(orgId);
    (0, $5uXOq.useEffect)(()=>{
        (0, $lWbFO.noInvitePermissionRendered).addMetadata({
            orgId: orgId,
            userRole: userRole
        });
        (0, $lWbFO.noInvitePermissionRendered).start();
    }, [
        orgId,
        userRole
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isFetchingOpenInviteNote) (0, $lWbFO.noInvitePermissionRendered).success({
            metadata: {
                orgId: orgId,
                userRole: userRole,
                failedGetOpenInviteNote: failedGetOpenInviteNote
            }
        });
    }, [
        failedGetOpenInviteNote,
        isFetchingOpenInviteNote,
        orgId,
        userRole
    ]);
    (0, $5uXOq.useEffect)(()=>{
        analytics.viewedNoInvitePermissionScreen();
    }, [
        analytics
    ]);
    const Wrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
            testId: "testId-no-invite-permission",
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                xcss: $ab7fa39a258339ac$var$styles.formWrapper,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                        spread: "space-between",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $ab7fa39a258339ac$var$styles.headingWrapper,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                                as: "h2",
                                id: "invite-people-title",
                                size: "medium",
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...(0, $fn6W9.messages).noInvitePermissionTitle
                                })
                            })
                        })
                    }),
                    children
                ]
            })
        });
    if (isFetchingOpenInviteNote) return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
            alignBlock: "center",
            alignInline: "center",
            testId: "testId-no-invite-permission-spinner",
            xcss: $ab7fa39a258339ac$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {})
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                alignBlock: "center",
                xcss: $ab7fa39a258339ac$var$styles.descriptionWrapper,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1bkVf.default), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        as: "p",
                        testId: "testId-no-invite-permission-description",
                        children: !!openInviteNote ? openInviteNote : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $fn6W9.messages).defaultNoInvitePermissionDescription,
                            values: {
                                productName: (0, $kx8ta.getProductTitle)(jiraSubProduct || productId)
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $ab7fa39a258339ac$var$styles.footer,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                    space: "space.100",
                    xcss: $ab7fa39a258339ac$var$styles.buttonWrapper,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6QlEX.default), {
                        actionSubjectId: 'closeNoInvitePermissionButton',
                        appearance: "primary",
                        onClick: onAcknowledgeButtonClick,
                        type: "button",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $fn6W9.messages).noInvitePermissionButtonTitle
                        })
                    })
                })
            })
        ]
    });
};
var $ab7fa39a258339ac$export$2e2bcd8739ae039 = $ab7fa39a258339ac$var$NoInvitePermission;

});
parcelRegister("7J4VB", function(module, exports) {

$parcel$export(module.exports, "NoInvitePermissionAnalytics", () => $efc2cffa899f5d47$export$35663e3a57687cac);

var $lp06J = parcelRequire("lp06J");

var $hatDq = parcelRequire("hatDq");
class $efc2cffa899f5d47$export$35663e3a57687cac extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    viewedNoInvitePermissionScreen() {
        const { disableNoInviteError: disableNoInviteError, inviteFromAssignModalCohort: inviteFromAssignModalCohort, orgId: orgId, source: source, userRole: userRole } = this.commonAttributes;
        this.fireScreen({
            name: (0, $hatDq.AnalyticsActionSubject).NO_INVITE_PERMOISSION_SCREEN,
            attributes: {
                disableNoInviteError: disableNoInviteError,
                inviteFromAssignModalCohort: inviteFromAssignModalCohort,
                orgId: orgId,
                source: source,
                userRole: userRole
            }
        });
    }
    getLinkedOrgSent(attributes) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).FETCH_LINKED_ORG,
            action: (0, $hatDq.AnalyticsAction).SENT,
            attributes: {
                source: source,
                userRole: userRole,
                ...attributes
            }
        });
    }
    getOpenInviteNoteSent(attributes) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).FETCH_OPEN_INVITE_NOTE,
            action: (0, $hatDq.AnalyticsAction).SENT,
            attributes: {
                source: source,
                userRole: userRole,
                ...attributes
            }
        });
    }
}

});

parcelRegister("1bkVf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c888542d1c41b79$export$2e2bcd8739ae039);
/* LazyLoadWarningIllustration.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $5sRpy = parcelRequire("5sRpy");

var $jZmOr = parcelRequire("jZmOr");
const $6c888542d1c41b79$var$styles = {
    wrapper: "_2hwxpxbi",
    placeholder: "_1bsbvbgk _4t3io7ol"
};

const $6c888542d1c41b79$var$LazyLoadedWarningIllustration = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("kG9sh")).catch((err)=>{
        throw err;
    }));
const $6c888542d1c41b79$var$Placeholder = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($6c888542d1c41b79$var$styles.wrapper, $6c888542d1c41b79$var$styles.placeholder),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
            xcss: $6c888542d1c41b79$var$styles.placeholder
        })
    });
var $6c888542d1c41b79$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jZmOr.BaseErrorBoundary), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($6c888542d1c41b79$var$Placeholder, {}),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: (0, $6tzHJ.cx)($6c888542d1c41b79$var$styles.wrapper, $6c888542d1c41b79$var$styles.placeholder),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($6c888542d1c41b79$var$LazyLoadedWarningIllustration, {})
            })
        })
    });

});
parcelRegister("kG9sh", function(module, exports) {

let $f0df108191e297dd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f0df108191e297dd$var$load("dv3Hf").then(()=>parcelRequire('hw9IE'));

});


parcelRegister("bnY52", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f8fc47bfb0b16ae$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6HEbe = parcelRequire("6HEbe");

var $lWbFO = parcelRequire("lWbFO");

var $7Nt5L = parcelRequire("7Nt5L");

var $kx8ta = parcelRequire("kx8ta");

var $7J4VB = parcelRequire("7J4VB");
var $3f8fc47bfb0b16ae$export$2e2bcd8739ae039 = (orgId)=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(!!orgId);
    const [openInviteNote, setOpenInviteNote] = (0, $5uXOq.useState)(undefined);
    const analytics = (0, $6HEbe.useAnalytics)((0, $7J4VB.NoInvitePermissionAnalytics));
    (0, $5uXOq.useEffect)(()=>{
        const getCustomisedErrorMessage = async ()=>{
            if (!isLoading || !orgId) return;
            let note;
            try {
                (0, $lWbFO.noInvitePermissionRendered).mark((0, $lWbFO.noInvitePermissionRenderedTimings).getOpenInviteNote.startMark);
                const response = await (0, $7Nt5L.defaultOpenInviteClient).getOpenInviteNote(orgId);
                // TODO: remove hardcoded responseCode once available from fetchJson
                analytics.getOpenInviteNoteSent({
                    orgId: orgId,
                    responseCode: 200
                });
                note = response.note;
            } catch (err) {
                const { errorMessage: errorMessage, responseCode: responseCode } = (0, $kx8ta.resolveError)(err);
                analytics.getOpenInviteNoteSent({
                    errorMessage: errorMessage,
                    orgId: orgId,
                    responseCode: responseCode
                });
            } finally{
                (0, $lWbFO.noInvitePermissionRendered).mark((0, $lWbFO.noInvitePermissionRenderedTimings).getOpenInviteNote.endMark);
            }
            setOpenInviteNote(note);
            setIsLoading(false);
        };
        getCustomisedErrorMessage();
    }, [
        analytics,
        isLoading,
        orgId,
        setOpenInviteNote
    ]);
    return {
        isLoading: isLoading,
        openInviteNote: openInviteNote,
        failedGetOpenInviteNote: !isLoading && !!orgId && openInviteNote === undefined
    };
};

});


parcelRegister("h0W5W", function(module, exports) {

$parcel$export(module.exports, "InviteSuccessContent", () => $25385b804b4ddb11$export$97aaf6c084b9ef59);
/* InviteSuccessContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $44cng = parcelRequire("44cng");

var $bWfiu = parcelRequire("bWfiu");

var $5sRpy = parcelRequire("5sRpy");
var $AX5oF = parcelRequire("AX5oF");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $6HEbe = parcelRequire("6HEbe");

var $6QlEX = parcelRequire("6QlEX");

var $hatDq = parcelRequire("hatDq");

var $fn6W9 = parcelRequire("fn6W9");

var $arcC3 = parcelRequire("arcC3");

var $1wiIH = parcelRequire("1wiIH");

var $4gxY5 = parcelRequire("4gxY5");

var $Q1cKJ = parcelRequire("Q1cKJ");

var $1bYNe = parcelRequire("1bYNe");
const $25385b804b4ddb11$var$styles = {
    wrapper: "_1rjc1ejb _18zr1ejb",
    productCheckboxWrapper: "_1q51v47k _85i51ejb _1i53muej _15a5nqa1 _uwhke4h9 _19pk1ejb",
    inviteSuccessDescription: "_ca0qpxbi"
};
const $25385b804b4ddb11$export$97aaf6c084b9ef59 = ({ availableProducts: availableProducts, invitees: invitees, invitedProducts: invitedProducts, successfulInviteText: successfulInviteText, isSendingInvitation: isSendingInvitation, onCancelButtonClick: onCancelButtonClick, onInviteButtonClick: onInviteButtonClick })=>{
    const analytics = (0, $6HEbe.useAnalytics)((0, $1wiIH.InviteSuccessContentAnalytics));
    const jiraProduct = availableProducts.find((product)=>product === 'jira-software');
    const confluenceProduct = availableProducts.find((product)=>product === 'confluence');
    const jpdProduct = availableProducts.find((product)=>product === 'jira-product-discovery');
    const invitedProduct = invitedProducts.find((productId)=>productId === 'jira-software') ?? invitedProducts.find((productId)=>productId === 'confluence') ?? invitedProducts.find((productId)=>productId === 'jira-product-discovery') ?? invitedProducts[0];
    const { selectedProducts: selectedProducts, setSelectedProducts: setSelectedProducts } = (0, $4gxY5.useProducts)();
    const { getRecaptchaToken: getRecaptchaToken, isRecaptchaLoading: isRecaptchaLoading } = (0, $1bYNe.default)();
    const attributes = (0, $5uXOq.useMemo)(()=>({
            products: availableProducts,
            invitees: invitees.length
        }), [
        availableProducts,
        invitees.length
    ]);
    (0, $5uXOq.useEffect)(()=>{
        analytics.driveMultiProductsSuccessModalViewed(attributes);
    }, [
        analytics,
        attributes
    ]);
    const handleAddButtonClick = async ()=>{
        await onInviteButtonClick(selectedProducts, true, getRecaptchaToken);
    };
    const handleProductCheckboxChange = (isChecked, productId)=>{
        if (isChecked) {
            setSelectedProducts([
                ...selectedProducts,
                productId
            ]);
            analytics.productCheckboxChecked(productId);
        } else {
            setSelectedProducts(selectedProducts.filter((product)=>product !== productId));
            analytics.productCheckboxUnchecked(productId);
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
        testId: "testId-invite-people-invite-success-content",
        xcss: $25385b804b4ddb11$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                alignBlock: "center",
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Q1cKJ.Success), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                        size: "medium",
                        children: successfulInviteText.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
                xcss: $25385b804b4ddb11$var$styles.inviteSuccessDescription,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                    children: successfulInviteText.description
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                xcss: $25385b804b4ddb11$var$styles.productCheckboxWrapper,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                        alignBlock: "center",
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44cng.default), {
                                data: invitees.map((member, index)=>({
                                        key: member.id,
                                        src: member.avatarUrl,
                                        name: member.name
                                    })),
                                maxCount: 3
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...(0, $fn6W9.messages).multiProductInviteAddProductHelper,
                                    values: {
                                        user: invitees[0].name,
                                        count: invitees.length,
                                        b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                                as: "strong",
                                                children: chunks
                                            })
                                    }
                                })
                            })
                        ]
                    }),
                    jiraProduct && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $arcC3.default), {
                        pairedProductId: invitedProduct,
                        productId: jiraProduct,
                        onChange: handleProductCheckboxChange
                    }),
                    confluenceProduct && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $arcC3.default), {
                        pairedProductId: invitedProduct,
                        productId: confluenceProduct,
                        onChange: handleProductCheckboxChange
                    }),
                    jpdProduct && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $arcC3.default), {
                        pairedProductId: invitedProduct,
                        productId: jpdProduct,
                        onChange: handleProductCheckboxChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $AX5oF.default), {
                justifyContent: "end",
                gap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6QlEX.default), {
                        actionSubjectId: (0, $hatDq.AnalyticsActionSubjectId).EXIT_DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL,
                        appearance: "subtle",
                        isDisabled: isSendingInvitation,
                        onClick: onCancelButtonClick,
                        analyticsAttributes: attributes,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $fn6W9.messages).multiProductInviteCancelButton
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6QlEX.default), {
                        actionSubjectId: (0, $hatDq.AnalyticsActionSubjectId).SUBMIT_DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL,
                        appearance: "primary",
                        type: "submit",
                        isLoading: isSendingInvitation || isRecaptchaLoading,
                        isDisabled: selectedProducts.length === 0,
                        onClick: handleAddButtonClick,
                        analyticsAttributes: {
                            ...attributes,
                            selectedProducts: selectedProducts
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $fn6W9.messages).multiProductInviteSubmitButton
                        })
                    })
                ]
            })
        ]
    });
};
var $25385b804b4ddb11$export$2e2bcd8739ae039 = $25385b804b4ddb11$export$97aaf6c084b9ef59;

});
parcelRegister("arcC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7abd6c0c31d2697f$export$2e2bcd8739ae039);
/* ProductCheckbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $5sRpy = parcelRequire("5sRpy");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $kx8ta = parcelRequire("kx8ta");

var $fn6W9 = parcelRequire("fn6W9");
const $7abd6c0c31d2697f$var$styles = {
    label: "_2rkopd34 _1rjcu2gc _18zru2gc _1e0c1txw _4cvr1h6o _19pkpxbi _80omtlke",
    uncheckedLabel: "_bfhkm7j4 _irr315ej",
    checkedLabel: "_bfhkfg4m _irr3i1yw",
    iconBox: "_2rkopd34 _1e0c1txw _1bah1h6o _4cvr1h6o _1o9zidpf _4t3i10mc _1bsb10mc _2hwxutpp",
    textStack: "_16jlkb7n _2hwxu2gc"
};
const $7abd6c0c31d2697f$export$f23db7c1097e3bcc = ({ productId: productId, pairedProductId: pairedProductId, onChange: onChange })=>{
    const [isChecked, setIsChecked] = (0, $5uXOq.useState)(false);
    const ProductIcon = (0, $kx8ta.getProductIcon)(productId);
    const productPairingMessage = $7abd6c0c31d2697f$var$getProductPairingMessageDescriptor({
        productId: productId,
        pairedProductId: pairedProductId
    });
    const handleProductCheckboxChange = (0, $5uXOq.useCallback)((productSelected)=>{
        setIsChecked(productSelected);
        onChange?.(productSelected, productId);
    }, [
        onChange,
        productId
    ]);
    const iconAppearance = isChecked ? 'inverse' : 'brand';
    const iconBackground = isChecked ? 'color.background.brand.bold' : 'color.background.input.pressed';
    const mainTextColor = isChecked ? 'color.text.selected' : 'color.text';
    const textColor = isChecked ? 'color.text.selected' : 'color.text.subtle';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        className: (0, $bwpsq.default)([
            $7abd6c0c31d2697f$var$styles.label,
            isChecked ? $7abd6c0c31d2697f$var$styles.checkedLabel : $7abd6c0c31d2697f$var$styles.uncheckedLabel
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $7abd6c0c31d2697f$var$styles.iconBox,
                backgroundColor: iconBackground,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(ProductIcon, {
                    appearance: iconAppearance,
                    size: "medium",
                    // Removes the default aria-label as it would repeat the product name
                    // which we render separately on screen:
                    label: ""
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                xcss: $7abd6c0c31d2697f$var$styles.textStack,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        color: mainTextColor,
                        children: (0, $kx8ta.getProductTitle)(productId)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        size: "small",
                        color: textColor,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...productPairingMessage,
                            values: {
                                invitedProduct: (0, $kx8ta.getProductTitle)(pairedProductId)
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                type: "checkbox",
                onChange: ()=>handleProductCheckboxChange(!isChecked),
                // Necessary only for Safari; allows to render focus styles:
                tabIndex: 0
            })
        ]
    });
};
var $7abd6c0c31d2697f$export$2e2bcd8739ae039 = $7abd6c0c31d2697f$export$f23db7c1097e3bcc;
function $7abd6c0c31d2697f$var$getProductPairingMessageDescriptor({ productId: productId, pairedProductId: pairedProductId }) {
    const productIds = [
        productId,
        pairedProductId
    ];
    if (productIds.includes('jira-software') && productIds.includes('confluence')) return (0, $fn6W9.messages).multiInviteProductCheckboxDescriptionJiraAndConfluence;
    if (productIds.includes('jira-software') && productIds.includes('jira-product-discovery')) return (0, $fn6W9.messages).multiInviteProductCheckboxDescriptionJiraAndJpd;
    if (productIds.includes('confluence') && productIds.includes('jira-product-discovery')) return (0, $fn6W9.messages).multiInviteProductCheckboxDescriptionConfluenceAndJpd;
    return (0, $fn6W9.messages).multiInviteProductCheckboxDescriptionDefault;
}

});

parcelRegister("1wiIH", function(module, exports) {

$parcel$export(module.exports, "InviteSuccessContentAnalytics", () => $ad186859b42a1387$export$6b29ddbe45651456);

var $hatDq = parcelRequire("hatDq");

var $lp06J = parcelRequire("lp06J");
class $ad186859b42a1387$export$6b29ddbe45651456 extends (0, $lp06J.BaseInvitePeopleAnalytics) {
    driveMultiProductsSuccessModalViewed(attributes) {
        this.fireScreen({
            name: (0, $hatDq.AnalyticsActionSubject).DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL,
            attributes: attributes
        });
    }
    productCheckboxChecked(product) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).PRODUCT_CHECKBOX,
            action: (0, $hatDq.AnalyticsAction).CHECKED,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubject).DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL,
            attributes: {
                product: product
            }
        });
    }
    productCheckboxUnchecked(product) {
        this.fireUI({
            actionSubject: (0, $hatDq.AnalyticsActionSubject).PRODUCT_CHECKBOX,
            action: (0, $hatDq.AnalyticsAction).UNCHECKED,
            actionSubjectId: (0, $hatDq.AnalyticsActionSubject).DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL,
            attributes: {
                product: product
            }
        });
    }
}

});

parcelRegister("Q1cKJ", function(module, exports) {

$parcel$export(module.exports, "Success", () => $d2a189f2b1c08af3$export$ffa3d9fee6fd705a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $d2a189f2b1c08af3$export$ffa3d9fee6fd705a = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "53",
        height: "55",
        viewBox: "-6 -5 65 65",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M36.9025 14.176L36.8552 14.1618L11.9827 40.001L11.9992 40.046L52.5994 54.2065L36.9025 14.176Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.4537 3.76419L22.0091 14.1855L8.29297 12.0015L8.37097 7.97855L8.4537 3.76419Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M33.6903 20.8225H28.9725L24.3445 7.0614H29.0623L33.6903 20.8225Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.532 36.9449L19.4588 36.7487C19.038 35.6378 18.3148 34.6876 17.3646 34.0045C16.3955 33.3072 15.2562 32.9385 14.0697 32.9385C12.8831 32.9385 11.7462 33.3072 10.7748 34.0045C9.82458 34.6876 9.10131 35.6378 8.68058 36.7487L8.60731 36.9449H4.41895L4.50404 36.5738C5.00749 34.3898 6.2224 32.4091 7.92658 30.998C8.77985 30.2912 9.7324 29.7429 10.7559 29.3623C11.8171 28.97 12.9304 28.7714 14.0673 28.7714C15.2042 28.7714 16.3175 28.97 17.3788 29.3623C18.4046 29.7405 19.3548 30.2912 20.208 30.998C21.9122 32.4091 23.1295 34.3898 23.6306 36.5738L23.7157 36.9449H19.5273H19.532Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M11.7037 22.9805C11.8479 22.8576 11.9874 22.7134 12.1197 22.5527C12.2521 22.392 12.3679 22.2218 12.4625 22.0516C13.0179 21.0518 12.8525 20.0189 12.115 19.1869C11.9897 19.0451 11.8479 18.908 11.6895 18.7803C11.5312 18.6527 11.3563 18.5298 11.1837 18.4305C10.217 17.8774 9.17464 17.92 8.30954 18.6574C8.163 18.7827 8.02118 18.9269 7.88645 19.0923C7.75409 19.2554 7.64064 19.4209 7.54845 19.5863C6.99536 20.5791 7.16318 21.6096 7.89827 22.4487C8.02827 22.5976 8.17482 22.7394 8.34027 22.8742C8.50573 23.0089 8.65936 23.1153 8.82482 23.2098C9.78918 23.7676 10.8339 23.7251 11.7014 22.9805H11.7037Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M30.9388 30.2936C31.083 30.1707 31.2225 30.0265 31.3548 29.8658C31.4872 29.7051 31.603 29.5349 31.6976 29.3647C32.253 28.3649 32.0876 27.332 31.3501 26.5C31.2248 26.3581 31.083 26.2211 30.9247 26.0934C30.7663 25.9658 30.5914 25.8429 30.4188 25.7436C29.4521 25.1905 28.4097 25.2331 27.5447 25.9705C27.3981 26.0958 27.2563 26.24 27.1216 26.4054C26.9868 26.5709 26.8757 26.734 26.7836 26.8994C26.2305 27.8921 26.3983 28.9227 27.1334 29.7618C27.2634 29.9107 27.4099 30.0525 27.5754 30.1872C27.7408 30.322 27.8945 30.4283 28.0599 30.5229C29.0243 31.0807 30.069 31.0381 30.9365 30.2936H30.9388Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19.4563 36.7487L19.5296 36.9449H23.7179L23.6329 36.5738C23.1554 34.4938 22.0279 32.5982 20.449 31.2036L17.5867 34.1794C18.4258 34.846 19.071 35.7276 19.4563 36.7487Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M33.6903 20.8225L32.8488 18.3218L30.4426 20.8225H33.6903Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M20.2749 19.2375L18.0872 23.7351L22.5847 25.9229L24.7725 21.4253L20.2749 19.2375Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.58621 26.2991C7.63112 26.2589 7.67603 26.2376 7.72331 26.2045C7.77058 26.188 7.82021 26.1549 7.87458 26.1502C7.87458 26.1502 7.91003 26.1549 7.9644 26.1644C8.01876 26.1856 8.0944 26.1998 8.17003 26.24C8.32367 26.3062 8.45367 26.4433 8.57185 26.5355C8.70894 26.838 8.73258 27.202 8.89094 27.5707C8.89094 27.5707 8.9524 27.6818 9.06112 27.7882C9.17222 27.8922 9.32821 27.9655 9.41331 27.9584C9.51967 27.9465 9.58585 27.9064 9.61421 27.8544C9.64258 27.8024 9.63312 27.7385 9.59294 27.6818C9.54567 27.6251 9.4913 27.5755 9.38494 27.4691C9.38731 27.462 9.38731 27.4478 9.3944 27.4407C9.26676 27.3296 9.21712 27.1216 9.17931 26.9018C9.13676 26.6796 9.10367 26.4125 8.91694 26.1478C8.89331 26.1738 8.85785 26.1715 8.86258 26.1478L8.90276 26.1289C8.82949 26.0533 8.74676 25.9895 8.68058 25.9233C8.60731 25.8665 8.5364 25.8098 8.46076 25.7649C8.31185 25.6845 8.14403 25.6278 7.94549 25.6916L7.99512 25.6373C7.64531 25.6042 7.28603 25.7625 7.04494 25.9351C6.79203 26.1076 6.57458 26.2944 6.37603 26.3842C6.27676 26.4291 6.18694 26.4551 6.09949 26.4456C6.01203 26.448 5.91749 26.4125 5.8324 26.3747C5.68349 26.292 5.57003 26.1289 5.48021 25.8949L5.47549 25.902H5.4684C5.46367 25.9516 5.47785 26.084 5.51331 26.188C5.52749 26.2447 5.55112 26.2849 5.56767 26.3204C5.58185 26.3582 5.5984 26.3724 5.5984 26.3724C5.42112 26.3346 5.33131 26.1502 5.30058 25.9705C5.26512 25.7862 5.27221 25.5853 5.19894 25.3985L5.25331 25.382C5.30767 25.5475 5.37149 25.6798 5.41167 25.7271C5.38567 25.5853 5.35967 25.4009 5.27221 25.1764C5.19185 24.9589 5.01694 24.6824 4.7404 24.5358C4.48512 24.3916 4.16603 24.3491 3.90131 24.42C3.63894 24.4885 3.47112 24.6209 3.35294 24.7225C3.38603 24.7509 3.50422 24.5642 3.62003 24.6658C3.47585 24.7391 3.36476 24.8455 3.25367 24.9258C3.19931 24.8525 3.28203 24.8313 3.28676 24.8076C3.25367 24.8147 3.16149 24.8691 3.03858 24.9471C2.91567 25.0227 2.75731 25.1315 2.59894 25.1811C2.44531 25.2331 2.28694 25.2213 2.12621 25.1386C1.97967 25.0653 1.88512 24.9116 1.80003 24.6895C1.71967 24.4673 1.65349 24.2049 1.54003 23.9662C1.43367 23.7251 1.24221 23.5171 1.07203 23.432C0.989305 23.3824 0.916033 23.3611 0.859306 23.354C0.804942 23.3445 0.767123 23.3445 0.750578 23.3564C0.715123 23.3776 0.762396 23.4415 0.875851 23.5431L0.826214 23.5715C1.07912 23.7275 1.19021 23.9685 1.19967 24.2664C1.21858 24.3042 1.21149 24.3113 1.2564 24.2971C1.26585 24.3065 1.28476 24.3184 1.30367 24.3089C1.41003 24.2687 1.39821 24.3751 1.41003 24.4129C1.23749 24.4389 1.28476 24.6658 1.4124 24.9116C1.47385 25.0345 1.57549 25.148 1.66058 25.226C1.75512 25.3016 1.83076 25.3465 1.85912 25.3631C1.82131 25.434 1.87567 25.4907 1.95603 25.5073C2.03167 25.5309 2.1144 25.5404 2.14985 25.5805C2.14276 25.5853 2.09312 25.6136 2.08603 25.616C2.09785 25.6396 2.19476 25.6846 2.33421 25.6775C2.47367 25.6846 2.6344 25.6207 2.76203 25.5569C3.00785 25.4127 3.15203 25.2544 3.07167 25.4435C3.42621 25.3205 3.7784 25.0298 4.07622 25.0109C4.21567 24.9967 4.39058 25.0487 4.51112 25.1386C4.63167 25.2284 4.72149 25.4033 4.79949 25.6207C4.87749 25.8382 4.93894 26.0911 5.06894 26.3511C5.13276 26.4787 5.22021 26.6111 5.33603 26.7198C5.44949 26.8309 5.58894 26.9089 5.7284 26.9633C6.00258 27.0744 6.34294 27.0626 6.59112 26.9633C6.84403 26.8735 7.03785 26.7529 7.21276 26.6725L7.19149 26.6631C7.20567 26.6607 7.22931 26.6324 7.25058 26.6465C7.2884 26.5756 7.37349 26.4764 7.44676 26.4055C7.52003 26.3322 7.58621 26.2896 7.58621 26.2896V26.2991ZM4.96967 25.46C4.96967 25.46 4.96021 25.46 4.95785 25.4624C4.9744 25.4553 4.8964 25.2851 4.89167 25.2804L4.94131 25.2567C5.13512 25.3986 4.89167 25.9398 4.92476 25.4931C4.90822 25.4836 4.95076 25.4695 4.96731 25.46H4.96967ZM3.70512 24.9093C3.6744 24.9187 3.64131 24.9353 3.60585 24.9518C3.73821 24.7651 4.02658 24.6469 4.29131 24.732C4.5584 24.8053 4.75221 24.9896 4.90349 25.1787C4.82785 25.174 4.7664 25.1575 4.71676 25.1244C4.65767 25.1031 4.62221 25.0558 4.57021 25.0275C4.54658 25.0109 4.52531 24.9896 4.50167 24.9707C4.47567 24.9542 4.44967 24.9376 4.42367 24.9211C4.3764 24.8833 4.31967 24.8691 4.27712 24.8525C4.18258 24.862 4.0904 24.862 3.99112 24.8644C3.89421 24.8691 3.79022 24.8856 3.7004 24.9116L3.70512 24.9093ZM1.42185 24.6847L1.39349 24.6918L1.38876 24.6776C1.38876 24.6776 1.40531 24.6753 1.41003 24.6776C1.41712 24.6776 1.42185 24.6824 1.42185 24.6871V24.6847ZM7.33803 26.2873C7.33803 26.3416 7.22458 26.3889 7.24112 26.2707C7.26712 26.2707 7.29312 26.2022 7.33803 26.2873ZM3.25603 25.1315C3.3104 25.2047 3.18985 25.3182 3.11422 25.2142C3.15676 25.1787 3.2064 25.1551 3.25603 25.1315ZM8.38276 26.1667C8.47731 26.1124 8.40167 26.1927 8.37331 26.2471C8.37331 26.2305 8.34731 26.2069 8.3804 26.1762V26.1667H8.38276ZM8.82712 26.7695C8.87676 26.7647 8.91931 26.7978 8.9264 26.8167C8.90749 26.8782 8.79403 26.8049 8.82712 26.7695ZM9.38021 27.8378C9.41331 27.7953 9.44403 27.7929 9.4204 27.8425C9.39676 27.8756 9.34949 27.8804 9.38258 27.826C9.38258 27.826 9.38022 27.8331 9.38258 27.8378H9.38021ZM2.5564 25.3135C2.55167 25.2307 2.58003 25.2118 2.62021 25.2071C2.6604 25.1953 2.7124 25.1953 2.73131 25.1622C2.79276 25.3087 2.62731 25.2638 2.59658 25.2969C2.58003 25.3016 2.56821 25.3064 2.55876 25.3135H2.5564ZM6.18931 26.6064C6.18221 26.5355 6.20821 26.5236 6.24367 26.526C6.27912 26.526 6.3264 26.526 6.34294 26.5071L6.36185 26.5591C6.33112 26.5756 6.30985 26.5969 6.28385 26.6111C6.25785 26.6205 6.22949 26.6206 6.19167 26.604H6.18931V26.6064ZM3.85403 24.5122C3.87767 24.4436 3.96276 24.4886 4.00058 24.4815C4.00767 24.5595 3.85403 24.602 3.85403 24.5122ZM5.22021 25.2969C5.14221 25.3371 5.15403 25.252 5.13749 25.2355C5.15876 25.2425 5.22021 25.2473 5.22494 25.2638C5.22731 25.2756 5.22021 25.2827 5.21785 25.2969H5.22021ZM6.14203 26.6678C6.08767 26.6655 6.02622 26.6702 5.97185 26.6489L5.98367 26.5945C6.03567 26.6135 6.09003 26.6064 6.14203 26.6111V26.6678ZM5.6764 26.4196L5.71185 26.3771C5.79694 26.37 5.72131 26.4929 5.6764 26.4196ZM6.7944 26.2991C6.7944 26.2991 6.77076 26.3086 6.76367 26.3133C6.6644 26.3913 6.68803 26.1242 6.7944 26.2991ZM7.39003 25.8429C7.39949 25.8287 7.41367 25.8051 7.43021 25.798C7.54367 25.7673 7.4704 25.9304 7.39003 25.8429Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M20.4231 6.63835C20.4822 6.62181 20.5318 6.62654 20.5886 6.61708C20.6382 6.62417 20.6996 6.61708 20.7493 6.63835C20.7493 6.63835 20.7776 6.65963 20.8226 6.69035C20.8627 6.7329 20.9242 6.78017 20.9715 6.85108C21.0778 6.98108 21.1298 7.16308 21.196 7.29781C21.1818 7.63108 21.0353 7.96435 21.0093 8.36617C21.0093 8.36617 21.014 8.49381 21.0613 8.63799C21.1133 8.78217 21.2196 8.9169 21.2976 8.94763C21.3969 8.98545 21.4749 8.98072 21.5246 8.94763C21.5718 8.91454 21.5955 8.85308 21.5836 8.78454C21.5671 8.71363 21.5411 8.64272 21.4962 8.5009C21.5033 8.49617 21.508 8.48435 21.5175 8.48199C21.4536 8.32599 21.5056 8.11799 21.5718 7.9029C21.6356 7.68544 21.7255 7.43254 21.6806 7.11344C21.6475 7.12526 21.6167 7.10872 21.6333 7.08744H21.6758C21.6451 6.98581 21.6026 6.89126 21.5718 6.80381C21.5316 6.71872 21.4938 6.63599 21.4489 6.56508C21.352 6.42563 21.2291 6.30035 21.0235 6.2649L21.0944 6.2389C20.7989 6.04981 20.4066 6.02617 20.1111 6.07108C19.8086 6.1089 19.5296 6.17744 19.3098 6.16563C19.2011 6.1609 19.1113 6.14199 19.0356 6.09472C18.9553 6.0569 18.8891 5.98126 18.83 5.91035C18.7331 5.76854 18.7095 5.57235 18.7331 5.32417L18.726 5.3289H18.7213C18.6929 5.36672 18.6456 5.49199 18.6315 5.60072C18.6126 5.70944 18.622 5.80399 18.622 5.80399C18.4802 5.68817 18.4849 5.4849 18.5393 5.31235C18.5913 5.13272 18.6882 4.95781 18.7095 4.7569L18.7638 4.76635C18.7378 4.9389 18.7331 5.08544 18.7473 5.14454C18.7898 5.00744 18.8489 4.83017 18.8749 4.59144C18.9033 4.36217 18.8726 4.03599 18.6929 3.78072C18.5298 3.5349 18.2675 3.3529 17.998 3.29381C17.7333 3.23708 17.5229 3.27726 17.374 3.31272C17.3906 3.3529 17.582 3.23944 17.6364 3.38363C17.4733 3.38363 17.3267 3.42617 17.192 3.44744C17.1778 3.35763 17.2606 3.37654 17.2747 3.35763C17.2416 3.34817 17.1353 3.35526 16.9911 3.36708C16.8469 3.3789 16.6578 3.40253 16.4924 3.37653C16.3316 3.3529 16.1969 3.27017 16.0906 3.12363C15.9936 2.99126 15.9795 2.81163 16.0055 2.5729C16.0338 2.33654 16.0953 2.07417 16.1047 1.80944C16.1189 1.54472 16.0433 1.27526 15.9322 1.12163C15.8826 1.0389 15.8258 0.989262 15.7786 0.956171C15.7336 0.92308 15.7006 0.906535 15.6793 0.908898C15.6391 0.911262 15.6509 0.989262 15.7053 1.13344H15.6486C15.8046 1.39108 15.7904 1.65581 15.6651 1.92763C15.6651 1.97017 15.6556 1.97253 15.7029 1.97963C15.7076 1.99144 15.7195 2.01272 15.7384 2.01035C15.8518 2.02453 15.7904 2.11199 15.7856 2.15217C15.6202 2.09781 15.5587 2.31999 15.5611 2.5989C15.5611 2.73599 15.5966 2.88253 15.6391 2.99363C15.6887 3.10235 15.736 3.17799 15.7526 3.20635C15.6864 3.25126 15.71 3.32926 15.7715 3.3789C15.8282 3.43563 15.8991 3.48054 15.9109 3.53254C15.9015 3.53254 15.8471 3.5349 15.8376 3.5349C15.8376 3.56326 15.9038 3.64599 16.0315 3.70272C16.152 3.77363 16.3246 3.79017 16.4664 3.79017C16.75 3.77363 16.9509 3.69799 16.7949 3.83035C17.166 3.88235 17.6127 3.78308 17.8869 3.90126C18.0193 3.95326 18.1493 4.07854 18.2155 4.21563C18.2816 4.35035 18.2816 4.5489 18.2533 4.77817C18.2249 5.00744 18.1635 5.26035 18.1611 5.55108C18.1611 5.69526 18.1776 5.85126 18.232 6.00017C18.284 6.15144 18.3715 6.28381 18.4707 6.3949C18.6646 6.61944 18.9718 6.76363 19.2389 6.78963C19.506 6.82272 19.7329 6.80617 19.9244 6.81326L19.9102 6.79435C19.9244 6.79908 19.9575 6.78254 19.9693 6.80617C20.0355 6.76126 20.156 6.70926 20.2553 6.6809C20.3546 6.64781 20.4326 6.64072 20.4326 6.64072L20.4231 6.63835ZM18.4755 4.70017C18.4755 4.70017 18.4684 4.69781 18.4636 4.70017C18.4802 4.70017 18.4873 4.51581 18.4873 4.50872H18.544C18.6527 4.72617 18.1895 5.0949 18.4211 4.71199C18.4093 4.69544 18.4566 4.70254 18.4755 4.70254V4.70017ZM17.6033 3.63181C17.5702 3.62472 17.5347 3.62708 17.4969 3.62472C17.7002 3.51835 18.0122 3.54672 18.2084 3.7429C18.4116 3.92963 18.5015 4.18254 18.5487 4.4189C18.4849 4.38108 18.4353 4.33617 18.4069 4.28654C18.3644 4.24163 18.3549 4.18253 18.3218 4.1329C18.3076 4.1069 18.2982 4.07854 18.2864 4.05017C18.2698 4.02417 18.2556 3.99817 18.2391 3.97217C18.2131 3.91544 18.1706 3.87763 18.1398 3.84217C18.05 3.80672 17.9696 3.76417 17.8798 3.72399C17.79 3.68381 17.6907 3.65072 17.6009 3.63417L17.6033 3.63181ZM15.6722 2.39326L15.6438 2.38617V2.36963C15.6438 2.36963 15.6627 2.37435 15.6651 2.37908C15.6698 2.38144 15.6746 2.38853 15.6722 2.3909V2.39326ZM20.2104 6.51544C20.1844 6.56272 20.0638 6.55563 20.13 6.45635C20.1513 6.46817 20.208 6.41854 20.2104 6.51544ZM17.1046 3.62472C17.1211 3.71454 16.9604 3.76181 16.9415 3.63417C16.9958 3.62235 17.0502 3.62235 17.1046 3.62472ZM21.196 6.88417C21.3047 6.87944 21.2007 6.91726 21.1511 6.95035C21.1582 6.93617 21.1464 6.90308 21.1913 6.8889L21.1984 6.88181L21.196 6.88417ZM21.3142 7.62163C21.3591 7.64054 21.3827 7.68781 21.3827 7.70908C21.3378 7.75399 21.2693 7.63817 21.3142 7.62163ZM21.3213 8.82472C21.3686 8.80108 21.3969 8.8129 21.3544 8.84835C21.3189 8.86726 21.274 8.84835 21.326 8.81526C21.326 8.81526 21.3213 8.81999 21.3189 8.82472H21.3213ZM16.3978 3.46872C16.4309 3.39308 16.464 3.38835 16.5018 3.40253C16.542 3.40963 16.5893 3.43326 16.62 3.41199C16.6082 3.57035 16.4806 3.45454 16.438 3.47108C16.4215 3.46872 16.4073 3.46635 16.3978 3.47108V3.46872ZM19.0404 6.27672C19.0664 6.21054 19.0947 6.21054 19.1255 6.22944C19.1562 6.24835 19.1987 6.26963 19.2224 6.25781L19.2153 6.31217C19.1798 6.31217 19.1515 6.32163 19.1207 6.32399C19.0947 6.31926 19.0664 6.30744 19.0427 6.27672H19.0404ZM17.9176 3.34817C17.9696 3.29853 18.024 3.37653 18.0618 3.38599C18.0311 3.45926 17.8751 3.42617 17.9176 3.34581V3.34817ZM18.7756 4.66944C18.6882 4.66944 18.7378 4.59854 18.7307 4.57726C18.7473 4.59381 18.7993 4.62454 18.7969 4.64344C18.7946 4.65526 18.7851 4.65763 18.7756 4.66944ZM18.9718 6.30744C18.9246 6.27908 18.8678 6.25781 18.8276 6.2129L18.8631 6.17035C18.9009 6.2129 18.9529 6.22708 18.9955 6.25781L18.9695 6.30744H18.9718ZM18.6693 5.87726L18.7213 5.85599C18.7993 5.88672 18.6787 5.96235 18.6693 5.87963V5.87726ZM19.7211 6.27672C19.7211 6.27672 19.6951 6.27435 19.6856 6.27672C19.5604 6.30272 19.7046 6.07344 19.7211 6.27672ZM20.4562 6.14199C20.4727 6.1349 20.494 6.11835 20.5106 6.12072C20.624 6.14435 20.4869 6.25781 20.4562 6.14199Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("1bYNe", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d86b4a14639fe6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kIcfN = parcelRequire("kIcfN");


var $hatDq = parcelRequire("hatDq");

var $kx8ta = parcelRequire("kx8ta");

var $daXvt = parcelRequire("daXvt");

var $lWbFO = parcelRequire("lWbFO");
const $88d86b4a14639fe6$var$useInvisibleRecaptchaWithUFO = ()=>{
    const { source: source } = (0, $daXvt.useInvitePeopleContext)();
    const { isRecaptchaLoaded: isRecaptchaLoaded, getRecaptchaToken: getRecaptchaToken, recaptchaLoadErrorReason: recaptchaLoadErrorReason } = (0, $kIcfN.useInvisibleRecaptcha)({
        siteKey: (0, $kx8ta.getRecaptchaSiteKey)(),
        displayBadge: false,
        analyticsChannel: (0, $241a88bae7861acc$export$85183a312807388d),
        analyticsSource: `${(0, $hatDq.AnalyticsActionSubject).DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL}_${source}`
    });
    const isInitialLoad = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (isInitialLoad.current) {
            (0, $lWbFO.recaptchaLoaded).start();
            isInitialLoad.current = false;
        }
        if (isRecaptchaLoaded) (0, $lWbFO.recaptchaLoaded).success();
        if (recaptchaLoadErrorReason) (0, $lWbFO.recaptchaLoaded).failure();
    }, [
        isRecaptchaLoaded,
        getRecaptchaToken,
        recaptchaLoadErrorReason
    ]);
    const isRecaptchaLoading = !isRecaptchaLoaded && !recaptchaLoadErrorReason;
    return (0, $5uXOq.useMemo)(()=>({
            getRecaptchaToken: getRecaptchaToken,
            isRecaptchaLoading: isRecaptchaLoading,
            recaptchaLoadErrorReason: recaptchaLoadErrorReason
        }), [
        getRecaptchaToken,
        isRecaptchaLoading,
        recaptchaLoadErrorReason
    ]);
};
var $88d86b4a14639fe6$export$2e2bcd8739ae039 = $88d86b4a14639fe6$var$useInvisibleRecaptchaWithUFO;

});



parcelRegister("6zLS8", function(module, exports) {

$parcel$export(module.exports, "TestId", () => $4801f195ab3876d0$export$f067415f668a97e9);
var $4801f195ab3876d0$export$f067415f668a97e9 = /*#__PURE__*/ function(TestId) {
    TestId["InvitePeopleDrawer"] = "testId-invite-people-drawer";
    TestId["InvitePeopleDrawerContent"] = "testId-invite-people-drawer-content";
    TestId["InvitePeopleDrawerImage"] = "testId-invite-people-drawer-img";
    TestId["InvitePeopleForm"] = "testId-invite-people-form";
    return TestId;
}({});

});

parcelRegister("9efUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8222744b175631ba$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
// This is a hacky solution to make the invite people drawer works in Jira with Issue Modal as there is no systematic way to change the z-index of the drawer
const $8222744b175631ba$var$ZIndexSetter = ()=>{
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (ref.current) {
            const portalElement = ref.current.closest && ref.current.closest('.atlaskit-portal');
            if (portalElement) // we set it to 550 because we want it to stay above the modal, and below flag, spotlight and tooltip
            // directly setting the style property is the safer option than setAttribute()
            // because we don't know what other possible style properties could be
            portalElement.style['z-index'] = 550;
        }
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref
    });
};
var $8222744b175631ba$export$2e2bcd8739ae039 = $8222744b175631ba$var$ZIndexSetter;

});


parcelRegister("k1GKH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "InvitePeopleModal", () => $56e935c20147b484$export$e3ec81c4d0451f63);
$parcel$export(module.exports, "default", () => $56e935c20147b484$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hordk = parcelRequire("hordk");
var $i2ajl = parcelRequire("i2ajl");

var $cKaFn = parcelRequire("cKaFn");
const $56e935c20147b484$var$InvitePeopleModalBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...props,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: '0px'
        },
        ref: ref
    });
});
const $56e935c20147b484$var$InvitePeopleModalWithTitleId = ({ onCloseHandler: onCloseHandler, ...invitePeopleProps })=>{
    const { titleId: titleId } = (0, $i2ajl.useModal)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($56e935c20147b484$var$InvitePeopleModalBody, {
        "aria-describedby": "invite-people-form-description",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            onClick: $56e935c20147b484$var$preventDialogClose,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cKaFn.InvitePeopleWithAnalytics), {
                onSendHandler: ()=>onCloseHandler('invite'),
                onCancelHandler: ()=>onCloseHandler('cancel'),
                titleId: titleId,
                ...invitePeopleProps,
                viewAs: 'modal'
            })
        })
    });
};
const $56e935c20147b484$var$preventDialogClose = (event)=>{
    event.stopPropagation();
};
const $56e935c20147b484$export$e3ec81c4d0451f63 = ({ onCloseHandler: onCloseHandler, ...invitePeopleProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hordk.default), {
        width: "small",
        onClose: ()=>onCloseHandler('blur'),
        shouldScrollInViewport: true,
        testId: 'invite-people-modal',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($56e935c20147b484$var$InvitePeopleModalWithTitleId, {
            onCloseHandler: onCloseHandler,
            ...invitePeopleProps
        })
    });
};
var $56e935c20147b484$export$2e2bcd8739ae039 = $56e935c20147b484$export$e3ec81c4d0451f63;

});



//# sourceMappingURL=async-invite-people-drawer.61d7947f.js.map
